import { FormCheck } from 'react-bootstrap';
import React from 'react';

export const getEditCell = (rowdata) => {
  if (rowdata.value != null) {
    // return <EditRequestedItemModal data={row} disableFields={false} />;
    let link = `/receiving/view/requestedItemId=${rowdata.row._original.id}`;
    return (
      <a href={link} className='info'>
        {' '}
        {/*onClick={() => window.location.href = `/receiving/view/requestedItemId=${rowdata.row._original.id}`}>*/}
        {rowdata.row._original.requestItemFYNumber}
      </a>
    );
  } else {
    return '';
  }
};

export const checkBoxes = (rowdata) => {
  if (rowdata.value != null) {
    // console.log('value = ' + JSON.stringify(value))
    // console.log('row: ' + JSON.stringify(row))
    return <FormCheck className='ml-2' />;
  } else {
    return '';
  }
};

export const requestFormColumns = [
  {
    //Header: 'Edit',
    accessor: 'id',
    width: 30,
    // type: 'string',
    filterable: false,
    Cell: checkBoxes,
  },
  {
    Header: 'Request #',
    accessor: 'requestItemFYNumber',
    width: 100,
    // type: 'string',
    Cell: getEditCell,
  },
  {
    Header: 'Description',
    accessor: 'description1',
    // width: 400,
    // type: 'string',
  },
  {
    Header: 'Serial #',
    accessor: 'serialNumber',
    width: 100,
    // type: 'string',
  },
  {
    Header: 'Barcode',
    accessor: 'barcode',
    width: 100,
    // type: 'string',
  },
  {
    Header: 'Status',
    accessor: 'status',
    //width: 200,
    //type: 'string',
    //Cell: reqItemStatus
  },
  {
    Header: 'Recipient',
    accessor: 'originalPurchaser',
    // width: 400,
    //type: 'string',
  },
];

export const barcodeTypes = [
  {
    needsBarcode: false,
    label: 'No Barcode',
    backColor: '#fff',
    textColor: '#333',
  },
  {
    needsBarcode: true,
    label: 'Capital',
    backColor: '#00f',
    textColor: '#fff',
  },
   {
    needsBarcode: true,
    label: 'Grants',
    backColor: '#080',
    textColor: '#fff',
  },
   {
    needsBarcode: true,
    label: 'GASB',
    backColor: '#ffa500',
    textColor: '#fff',
  },
   {
    needsBarcode: true,
    label: 'Regular',
    backColor: '#fff',
    textColor: '#333',
  },
];

/** ALL PRESENT IN DROPDOWNS TABLE, NOT CURRENTLY IN USE */

export const pCards = [
  {
    val: '',
    desc: '',
  },
  {
    desc: 'P-Card; Kay',
    val: 'P-CARD',
  },
  {
    desc: 'P-Card; Carol',
    val: 'P-Card',
  },
  {
    desc: 'P-Card; Laura',
    val: 'p-card',
  },
  {
    desc: 'P-Card; Terry',
    val: 'P-card',
  },
  {
    desc: 'PO',
    val: 'PO',
  },
  {
    desc: 'Rewards Program',
    val: 'Rewards',
  },
];

export const majorAccountingClasses = [
  {
    code: '',
    description: '',
  },
  {
    code: '01',
    description: 'Land & Buildings',
  },
  {
    code: '05',
    description: 'Road & Bridges, Etc.',
  },
  {
    code: '10',
    description: 'Auto, Machinery & Equip',
  },
  {
    code: '15',
    description: 'Water & Sewer Plants',
  },
  {
    code: '20',
    description: 'Water and Sewer Lines',
  },
  {
    code: '99',
    description: 'Property Inventory',
  },
];

export const majorEquipmentClasses = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: 'AU1',
    Description: 'Automobiles - 10 years',
  },
  {
    Code: 'AU5',
    Description: 'Automobiles - 5 years',
  },
  {
    Code: 'AV1',
    Description: 'Audio Visual - 10 years',
  },
  {
    Code: 'AV5',
    Description: 'Audio Visual - 5 years',
  },
  {
    Code: 'AV7',
    Description: 'Audio Visual - 7 years',
  },
  {
    Code: 'BRD',
    Description: 'Bridges',
  },
  {
    Code: 'BRE',
    Description: 'Buildings On Recreation Land',
  },
  {
    Code: 'BUI',
    Description: 'Buildings',
  },
  {
    Code: 'C25',
    Description: 'Culverts - Metal',
  },
  {
    Code: 'C50',
    Description: 'Culverts -Concrete',
  },
  {
    Code: 'DBR',
    Description: 'Donated Bridges',
  },
  {
    Code: 'DFR',
    Description: 'Donated Fire Supressions',
  },
  {
    Code: 'DIF',
    Description: 'Donated Infrastructure',
  },
  {
    Code: 'DST',
    Description: 'Donated Storm Drains',
  },
  {
    Code: 'DSW',
    Description: 'Donated SW, Curbs, & Gutters',
  },
  {
    Code: 'D00',
    Description: 'Donated Roads - Subbase',
  },
  {
    Code: 'D17',
    Description: 'Donated Roads - Surface',
  },
  {
    Code: 'D25',
    Description: 'Donated Culverts - Metal',
  },
  {
    Code: 'D30',
    Description: 'Donated Roads - Base',
  },
  {
    Code: 'D50',
    Description: 'Donated Culverts - Concrete',
  },
  {
    Code: 'EAS',
    Description: 'Easements',
  },
  {
    Code: 'EQU',
    Description: 'Equipment',
  },
  {
    Code: 'FU1',
    Description: 'Furniture & Fixtures -10 years',
  },
  {
    Code: 'FU5',
    Description: 'Furniture & Fixtures - 5 years',
  },
  {
    Code: 'FU7',
    Description: 'Furniture & Fixtures - 7 years',
  },
  {
    Code: 'HAR',
    Description: 'Hardware',
  },
  {
    Code: 'HIS',
    Description: 'Historical Property & Work',
  },
  {
    Code: 'IGS',
    Description: 'Internally Generated Software',
  },
  {
    Code: 'LAI',
    Description: 'Land Improvement',
  },
  {
    Code: 'LAN',
    Description: 'Land',
  },
  {
    Code: 'LB1',
    Description: 'Library - 10 years',
  },
  {
    Code: 'LB5',
    Description: 'Library - 5 years',
  },
  {
    Code: 'LL1',
    Description: 'Leases - 10 years',
  },
  {
    Code: 'LL5',
    Description: 'Leases - 5 years',
  },
  {
    Code: 'MEC',
    Description: 'Mechanical Equipment',
  },
  {
    Code: 'MIS',
    Description: 'Misc Equipment',
  },
  {
    Code: 'OTH',
    Description: 'Other',
  },
  {
    Code: 'REC',
    Description: 'Recreation Land Held in Trust',
  },
  {
    Code: 'R00',
    Description: 'Roads - Subbase',
  },
  {
    Code: 'R17',
    Description: 'Roads - Surface',
  },
  {
    Code: 'R30',
    Description: 'Roads - Base',
  },
  {
    Code: 'SOF',
    Description: 'Software',
  },
  {
    Code: 'STM',
    Description: 'Storm Drains',
  },
  {
    Code: 'SWK',
    Description: 'SW, Curbs, & Gutters',
  },
  {
    Code: 'TRA',
    Description: 'Traffic Signals',
  },
  {
    Code: 'WCI',
    Description: 'Water Struct - Capital',
  },
  {
    Code: 'WCO',
    Description: 'Water Connections',
  },
  {
    Code: 'WJT',
    Description: 'Water Joint Ventures',
  },
  {
    Code: 'WLI',
    Description: 'Water Line Laterals',
  },
  {
    Code: 'WME',
    Description: 'Water Meters',
  },
  {
    Code: 'WST',
    Description: 'Water Structure',
  },
  {
    Code: 'WWC',
    Description: 'Sewer Connections',
  },
  {
    Code: 'WWI',
    Description: 'Sewer Struct - Capital',
  },
  {
    Code: 'WWJ',
    Description: 'Sewer Joint Ventures',
  },
  {
    Code: 'WWL',
    Description: 'Sewer Lines & Laterals',
  },
  {
    Code: 'WWS',
    Description: 'Sewer Structures',
  },
];

export const manufacturers = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: 'A J',
    Description: 'A J STATIONERS',
  },
  {
    Code: 'AB',
    Description: 'AB DICK',
  },
  {
    Code: 'ABC',
    Description: 'ABCO',
  },
  {
    Code: 'ABL',
    Description: 'ABLE',
  },
  {
    Code: 'AB2',
    Description: 'ABSOCOLD',
  },
  {
    Code: 'ACE',
    Description: 'ACER',
  },
  {
    Code: 'ACM',
    Description: 'ACME VISIBLE',
  },
  {
    Code: 'ACR',
    Description: 'ACR',
  },
  {
    Code: 'AC1',
    Description: 'ACCO',
  },
  {
    Code: 'AC2',
    Description: 'ACCUGRID',
  },
  {
    Code: 'AC3',
    Description: 'ACCULIGHT',
  },
  {
    Code: 'AC5',
    Description: 'ACCUPOWER',
  },
  {
    Code: 'AC6',
    Description: 'ACCUSOURCE',
  },
  {
    Code: 'ADC',
    Description: 'ADC',
  },
  {
    Code: 'ADL',
    Description: 'ADLER-ROYAL',
  },
  {
    Code: 'ADM',
    Description: 'ADMIRAL',
  },
  {
    Code: 'ADS',
    Description: 'ADS',
  },
  {
    Code: 'AGE',
    Description: 'AGER',
  },
  {
    Code: 'AIE',
    Description: 'AIE',
  },
  {
    Code: 'AIW',
    Description: 'AIWA',
  },
  {
    Code: 'AJ',
    Description: 'AJ STATIONER',
  },
  {
    Code: 'ALF',
    Description: 'ALFON',
  },
  {
    Code: 'ALL',
    Description: 'ALL PRO',
  },
  {
    Code: 'ALM',
    Description: 'ALMA',
  },
  {
    Code: 'ALO',
    Description: 'ALONG',
  },
  {
    Code: 'ALR',
    Description: 'ALR',
  },
  {
    Code: 'AL1',
    Description: 'ALL STEEL',
  },
  {
    Code: 'AL3',
    Description: 'ALLSAFE FIRE',
  },
  {
    Code: 'AM.',
    Description: 'AM.SCI.PRODUCTS',
  },
  {
    Code: 'AMA',
    Description: 'AMANA',
  },
  {
    Code: 'AMD',
    Description: 'AMDEK',
  },
  {
    Code: 'AMO',
    Description: 'AMO',
  },
  {
    Code: 'AMP',
    Description: 'AMPLIVOX',
  },
  {
    Code: 'AMS',
    Description: 'AMS',
  },
  {
    Code: 'AMX',
    Description: 'AMX',
  },
  {
    Code: 'AM3',
    Description: 'AMERICAN',
  },
  {
    Code: 'AM4',
    Description: 'AMERICAN EAGLE',
  },
  {
    Code: 'AM5',
    Description: 'AMERICAN FIRE',
  },
  {
    Code: 'AM6',
    Description: 'AMF',
  },
  {
    Code: 'AMZ',
    Description: 'AMAZON',
  },
  {
    Code: 'ANN',
    Description: 'ANNAPOLIS LAWN',
  },
  {
    Code: 'AN1',
    Description: 'ANDERSON',
  },
  {
    Code: 'AN2',
    Description: 'ANDERSON HICKORY',
  },
  {
    Code: 'AN3',
    Description: 'ANDERSON-HICKEY',
  },
  {
    Code: 'AN4',
    Description: 'ANDREWS',
  },
  {
    Code: 'AOC',
    Description: 'AOC',
  },
  {
    Code: 'AOL',
    Description: 'AOL',
  },
  {
    Code: 'APC',
    Description: 'APC',
  },
  {
    Code: 'APE',
    Description: 'APEX',
  },
  {
    Code: 'APO',
    Description: 'APOLLO',
  },
  {
    Code: 'APR',
    Description: 'APR',
  },
  {
    Code: 'AP1',
    Description: 'ALPHATRONIX',
  },
  {
    Code: 'AP3',
    Description: 'APPLIED CONCEPTS',
  },
  {
    Code: 'AP4',
    Description: 'APPLE',
  },
  {
    Code: 'AP5',
    Description: 'APPLIED BIOSYSTEMS',
  },
  {
    Code: 'ARR',
    Description: 'ARRI',
  },
  {
    Code: 'AR1',
    Description: 'ARC',
  },
  {
    Code: 'AR3',
    Description: 'ARION',
  },
  {
    Code: 'AR4',
    Description: 'ARISTO',
  },
  {
    Code: 'AR5',
    Description: 'ART METAL',
  },
  {
    Code: 'AR6',
    Description: 'ARTEC',
  },
  {
    Code: 'AR7',
    Description: 'ARTOPEX',
  },
  {
    Code: 'AR8',
    Description: 'ARTSTEEL',
  },
  {
    Code: 'AS1',
    Description: 'AST',
  },
  {
    Code: 'AS2',
    Description: 'ASTATIC',
  },
  {
    Code: 'AS3',
    Description: 'ASTRON',
  },
  {
    Code: 'AT&',
    Description: 'AT&T',
  },
  {
    Code: 'ATC',
    Description: 'ATC',
  },
  {
    Code: 'ATF',
    Description: 'ATF',
  },
  {
    Code: 'ATH',
    Description: 'ATHENA GTX, INC',
  },
  {
    Code: 'ATL',
    Description: 'ATLANTIC FITNESS',
  },
  {
    Code: 'ATR',
    Description: 'ATREC',
  },
  {
    Code: 'AT1',
    Description: 'ALTA',
  },
  {
    Code: 'AT2',
    Description: 'ALTEC LANSING',
  },
  {
    Code: 'AT3',
    Description: 'ALTIMA',
  },
  {
    Code: 'AU1',
    Description: 'AUDIOLOG',
  },
  {
    Code: 'AU2',
    Description: 'AUDIOTRONICS',
  },
  {
    Code: 'AU3',
    Description: 'AURORA VISION',
  },
  {
    Code: 'AU4',
    Description: 'AUTOLAB',
  },
  {
    Code: 'AU5',
    Description: 'AUTOLOGIC',
  },
  {
    Code: 'AVA',
    Description: 'AVANTI',
  },
  {
    Code: 'AVI',
    Description: 'AVITRON',
  },
  {
    Code: 'AVT',
    Description: 'AVTRON LOADBANK, INC',
  },
  {
    Code: 'AXC',
    Description: 'AXCITON',
  },
  {
    Code: 'AXS',
    Description: 'AXIS',
  },
  {
    Code: 'AYD',
    Description: 'AYDIN',
  },
  {
    Code: 'A0C',
    Description: 'A0C',
  },
  {
    Code: 'BAL',
    Description: 'BALDOR',
  },
  {
    Code: 'BAR',
    Description: 'BARRACUDA',
  },
  {
    Code: 'BA1',
    Description: 'BACHARACH',
  },
  {
    Code: 'BA2',
    Description: 'BACKPACK',
  },
  {
    Code: 'BA3',
    Description: 'BACKUPS',
  },
  {
    Code: 'BA4',
    Description: 'BALLY BLOCK',
  },
  {
    Code: 'BA5',
    Description: 'BALT STATIONERY',
  },
  {
    Code: 'BA6',
    Description: 'BALTIMORE AUTO',
  },
  {
    Code: 'BA7',
    Description: 'BARNSTEAD',
  },
  {
    Code: 'BA8',
    Description: 'BARRICKS',
  },
  {
    Code: 'BA9',
    Description: 'BARRON',
  },
  {
    Code: 'BEC',
    Description: 'BECKMAN',
  },
  {
    Code: 'BED',
    Description: 'BEDFORD',
  },
  {
    Code: 'BEI',
    Description: 'BEIGE',
  },
  {
    Code: 'BEN',
    Description: 'BENCHER',
  },
  {
    Code: 'BEQ',
    Description: 'BENQ',
  },
  {
    Code: 'BEV',
    Description: 'BEVIS',
  },
  {
    Code: 'BE1',
    Description: 'BELL',
  },
  {
    Code: 'BE2',
    Description: 'BELL AND HOWELL',
  },
  {
    Code: 'BE3',
    Description: 'BELLCO',
  },
  {
    Code: 'BIL',
    Description: 'BILORA',
  },
  {
    Code: 'BI1',
    Description: 'BIOSYSTEMS',
  },
  {
    Code: 'BI2',
    Description: 'BIOSYTEMS',
  },
  {
    Code: 'BLO',
    Description: 'BLOWER',
  },
  {
    Code: 'BL1',
    Description: 'BLACK BOX',
  },
  {
    Code: 'BL2',
    Description: 'BLAKRAY',
  },
  {
    Code: 'BL3',
    Description: 'BLACK & DECKER',
  },
  {
    Code: 'BOC',
    Description: 'BOCA',
  },
  {
    Code: 'BOE',
    Description: 'BOEKEL',
  },
  {
    Code: 'BOG',
    Description: 'BOGEN',
  },
  {
    Code: 'BOS',
    Description: 'BOSTON',
  },
  {
    Code: 'BOW',
    Description: 'BOWENS FARM',
  },
  {
    Code: 'BOX',
    Description: 'BOXLIGHT',
  },
  {
    Code: 'BRI',
    Description: 'BRIGGS & STRATTON',
  },
  {
    Code: 'BRO',
    Description: 'BROTHER',
  },
  {
    Code: 'BR1',
    Description: 'BERGER',
  },
  {
    Code: 'BR2',
    Description: 'BERNOULLI',
  },
  {
    Code: 'BR3',
    Description: 'BRAND',
  },
  {
    Code: 'BR4',
    Description: 'BRANDT',
  },
  {
    Code: 'BR5',
    Description: 'BRANLUEBBE',
  },
  {
    Code: 'BR6',
    Description: 'BRETFORD',
  },
  {
    Code: 'BR7',
    Description: 'BROTHER',
  },
  {
    Code: 'BR8',
    Description: 'BROWN',
  },
  {
    Code: 'BR9',
    Description: 'BRUEL KJAER',
  },
  {
    Code: 'BSH',
    Description: 'BSH',
  },
  {
    Code: 'BS1',
    Description: 'BESSLER',
  },
  {
    Code: 'BS2',
    Description: 'BEST',
  },
  {
    Code: 'BS3',
    Description: 'BEST BUILT',
  },
  {
    Code: 'BS4',
    Description: 'BEST BUY',
  },
  {
    Code: 'BS5',
    Description: 'BEST DATA',
  },
  {
    Code: 'BUF',
    Description: 'BUFFALO',
  },
  {
    Code: 'BUH',
    Description: 'BUHL',
  },
  {
    Code: 'BUI',
    Description: 'BUILT IN HOUSE',
  },
  {
    Code: 'BUR',
    Description: 'BURLE',
  },
  {
    Code: 'BU1',
    Description: 'BAUMFOLDER',
  },
  {
    Code: 'BU2',
    Description: 'BAUSCH/LOMB',
  },
  {
    Code: 'BU3',
    Description: 'BLUE M',
  },
  {
    Code: 'BU4',
    Description: 'BLUM',
  },
  {
    Code: 'BU5',
    Description: 'BUSH',
  },
  {
    Code: 'BU6',
    Description: 'BUSHNELL',
  },
  {
    Code: 'B10',
    Description: 'BRUNING',
  },
  {
    Code: 'C&H',
    Description: 'C&H',
  },
  {
    Code: 'CAE',
    Description: 'CAERE',
  },
  {
    Code: 'CAL',
    Description: 'CAL COMP',
  },
  {
    Code: 'CAM',
    Description: 'CAMBRIDGE',
  },
  {
    Code: 'CAN',
    Description: 'CANON',
  },
  {
    Code: 'CAR',
    Description: 'CARDINAL',
  },
  {
    Code: 'CAS',
    Description: 'CASIO',
  },
  {
    Code: 'CA1',
    Description: 'CABOT WREN',
  },
  {
    Code: 'CA2',
    Description: 'CABOT WRENN',
  },
  {
    Code: 'CA3',
    Description: 'CABOTT WRENN',
  },
  {
    Code: 'CDW',
    Description: 'CDW GOVERNMENT INC',
  },
  {
    Code: 'CE',
    Description: 'CE',
  },
  {
    Code: 'CEN',
    Description: 'CENTRECOM',
  },
  {
    Code: 'CER',
    Description: 'CERNING',
  },
  {
    Code: 'CE1',
    Description: 'CELERON',
  },
  {
    Code: 'CE2',
    Description: 'CELLMARK DIAGNOSTICS',
  },
  {
    Code: 'CE3',
    Description: 'CELLULAR ONE',
  },
  {
    Code: 'CE4',
    Description: 'CELRON',
  },
  {
    Code: 'CE5',
    Description: 'CENTURY',
  },
  {
    Code: 'CHA',
    Description: 'CHASE',
  },
  {
    Code: 'CHE',
    Description: 'CH&E',
  },
  {
    Code: 'CHU',
    Description: 'CHUNTEX',
  },
  {
    Code: 'CH1',
    Description: 'CHALLENGE',
  },
  {
    Code: 'CH2',
    Description: 'CHAMPION',
  },
  {
    Code: 'CH3',
    Description: 'CHATILLION',
  },
  {
    Code: 'CH4',
    Description: 'CHEER',
  },
  {
    Code: 'CH5',
    Description: 'CHESLEY',
  },
  {
    Code: 'CH6',
    Description: 'CHINON',
  },
  {
    Code: 'CH7',
    Description: 'CHISHOLM',
  },
  {
    Code: 'CH8',
    Description: 'CHIU TECH',
  },
  {
    Code: 'CIR',
    Description: 'CIRCUIT CITY',
  },
  {
    Code: 'CIS',
    Description: 'CISCO SYSTEMS',
  },
  {
    Code: 'CI1',
    Description: 'CITIZEN',
  },
  {
    Code: 'CI2',
    Description: 'CITOH',
  },
  {
    Code: 'CLI',
    Description: 'CLI',
  },
  {
    Code: 'CLO',
    Description: 'CLONE',
  },
  {
    Code: 'CL1',
    Description: 'CLARIDGE',
  },
  {
    Code: 'CL2',
    Description: 'CLARKE',
  },
  {
    Code: 'CL3',
    Description: 'CLARY',
  },
  {
    Code: 'CML',
    Description: 'CML',
  },
  {
    Code: 'CM1',
    Description: 'COMPAQ',
  },
  {
    Code: 'CM2',
    Description: 'CAMERZ',
  },
  {
    Code: 'CM3',
    Description: 'COMPUADD',
  },
  {
    Code: 'CM4',
    Description: 'COMPUTER',
  },
  {
    Code: 'CM5',
    Description: 'COMPUTREND',
  },
  {
    Code: 'CM6',
    Description: 'COMTEX',
  },
  {
    Code: 'CM7',
    Description: 'COMVERSE',
  },
  {
    Code: 'CM8',
    Description: 'COMPREHENSIVE',
  },
  {
    Code: 'CNE',
    Description: 'CNET',
  },
  {
    Code: 'CN1',
    Description: 'CONTINENTAL',
  },
  {
    Code: 'CN2',
    Description: 'CONVEYANT',
  },
  {
    Code: 'COL',
    Description: 'COLEMAN',
  },
  {
    Code: 'COR',
    Description: 'CORDLEY',
  },
  {
    Code: 'COT',
    Description: 'COTTERMAN',
  },
  {
    Code: 'COU',
    Description: 'COUNCIL',
  },
  {
    Code: 'CO1',
    Description: 'COASTAL COMPUTE',
  },
  {
    Code: 'CO2',
    Description: 'COASTAR',
  },
  {
    Code: 'CO3',
    Description: 'COHERENT',
  },
  {
    Code: 'CO4',
    Description: 'COLE',
  },
  {
    Code: 'CO5',
    Description: 'COLE MEDICAL',
  },
  {
    Code: 'CO6',
    Description: 'COLE PARMER',
  },
  {
    Code: 'CO7',
    Description: 'COLORADO',
  },
  {
    Code: 'CO8',
    Description: 'COMFORT AIRE',
  },
  {
    Code: 'CO9',
    Description: 'COMFORT LINE',
  },
  {
    Code: 'CRA',
    Description: 'CRAFTSMAN',
  },
  {
    Code: 'CRE',
    Description: 'CREATIVE',
  },
  {
    Code: 'CRF',
    Description: 'CRAFTSMAN',
  },
  {
    Code: 'CR1',
    Description: 'CARRIER',
  },
  {
    Code: 'CR2',
    Description: 'CORDOVAN',
  },
  {
    Code: 'CR3',
    Description: 'COREY',
  },
  {
    Code: 'CR4',
    Description: 'CORNEA',
  },
  {
    Code: 'CR5',
    Description: 'CORNING',
  },
  {
    Code: 'CR6',
    Description: 'CROSLEY',
  },
  {
    Code: 'CR7',
    Description: 'CROSSCOM',
  },
  {
    Code: 'CR8',
    Description: 'CROWN',
  },
  {
    Code: 'CS1',
    Description: 'CSI',
  },
  {
    Code: 'CS2',
    Description: 'CSI',
  },
  {
    Code: 'CTX',
    Description: 'CTX',
  },
  {
    Code: 'CUE',
    Description: 'CUESTA SYSTEMS',
  },
  {
    Code: 'CU1',
    Description: 'CUMMINS',
  },
  {
    Code: 'CU2',
    Description: 'CUMMINS-ALLISON',
  },
  {
    Code: 'CU3',
    Description: 'CUMULUS',
  },
  {
    Code: 'CU4',
    Description: 'CURTIS',
  },
  {
    Code: 'CYB',
    Description: 'CYBERSYS INTEGRATION TECH, INC',
  },
  {
    Code: 'CY1',
    Description: 'CRYSTAL TIPS',
  },
  {
    Code: 'CY2',
    Description: 'CRYSTALTIPS',
  },
  {
    Code: 'CY3',
    Description: 'CYBER POWER',
  },
  {
    Code: 'CY4',
    Description: 'CYBERVISION',
  },
  {
    Code: 'CY5',
    Description: 'CYBEX',
  },
  {
    Code: 'CY6',
    Description: 'C',
  },
  {
    Code: 'DAE',
    Description: 'DAEWOO',
  },
  {
    Code: 'DAN',
    Description: 'DANBY',
  },
  {
    Code: 'DAR',
    Description: 'DAR/RAN',
  },
  {
    Code: 'DAT',
    Description: 'DATASTOR',
  },
  {
    Code: 'DAV',
    Description: 'DAVID EDWARD',
  },
  {
    Code: 'DA1',
    Description: 'DALITE',
  },
  {
    Code: 'DA2',
    Description: 'DALY',
  },
  {
    Code: 'DA3',
    Description: 'DAKE',
  },
  {
    Code: 'DBA',
    Description: 'DBA Lab Mart',
  },
  {
    Code: 'DCS',
    Description: 'DCS',
  },
  {
    Code: 'DEC',
    Description: 'DECATUR ELECTRONICS',
  },
  {
    Code: 'DEL',
    Description: 'DELL',
  },
  {
    Code: 'DEN',
    Description: 'DENSO',
  },
  {
    Code: 'DES',
    Description: 'DESKJET 895C',
  },
  {
    Code: 'DET',
    Description: 'DETECTO',
  },
  {
    Code: 'DEV',
    Description: 'DEVILBLISS AIR',
  },
  {
    Code: 'DEW',
    Description: 'Dewalt',
  },
  {
    Code: 'DE1',
    Description: 'DELTECH',
  },
  {
    Code: 'DE2',
    Description: 'DENVER',
  },
  {
    Code: 'DE3',
    Description: 'DELTA',
  },
  {
    Code: 'DFI',
    Description: 'DFI',
  },
  {
    Code: 'DG1',
    Description: 'DIGAL',
  },
  {
    Code: 'DG2',
    Description: 'DIGI',
  },
  {
    Code: 'DG3',
    Description: 'DIGITAL',
  },
  {
    Code: 'DG4',
    Description: 'DIGIVIEW',
  },
  {
    Code: 'DHI',
    Description: 'DHILPS',
  },
  {
    Code: 'DIA',
    Description: 'DIAMOND',
  },
  {
    Code: 'DIC',
    Description: 'DICTAPHONE',
  },
  {
    Code: 'DIM',
    Description: 'DIMENSION',
  },
  {
    Code: 'DI1',
    Description: 'DIAMOND BACK',
  },
  {
    Code: 'DOA',
    Description: 'DOAR',
  },
  {
    Code: 'DOC',
    Description: 'DOCSTAR',
  },
  {
    Code: 'DOL',
    Description: 'DOLMAR',
  },
  {
    Code: 'DOM',
    Description: 'DOMORE',
  },
  {
    Code: 'DOU',
    Description: 'DOURON',
  },
  {
    Code: 'DPS',
    Description: 'DPS',
  },
  {
    Code: 'DTK',
    Description: 'DTK',
  },
  {
    Code: 'DTN',
    Description: 'DTN',
  },
  {
    Code: 'DT1',
    Description: 'DATA PRODUCTS',
  },
  {
    Code: 'DT2',
    Description: 'DATA STAR',
  },
  {
    Code: 'DT3',
    Description: 'DATACARD',
  },
  {
    Code: 'DT4',
    Description: 'DATAFAX',
  },
  {
    Code: 'DT5',
    Description: 'DATAPHONE',
  },
  {
    Code: 'DT6',
    Description: 'DATASHIELDS',
  },
  {
    Code: 'DUA',
    Description: 'DUAL MODE',
  },
  {
    Code: 'DUK',
    Description: 'DUKANE',
  },
  {
    Code: 'DUN',
    Description: 'DUNN',
  },
  {
    Code: 'DU1',
    Description: 'DURON',
  },
  {
    Code: 'DYN',
    Description: 'DYNAMIC iMAGING SYSTEMS INC',
  },
  {
    Code: 'DYS',
    Description: 'DYSON',
  },
  {
    Code: 'DY1',
    Description: 'DAYTEK',
  },
  {
    Code: 'DY2',
    Description: 'DAYTON',
  },
  {
    Code: 'EAG',
    Description: 'EAGLE',
  },
  {
    Code: 'EAR',
    Description: 'EARTH SECURITY',
  },
  {
    Code: 'EAS',
    Description: 'EASTERNCOMPUTER',
  },
  {
    Code: 'EAZ',
    Description: 'EAZY',
  },
  {
    Code: 'EBT',
    Description: 'EBTECH',
  },
  {
    Code: 'ECH',
    Description: 'ECHO',
  },
  {
    Code: 'ECK',
    Description: 'ECKADAMS',
  },
  {
    Code: 'EDC',
    Description: 'EDCO INC',
  },
  {
    Code: 'EDI',
    Description: 'EDISON',
  },
  {
    Code: 'EDS',
    Description: 'EDSON STYLUS',
  },
  {
    Code: 'EDW',
    Description: 'EDWARDS',
  },
  {
    Code: 'EG',
    Description: 'EG',
  },
  {
    Code: 'EII',
    Description: 'ELL',
  },
  {
    Code: 'EIK',
    Description: 'EIKI',
  },
  {
    Code: 'ELK',
    Description: 'ELKI',
  },
  {
    Code: 'ELM',
    Description: 'ELMO',
  },
  {
    Code: 'ELO',
    Description: 'ELO TOUCH SOLUTIONS',
  },
  {
    Code: 'ELT',
    Description: 'ELTRON',
  },
  {
    Code: 'EL1',
    Description: 'ELECTRIC EEL',
  },
  {
    Code: 'EL2',
    Description: 'ELECTROHOME',
  },
  {
    Code: 'EL3',
    Description: 'ELECTROVOICE',
  },
  {
    Code: 'EMC',
    Description: 'EMC',
  },
  {
    Code: 'EME',
    Description: 'EMERSON',
  },
  {
    Code: 'ENV',
    Description: 'ENVOY',
  },
  {
    Code: 'EPS',
    Description: 'EPSON',
  },
  {
    Code: 'ERC',
    Description: 'ERC INC',
  },
  {
    Code: 'ERY',
    Description: 'ERYN',
  },
  {
    Code: 'EST',
    Description: 'E-STAR',
  },
  {
    Code: 'ETA',
    Description: 'ETA',
  },
  {
    Code: 'ETH',
    Description: 'ETHERWAN',
  },
  {
    Code: 'EUR',
    Description: 'EUREKA',
  },
  {
    Code: 'EV1',
    Description: 'EVER VISION',
  },
  {
    Code: 'EV2',
    Description: 'EVEREX',
  },
  {
    Code: 'EXP',
    Description: 'EXPRESS',
  },
  {
    Code: 'EXT',
    Description: 'EXTRON',
  },
  {
    Code: 'EXX',
    Description: 'EXXIS',
  },
  {
    Code: 'EX1',
    Description: 'EXABYTE',
  },
  {
    Code: 'EX2',
    Description: 'EXAKTA',
  },
  {
    Code: 'EX3',
    Description: 'EXECUTIVE',
  },
  {
    Code: 'EX4',
    Description: 'EXECUTONE',
  },
  {
    Code: 'EYE',
    Description: 'EYECOM',
  },
  {
    Code: 'EYR',
    Description: 'EYRETEL',
  },
  {
    Code: 'EZG',
    Description: 'EZGO',
  },
  {
    Code: 'E6',
    Description: 'E6',
  },
  {
    Code: 'F&A',
    Description: 'F&A APPLIANCE',
  },
  {
    Code: 'F&B',
    Description: 'F&B APPLIANCE',
  },
  {
    Code: 'FAI',
    Description: 'FAIRBANKS',
  },
  {
    Code: 'FAL',
    Description: 'FALCON',
  },
  {
    Code: 'FAS',
    Description: 'FASTENAL',
  },
  {
    Code: 'FA1',
    Description: 'FASCO',
  },
  {
    Code: 'FED',
    Description: 'FEDDERS',
  },
  {
    Code: 'FEM',
    Description: 'FEMO MANUFACTURING',
  },
  {
    Code: 'FER',
    Description: 'FERRUPS',
  },
  {
    Code: 'FE1',
    Description: 'FELLOWES',
  },
  {
    Code: 'FE2',
    Description: 'FELLOWS',
  },
  {
    Code: 'FIR',
    Description: 'FIRE KING',
  },
  {
    Code: 'FI1',
    Description: 'FISCHER',
  },
  {
    Code: 'FI2',
    Description: 'FISHER',
  },
  {
    Code: 'FI3',
    Description: 'FISHER SCIENFIC',
  },
  {
    Code: 'FI4',
    Description: 'FISHER SCIENT',
  },
  {
    Code: 'FI5',
    Description: 'FISHER SCIENTIFIC',
  },
  {
    Code: 'FI6',
    Description: 'FISHER SENTIFIC',
  },
  {
    Code: 'FI7',
    Description: 'FISHERSCIENTFIC',
  },
  {
    Code: 'FI8',
    Description: 'FISHERSCIENTIFC',
  },
  {
    Code: 'FI9',
    Description: 'FISHES SCIENT',
  },
  {
    Code: 'FL',
    Description: 'FL ANDERSON',
  },
  {
    Code: 'FLU',
    Description: 'FLUKE',
  },
  {
    Code: 'FL1',
    Description: 'FLEXSTATION/XXI',
  },
  {
    Code: 'FL2',
    Description: 'FLEXSTEEL',
  },
  {
    Code: 'FM1',
    Description: 'FM 1100',
  },
  {
    Code: 'FN1',
    Description: 'FENDER',
  },
  {
    Code: 'FN2',
    Description: 'FENTON',
  },
  {
    Code: 'FOC',
    Description: 'FOCUS',
  },
  {
    Code: 'FOL',
    Description: 'FOLCOMER EQUIP',
  },
  {
    Code: 'FOR',
    Description: 'FOR',
  },
  {
    Code: 'FOX',
    Description: 'FOXBORO',
  },
  {
    Code: 'FO1',
    Description: 'FORA',
  },
  {
    Code: 'FRA',
    Description: 'FRANK PARSONS',
  },
  {
    Code: 'FRC',
    Description: 'FRC',
  },
  {
    Code: 'FRG',
    Description: 'FRIGIDAIRE',
  },
  {
    Code: 'FRI',
    Description: 'FRIDEN',
  },
  {
    Code: 'FR1',
    Description: 'FERGUSON CORP',
  },
  {
    Code: 'FR2',
    Description: 'FERGUSON TRENCH',
  },
  {
    Code: 'FT1',
    Description: 'FUTRA',
  },
  {
    Code: 'FT2',
    Description: 'FUTURA',
  },
  {
    Code: 'FT3',
    Description: 'FUTURE POWER',
  },
  {
    Code: 'FUJ',
    Description: 'FUJI',
  },
  {
    Code: 'FU1',
    Description: 'FUJITSU',
  },
  {
    Code: 'GAL',
    Description: 'GALLANT',
  },
  {
    Code: 'GAM',
    Description: 'GARMIN',
  },
  {
    Code: 'GAR',
    Description: 'GARRETT',
  },
  {
    Code: 'GAS',
    Description: 'GAS TEC',
  },
  {
    Code: 'GA1',
    Description: 'GALLS',
  },
  {
    Code: 'GB1',
    Description: 'GBC',
  },
  {
    Code: 'GB2',
    Description: 'GBC BATES',
  },
  {
    Code: 'GB3',
    Description: 'GBC-DOC SEAL',
  },
  {
    Code: 'GCC',
    Description: 'GCCTECH',
  },
  {
    Code: 'GE',
    Description: 'GE',
  },
  {
    Code: 'GEM',
    Description: 'GEM',
  },
  {
    Code: 'GE1',
    Description: 'GENDATACOM',
  },
  {
    Code: 'GE2',
    Description: 'GENERAL DATA',
  },
  {
    Code: 'GE3',
    Description: 'GENERAL ELECT',
  },
  {
    Code: 'GE4',
    Description: 'GENERAL RADIO',
  },
  {
    Code: 'GE5',
    Description: 'GENIUS',
  },
  {
    Code: 'GF',
    Description: 'GF',
  },
  {
    Code: 'GIL',
    Description: 'GILSON',
  },
  {
    Code: 'GIT',
    Description: 'GITZO',
  },
  {
    Code: 'GLA',
    Description: 'GLASS',
  },
  {
    Code: 'GL1',
    Description: 'GLOBAL',
  },
  {
    Code: 'GL2',
    Description: 'GLOBE',
  },
  {
    Code: 'GOO',
    Description: 'GOODMAN',
  },
  {
    Code: 'GOR',
    Description: 'GOOD ROADS',
  },
  {
    Code: 'GOT',
    Description: 'GOTCHA COVERED',
  },
  {
    Code: 'GO1',
    Description: 'GOLDEN CREST',
  },
  {
    Code: 'GO2',
    Description: 'GOLDSTAR',
  },
  {
    Code: 'GRI',
    Description: 'GRID',
  },
  {
    Code: 'GR1',
    Description: 'GRAINGER',
  },
  {
    Code: 'GR2',
    Description: 'GRAINGER',
  },
  {
    Code: 'GR3',
    Description: 'GRAMPATTON',
  },
  {
    Code: 'GR4',
    Description: 'GRAPHTEC',
  },
  {
    Code: 'GR5',
    Description: 'GRASS VALLEY',
  },
  {
    Code: 'GR6',
    Description: 'GRAYAUDOGRAPH',
  },
  {
    Code: 'GR7',
    Description: 'GRAYBAR',
  },
  {
    Code: 'GSC',
    Description: 'GARDALL SAFE CORP',
  },
  {
    Code: 'GSP',
    Description: 'GSP',
  },
  {
    Code: 'GTC',
    Description: 'GTCO',
  },
  {
    Code: 'GT1',
    Description: 'GATEWAY',
  },
  {
    Code: 'GT2',
    Description: 'GATEWAY',
  },
  {
    Code: 'GT3',
    Description: 'GATEWAY2000',
  },
  {
    Code: 'GOV',
    Description: 'GOVCONNECTION'
  },
  {
    Code: 'GUA',
    Description: 'GUARDALL',
  },
  {
    Code: 'GUI',
    Description: 'GUIDANCE SOFTWA',
  },
  {
    Code: 'GUN',
    Description: 'GUNLOCKE',
  },
  {
    Code: 'GVC',
    Description: 'GVC',
  },
  {
    Code: 'GX1',
    Description: 'GX 150',
  },
  {
    Code: 'GX2',
    Description: 'GX 200',
  },
  {
    Code: 'HAC',
    Description: 'HACH',
  },
  {
    Code: 'HAI',
    Description: 'HAI',
  },
  {
    Code: 'HAL',
    Description: 'HALL',
  },
  {
    Code: 'HAM',
    Description: 'HAMILTON',
  },
  {
    Code: 'HAR',
    Description: 'HARMON/KARDON',
  },
  {
    Code: 'HAS',
    Description: 'HASKELL',
  },
  {
    Code: 'HAT',
    Description: 'HATACHI',
  },
  {
    Code: 'HAW',
    Description: 'HAWORTH',
  },
  {
    Code: 'HAY',
    Description: 'HAYES',
  },
  {
    Code: 'HA1',
    Description: 'HAIBC',
  },
  {
    Code: 'HA2',
    Description: 'HAMMER',
  },
  {
    Code: 'HA3',
    Description: 'HARVARD',
  },
  {
    Code: 'HA4',
    Description: 'HAWORTH',
  },
  {
    Code: 'HA5',
    Description: 'HAWTHORNE',
  },
  {
    Code: 'HA6',
    Description: 'HAYWORTH',
  },
  {
    Code: 'HBF',
    Description: 'HBF',
  },
  {
    Code: 'HEA',
    Description: 'HEALTHOMETER',
  },
  {
    Code: 'HEL',
    Description: 'HELLEMS',
  },
  {
    Code: 'HEN',
    Description: 'HENNING',
  },
  {
    Code: 'HER',
    Description: 'HERMAN MILLER',
  },
  {
    Code: 'HE1',
    Description: 'HEWLETT PACK',
  },
  {
    Code: 'HE2',
    Description: 'HEWLETT PACKARD',
  },
  {
    Code: 'HE3',
    Description: 'HELI-FLEX',
  },
  {
    Code: 'HIL',
    Description: 'HILLSIDE',
  },
  {
    Code: 'HIT',
    Description: 'HITACHI',
  },
  {
    Code: 'HOB',
    Description: 'HOBART',
  },
  {
    Code: 'HOE',
    Description: 'HOERFER',
  },
  {
    Code: 'HOG',
    Description: 'HOGENTOGLER',
  },
  {
    Code: 'HOM',
    Description: 'HOMELITE',
  },
  {
    Code: 'HON',
    Description: 'HON',
  },
  {
    Code: 'HOO',
    Description: 'HOOVER',
  },
  {
    Code: 'HOP',
    Description: 'HOPE',
  },
  {
    Code: 'HOW',
    Description: 'HOWE',
  },
  {
    Code: 'HO1',
    Description: 'HOT SHAKER',
  },
  {
    Code: 'HO2',
    Description: 'HOTPACK',
  },
  {
    Code: 'HO3',
    Description: 'HOTPOINT',
  },
  {
    Code: 'HO4',
    Description: 'HONDA',
  },
  {
    Code: 'HO5',
    Description: 'HOMAK',
  },
  {
    Code: 'HPE',
    Description: 'HPERDATA',
  },
  {
    Code: 'HP1',
    Description: 'HP',
  },
  {
    Code: 'HP3',
    Description: 'HP C5876A',
  },
  {
    Code: 'HP4',
    Description: 'HP II',
  },
  {
    Code: 'HP5',
    Description: 'HP LASERJET',
  },
  {
    Code: 'HP6',
    Description: 'HP NET SERVER',
  },
  {
    Code: 'HSI',
    Description: 'HSI',
  },
  {
    Code: 'HTS',
    Description: 'HTS',
  },
  {
    Code: 'HUD',
    Description: 'HUDSON',
  },
  {
    Code: 'HUK',
    Description: 'HUSKEE',
  },
  {
    Code: 'HUL',
    Description: 'HULL',
  },
  {
    Code: 'HUM',
    Description: 'HUMBOLT',
  },
  {
    Code: 'HUQ',
    Description: 'HUSQURNA',
  },
  {
    Code: 'HUS',
    Description: 'HUSKY',
  },
  {
    Code: 'HV2',
    Description: 'HV2000000LE',
  },
  {
    Code: 'HYA',
    Description: 'HYAMA',
  },
  {
    Code: 'HYW',
    Description: 'HONEYWELL',
  },
  {
    Code: 'HY1',
    Description: 'HYPER',
  },
  {
    Code: 'HY2',
    Description: 'HYPERDATA',
  },
  {
    Code: 'HY3',
    Description: 'HYTHERMCO',
  },
  {
    Code: 'HY4',
    Description: 'HYTHERMOCO',
  },
  {
    Code: 'HY5',
    Description: 'HYUNDAI',
  },
  {
    Code: 'IBI',
    Description: 'IBICO',
  },
  {
    Code: 'IBM',
    Description: 'IBM',
  },
  {
    Code: 'IB1',
    Description: 'IBM THINK PAD',
  },
  {
    Code: 'ICE',
    Description: 'ICEOMATIC',
  },
  {
    Code: 'IDE',
    Description: 'IDENTATRONICS',
  },
  {
    Code: 'IDM',
    Description: 'IDM',
  },
  {
    Code: 'IGS',
    Description: 'IGS',
  },
  {
    Code: 'IG1',
    Description: 'INGERSOLL-RAND1',
  },
  {
    Code: 'IKE',
    Description: 'IKEA',
  },
  {
    Code: 'ILC',
    Description: 'ILCO',
  },
  {
    Code: 'IMA',
    Description: 'IMAGIC',
  },
  {
    Code: 'IMG',
    Description: 'IMG',
  },
  {
    Code: 'IMP',
    Description: 'IMPACT DISPLAYS',
  },
  {
    Code: 'IMT',
    Description: 'IMTECH',
  },
  {
    Code: 'IM1',
    Description: 'IMPRESSION',
  },
  {
    Code: 'INC',
    Description: 'INTERIOR CONNECTIONS',
  },
  {
    Code: 'IND',
    Description: 'INDESIT',
  },
  {
    Code: 'INE',
    Description: 'INTERMEC',
  },
  {
    Code: 'INF',
    Description: 'INFOCOMP',
  },
  {
    Code: 'ING',
    Description: 'INGERSOLL-RAND',
  },
  {
    Code: 'INN',
    Description: 'INNOVATION',
  },
  {
    Code: 'INS',
    Description: 'INSPIRON',
  },
  {
    Code: 'INT',
    Description: 'INTEGRAPH',
  },
  {
    Code: 'INV',
    Description: 'INVINCIBLE',
  },
  {
    Code: 'IN1',
    Description: 'INDIAN DESK',
  },
  {
    Code: 'IN2',
    Description: 'INDIANA DESK',
  },
  {
    Code: 'IN3',
    Description: 'INFOCUS',
  },
  {
    Code: 'IN4',
    Description: 'INFORMATION PRO',
  },
  {
    Code: 'IN5',
    Description: 'INFOSTAR',
  },
  {
    Code: 'IN6',
    Description: 'INSIGHT'
  },
  {
    Code: 'IOG',
    Description: 'IOGEAR',
  },
  {
    Code: 'IOM',
    Description: 'IOMEGA',
  },
  {
    Code: 'IO1',
    Description: 'ISOETECH',
  },
  {
    Code: 'ISC',
    Description: 'INDUSTRIAL SCIENTIFIC',
  },
  {
    Code: 'ISO',
    Description: 'ISOETEC',
  },
  {
    Code: 'IS1',
    Description: 'INSPIRONS',
  },
  {
    Code: 'IT1',
    Description: 'INTEGRITY',
  },
  {
    Code: 'IT2',
    Description: 'INTEL',
  },
  {
    Code: 'IT3',
    Description: 'INTELIFAX',
  },
  {
    Code: 'IT4',
    Description: 'INTERACTIVE',
  },
  {
    Code: 'IT5',
    Description: 'INTERGRAPH',
  },
  {
    Code: 'IT6',
    Description: 'INTERIOR SCIENCE',
  },
  {
    Code: 'IT7',
    Description: 'INTERLAKE',
  },
  {
    Code: 'IT8',
    Description: 'INTERNATIONAL',
  },
  {
    Code: 'IT9',
    Description: 'INTERNATL OFF',
  },
  {
    Code: 'I10',
    Description: 'INTERNATLOFFICE',
  },
  {
    Code: 'I11',
    Description: 'INTERROYAL',
  },
  {
    Code: 'I12',
    Description: 'INTOXIMETER',
  },
  {
    Code: 'J H',
    Description: 'J H BURKE',
  },
  {
    Code: 'J P',
    Description: 'J P FULLER',
  },
  {
    Code: 'JAS',
    Description: 'JASPER',
  },
  {
    Code: 'JAV',
    Description: 'JAVELIN',
  },
  {
    Code: 'JBL',
    Description: 'JBL',
  },
  {
    Code: 'JCM',
    Description: 'JCM',
  },
  {
    Code: 'JE',
    Description: 'JE ADAMS',
  },
  {
    Code: 'JEM',
    Description: 'JEMS',
  },
  {
    Code: 'JES',
    Description: 'JES934WY001',
  },
  {
    Code: 'JL',
    Description: 'JL',
  },
  {
    Code: 'JM1',
    Description: 'JEMSNI',
  },
  {
    Code: 'JOH',
    Description: 'JOHN DEERE',
  },
  {
    Code: 'JOR',
    Description: 'JORDAN',
  },
  {
    Code: 'JP',
    Description: 'JP FULLER',
  },
  {
    Code: 'JR1',
    Description: 'JORDON',
  },
  {
    Code: 'JTX',
    Description: 'JTX',
  },
  {
    Code: 'JVC',
    Description: 'JVC',
  },
  {
    Code: 'KAH',
    Description: 'KAHLON',
  },
  {
    Code: 'KAR',
    Description: 'KARDEX',
  },
  {
    Code: 'KDS',
    Description: 'KDS',
  },
  {
    Code: 'KD1',
    Description: 'KODAC',
  },
  {
    Code: 'KEI',
    Description: 'KEILHAUER',
  },
  {
    Code: 'KEL',
    Description: 'KEILHAVEN',
  },
  {
    Code: 'KEM',
    Description: 'KEM PONENT',
  },
  {
    Code: 'KEN',
    Description: 'KENMORE',
  },
  {
    Code: 'KEY',
    Description: 'KEYNOTE',
  },
  {
    Code: 'KE1',
    Description: 'KENINGTON',
  },
  {
    Code: 'KE2',
    Description: 'KENSINGTON',
  },
  {
    Code: 'KE3',
    Description: 'KENT',
  },
  {
    Code: 'KFC',
    Description: 'KFC',
  },
  {
    Code: 'KI',
    Description: 'KI',
  },
  {
    Code: 'KI/',
    Description: 'KI/VERSA',
  },
  {
    Code: 'KIC',
    Description: 'KICHEK',
  },
  {
    Code: 'KIH',
    Description: 'KEIL HAVEN',
  },
  {
    Code: 'KIM',
    Description: 'KIMBALL',
  },
  {
    Code: 'KIN',
    Description: 'KINDERPRINT',
  },
  {
    Code: 'KNO',
    Description: 'KNOX',
  },
  {
    Code: 'KN1',
    Description: 'KING ARTHUR',
  },
  {
    Code: 'KN2',
    Description: 'KINYO',
  },
  {
    Code: 'KO',
    Description: 'KONICA',
  },
  {
    Code: 'KOB',
    Description: 'KOBRA',
  },
  {
    Code: 'KOC',
    Description: 'KOCHEK',
  },
  {
    Code: 'KOD',
    Description: 'KODAK',
  },
  {
    Code: 'KOS',
    Description: 'KOSS',
  },
  {
    Code: 'KRA',
    Description: 'KRAMER',
  },
  {
    Code: 'KRC',
    Description: 'KARCHER',
  },
  {
    Code: 'KRO',
    Description: 'KROY',
  },
  {
    Code: 'KUN',
    Description: 'KUNTZ',
  },
  {
    Code: 'KUR',
    Description: 'KURZWEIL',
  },
  {
    Code: 'KV',
    Description: 'KV',
  },
  {
    Code: 'L A',
    Description: 'L AND L',
  },
  {
    Code: 'L+L',
    Description: 'L+L KILN',
  },
  {
    Code: 'LA-',
    Description: 'LA-Z Boy',
  },
  {
    Code: 'LAB',
    Description: 'LABCONCO',
  },
  {
    Code: 'LAC',
    Description: 'LACIE',
  },
  {
    Code: 'LAE',
    Description: 'LAERDAL',
  },
  {
    Code: 'LAF',
    Description: 'LAFAYETTE',
  },
  {
    Code: 'LAM',
    Description: 'LAMINEX',
  },
  {
    Code: 'LAN',
    Description: 'LANDA',
  },
  {
    Code: 'LAS',
    Description: 'LASERNET',
  },
  {
    Code: 'LAZ',
    Description: 'LAZYBOY',
  },
  {
    Code: 'LA1',
    Description: 'LABLINE',
  },
  {
    Code: 'LA2',
    Description: 'LABTECH',
  },
  {
    Code: 'LA3',
    Description: 'LANDTEC',
  },
  {
    Code: 'LA4',
    Description: 'LANIER',
  },
  {
    Code: 'LA5',
    Description: 'LANIER',
  },
  {
    Code: 'LEA',
    Description: 'LEADER',
  },
  {
    Code: 'LEC',
    Description: 'LECIA',
  },
  {
    Code: 'LEG',
    Description: 'LEGACY',
  },
  {
    Code: 'LEI',
    Description: 'LEITZ',
  },
  {
    Code: 'LEX',
    Description: 'LEX MARK',
  },
  {
    Code: 'LE1',
    Description: 'LEADING',
  },
  {
    Code: 'LE2',
    Description: 'LEARDAL',
  },
  {
    Code: 'LE3',
    Description: 'LEADING EDGE',
  },
  {
    Code: 'LFN',
    Description: 'LIFE FITNESS',
  },
  {
    Code: 'LGE',
    Description: 'LG ELECTRONICS',
  },
  {
    Code: 'LG1',
    Description: 'LIGHTWARE',
  },
  {
    Code: 'LG5',
    Description: 'LG52X',
  },
  {
    Code: 'LIB',
    Description: 'LIBEC',
  },
  {
    Code: 'LIE',
    Description: 'LIEBERT',
  },
  {
    Code: 'LIG',
    Description: 'LIGHT STREAM',
  },
  {
    Code: 'LII',
    Description: 'LI ION',
  },
  {
    Code: 'LIN',
    Description: 'LINBERG',
  },
  {
    Code: 'LIT',
    Description: 'LITTON',
  },
  {
    Code: 'LI1',
    Description: 'LINCOLN',
  },
  {
    Code: 'LM1',
    Description: 'LAMOTTE',
  },
  {
    Code: 'LN1',
    Description: 'LINDBERG',
  },
  {
    Code: 'LN2',
    Description: 'LINDSEY',
  },
  {
    Code: 'LN3',
    Description: 'LINK',
  },
  {
    Code: 'LN4',
    Description: 'LANTRONIX',
  },
  {
    Code: 'LOU',
    Description: 'LOUROE',
  },
  {
    Code: 'LOW',
    Description: 'LOWEL',
  },
  {
    Code: 'LP',
    Description: 'LP',
  },
  {
    Code: 'LUM',
    Description: 'LUMA',
  },
  {
    Code: 'LW1',
    Description: 'LOWELL',
  },
  {
    Code: 'LXI',
    Description: 'LXI',
  },
  {
    Code: 'LX1',
    Description: 'LEXMARCH',
  },
  {
    Code: 'LX2',
    Description: 'LEXMARK',
  },
  {
    Code: 'LYN',
    Description: 'LYNK',
  },
  {
    Code: 'LYO',
    Description: 'LYON',
  },
  {
    Code: 'LY1',
    Description: 'LYNX',
  },
  {
    Code: 'M W',
    Description: 'M WARD',
  },
  {
    Code: 'MAC',
    Description: 'MACGILL',
  },
  {
    Code: 'MAG',
    Description: 'MAG',
  },
  {
    Code: 'MAJ',
    Description: 'MAJESTIC',
  },
  {
    Code: 'MAK',
    Description: 'MAKITA',
  },
  {
    Code: 'MAL',
    Description: 'MALENOTTI',
  },
  {
    Code: 'MAM',
    Description: 'MAMIYA',
  },
  {
    Code: 'MAN',
    Description: 'MANITOWAC',
  },
  {
    Code: 'MAR',
    Description: 'MARANTZ',
  },
  {
    Code: 'MAT',
    Description: 'MATH',
  },
  {
    Code: 'MAW',
    Description: 'MAWTECH',
  },
  {
    Code: 'MAX',
    Description: 'MAX TECH',
  },
  {
    Code: 'MA1',
    Description: 'MACKIE',
  },
  {
    Code: 'MA2',
    Description: 'MAGIC CHEF',
  },
  {
    Code: 'MA3',
    Description: 'MAGICTRONIC',
  },
  {
    Code: 'MA4',
    Description: 'MAGITRONIC',
  },
  {
    Code: 'MA5',
    Description: 'MAGNAVOX',
  },
  {
    Code: 'MA6',
    Description: 'MAGNUM',
  },
  {
    Code: 'MA7',
    Description: 'MANITOWOC',
  },
  {
    Code: 'MA8',
    Description: 'MANNESMAN TALLY',
  },
  {
    Code: 'MB',
    Description: 'MB',
  },
  {
    Code: 'MBC',
    Description: 'MBC',
  },
  {
    Code: 'MBM',
    Description: 'MBM',
  },
  {
    Code: 'MC/',
    Description: 'MC/DOUGLAS',
  },
  {
    Code: 'MCC',
    Description: 'MCCORMICK',
  },
  {
    Code: 'MCE',
    Description: 'MCENROE',
  },
  {
    Code: 'MCO',
    Description: 'MCO',
  },
  {
    Code: 'MC1',
    Description: 'MICROTECK',
  },
  {
    Code: 'MC2',
    Description: 'MICROTEK',
  },
  {
    Code: 'MC3',
    Description: 'MICROTOX',
  },
  {
    Code: 'MD1',
    Description: 'MIDLAND',
  },
  {
    Code: 'MED',
    Description: 'MEDICAL LABS',
  },
  {
    Code: 'MEM',
    Description: 'MEMOREX',
  },
  {
    Code: 'MES',
    Description: 'MEDTRONICS',
  },
  {
    Code: 'MET',
    Description: 'METAL-TAC',
  },
  {
    Code: 'MEY',
    Description: 'MEYR',
  },
  {
    Code: 'MGA',
    Description: 'MGA',
  },
  {
    Code: 'MGE',
    Description: 'MAGELLAN',
  },
  {
    Code: 'MIC',
    Description: 'MICOM',
  },
  {
    Code: 'MID',
    Description: 'MID ATLANTIC',
  },
  {
    Code: 'MIL',
    Description: 'MILLER',
  },
  {
    Code: 'MIN',
    Description: 'MINERALIGHT',
  },
  {
    Code: 'MIR',
    Description: 'MIRACLE',
  },
  {
    Code: 'MIS',
    Description: 'MISONIX',
  },
  {
    Code: 'MIT',
    Description: 'MITA',
  },
  {
    Code: 'MI1',
    Description: 'MICRO DESIGN',
  },
  {
    Code: 'MI2',
    Description: 'MICRO FERRUPS',
  },
  {
    Code: 'MI3',
    Description: 'MICRO MASTER',
  },
  {
    Code: 'MI4',
    Description: 'MICRO SOLUTIONS',
  },
  {
    Code: 'MI5',
    Description: 'MICROFERRUPS',
  },
  {
    Code: 'MI6',
    Description: 'MICROLAG',
  },
  {
    Code: 'MI7',
    Description: 'MICROLOG',
  },
  {
    Code: 'MI8',
    Description: 'MICRON',
  },
  {
    Code: 'MI9',
    Description: 'MICROTEC',
  },
  {
    Code: 'MLD',
    Description: 'MLD Seating',
  },
  {
    Code: 'ML1',
    Description: 'MILTON ROY',
  },
  {
    Code: 'MM1',
    Description: 'MEMOREX TELEX',
  },
  {
    Code: 'MN1',
    Description: 'Minolta',
  },
  {
    Code: 'MN2',
    Description: 'Minolta Camera Co',
  },
  {
    Code: 'MN3',
    Description: 'MINUTEMAN',
  },
  {
    Code: 'MOD',
    Description: 'MODERN',
  },
  {
    Code: 'MON',
    Description: 'MONARCH',
  },
  {
    Code: 'MOO',
    Description: 'MOORE',
  },
  {
    Code: 'MOP',
    Description: 'MOPET',
  },
  {
    Code: 'MOS',
    Description: 'MICROSOFT',
  },
  {
    Code: 'MOT',
    Description: 'MOTOROLA',
  },
  {
    Code: 'MOU',
    Description: 'MOUNTAIN',
  },
  {
    Code: 'MO1',
    Description: 'MONTANA',
  },
  {
    Code: 'MO2',
    Description: 'MONTGOMERY WARD',
  },
  {
    Code: 'MO3',
    Description: 'MONORAIL',
  },
  {
    Code: 'MO4',
    Description: 'MOTRO',
  },
  {
    Code: 'MO5',
    Description: 'MOTION COMPUTING',
  },
  {
    Code: 'MPC',
    Description: 'MPC2',
  },
  {
    Code: 'MR.',
    Description: 'MR. COFFEE',
  },
  {
    Code: 'MR1',
    Description: 'MARKET FORGE',
  },
  {
    Code: 'MR2',
    Description: 'MARKETFORGE',
  },
  {
    Code: 'MR3',
    Description: 'MARTI',
  },
  {
    Code: 'MR4',
    Description: 'MARTIN YALE',
  },
  {
    Code: 'MR5',
    Description: 'MARVEL',
  },
  {
    Code: 'MR6',
    Description: 'Mirats',
  },
  {
    Code: 'MSA',
    Description: 'MSA',
  },
  {
    Code: 'MSI',
    Description: 'MSI',
  },
  {
    Code: 'MT1',
    Description: 'MATHESON',
  },
  {
    Code: 'MT2',
    Description: 'Matthews',
  },
  {
    Code: 'MT3',
    Description: 'Metrotech',
  },
  {
    Code: 'MT4',
    Description: 'METTLER',
  },
  {
    Code: 'MT5',
    Description: 'Metoschnitt',
  },
  {
    Code: 'MT6',
    Description: 'MITSUBA',
  },
  {
    Code: 'MT7',
    Description: 'METRO',
  },
  {
    Code: 'MT8',
    Description: 'MITSUBISHI',
  },
  {
    Code: 'MUL',
    Description: 'MULTIGRAPHIC',
  },
  {
    Code: 'MUR',
    Description: 'MURATA',
  },
  {
    Code: 'MU1',
    Description: 'MULTIGRAPHICS',
  },
  {
    Code: 'MU2',
    Description: 'MULTITECH',
  },
  {
    Code: 'MX1',
    Description: 'Maxtech',
  },
  {
    Code: 'MX2',
    Description: 'Maxtor',
  },
  {
    Code: 'M1L',
    Description: 'Milwaukee',
  },
  {
    Code: 'N/A',
    Description: 'N/A',
  },
  {
    Code: 'NA',
    Description: 'NA',
  },
  {
    Code: 'NAC',
    Description: 'NACH',
  },
  {
    Code: 'NAN',
    Description: 'Nanao',
  },
  {
    Code: 'NAP',
    Description: 'NAPCO',
  },
  {
    Code: 'NAT',
    Description: 'National',
  },
  {
    Code: 'NA1',
    Description: 'NANOA',
  },
  {
    Code: 'NA2',
    Description: 'National Saybrook',
  },
  {
    Code: 'NA3',
    Description: 'National Timerlane',
  },
  {
    Code: 'NBA',
    Description: 'NBASE',
  },
  {
    Code: 'NCR',
    Description: 'NCR',
  },
  {
    Code: 'NCS',
    Description: 'NCS Pearson',
  },
  {
    Code: 'NEC',
    Description: 'NEC',
  },
  {
    Code: 'NEO',
    Description: 'Neopost',
  },
  {
    Code: 'NEW',
    Description: 'NEW',
  },
  {
    Code: 'NE1',
    Description: 'New Hermes',
  },
  {
    Code: 'NE2',
    Description: 'NEWBRIDGE',
  },
  {
    Code: 'NIC',
    Description: 'NICOLET',
  },
  {
    Code: 'NIK',
    Description: 'Nikon',
  },
  {
    Code: 'NIS',
    Description: 'NISSEN',
  },
  {
    Code: 'NOK',
    Description: 'NOKIA',
  },
  {
    Code: 'NON',
    Description: 'NONE',
  },
  {
    Code: 'NOR',
    Description: 'NORELCO',
  },
  {
    Code: 'NOT',
    Description: 'NOTEBOOK',
  },
  {
    Code: 'NOW',
    Description: 'Now',
  },
  {
    Code: 'NO1',
    Description: 'Norix',
  },
  {
    Code: 'NO2',
    Description: 'NORMAN',
  },
  {
    Code: 'NO3',
    Description: 'Norson',
  },
  {
    Code: 'NO4',
    Description: 'NORTHGATE',
  },
  {
    Code: 'NO5',
    Description: 'NORTHLAND',
  },
  {
    Code: 'NO6',
    Description: 'NORTHWEST',
  },
  {
    Code: 'NO7',
    Description: 'Notestar',
  },
  {
    Code: 'NO8',
    Description: 'Notrix',
  },
  {
    Code: 'NPC',
    Description: 'NPC',
  },
  {
    Code: 'NUA',
    Description: 'NUARK',
  },
  {
    Code: 'OCE',
    Description: 'OCE',
  },
  {
    Code: 'OC1',
    Description: 'Ocean View',
  },
  {
    Code: 'OFF',
    Description: 'Office Depot',
  },
  {
    Code: 'OF1',
    Description: 'Office Specialty',
  },
  {
    Code: 'OHA',
    Description: 'OHAUS',
  },
  {
    Code: 'OKI',
    Description: 'OKI',
  },
  {
    Code: 'OK1',
    Description: 'Okidata 10I',
  },
  {
    Code: 'OK2',
    Description: 'Okijet',
  },
  {
    Code: 'OLY',
    Description: 'OLYMPUS',
  },
  {
    Code: 'OME',
    Description: 'Omega',
  },
  {
    Code: 'OMN',
    Description: 'Omni',
  },
  {
    Code: 'OM1',
    Description: 'Omni Fax',
  },
  {
    Code: 'OM2',
    Description: 'Omnibook',
  },
  {
    Code: 'OM3',
    Description: 'OMNICHROME',
  },
  {
    Code: 'OM4',
    Description: 'OMNICRON',
  },
  {
    Code: 'OM5',
    Description: 'Omnifax',
  },
  {
    Code: 'ONA',
    Description: 'Onan',
  },
  {
    Code: 'ONE',
    Description: 'ONEAC',
  },
  {
    Code: 'OPT',
    Description: 'OPTIMA',
  },
  {
    Code: 'OP1',
    Description: 'Optimus',
  },
  {
    Code: 'OP2',
    Description: 'OPTIQUEST',
  },
  {
    Code: 'ORA',
    Description: 'ORAPER',
  },
  {
    Code: 'ORI',
    Description: 'ORION',
  },
  {
    Code: 'OVL',
    Description: 'Ovlo',
  },
  {
    Code: 'PAC',
    Description: 'Packard Bell',
  },
  {
    Code: 'PAL',
    Description: 'Palm',
  },
  {
    Code: 'PAN',
    Description: 'PANASONIC',
  },
  {
    Code: 'PAO',
    Description: 'Paoli',
  },
  {
    Code: 'PAR',
    Description: 'PARADRIVE',
  },
  {
    Code: 'PAS',
    Description: 'PASO',
  },
  {
    Code: 'PAT',
    Description: 'Patrician',
  },
  {
    Code: 'PA2',
    Description: 'PANAVOICE',
  },
  {
    Code: 'PA3',
    Description: 'Paragon',
  },
  {
    Code: 'PC',
    Description: 'PC',
  },
  {
    Code: 'PC1',
    Description: 'PC MIGHT',
  },
  {
    Code: 'PC3',
    Description: 'PC353',
  },
  {
    Code: 'PEA',
    Description: 'Pearl Corder',
  },
  {
    Code: 'PED',
    Description: 'PEDRO',
  },
  {
    Code: 'PEI',
    Description: 'PELICAN',
  },
  {
    Code: 'PEL',
    Description: 'PELCO',
  },
  {
    Code: 'PEN',
    Description: 'PENRIL',
  },
  {
    Code: 'PER',
    Description: 'PERCIVAL SCI.',
  },
  {
    Code: 'PET',
    Description: 'PETER PEPPER',
  },
  {
    Code: 'PE1',
    Description: 'PEAVY',
  },
  {
    Code: 'PE2',
    Description: 'PENTAX',
  },
  {
    Code: 'PE4',
    Description: 'PERKIN ELMER',
  },
  {
    Code: 'PHA',
    Description: 'PHARMACIA',
  },
  {
    Code: 'PHI',
    Description: 'PHILIPS',
  },
  {
    Code: 'PHO',
    Description: 'PHONEMATE',
  },
  {
    Code: 'PHY',
    Description: 'Physio Control Corp',
  },
  {
    Code: 'PH1',
    Description: 'Phillips',
  },
  {
    Code: 'PH2',
    Description: 'PHISIOCONTROL',
  },
  {
    Code: 'PIO',
    Description: 'PIONEER',
  },
  {
    Code: 'PIT',
    Description: 'Pitney Bowes',
  },
  {
    Code: 'PIX',
    Description: 'PIXIE',
  },
  {
    Code: 'PI1',
    Description: 'PIONEX',
  },
  {
    Code: 'PLA',
    Description: 'PLANET',
  },
  {
    Code: 'PLE',
    Description: 'PERLE',
  },
  {
    Code: 'PLN',
    Description: 'PLANAR',
  },
  {
    Code: 'PL1',
    Description: 'PLANHOLD',
  },
  {
    Code: 'PL2',
    Description: 'Platopan',
  },
  {
    Code: 'PL3',
    Description: 'PLAYMATE',
  },
  {
    Code: 'POL',
    Description: 'POLARIOD',
  },
  {
    Code: 'POU',
    Description: 'Poulan',
  },
  {
    Code: 'POW',
    Description: 'POWER',
  },
  {
    Code: 'PO1',
    Description: 'Polycom, Inc',
  },
  {
    Code: 'PO2',
    Description: 'Pollard',
  },
  {
    Code: 'PO4',
    Description: 'PORTER',
  },
  {
    Code: 'PO5',
    Description: 'Porter Lee',
  },
  {
    Code: 'PO6',
    Description: 'PORTO CLINIC',
  },
  {
    Code: 'PO7',
    Description: 'Power Edge',
  },
  {
    Code: 'PO8',
    Description: 'Power Plus',
  },
  {
    Code: 'PO9',
    Description: 'POWERHOUSE',
  },
  {
    Code: 'PRA',
    Description: 'PRACTICAL',
  },
  {
    Code: 'PRE',
    Description: 'PRECISION',
  },
  {
    Code: 'PRI',
    Description: 'PRIMESTAR',
  },
  {
    Code: 'PRM',
    Description: 'PRICE MODERN',
  },
  {
    Code: 'PRO',
    Description: 'PROCORP',
  },
  {
    Code: 'PRT',
    Description: 'PRTEC',
  },
  {
    Code: 'PR1',
    Description: 'PRATICAL',
  },
  {
    Code: 'PR2',
    Description: 'Premier',
  },
  {
    Code: 'PR3',
    Description: 'Percon',
  },
  {
    Code: 'PR4',
    Description: 'PRINCETON',
  },
  {
    Code: 'PR5',
    Description: 'Pro Scout',
  },
  {
    Code: 'PR6',
    Description: 'Projector',
  },
  {
    Code: 'PR7',
    Description: 'Promaxima',
  },
  {
    Code: 'PR8',
    Description: 'Proscan',
  },
  {
    Code: 'PR9',
    Description: 'Provideo',
  },
  {
    Code: 'PSC',
    Description: 'PSC',
  },
  {
    Code: 'PT1',
    Description: 'Proto',
  },
  {
    Code: 'PUL',
    Description: 'Pullman Holt',
  },
  {
    Code: 'PW1',
    Description: 'POWERTEC',
  },
  {
    Code: 'PW2',
    Description: 'POWERWARE',
  },
  {
    Code: 'P10',
    Description: 'Proxima',
  },
  {
    Code: 'Q-L',
    Description: 'Q-Line',
  },
  {
    Code: 'QMS',
    Description: 'QMS',
  },
  {
    Code: 'QUA',
    Description: 'Quacker',
  },
  {
    Code: 'QUE',
    Description: 'QUEBEC',
  },
  {
    Code: 'QUM',
    Description: 'QUME',
  },
  {
    Code: 'QUN',
    Description: 'QUNTEX',
  },
  {
    Code: 'QU1',
    Description: 'Quaker',
  },
  {
    Code: 'QU2',
    Description: 'QUANTEX',
  },
  {
    Code: 'QU3',
    Description: 'QUARSAR',
  },
  {
    Code: 'QU4',
    Description: 'Quartet',
  },
  {
    Code: 'QU5',
    Description: 'QUASAR',
  },
  {
    Code: 'QU6',
    Description: 'QUASER',
  },
  {
    Code: 'QU7',
    Description: 'QUEST TECH',
  },
  {
    Code: 'RAC',
    Description: 'RACAL',
  },
  {
    Code: 'RAL',
    Description: 'RALEIGH',
  },
  {
    Code: 'RAM',
    Description: 'RAMFAN',
  },
  {
    Code: 'RAN',
    Description: 'RAND',
  },
  {
    Code: 'RAP',
    Description: 'RAPIDPRINT',
  },
  {
    Code: 'RAY',
    Description: 'Raytek',
  },
  {
    Code: 'RA1',
    Description: 'RACAL MILGO',
  },
  {
    Code: 'RA4',
    Description: 'RACALVADIC',
  },
  {
    Code: 'RA5',
    Description: 'RAD',
  },
  {
    Code: 'RA6',
    Description: 'RADIANT',
  },
  {
    Code: 'RA7',
    Description: 'RADIO SHACK',
  },
  {
    Code: 'RA8',
    Description: 'RADIUS',
  },
  {
    Code: 'RA9',
    Description: 'RANE',
  },
  {
    Code: 'RCA',
    Description: 'RCA',
  },
  {
    Code: 'REA',
    Description: 'REALIST',
  },
  {
    Code: 'REC',
    Description: 'RECORDEX',
  },
  {
    Code: 'RED',
    Description: 'REDI',
  },
  {
    Code: 'REF',
    Description: 'REFLEX',
  },
  {
    Code: 'REI',
    Description: 'REICHERT',
  },
  {
    Code: 'REL',
    Description: 'RELIANCE',
  },
  {
    Code: 'REN',
    Description: 'RENEX',
  },
  {
    Code: 'REP',
    Description: 'REPLAY',
  },
  {
    Code: 'RET',
    Description: 'RETFORD',
  },
  {
    Code: 'RE1',
    Description: 'REALISTIC',
  },
  {
    Code: 'RE2',
    Description: 'REALITIC',
  },
  {
    Code: 'RE3',
    Description: 'RECORTEC',
  },
  {
    Code: 'RE4',
    Description: 'REDITILT',
  },
  {
    Code: 'RE5',
    Description: 'RELISYS',
  },
  {
    Code: 'RE6',
    Description: 'RELYSIS',
  },
  {
    Code: 'RE7',
    Description: 'RELYSYS',
  },
  {
    Code: 'RE8',
    Description: 'REDMAX',
  },
  {
    Code: 'RHI',
    Description: 'RHINOTUFF',
  },
  {
    Code: 'RHO',
    Description: 'RHINO EQUIPMENT CORP',
  },
  {
    Code: 'RIC',
    Description: 'RICOH',
  },
  {
    Code: 'RID',
    Description: 'RIDGID',
  },
  {
    Code: 'RIT',
    Description: 'RITTER',
  },
  {
    Code: 'ROB',
    Description: 'ROBOT',
  },
  {
    Code: 'ROL',
    Description: 'ROLA TAPE',
  },
  {
    Code: 'ROP',
    Description: 'ROPER',
  },
  {
    Code: 'ROR',
    Description: 'RORER',
  },
  {
    Code: 'ROT',
    Description: 'ROTOMIX',
  },
  {
    Code: 'ROY',
    Description: 'ROYAL',
  },
  {
    Code: 'RO1',
    Description: 'ROLLS',
  },
  {
    Code: 'RO2',
    Description: 'ROLL-A-BENCH',
  },
  {
    Code: 'RPC',
    Description: 'RPC',
  },
  {
    Code: 'RPG',
    Description: 'RPG',
  },
  {
    Code: 'RUS',
    Description: 'RUSS BASSETT',
  },
  {
    Code: 'RU1',
    Description: 'RUSSELL',
  },
  {
    Code: 'RYO',
    Description: 'RYOBI',
  },
  {
    Code: 'SA',
    Description: 'SA',
  },
  {
    Code: 'SAE',
    Description: 'SAEGER',
  },
  {
    Code: 'SAF',
    Description: 'SAFEWARE, INC',
  },
  {
    Code: 'SAG',
    Description: 'SAGER',
  },
  {
    Code: 'SAM',
    Description: 'SAMASUG',
  },
  {
    Code: 'SAN',
    Description: 'SANDUSKY',
  },
  {
    Code: 'SAP',
    Description: 'SAPHIRE',
  },
  {
    Code: 'SAR',
    Description: 'SARDO',
  },
  {
    Code: 'SAT',
    Description: 'SATORIUS',
  },
  {
    Code: 'SAU',
    Description: 'SAUDER',
  },
  {
    Code: 'SAV',
    Description: 'SAVANT',
  },
  {
    Code: 'SA2',
    Description: 'SAMLEX',
  },
  {
    Code: 'SA3',
    Description: 'SAMPO',
  },
  {
    Code: 'SA4',
    Description: 'SAMSON',
  },
  {
    Code: 'SA5',
    Description: 'SAMSONITE',
  },
  {
    Code: 'SA6',
    Description: 'SAMSUNG',
  },
  {
    Code: 'SA7',
    Description: 'Samtron',
  },
  {
    Code: 'SCA',
    Description: 'SCAN TECH',
  },
  {
    Code: 'SCB',
    Description: 'SCBA',
  },
  {
    Code: 'SCE',
    Description: 'Sceptre',
  },
  {
    Code: 'SCH',
    Description: 'Schonstedt',
  },
  {
    Code: 'SCI',
    Description: 'SCI.ATLANTA',
  },
  {
    Code: 'SCO',
    Description: 'SCOTCHLITE',
  },
  {
    Code: 'SC1',
    Description: 'Scanmaker',
  },
  {
    Code: 'SC2',
    Description: 'SCANTRON',
  },
  {
    Code: 'SC3',
    Description: 'SCAPTRE',
  },
  {
    Code: 'SC4',
    Description: 'Scepture',
  },
  {
    Code: 'SC5',
    Description: 'SCHOOL HEALTH',
  },
  {
    Code: 'SC6',
    Description: 'SCHOOLVIEW',
  },
  {
    Code: 'SC7',
    Description: 'Schwab',
  },
  {
    Code: 'SC8',
    Description: 'SCIENTECH',
  },
  {
    Code: 'SEA',
    Description: 'SEAGATE',
  },
  {
    Code: 'SEC',
    Description: 'Security',
  },
  {
    Code: 'SEE',
    Description: 'Seed',
  },
  {
    Code: 'SEK',
    Description: 'SEKONIC',
  },
  {
    Code: 'SEL',
    Description: 'Selectric II',
  },
  {
    Code: 'SEN',
    Description: 'Sennheiser',
  },
  {
    Code: 'SEP',
    Description: 'SEPCO',
  },
  {
    Code: 'SER',
    Description: 'SER',
  },
  {
    Code: 'SEV',
    Description: 'Severna Sew & Vac',
  },
  {
    Code: 'SE1',
    Description: 'SEARS',
  },
  {
    Code: 'SE2',
    Description: 'SEED-VISION',
  },
  {
    Code: 'SE3',
    Description: 'SEENET',
  },
  {
    Code: 'SE4',
    Description: 'SEERITE',
  },
  {
    Code: 'SE5',
    Description: 'STEINER',
  },
  {
    Code: 'SE6',
    Description: 'STEPHENSON',
  },
  {
    Code: 'SE7',
    Description: 'Sterling',
  },
  {
    Code: 'SE8',
    Description: 'Sterling',
  },
  {
    Code: 'SE9',
    Description: 'Sentry',
  },
  {
    Code: 'SHA',
    Description: 'Sharp',
  },
  {
    Code: 'SHI',
    Description: 'SHIMADZU',
  },
  {
    Code: 'SHN',
    Description: 'SHINDAIWA',
  },
  {
    Code: 'SHO',
    Description: 'SHORELINE',
  },
  {
    Code: 'SHR',
    Description: 'Shredey',
  },
  {
    Code: 'SHU',
    Description: 'SHURE',
  },
  {
    Code: 'SH1',
    Description: 'SHINTOM',
  },
  {
    Code: 'SH2',
    Description: 'SHRED-IT',
  },
  {
    Code: 'SIG',
    Description: 'SIGMA',
  },
  {
    Code: 'SIL',
    Description: 'SILVER REED',
  },
  {
    Code: 'SIM',
    Description: 'SIMA',
  },
  {
    Code: 'SIN',
    Description: 'SINGER',
  },
  {
    Code: 'SIR',
    Description: 'SIRCHIE',
  },
  {
    Code: 'SIV',
    Description: 'SIVER ORANGE',
  },
  {
    Code: 'SI1',
    Description: 'SIGNATURE',
  },
  {
    Code: 'SI2',
    Description: 'SILVERREED',
  },
  {
    Code: 'SI3',
    Description: 'SILVERREED',
  },
  {
    Code: 'SI4',
    Description: 'SILVER-REED',
  },
  {
    Code: 'SI5',
    Description: 'SILVERRODS',
  },
  {
    Code: 'SI6',
    Description: 'SIMPLEX',
  },
  {
    Code: 'SI7',
    Description: 'SIMULAIDS',
  },
  {
    Code: 'SI8',
    Description: 'SIREX',
  },
  {
    Code: 'SKY',
    Description: 'SKYLINE',
  },
  {
    Code: 'SLA',
    Description: 'SLAMMER',
  },
  {
    Code: 'SLW',
    Description: 'SLWABER',
  },
  {
    Code: 'SMA',
    Description: 'SMART',
  },
  {
    Code: 'SME',
    Description: 'SMED',
  },
  {
    Code: 'SMI',
    Description: 'SMILE',
  },
  {
    Code: 'SM1',
    Description: 'SMITH CORONA',
  },
  {
    Code: 'SNA',
    Description: 'SNAP ON TOOLS',
  },
  {
    Code: 'SNY',
    Description: 'SYNDER INDUSTRIES',
  },
  {
    Code: 'SN1',
    Description: 'SANSUI',
  },
  {
    Code: 'SN2',
    Description: 'SANTORIUS',
  },
  {
    Code: 'SN3',
    Description: 'SANYO',
  },
  {
    Code: 'SN4',
    Description: 'SONIC',
  },
  {
    Code: 'SOF',
    Description: 'SOFTVIEW',
  },
  {
    Code: 'SOI',
    Description: 'SOILTEST',
  },
  {
    Code: 'SOL',
    Description: 'SOLA',
  },
  {
    Code: 'SON',
    Description: 'SONY',
  },
  {
    Code: 'SOR',
    Description: 'SOROFUGE',
  },
  {
    Code: 'SOU',
    Description: 'SOUNDCRAFT',
  },
  {
    Code: 'SO1',
    Description: 'SCOTCHPAK',
  },
  {
    Code: 'SO2',
    Description: 'SCOTSMAN',
  },
  {
    Code: 'SO3',
    Description: 'SCOTT',
  },
  {
    Code: 'SO4',
    Description: 'STORAGETEK',
  },
  {
    Code: 'SO5',
    Description: 'STOW DAVIS',
  },
  {
    Code: 'SO6',
    Description: 'STOWAL',
  },
  {
    Code: 'SO7',
    Description: 'SOLAR',
  },
  {
    Code: 'SO8',
    Description: 'SOUTH BEND',
  },
  {
    Code: 'SP',
    Description: 'SP',
  },
  {
    Code: 'SPA',
    Description: 'SPACE GUARD',
  },
  {
    Code: 'SPE',
    Description: 'SPECTROLINE',
  },
  {
    Code: 'SP3',
    Description: 'SPECTRUM',
  },
  {
    Code: 'SP4',
    Description: 'SPEEDAIRE',
  },
  {
    Code: 'SP5',
    Description: 'SPEED QUEEN',
  },
  {
    Code: 'SP6',
    Description: 'SPENCER',
  },
  {
    Code: 'SP7',
    Description: 'SPER SCIENTIFIC',
  },
  {
    Code: 'SP8',
    Description: 'SPACESAVER',
  },
  {
    Code: 'SP9',
    Description: 'SPARTAN',
  },
  {
    Code: 'SR1',
    Description: 'SARGENT WELCH',
  },
  {
    Code: 'SSS',
    Description: 'SSS',
  },
  {
    Code: 'STA',
    Description: 'STACOR',
  },
  {
    Code: 'STI',
    Description: 'STIHL',
  },
  {
    Code: 'STN',
    Description: 'STONE',
  },
  {
    Code: 'STO',
    Description: 'STORAGE LOGIC',
  },
  {
    Code: 'STU',
    Description: 'STUDIO',
  },
  {
    Code: 'STY',
    Description: 'STYLEX',
  },
  {
    Code: 'ST1',
    Description: 'STANDARD',
  },
  {
    Code: 'ST2',
    Description: 'STATE INDUS',
  },
  {
    Code: 'ST4',
    Description: 'STATE USE',
  },
  {
    Code: 'ST5',
    Description: 'STATE USE IND',
  },
  {
    Code: 'ST6',
    Description: 'STATESMAN',
  },
  {
    Code: 'ST7',
    Description: 'STEADCAM, JR',
  },
  {
    Code: 'ST8',
    Description: 'STEELCASE',
  },
  {
    Code: 'ST9',
    Description: 'STEINER',
  },
  {
    Code: 'SUI',
    Description: 'SUI',
  },
  {
    Code: 'SUN',
    Description: 'SUN',
  },
  {
    Code: 'SUP',
    Description: 'SUPERTRON',
  },
  {
    Code: 'SU1',
    Description: 'SOUTHERNSTATES',
  },
  {
    Code: 'SU2',
    Description: 'SOUTHWESTERN BELL',
  },
  {
    Code: 'SVG',
    Description: 'SVGA',
  },
  {
    Code: 'SV1',
    Description: 'SAVIN',
  },
  {
    Code: 'SWI',
    Description: 'SWIFT',
  },
  {
    Code: 'SW1',
    Description: 'SWINGTEC',
  },
  {
    Code: 'SW2',
    Description: 'SWINTEC',
  },
  {
    Code: 'SW3',
    Description: 'SWINTEL',
  },
  {
    Code: 'SYL',
    Description: 'SYLVANIA',
  },
  {
    Code: 'SYM',
    Description: 'SYMBOLOGY',
  },
  {
    Code: 'SY2',
    Description: 'SYMANTEC',
  },
  {
    Code: 'SY3',
    Description: 'SYMBOL',
  },
  {
    Code: 'SY4',
    Description: 'SYMPHONIC',
  },
  {
    Code: 'SY5',
    Description: 'SYNCMASTER',
  },
  {
    Code: 'TAA',
    Description: 'TAADLERROYAL',
  },
  {
    Code: 'TAN',
    Description: 'TANDBERG',
  },
  {
    Code: 'TAP',
    Description: 'TAPCO',
  },
  {
    Code: 'TAS',
    Description: 'TASCAM',
  },
  {
    Code: 'TAT',
    Description: 'TATUNG',
  },
  {
    Code: 'TAY',
    Description: 'TAYLOR',
  },
  {
    Code: 'TA1',
    Description: 'TANDY',
  },
  {
    Code: 'TA2',
    Description: 'TAPPAN',
  },
  {
    Code: 'TA3',
    Description: 'TASCO',
  },
  {
    Code: 'TA4',
    Description: 'TASK',
  },
  {
    Code: 'TCH',
    Description: 'TECHUMSEH',
  },
  {
    Code: 'TEA',
    Description: 'TEAC',
  },
  {
    Code: 'TEC',
    Description: 'TECATOR',
  },
  {
    Code: 'TEK',
    Description: 'TEKTRONICS',
  },
  {
    Code: 'TEL',
    Description: 'TELEX',
  },
  {
    Code: 'TEN',
    Description: 'TENNSCO',
  },
  {
    Code: 'TES',
    Description: 'TESTRITE',
  },
  {
    Code: 'TE1',
    Description: 'TEAM',
  },
  {
    Code: 'TE2',
    Description: 'TEAM TECH',
  },
  {
    Code: 'TE3',
    Description: 'TECHMEDIA',
  },
  {
    Code: 'TE4',
    Description: 'TELTREND',
  },
  {
    Code: 'TE5',
    Description: 'TEEL',
  },
  {
    Code: 'THE',
    Description: 'THELCO',
  },
  {
    Code: 'TH1',
    Description: 'THERMOLYNE',
  },
  {
    Code: 'TIF',
    Description: 'TIFFANY',
  },
  {
    Code: 'TIM',
    Description: 'TIMBERSTONE',
  },
  {
    Code: 'TI1',
    Description: 'TIFFINY',
  },
  {
    Code: 'TI2',
    Description: 'TRINITRON',
  },
  {
    Code: 'TI3',
    Description: 'TRIPP',
  },
  {
    Code: 'TI4',
    Description: 'TRIPP LITE',
  },
  {
    Code: 'TI5',
    Description: 'TRIPPLITE',
  },
  {
    Code: 'TI6',
    Description: 'TRIMBLE',
  },
  {
    Code: 'TOA',
    Description: 'TOASTMASTER',
  },
  {
    Code: 'TOD',
    Description: 'TODD',
  },
  {
    Code: 'TOL',
    Description: 'TOLEDO',
  },
  {
    Code: 'TOP',
    Description: 'TOP',
  },
  {
    Code: 'TOR',
    Description: 'TORO',
  },
  {
    Code: 'TOS',
    Description: 'TOSHIBA',
  },
  {
    Code: 'TOT',
    Description: 'TOTAL',
  },
  {
    Code: 'TO1',
    Description: 'TODD ENTERPRISE',
  },
  {
    Code: 'TO2',
    Description: 'TOP VAC',
  },
  {
    Code: 'TO3',
    Description: 'TOSHIBA',
  },
  {
    Code: 'TO4',
    Description: 'TOTAL OFC',
  },
  {
    Code: 'TO5',
    Description: 'TOTAL OFFICE',
  },
  {
    Code: 'TO6',
    Description: 'TOPCON',
  },
  {
    Code: 'TO7',
    Description: 'TORIT',
  },
  {
    Code: 'TRA',
    Description: 'TRAACS',
  },
  {
    Code: 'TRE',
    Description: 'TREADWAY',
  },
  {
    Code: 'TRI',
    Description: 'TRICOR',
  },
  {
    Code: 'TRK',
    Description: 'TRACKER',
  },
  {
    Code: 'TRW',
    Description: 'TRW',
  },
  {
    Code: 'TRY',
    Description: 'TROY',
  },
  {
    Code: 'TR1',
    Description: 'TRACEABLE',
  },
  {
    Code: 'TR2',
    Description: 'TRADE MARK',
  },
  {
    Code: 'TR4',
    Description: 'TRAINGLE',
  },
  {
    Code: 'TR5',
    Description: 'TRAN',
  },
  {
    Code: 'TR6',
    Description: 'TRANS',
  },
  {
    Code: 'TR7',
    Description: 'TRANSCRIBER',
  },
  {
    Code: 'TR8',
    Description: 'TRENCHMASTER',
  },
  {
    Code: 'TR9',
    Description: 'TRENDWAY',
  },
  {
    Code: 'TSI',
    Description: 'TSI',
  },
  {
    Code: 'TTI',
    Description: 'TTI',
  },
  {
    Code: 'TUN',
    Description: 'TUNTURI',
  },
  {
    Code: 'TUR',
    Description: 'TURNSTONE',
  },
  {
    Code: 'TUV',
    Description: 'TUV',
  },
  {
    Code: 'TYD',
    Description: 'TYDER',
  },
  {
    Code: 'UDS',
    Description: 'UDS',
  },
  {
    Code: 'UDX',
    Description: 'UDX',
  },
  {
    Code: 'ULI',
    Description: 'ULINE',
  },
  {
    Code: 'ULT',
    Description: 'ULT TECH CO',
  },
  {
    Code: 'UL1',
    Description: 'ULTIMATE',
  },
  {
    Code: 'UL2',
    Description: 'ULTRA',
  },
  {
    Code: 'UL3',
    Description: 'ULTRA SONIC',
  },
  {
    Code: 'UL4',
    Description: 'ULTRAK',
  },
  {
    Code: 'UL5',
    Description: 'ULTRALIGHT',
  },
  {
    Code: 'UL6',
    Description: 'ULTRATEC',
  },
  {
    Code: 'UL7',
    Description: 'ULTRAX',
  },
  {
    Code: 'UMA',
    Description: 'UMAX',
  },
  {
    Code: 'UND',
    Description: 'UNDERWRITER LAB',
  },
  {
    Code: 'UNE',
    Description: 'UNIDEN',
  },
  {
    Code: 'UNI',
    Description: 'UNIBIND',
  },
  {
    Code: 'UNK',
    Description: 'UNK',
  },
  {
    Code: 'UNT',
    Description: 'UNTRA',
  },
  {
    Code: 'UN1',
    Description: 'UNISYS',
  },
  {
    Code: 'UN2',
    Description: 'UNITED',
  },
  {
    Code: 'UN3',
    Description: 'UNIVERSAL',
  },
  {
    Code: 'UPS',
    Description: 'UPSONIC',
  },
  {
    Code: 'US',
    Description: 'US LOGIC',
  },
  {
    Code: 'USA',
    Description: 'USA',
  },
  {
    Code: 'USB',
    Description: 'USBI',
  },
  {
    Code: 'USF',
    Description: 'USFO',
  },
  {
    Code: 'USI',
    Description: 'USI',
  },
  {
    Code: 'USR',
    Description: 'USRobotics',
  },
  {
    Code: 'US1',
    Description: 'US ROBOTICS',
  },
  {
    Code: 'US2',
    Description: 'USIT',
  },
  {
    Code: 'US3',
    Description: 'USITECH',
  },
  {
    Code: 'UTC',
    Description: 'UTC',
  },
  {
    Code: 'VAL',
    Description: 'VALLEN',
  },
  {
    Code: 'VAN',
    Description: 'VANLAB',
  },
  {
    Code: 'VAR',
    Description: 'VARIAN',
  },
  {
    Code: 'VA1',
    Description: 'VALK',
  },
  {
    Code: 'VA2',
    Description: 'VALIANT',
  },
  {
    Code: 'VEJ',
    Description: 'VEJLE',
  },
  {
    Code: 'VEL',
    Description: 'VELBON',
  },
  {
    Code: 'VEN',
    Description: 'VENTEL',
  },
  {
    Code: 'VER',
    Description: 'VERNITROL',
  },
  {
    Code: 'VE1',
    Description: 'VENTUR',
  },
  {
    Code: 'VE2',
    Description: 'VERTIFLEX',
  },
  {
    Code: 'VIA',
    Description: 'VIACON',
  },
  {
    Code: 'VIC',
    Description: 'VICON',
  },
  {
    Code: 'VID',
    Description: 'VIDAR TRU SCAN',
  },
  {
    Code: 'VIE',
    Description: 'VIEW SONIC',
  },
  {
    Code: 'VIR',
    Description: 'VIRCO',
  },
  {
    Code: 'VIS',
    Description: 'VISA POINT',
  },
  {
    Code: 'VIT',
    Description: 'VIT',
  },
  {
    Code: 'VIZ',
    Description: 'VIZIO',
  },
  {
    Code: 'VI1',
    Description: 'VIDEONICS',
  },
  {
    Code: 'VI2',
    Description: 'VIDEOTEK',
  },
  {
    Code: 'VI3',
    Description: 'VIEWSONIC',
  },
  {
    Code: 'VI4',
    Description: 'VISTA',
  },
  {
    Code: 'VI5',
    Description: 'VISTA POINT',
  },
  {
    Code: 'VI7',
    Description: 'VISUAL',
  },
  {
    Code: 'VI8',
    Description: 'VITEQ',
  },
  {
    Code: 'VI9',
    Description: 'VITERMASTER',
  },
  {
    Code: 'VMR',
    Description: 'VMR',
  },
  {
    Code: 'VOR',
    Description: 'VORTEX',
  },
  {
    Code: 'VSI',
    Description: 'VSI',
  },
  {
    Code: 'VSR',
    Description: 'VSR',
  },
  {
    Code: 'VWR',
    Description: 'VWR',
  },
  {
    Code: 'VW1',
    Description: 'VWR SENTIFIC',
  },
  {
    Code: 'W W',
    Description: 'W WESTINGHOUSE',
  },
  {
    Code: 'WAL',
    Description: 'WALKABOUT',
  },
  {
    Code: 'WAR',
    Description: 'WARDS',
  },
  {
    Code: 'WAV',
    Description: 'WAVETRON',
  },
  {
    Code: 'WA1',
    Description: 'WALKER',
  },
  {
    Code: 'WA2',
    Description: 'WARING',
  },
  {
    Code: 'WEE',
    Description: 'WEEDEATER',
  },
  {
    Code: 'WEI',
    Description: 'WEIDER',
  },
  {
    Code: 'WEL',
    Description: 'WELBILT',
  },
  {
    Code: 'WEN',
    Description: 'WEN',
  },
  {
    Code: 'WER',
    Description: 'WERNER',
  },
  {
    Code: 'WES',
    Description: 'WESCO',
  },
  {
    Code: 'WE1',
    Description: 'WESTINGHOUSE',
  },
  {
    Code: 'WE2',
    Description: 'WESTOVER',
  },
  {
    Code: 'WE3',
    Description: 'WELLS',
  },
  {
    Code: 'WE4',
    Description: 'WESTERN',
  },
  {
    Code: 'WHE',
    Description: 'WHELEN',
  },
  {
    Code: 'WHI',
    Description: 'WHIRLPOOL',
  },
  {
    Code: 'WH1',
    Description: 'WHELEN',
  },
  {
    Code: 'WH2',
    Description: 'WHITE',
  },
  {
    Code: 'WH3',
    Description: 'WHITE WESTING',
  },
  {
    Code: 'WIL',
    Description: 'WILL',
  },
  {
    Code: 'WIN',
    Description: 'WIN',
  },
  {
    Code: 'WIR',
    Description: 'WIRLPOOL',
  },
  {
    Code: 'WI1',
    Description: 'WILLIAM MACGILL',
  },
  {
    Code: 'WI2',
    Description: 'WILSON/JONES',
  },
  {
    Code: 'WI3',
    Description: 'WINBOOK',
  },
  {
    Code: 'WI4',
    Description: 'WINCO',
  },
  {
    Code: 'WI5',
    Description: 'WILTON',
  },
  {
    Code: 'WI6',
    Description: 'WILLIAMS',
  },
  {
    Code: 'WOL',
    Description: 'WOLLENSAK',
  },
  {
    Code: 'WOR',
    Description: 'WORK HORSE',
  },
  {
    Code: 'WO1',
    Description: 'WORLD',
  },
  {
    Code: 'WWH',
    Description: 'WWHELEN',
  },
  {
    Code: 'WYS',
    Description: 'WYSE',
  },
  {
    Code: 'XER',
    Description: 'XEROX',
  },
  {
    Code: 'YAM',
    Description: 'YAMAHA',
  },
  {
    Code: 'YES',
    Description: 'YES',
  },
  {
    Code: 'YOR',
    Description: 'YORK',
  },
  {
    Code: 'YSI',
    Description: 'YSI',
  },
  {
    Code: 'ZEI',
    Description: 'ZEISS',
  },
  {
    Code: 'ZEN',
    Description: 'ZENITH',
  },
  {
    Code: 'ZIP',
    Description: 'ZIP',
  },
  {
    Code: 'ZOO',
    Description: 'ZOOM',
  },
  {
    Code: 'ZYN',
    Description: 'ZYNK',
  },
  {
    Code: '3 C',
    Description: '3 COM',
  },
  {
    Code: '3M',
    Description: '3M',
  },
  {
    Code: '4AF',
    Description: '4AFOURA',
  },
  {
    Code: '420',
    Description: '4206A',
  },
];

export const departments = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: 'ACC',
    Description: 'COMMUNITY COLLEGE',
  },
  {
    Code: 'AGE',
    Description: 'SERVICES FOR THE AGING',
  },
  {
    Code: 'AHR',
    Description: 'ADMINSTRATIVE HEARINGS',
  },
  {
    Code: 'BOA',
    Description: 'BOARD OF APPEALS',
  },
  {
    Code: 'BOE',
    Description: 'BOARD OF EDUCATION',
  },
  {
    Code: 'BUD',
    Description: 'OFFICE OF BUDGET',
  },
  {
    Code: 'CAO',
    Description: 'CHIEF ADMINSTRATIVE OFFICE',
  },
  {
    Code: 'CES',
    Description: 'COOPERATIVE EXTENSION SERVICE',
  },
  {
    Code: 'CIR',
    Description: 'CIRCUIT COURT',
  },
  {
    Code: 'CLS',
    Description: 'BOARD OF LICENCES COMMISSIONER',
  },
  {
    Code: 'CSV',
    Description: 'CENTRAL SERVICES',
  },
  {
    Code: 'DET',
    Description: 'DETENTION',
  },
  {
    Code: 'ELE',
    Description: 'BOARD OF SUPERVISORS ELECTION',
  },
  {
    Code: 'ETH',
    Description: 'ETHICS COMMISSION',
  },
  {
    Code: 'EXE',
    Description: 'COUNTY EXECUTIVE',
  },
  {
    Code: 'FIN',
    Description: 'OFFICE OF FINANCE',
  },
  {
    Code: 'FIR',
    Description: 'FIRE',
  },
  {
    Code: 'GAR',
    Description: 'CENTRAL GARAGE',
  },
  {
    Code: 'HLH',
    Description: 'HEALTH',
  },
  {
    Code: 'IAP',
    Description: 'INSPECTIONS AND PERMITS',
  },
  {
    Code: 'LAN',
    Description: 'LAND USE AND ENVIRONMENT',
  },
  {
    Code: 'LAW',
    Description: 'LAW',
  },
  {
    Code: 'LEG',
    Description: 'LEGISLATIVE BRANCH',
  },
  {
    Code: 'LIB',
    Description: 'PUBLIC LIBRARY SYSTEM',
  },
  {
    Code: 'MAI',
    Description: 'MAILROOM',
  },
  {
    Code: 'NA',
    Description: 'NOT APPILICABLE',
  },
  {
    Code: 'OEM',
    Description: 'OFFICE OF EMERGENCY MANAGEMENT',
  },
  {
    Code: 'OIT',
    Description: 'OFFICE OF INFORMATION TECHNOLO',
  },
  {
    Code: 'ORP',
    Description: 'ORPHANS COURT',
  },
  {
    Code: 'PAZ',
    Description: 'PLANNING AND ZONING',
  },
  {
    Code: 'PER',
    Description: 'PERSONNEL',
  },
  {
    Code: 'POL',
    Description: 'POLICE',
  },
  {
    Code: 'PSH',
    Description: 'PRINT SHOP',
  },
  {
    Code: 'PUB',
    Description: 'PUBLIC WORKS',
  },
  {
    Code: 'RCP',
    Description: 'RECS & PARKS',
  },
  {
    Code: 'SHR',
    Description: 'SHERIFFS OFFICE',
  },
  {
    Code: 'SIF',
    Description: 'SELF INSURANCE',
  },
  {
    Code: 'SOC',
    Description: 'SOCICAL SERVICES',
  },
  {
    Code: 'SRI',
    Description: 'LOCAL MANAGEMENT BOARD',
  },
  {
    Code: 'STO',
    Description: 'STATES ATTORNEY',
  },
  {
    Code: 'SWF',
    Description: 'WASTE COLLECTION',
  },
  {
    Code: 'TRN',
    Description: 'TRANSPORTATION',
  },
  {
    Code: 'UTL',
    Description: 'WATER AND WASTEWATER',
  },
  {
    Code: 'WMG',
    Description: 'WHITEMORE GARAGE',
  },
];

export const functions = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: '',
    Description: 'Blank Valid',
  },
  {
    Code: 'AHR',
    Description: 'Administrative Hearings',
  },
  {
    Code: 'CDE',
    Description: 'Code Enforcement',
  },
  {
    Code: 'EDU',
    Description: 'Education',
  },
  {
    Code: 'EDV',
    Description: 'Economic Development',
  },
  {
    Code: 'GEN',
    Description: 'General Government',
  },
  {
    Code: 'HHS',
    Description: 'Health & Human Services',
  },
  {
    Code: 'JUD',
    Description: 'Judicial',
  },
  {
    Code: 'LEG',
    Description: 'Legislative Branch',
  },
  {
    Code: 'LUD',
    Description: 'Land Use & Development',
  },
  {
    Code: 'NA',
    Description: 'Not Applicable',
  },
  {
    Code: 'PST',
    Description: 'Public Safety',
  },
  {
    Code: 'PWK',
    Description: 'Public Works',
  },
  {
    Code: 'RCS',
    Description: 'Recs & Community Services',
  },
  {
    Code: 'SWF',
    Description: 'Waste Collection',
  },
  {
    Code: 'UTL',
    Description: 'Water and Wastewater',
  },
];

export const catCode6 = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: '',
    Description: 'BLANK VALID',
  },
  {
    Code: 'COP',
    Description: 'COPIER',
  },
  {
    Code: 'DES',
    Description: 'DESKTOP COMPUTER (CPU)',
  },
  {
    Code: 'LAP',
    Description: 'LAPTOP COMPUTER',
  },
  {
    Code: 'PAD',
    Description: 'I-PAD',
  },
  {
    Code: 'PRI',
    Description: 'PRINTER',
  },
  {
    Code: 'SER',
    Description: 'SERVER',
  },
  {
    Code: 'TAB',
    Description: 'TABLET',
  },
];

export const physicalOwners = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: null,
    Description: '.',
  },
  {
    Code: 1000,
    Description: 'GENERAL FUND',
  },
  {
    Code: 1001,
    Description: 'GENERAL FUND REVENUES',
  },
  {
    Code: 1002,
    Description: 'REVENUE RESERVE FUND',
  },
  {
    Code: 1003,
    Description: 'CENTRAL CASH',
  },
  {
    Code: 1004,
    Description: 'Reserve for Perm Public Improv',
  },
  {
    Code: 1010,
    Description: 'COUNTY EXECUTIVE',
  },
  {
    Code: 1011,
    Description: 'COUNTY EXECUTIVE',
  },
  {
    Code: 1012,
    Description: 'HUMAN SERVICES',
  },
  {
    Code: 1013,
    Description: 'ECONOMIC DEVELOPMENT',
  },
  {
    Code: 1030,
    Description: 'CHIEF ADMINISTRATIVE OFFICE',
  },
  {
    Code: 1031,
    Description: 'MANAGEMENT & CONTROL',
  },
  {
    Code: 1032,
    Description: 'CONTINGENCY',
  },
  {
    Code: 1033,
    Description: 'COMMUNITY SERVICES',
  },
  {
    Code: 1040,
    Description: 'OFFICE OF FINANCE',
  },
  {
    Code: 1041,
    Description: 'ACCOUNTING AND CONTROL',
  },
  {
    Code: 1042,
    Description: 'BILLINGS AND CUSTOMER SERVICE',
  },
  {
    Code: 1043,
    Description: 'OPERATIONS',
  },
  {
    Code: 1044,
    Description: 'BUDGET & MANAGEMENT ANALYSIS',
  },
  {
    Code: 1045,
    Description: 'PAY-AS-YOU-G0',
  },
  {
    Code: 1046,
    Description: 'DEBT SERVICES & MANDATED GRANT',
  },
  {
    Code: 1047,
    Description: 'GENERAL COUNTY DEBT SERVICES',
  },
  {
    Code: 1048,
    Description: 'General County Mandated Grants',
  },
  {
    Code: 1049,
    Description: 'Revenue Reserve GF Contrib.',
  },
  {
    Code: 1050,
    Description: 'Perm Public Imp-GF Contrib.',
  },
  {
    Code: 1055,
    Description: 'OFFICE OF THE BUDGET',
  },
  {
    Code: 1056,
    Description: 'HUMAN SERVICES GRANTS',
  },
  {
    Code: 1060,
    Description: 'CENTRAL SERVICES',
  },
  {
    Code: 1061,
    Description: 'ADMINISTRATION',
  },
  {
    Code: 1062,
    Description: 'PURCHASING',
  },
  {
    Code: 1063,
    Description: 'RISK MANAGEMENT',
  },
  {
    Code: 1065,
    Description: 'FACILITIES MANAGEMENT',
  },
  {
    Code: 1066,
    Description: 'ADMINSTRATION',
  },
  {
    Code: 1067,
    Description: 'NORTHERN MOBILE CREW',
  },
  {
    Code: 1068,
    Description: 'CENTRAL MOBILE CREW-INACTIVE',
  },
  {
    Code: 1069,
    Description: 'SOUTHERN MOBILE CREW',
  },
  {
    Code: 1070,
    Description: 'CONSTRUCTION CREW',
  },
  {
    Code: 1071,
    Description: 'HORTICULTURE CREW',
  },
  {
    Code: 1072,
    Description: 'CUSTODIAL/SECURITY',
  },
  {
    Code: 1073,
    Description: 'CENTRAL MOBILE CREW',
  },
  {
    Code: 1074,
    Description: 'REAL ESTATE',
  },
  {
    Code: 1075,
    Description: 'REAL ESTATE ADMINSTRATION',
  },
  {
    Code: 1076,
    Description: 'PROPERTY CONTROL & ACCOUNTING',
  },
  {
    Code: 1077,
    Description: 'ADA ACTIVITIES',
  },
  {
    Code: 1078,
    Description: 'INFORMATION SERVICES',
  },
  {
    Code: 1079,
    Description: 'TELECOMMUNICATIONS',
  },
  {
    Code: 1080,
    Description: 'PRINT SHOP',
  },
  {
    Code: 1081,
    Description: 'MAIL ROOM',
  },
  {
    Code: 1082,
    Description: 'Millersville Crew',
  },
  {
    Code: 1083,
    Description: 'Central Maintenance',
  },
  {
    Code: 1085,
    Description: 'OIT-OFFICE OF INFO TECHNOLOGY',
  },
  {
    Code: 1086,
    Description: 'OIT-OFFICE OF INFO TECHNOLOGY',
  },
  {
    Code: 1087,
    Description: 'OIT-HELP CENTER',
  },
  {
    Code: 1088,
    Description: 'OIT-PEG',
  },
  {
    Code: 1089,
    Description: 'TECHNICAL SERVICES',
  },
  {
    Code: 1090,
    Description: 'OIT-STAGING AREA',
  },
  {
    Code: 1091,
    Description: 'OIT-COMPUTER ROOM',
  },
  {
    Code: 1092,
    Description: 'OIT-INACCESSIBLE',
  },
  {
    Code: 1100,
    Description: 'OFFICE OF LAW',
  },
  {
    Code: 1101,
    Description: 'OFFICE OF LAW',
  },
  {
    Code: 1110,
    Description: 'PERSONNEL',
  },
  {
    Code: 1111,
    Description: 'ADMINISTRATION',
  },
  {
    Code: 1112,
    Description: 'PERSONNEL BOARD',
  },
  {
    Code: 1113,
    Description: 'OTHER PERSONNEL PAYMENTS',
  },
  {
    Code: 1120,
    Description: 'POL-POLICE',
  },
  {
    Code: 1121,
    Description: "POL-CHIEF'S BUREAU",
  },
  {
    Code: 1123,
    Description: "POL-CHIEF'S OFFICE",
  },
  {
    Code: 1124,
    Description: "POL-DEPUTY CHIEF'S OFFICE",
  },
  {
    Code: 1125,
    Description: 'POL-INTERNAL AFFAIRS',
  },
  {
    Code: 1126,
    Description: 'POL-INTELLIGENCE',
  },
  {
    Code: 1127,
    Description: 'POL-PUBLIC INFORMATION OFFICE',
  },
  {
    Code: 1129,
    Description: 'POL-MANAGEMENT PLANNING',
  },
  {
    Code: 1130,
    Description: 'POL-PERSONNEL',
  },
  {
    Code: 1131,
    Description: 'POL-ACCREDITATIONS',
  },
  {
    Code: 1132,
    Description: 'POL-TRAINING ACADEMY',
  },
  {
    Code: 1133,
    Description: 'POL-FIELD OPERATIONS BUREAU',
  },
  {
    Code: 1134,
    Description: 'POL-PATROL DIVISION',
  },
  {
    Code: 1135,
    Description: 'POL-NORTHERN DISTRICT',
  },
  {
    Code: 1136,
    Description: 'POL-EASTERN DISTRICT',
  },
  {
    Code: 1137,
    Description: 'POL-SOUTHERN DISTRICT',
  },
  {
    Code: 1138,
    Description: 'POL-WESTERN DISTRICT',
  },
  {
    Code: 1139,
    Description: 'POL-COURT LIAISON',
  },
  {
    Code: 1140,
    Description: 'POL-TRAFFIC SAFETY',
  },
  {
    Code: 1141,
    Description: 'POL-SPECIAL OPERATIONS',
  },
  {
    Code: 1142,
    Description: 'POL-K-9',
  },
  {
    Code: 1143,
    Description: 'POL-AVIATION',
  },
  {
    Code: 1144,
    Description: 'POL-OPERATIONS',
  },
  {
    Code: 1145,
    Description: 'POL-CRIMINAL INVESTIGA DIVISIO',
  },
  {
    Code: 1146,
    Description: 'POL-NARCOTICS',
  },
  {
    Code: 1147,
    Description: 'POL-CID PROPERTY',
  },
  {
    Code: 1148,
    Description: 'POL-CID PERSONS',
  },
  {
    Code: 1149,
    Description: 'POL-JUVENILE VICTIM WITNESS',
  },
  {
    Code: 1150,
    Description: 'POL-PERSONS',
  },
  {
    Code: 1151,
    Description: 'POL-SERVICES BUREAU',
  },
  {
    Code: 1152,
    Description: 'POL-COMMUNICATIONS',
  },
  {
    Code: 1153,
    Description: 'POL-EVIDENCE COLLECTION',
  },
  {
    Code: 1154,
    Description: 'POL-IDENT/EVIDENCE COLLECTION',
  },
  {
    Code: 1155,
    Description: 'POL-PROPERTY MANAGEMENT',
  },
  {
    Code: 1156,
    Description: 'POL-CRIME LAB',
  },
  {
    Code: 1158,
    Description: 'POL-OIT MOBILE DEVICE COMPUTER',
  },
  {
    Code: 1159,
    Description: 'POL - OIT',
  },
  {
    Code: 1160,
    Description: 'POL-RECORDS',
  },
  {
    Code: 1161,
    Description: 'POL-YOUTH ACTIVITIES SECTION',
  },
  {
    Code: 1162,
    Description: 'POL-YOUTH ACTIVITIES PROGRAM',
  },
  {
    Code: 1163,
    Description: 'POL-DARE',
  },
  {
    Code: 1164,
    Description: 'POL-COMMUNITY RELATIONS',
  },
  {
    Code: 1165,
    Description: 'POL-CRIME PREVENTION',
  },
  {
    Code: 1166,
    Description: 'POL-SCHOOL CROSSING GUARDS',
  },
  {
    Code: 1167,
    Description: 'POL-SCHOOL RESOURCE OFFICERS',
  },
  {
    Code: 1168,
    Description: 'POL-TECHNICAL SUPPORT',
  },
  {
    Code: 1170,
    Description: 'POL-CAREER CRIMINAL UNIT',
  },
  {
    Code: 1171,
    Description: 'POL-RED LIGHT PROGRAM',
  },
  {
    Code: 1172,
    Description: 'POL-CRIME ANALYSIS UNIT',
  },
  {
    Code: 1173,
    Description: 'POL-OIT-MOBILE DEVICE COMPUTER',
  },
  {
    Code: 1176, 
    Description: 'Animal Control'
  },
  {
    Code: 1200,
    Description: 'Fire Department',
  },
  {
    Code: 1201,
    Description: 'Administration Bureau',
  },
  {
    Code: 1202,
    Description: 'Administration',
  },
  {
    Code: 1203,
    Description: 'Volunteer Support',
  },
  {
    Code: 1204,
    Description: 'Operations Bureau',
  },
  {
    Code: 1205,
    Description: 'Suppression',
  },
  {
    Code: 1206,
    Description: 'Services Bureau',
  },
  {
    Code: 1207,
    Description: 'Fire Marshal',
  },
  {
    Code: 1208,
    Description: 'Maintenance',
  },
  {
    Code: 1209,
    Description: 'Training',
  },
  {
    Code: 1210,
    Description: 'Communications',
  },
  {
    Code: 1211,
    Description: 'EMS/Special Operations Bureau',
  },
  {
    Code: 1212,
    Description: 'ALS',
  },
  {
    Code: 1213,
    Description: 'Special Teams',
  },
  {
    Code: 1214,
    Description: 'Heat',
  },
  {
    Code: 1215,
    Description: 'Dive',
  },
  {
    Code: 1216,
    Description: 'Hazardous Materials',
  },
  {
    Code: 1217,
    Description: 'Emergency Management',
  },
  {
    Code: 1219,
    Description: 'CAO - Emergency Management',
  },
  {
    Code: 1220,
    Description: 'Department of Transportation',
  },
  {
    Code: 1225,
    Description: 'Department of Transportation',
  },
  {
    Code: 1240,
    Description: 'Office of Emergency Management',
  },
  {
    Code: 1250,
    Description: 'Inspections and Permits',
  },
  {
    Code: 1251,
    Description: 'Permits Application',
  },
  {
    Code: 1252,
    Description: 'Administration & Support',
  },
  {
    Code: 1253,
    Description: 'Permit Issuance',
  },
  {
    Code: 1254,
    Description: 'Zoning Review',
  },
  {
    Code: 1255,
    Description: 'Technical Services',
  },
  {
    Code: 1256,
    Description: 'Licensing',
  },
  {
    Code: 1257,
    Description: 'Inspection Services',
  },
  {
    Code: 1258,
    Description: 'Administration & Support',
  },
  {
    Code: 1259,
    Description: 'Environmental Programs',
  },
  {
    Code: 1260,
    Description: 'Inspections',
  },
  {
    Code: 1261,
    Description: 'Zoning Enforcement',
  },
  {
    Code: 1262,
    Description: 'Planning and Zoning',
  },
  {
    Code: 1263,
    Description: 'Planning',
  },
  {
    Code: 1264,
    Description: 'Administration & Support',
  },
  {
    Code: 1265,
    Description: 'Envir/Plan Svcs.',
  },
  {
    Code: 1266,
    Description: 'Zoning',
  },
  {
    Code: 1267,
    Description: 'Long Range Plan',
  },
  {
    Code: 1268,
    Description: 'Development',
  },
  {
    Code: 1269,
    Description: 'GIS',
  },
  {
    Code: 1270,
    Description: 'Transportation',
  },
  {
    Code: 1271,
    Description: 'Cultural Resources',
  },
  {
    Code: 1272,
    Description: 'P&Z - Zoning Enforcement',
  },
  {
    Code: 1280,
    Description: 'I&P - SUBDIVISION & AGREEMENTS',
  },
  {
    Code: 1281,
    Description: 'I&P - CODE COMPLIANCE DIVISION',
  },
  {
    Code: 1282,
    Description: 'I&P - Planning',
  },
  {
    Code: 1283,
    Description: 'I&P - Engineering',
  },
  {
    Code: 1295,
    Description: 'Office Of Admin. Hearings',
  },
  {
    Code: 1296,
    Description: 'Office of Admin. Hearings',
  },
  {
    Code: 1300,
    Description: 'Public Works',
  },
  {
    Code: 1301,
    Description: "Director's Office",
  },
  {
    Code: 1302,
    Description: 'Bureau of Engineering',
  },
  {
    Code: 1303,
    Description: 'Technical Engineering Div',
  },
  {
    Code: 1304,
    Description: 'General Engineering Div',
  },
  {
    Code: 1305,
    Description: 'Bureau of Highways',
  },
  {
    Code: 1306,
    Description: 'Traffic Engineering',
  },
  {
    Code: 1307,
    Description: 'Road Operations',
  },
  {
    Code: 1308,
    Description: 'Road Operations Admin',
  },
  {
    Code: 1309,
    Description: 'Districts',
  },
  {
    Code: 1310,
    Description: 'Northern',
  },
  {
    Code: 1311,
    Description: 'Central',
  },
  {
    Code: 1312,
    Description: 'Southern',
  },
  {
    Code: 1313,
    Description: 'Infrastructure Management',
  },
  {
    Code: 1314,
    Description: 'Bureau of Hwys Admin',
  },
  {
    Code: 1316,
    Description: 'Watershed & Ecosystem Services',
  },
  {
    Code: 1400,
    Description: 'Recreation and Parks',
  },
  {
    Code: 1401,
    Description: "Director's Office",
  },
  {
    Code: 1402,
    Description: 'Organized Recreation',
  },
  {
    Code: 1403,
    Description: 'Parks Management & Development',
  },
  {
    Code: 1404,
    Description: 'Recreation Programs',
  },
  {
    Code: 1405,
    Description: 'South County',
  },
  {
    Code: 1406,
    Description: 'West County',
  },
  {
    Code: 1407,
    Description: 'North County',
  },
  {
    Code: 1408,
    Description: 'East County',
  },
  {
    Code: 1409,
    Description: 'Special Programs',
  },
  {
    Code: 1410,
    Description: 'Therapeutic',
  },
  {
    Code: 1411,
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: 1412,
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: 1413,
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: 1414,
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: 1415,
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: 1416,
    Description: 'Randazzo Softball Complex',
  },
  {
    Code: 1417,
    Description: 'Cannon Stadium',
  },
  {
    Code: 1418,
    Description: 'Adult Athl. Complex  Ord. Rd.',
  },
  {
    Code: 1419,
    Description: 'Special Facilities',
  },
  {
    Code: 1420,
    Description: 'Aquatics',
  },
  {
    Code: 1421,
    Description: 'B & A Trail',
  },
  {
    Code: 1422,
    Description: "Down's Park",
  },
  {
    Code: 1423,
    Description: 'Eisenhower Golf Course',
  },
  {
    Code: 1424,
    Description: 'Lake Waterford Park',
  },
  {
    Code: 1425,
    Description: 'Mayo Beach Park',
  },
  {
    Code: 1426,
    Description: 'Quiet Waters Park',
  },
  {
    Code: 1427,
    Description: 'Park Management',
  },
  {
    Code: 1428,
    Description: 'Andover Equestrian Center',
  },
  {
    Code: 1429,
    Description: 'Environmental Facilities',
  },
  {
    Code: 1430,
    Description: 'Jug Bay',
  },
  {
    Code: 1431,
    Description: 'Thomas Point',
  },
  {
    Code: 1432,
    Description: 'Horticulture Section',
  },
  {
    Code: 1433,
    Description: 'Unimproved Properties',
  },
  {
    Code: 1434,
    Description: 'Kinder Farm Park',
  },
  {
    Code: 1435,
    Description: 'Park Maintenance',
  },
  {
    Code: 1436,
    Description: 'Recreation Bureau Grants',
  },
  {
    Code: 1437,
    Description: 'North Arundel Acquatic Center',
  },
  {
    Code: 1438,
    Description: 'Fort Smallwood Park',
  },
  {
    Code: 1441,
    Description: 'Resource Conservation',
  },
  {
    Code: 1442,
    Description: 'Lake Waterford Park',
  },
  {
    Code: 1443,
    Description: 'Jonas Green Park',
  },
  {
    Code: 1445,
    Description: 'Park Operations North',
  },
  {
    Code: 1446,
    Description: 'Park Operations South',
  },
  {
    Code: 1448,
    Description: 'Downs/Ft. Smallwood Park',
  },
  {
    Code: 1500,
    Description: 'Aging',
  },
  {
    Code: 1501,
    Description: 'Direction/Administration',
  },
  {
    Code: 1502,
    Description: 'Nutrition',
  },
  {
    Code: 1503,
    Description: 'Transportation',
  },
  {
    Code: 1504,
    Description: 'Senior Centers',
  },
  {
    Code: 1505,
    Description: 'Pascal Senior Center',
  },
  {
    Code: 1506,
    Description: 'Arnold Senior Center',
  },
  {
    Code: 1507,
    Description: 'South County Senior Center',
  },
  {
    Code: 1508,
    Description: 'Annapolis Senior Center',
  },
  {
    Code: 1509,
    Description: "O'Malley Senior Center",
  },
  {
    Code: 1510,
    Description: 'Pasadena Senior Center',
  },
  {
    Code: 1511,
    Description: 'Outreach & Referral',
  },
  {
    Code: 1512,
    Description: 'Information and Assistance',
  },
  {
    Code: 1513,
    Description: 'Volunteers & Employment',
  },
  {
    Code: 1514,
    Description: 'Medicaid Waiver',
  },
  {
    Code: 1515,
    Description: 'Friendly Visiting',
  },
  {
    Code: 1516,
    Description: 'Severn Intergenerational Center'
  },
  {
    Code: 1517,
    Description: 'Sr. Hlth Ins. Counsel. Prgrm',
  },
  {
    Code: 1518,
    Description: 'Long Term Care',
  },
  {
    Code: 1519,
    Description: 'Senior Care',
  },
  {
    Code: 1520,
    Description: 'Ombudsman',
  },
  {
    Code: 1521,
    Description: 'Brooklyn Park Senior Center',
  },
  {
    Code: 1550,
    Description: 'Detention Facilities',
  },
  {
    Code: 1551,
    Description: 'Jennifer Road - Pretrail',
  },
  {
    Code: 1552,
    Description: 'Ordnance Road - Inmates',
  },
  {
    Code: 1553,
    Description: 'Admin/Support Service',
  },
  {
    Code: 1570,
    Description: 'Legislative Branch',
  },
  {
    Code: 1571,
    Description: 'County Council',
  },
  {
    Code: 1572,
    Description: 'County Auditor',
  },
  {
    Code: 1573,
    Description: 'Board of Appeals',
  },
  {
    Code: 1580,
    Description: 'Ethics Commission',
  },
  {
    Code: 1581,
    Description: 'Ethics Commission',
  },
  {
    Code: 1585,
    Description: "Office of the State's Attorney",
  },
  {
    Code: 1586,
    Description: "Office of the State's Attorney",
  },
  {
    Code: 1590,
    Description: 'Office of the Sheriff',
  },
  {
    Code: 1591,
    Description: 'Administration',
  },
  {
    Code: 1592,
    Description: 'Security',
  },
  {
    Code: 1593,
    Description: 'Ciminal Warrants',
  },
  {
    Code: 1594,
    Description: 'Domestic Relations Activities',
  },
  {
    Code: 1595,
    Description: 'Civil Process',
  },
  {
    Code: 1610,
    Description: 'Circuit Court',
  },
  {
    Code: 1611,
    Description: 'Disposition of Litigation',
  },
  {
    Code: 1612,
    Description: 'Domestic Relations',
  },
  {
    Code: 1620,
    Description: 'Orphans Court',
  },
  {
    Code: 1621,
    Description: 'Orphans Court',
  },
  {
    Code: 1625,
    Description: 'Board Of License Commissioners',
  },
  {
    Code: 1626,
    Description: 'Board of License Commissioners',
  },
  {
    Code: 1630,
    Description: 'Bd Of Supervisors Of Elections',
  },
  {
    Code: 1631,
    Description: 'Bd of Supevisors of Elections',
  },
  {
    Code: 1635,
    Description: 'Cooperative Extension Service',
  },
  {
    Code: 1636,
    Description: 'Cooperative Extension Service',
  },
  {
    Code: 1640,
    Description: 'Human Services',
  },
  {
    Code: 1641,
    Description: 'Administration',
  },
  {
    Code: 1642,
    Description: 'Grants',
  },
  {
    Code: 1660,
    Description: 'Social Services',
  },
  {
    Code: 1661,
    Description: 'Adult Services',
  },
  {
    Code: 1662,
    Description: 'Family & Youth Services',
  },
  {
    Code: 1663,
    Description: 'Staff Services',
  },
  {
    Code: 1664,
    Description: 'Family Preservation',
  },
  {
    Code: 1665,
    Description: 'Return Diversion',
  },
  {
    Code: 1680,
    Description: 'Land Use & Environ. Core Group',
  },
  {
    Code: 1681,
    Description: 'Direction',
  },
  {
    Code: 1682,
    Description: 'Tipton Airfield',
  },
  {
    Code: 1683,
    Description: 'David Taylor',
  },
  {
    Code: 1684,
    Description: 'School Construction',
  },
  {
    Code: 1686,
    Description: 'Environ & Cultural Resources',
  },
  {
    Code: 1700,
    Description: 'Soil Conservation',
  },
  {
    Code: 1701,
    Description: 'Soil Conservation',
  },
  {
    Code: 1710,
    Description: 'Health Department',
  },
  {
    Code: 1711,
    Description: 'Health Department Administrati',
  },
  {
    Code: 1712,
    Description: 'Administration - (Non State)',
  },
  {
    Code: 1713,
    Description: 'Administration (State)',
  },
  {
    Code: 1714,
    Description: 'Clinic and School Health',
  },
  {
    Code: 1715,
    Description: 'Admin, Clinic & School Health',
  },
  {
    Code: 1716,
    Description: 'Admin, Clinic & School Health',
  },
  {
    Code: 1717,
    Description: 'Reproductive Health',
  },
  {
    Code: 1718,
    Description: 'Family Planning Program',
  },
  {
    Code: 1719,
    Description: 'Materity Program',
  },
  {
    Code: 1720,
    Description: 'Dental Health',
  },
  {
    Code: 1721,
    Description: 'Dental Health Program',
  },
  {
    Code: 1722,
    Description: 'School Health & Support',
  },
  {
    Code: 1723,
    Description: 'O/T - P/T Program',
  },
  {
    Code: 1724,
    Description: 'School Support Program',
  },
  {
    Code: 1725,
    Description: 'School Health-Shared PDS Aides',
  },
  {
    Code: 1726,
    Description: 'School Hlth Prgrm I & TP -BOE',
  },
  {
    Code: 1727,
    Description: 'Community Outreach',
  },
  {
    Code: 1728,
    Description: 'Admin, Community Outreach',
  },
  {
    Code: 1729,
    Description: 'Community Outreach Admin',
  },
  {
    Code: 1730,
    Description: 'Eligibility & Enrollment',
  },
  {
    Code: 1731,
    Description: 'PWC Eligibilty Program',
  },
  {
    Code: 1732,
    Description: 'Case Management',
  },
  {
    Code: 1733,
    Description: 'Home Visiting Program',
  },
  {
    Code: 1734,
    Description: 'WIC',
  },
  {
    Code: 1735,
    Description: 'Community Health',
  },
  {
    Code: 1736,
    Description: 'Child Health Program',
  },
  {
    Code: 1737,
    Description: 'Nurse-Is-In Program',
  },
  {
    Code: 1738,
    Description: 'Service Quality',
  },
  {
    Code: 1739,
    Description: 'Surveillance Program',
  },
  {
    Code: 1740,
    Description: 'Planning & Surveillance',
  },
  {
    Code: 1741,
    Description: 'Health Info & Risk Reduction',
  },
  {
    Code: 1742,
    Description: 'Nutrition Program',
  },
  {
    Code: 1743,
    Description: 'Health Information Program',
  },
  {
    Code: 1744,
    Description: 'Aging',
  },
  {
    Code: 1745,
    Description: 'Aging Program',
  },
  {
    Code: 1746,
    Description: 'Personal Care Program',
  },
  {
    Code: 1747,
    Description: 'Community and Environ. Hlth',
  },
  {
    Code: 1748,
    Description: 'Admin, Environmental Health',
  },
  {
    Code: 1749,
    Description: 'Environmental Health Admin',
  },
  {
    Code: 1750,
    Description: 'Community Services',
  },
  {
    Code: 1751,
    Description: 'Community Services Program',
  },
  {
    Code: 1752,
    Description: 'Animal Control Program',
  },
  {
    Code: 1753,
    Description: 'Sanitary Engineering',
  },
  {
    Code: 1754,
    Description: 'Sanitary Engineering Program',
  },
  {
    Code: 1755,
    Description: 'Communicable Disease',
  },
  {
    Code: 1756,
    Description: 'Communic. Disease Program',
  },
  {
    Code: 1757,
    Description: 'TB Program',
  },
  {
    Code: 1758,
    Description: 'STD Program',
  },
  {
    Code: 1759,
    Description: 'Mental Health & Addictions',
  },
  {
    Code: 1760,
    Description: 'Mental Health',
  },
  {
    Code: 1761,
    Description: 'Addictions Treatment',
  },
  {
    Code: 1762,
    Description: 'Addictions Prevention',
  },
  {
    Code: 1763,
    Description: 'Sexual Assault Crisis Center',
  },
  {
    Code: 1764,
    Description: 'Health Info and Promotion',
  },
  {
    Code: 1765,
    Description: 'Administration, HIP',
  },
  {
    Code: 1766,
    Description: 'Administration, HIP',
  },
  {
    Code: 1767,
    Description: 'Communication',
  },
  {
    Code: 1768,
    Description: 'Communication',
  },
  {
    Code: 1769,
    Description: 'Adult Risk Reduction',
  },
  {
    Code: 1770,
    Description: 'Adult Risk Reduction',
  },
  {
    Code: 1771,
    Description: 'Youth Risk Reduction',
  },
  {
    Code: 1772,
    Description: 'Youth Risk Reduction',
  },
  {
    Code: 1773,
    Description: 'Minority Health',
  },
  {
    Code: 1774,
    Description: 'Minority Health',
  },
  {
    Code: 1985,
    Description: 'Public Libraries',
  },
  {
    Code: 1990,
    Description: 'Community College - GF Contrib',
  },
  {
    Code: 1995,
    Description: 'BOE - County Contribution',
  },
  {
    Code: 2000,
    Description: 'Whitmore Parking Garage',
  },
  {
    Code: 2010,
    Description: 'Child Care',
  },
  {
    Code: 2011,
    Description: 'Child Care Revenues',
  },
  {
    Code: 2012,
    Description: 'Area 1',
  },
  {
    Code: 2013,
    Description: 'Edgewater',
  },
  {
    Code: 2014,
    Description: 'Shady Side',
  },
  {
    Code: 2015,
    Description: 'Davidsonville',
  },
  {
    Code: 2016,
    Description: "Tracey's Landing",
  },
  {
    Code: 2017,
    Description: 'Hillsmere',
  },
  {
    Code: 2018,
    Description: 'Lothian',
  },
  {
    Code: 2019,
    Description: 'Crofton Meadows',
  },
  {
    Code: 2020,
    Description: 'Four Seasons',
  },
  {
    Code: 2021,
    Description: 'Waugh Chapel Elementary',
  },
  {
    Code: 2022,
    Description: 'Area 2',
  },
  {
    Code: 2023,
    Description: 'Brock Bridge',
  },
  {
    Code: 2024,
    Description: 'Maryland City',
  },
  {
    Code: 2025,
    Description: 'Severna Park',
  },
  {
    Code: 2026,
    Description: 'Benfield Elementary',
  },
  {
    Code: 2027,
    Description: 'Oak Hill Elementary',
  },
  {
    Code: 2028,
    Description: 'Severn Elementary',
  },
  {
    Code: 2029,
    Description: 'Quarterfield Elementary',
  },
  {
    Code: 2030,
    Description: 'Pasadena Elementary',
  },
  {
    Code: 2031,
    Description: 'Hilltop',
  },
  {
    Code: 2032,
    Description: 'Area 3',
  },
  {
    Code: 2033,
    Description: 'Windsor Farm',
  },
  {
    Code: 2034,
    Description: 'Broadneck',
  },
  {
    Code: 2035,
    Description: 'Rolling Knolls',
  },
  {
    Code: 2036,
    Description: 'Bodkin',
  },
  {
    Code: 2037,
    Description: 'Southshore',
  },
  {
    Code: 2038,
    Description: 'Solley Elementary',
  },
  {
    Code: 2039,
    Description: 'High Point Elementary',
  },
  {
    Code: 2040,
    Description: 'Lake Shore Elementary',
  },
  {
    Code: 2041,
    Description: 'Cape St. Claire',
  },
  {
    Code: 2042,
    Description: 'Area 4',
  },
  {
    Code: 2043,
    Description: 'Crofton Middle',
  },
  {
    Code: 2044,
    Description: 'Glendale',
  },
  {
    Code: 2045,
    Description: 'Administration',
  },
  {
    Code: 2046,
    Description: 'Administration',
  },
  {
    Code: 2047,
    Description: 'Southern MS',
  },
  {
    Code: 2048,
    Description: 'Harman ES',
  },
  {
    Code: 2049,
    Description: 'Manor View ES',
  },
  {
    Code: 2050,
    Description: 'Mayo School Age Child Care',
  },
  {
    Code: 2100,
    Description: 'Developer Streetlight Install.',
  },
  {
    Code: 2110,
    Description: 'FAST Fund',
  },
  {
    Code: 2111,
    Description: 'FAST Fund Revenues',
  },
  {
    Code: 2112,
    Description: "State's Attorney",
  },
  {
    Code: 2113,
    Description: 'County Forfeiture',
  },
  {
    Code: 2114,
    Description: 'POLICE',
  },
  {
    Code: 2115,
    Description: 'County Forfeiture',
  },
  {
    Code: 2116,
    Description: 'Federal Forfeiture',
  },
  {
    Code: 2150,
    Description: 'Conference & Tourism Fund',
  },
  {
    Code: 2160,
    Description: 'Economic Development Fund',
  },
  {
    Code: 2170,
    Description: 'Incentive Loan Fund',
  },
  {
    Code: 2180,
    Description: 'Piney Orchard Wastewater Srvc',
  },
  {
    Code: 2200,
    Description: 'Local Management Board (SRI)',
  },
  {
    Code: 2201,
    Description: 'System Reform Initia. Revenues',
  },
  {
    Code: 2202,
    Description: 'Administration',
  },
  {
    Code: 2203,
    Description: 'Family Preservation',
  },
  {
    Code: 2204,
    Description: 'Return/Diversion',
  },
  {
    Code: 2205,
    Description: 'Contractor Family Preservation',
  },
  {
    Code: 2206,
    Description: 'Contractor Return/Diversion',
  },
  {
    Code: 2207,
    Description: 'Youth Service Bureaus',
  },
  {
    Code: 2208,
    Description: 'DHR Family Services',
  },
  {
    Code: 2209,
    Description: 'Community Partnerships',
  },
  {
    Code: 2290,
    Description: 'Housing Trust',
  },
  {
    Code: 2301,
    Description: 'Impact Fees-Schools, Dist1',
  },
  {
    Code: 2302,
    Description: 'Impact Fees-Schools, Dist2',
  },
  {
    Code: 2303,
    Description: 'Impact Fees-Schools, Dist3',
  },
  {
    Code: 2304,
    Description: 'Impact Fees-Schools, Dist4',
  },
  {
    Code: 2305,
    Description: 'Impact Fees-Schools, Dist5',
  },
  {
    Code: 2306,
    Description: 'Impact Fees-Schools, Dist6',
  },
  {
    Code: 2307,
    Description: 'Impact Fees-Schools, Dist7',
  },
  {
    Code: 2308,
    Description: 'Impact Fees-Highway, Dist1',
  },
  {
    Code: 2309,
    Description: 'Impact Fees-Highway, Dist2',
  },
  {
    Code: 2310,
    Description: 'Impact Fees-Highway, Dist3',
  },
  {
    Code: 2311,
    Description: 'Impact Fees-Highway, Dist4',
  },
  {
    Code: 2312,
    Description: 'Impact Fees-Highway, Dist5',
  },
  {
    Code: 2313,
    Description: 'Imp Fees-Hwy, Greenbrch La',
  },
  {
    Code: 2314,
    Description: 'Developer Agree - Russett',
  },
  {
    Code: 2315,
    Description: 'Develop Agree-Ameribanc',
  },
  {
    Code: 2316,
    Description: 'Devevloper Agree Seven Oak',
  },
  {
    Code: 2317,
    Description: 'Devel Agree Piney Orchard',
  },
  {
    Code: 2318,
    Description: 'West Annapolis Elementary',
  },
  {
    Code: 2319,
    Description: 'Arundel Sr High School',
  },
  {
    Code: 2320,
    Description: 'Odenton Elementary',
  },
  {
    Code: 2321,
    Description: 'Waugh Chapel Elementary',
  },
  {
    Code: 2322,
    Description: 'Crofton Elementary',
  },
  {
    Code: 2323,
    Description: 'Crofton Woods Elementary',
  },
  {
    Code: 2324,
    Description: 'Belvedere Elementary',
  },
  {
    Code: 2325,
    Description: 'Broadneck Elementary',
  },
  {
    Code: 2326,
    Description: 'Cape St. Claire Elementary',
  },
  {
    Code: 2327,
    Description: 'Windsor Farm Elementary',
  },
  {
    Code: 2328,
    Description: 'Magothy River Middle',
  },
  {
    Code: 2329,
    Description: 'Ft Smallwood Elementary',
  },
  {
    Code: 2330,
    Description: 'Jacobsville Elementary',
  },
  {
    Code: 2331,
    Description: 'Lake Shore Elementary',
  },
  {
    Code: 2332,
    Description: 'Pasadena Elementary',
  },
  {
    Code: 2333,
    Description: 'Oakwood Elementary',
  },
  {
    Code: 2334,
    Description: 'Richard Henry Lee Elem',
  },
  {
    Code: 2335,
    Description: 'Marley Middle School',
  },
  {
    Code: 2336,
    Description: 'Freetowne Elementary',
  },
  {
    Code: 2337,
    Description: 'Marley Elementary',
  },
  {
    Code: 2338,
    Description: 'Harman Elementary',
  },
  {
    Code: 2339,
    Description: 'North County Sr High Sch',
  },
  {
    Code: 2340,
    Description: 'George Fox Middle School',
  },
  {
    Code: 2341,
    Description: 'High Point Elementary',
  },
  {
    Code: 2342,
    Description: 'Sunset Elementary',
  },
  {
    Code: 2343,
    Description: 'Olde Mill Sr High School',
  },
  {
    Code: 2344,
    Description: 'Severn Elementary',
  },
  {
    Code: 2345,
    Description: 'Southgate Elementary',
  },
  {
    Code: 2346,
    Description: 'Glen Burnie Park Elem',
  },
  {
    Code: 2347,
    Description: 'Millersville Elementary',
  },
  {
    Code: 2348,
    Description: 'Ridgeway Elementary',
  },
  {
    Code: 2349,
    Description: 'South Shore Elementary',
  },
  {
    Code: 2350,
    Description: 'Southgate-Elvation Towne',
  },
  {
    Code: 2351,
    Description: 'Severna Pk  Sr High School',
  },
  {
    Code: 2352,
    Description: 'Folger McKinsey Elem',
  },
  {
    Code: 2353,
    Description: 'Jones Elementary',
  },
  {
    Code: 2354,
    Description: 'Davidsonville Elementary',
  },
  {
    Code: 2355,
    Description: 'Southern Middle School',
  },
  {
    Code: 2356,
    Description: 'Lothian Elementary',
  },
  {
    Code: 2357,
    Description: 'Shady Side Elementary',
  },
  {
    Code: 2358,
    Description: 'Traceys Elementary',
  },
  {
    Code: 2359,
    Description: 'Four Seasons Elementary',
  },
  {
    Code: 2360,
    Description: 'Magothy River Middle School',
  },
  {
    Code: 2361,
    Description: 'Belvedere El Students Only',
  },
  {
    Code: 2362,
    Description: 'Developer Agree Opus East',
  },
  {
    Code: 2363,
    Description: 'Four Seasons E/S-Crofton Farms',
  },
  {
    Code: 2364,
    Description: 'Devel Agree City of Annapolis',
  },
  {
    Code: 2400,
    Description: 'Impact Fees Public Safety',
  },
  {
    Code: 2450,
    Description: 'Laurel Racetrack Revenues',
  },
  {
    Code: 2619,
    Description: 'HOLLAND POINT SPEC POL-PAYROLL',
  },
  {
    Code: 2800,
    Description: 'Nursery Road Tax Increment Dis',
  },
  {
    Code: 2801,
    Description: 'West Cty Tax Incr Dist (NBP)',
  },
  {
    Code: 2802,
    Description: 'Farmington Special Taxing Dist',
  },
  {
    Code: 2803,
    Description: 'Park Place Tax Increment Dist.',
  },
  {
    Code: 2804,
    Description: 'Arundel Mills Tax Inc District',
  },
  {
    Code: 2805,
    Description: 'Parole Tax Increment District',
  },
  {
    Code: 2806,
    Description: 'Natl Bus Park Special Tax Dist',
  },
  {
    Code: 2850,
    Description: 'IPA Debt Service',
  },
  {
    Code: 3010,
    Description: 'Gen Cnty Cap Projs',
  },
  {
    Code: 3011,
    Description: 'Gen Cnty CP-Closed',
  },
  {
    Code: 3019,
    Description: 'I&P Branch Plant',
  },
  {
    Code: 3020,
    Description: 'Gen  Cnty Cap Proj-Storm Drain',
  },
  {
    Code: 3021,
    Description: 'Gen Cnty CP-Storm Drains-Close',
  },
  {
    Code: 3030,
    Description: 'Gen Cnty Cap Proj-Educ',
  },
  {
    Code: 3031,
    Description: 'Gen Cnty CP-Educ-Closed',
  },
  {
    Code: 3040,
    Description: 'Gen Cnty Cap Proj-Fire/Police',
  },
  {
    Code: 3041,
    Description: 'Gen Cnty CP-Fire/Pol-Closed',
  },
  {
    Code: 3050,
    Description: 'Gen Cnty Cap Proj-Rds/Brdgs',
  },
  {
    Code: 3051,
    Description: 'Gen Cnty CP-Rds/Brdgs',
  },
  {
    Code: 3060,
    Description: 'Gen Cnty Cap Proj-Comm Coll',
  },
  {
    Code: 3061,
    Description: 'Gen Cnty CP-Comm Coll-Closed',
  },
  {
    Code: 3070,
    Description: 'Gen Cnty Cap Proj-Libraries',
  },
  {
    Code: 3071,
    Description: 'Gen Cnty CP-Libraries-Closed',
  },
  {
    Code: 3080,
    Description: 'Gen Cnty Cap Proj-CBG',
  },
  {
    Code: 3081,
    Description: 'Gen Cnty CP-CBG-Closed',
  },
  {
    Code: 3090,
    Description: 'Gen Cnty Cap Proj-Res & Parks',
  },
  {
    Code: 3091,
    Description: 'Gen Cnty CP-Rec & Parks-Closed',
  },
  {
    Code: 3100,
    Description: 'Gen Cnty Cap Proj-Dredging',
  },
  {
    Code: 3101,
    Description: 'Gen Cnty CP-Dredging-Closed',
  },
  {
    Code: 4000,
    Description: 'Utility Operating Fund',
  },
  {
    Code: 4004,
    Description: 'Utility Operations',
  },
  {
    Code: 4010,
    Description: 'Water Operations',
  },
  {
    Code: 4011,
    Description: 'Water Operations Revenues',
  },
  {
    Code: 4012,
    Description: 'Facility Maintenance',
  },
  {
    Code: 4013,
    Description: 'Facility Operations',
  },
  {
    Code: 4014,
    Description: 'Water Line Maintenance',
  },
  {
    Code: 4015,
    Description: 'Emergency Services',
  },
  {
    Code: 4016,
    Description: 'Collection/Dist Support Serv',
  },
  {
    Code: 4017,
    Description: 'Meter Services',
  },
  {
    Code: 4018,
    Description: 'Water Administration',
  },
  {
    Code: 4020,
    Description: 'Wastewater Operations',
  },
  {
    Code: 4021,
    Description: 'Wastewater Operations Revenues',
  },
  {
    Code: 4023,
    Description: 'Piney Orchard WRF',
  },
  {
    Code: 4024,
    Description: 'Cox Creek',
  },
  {
    Code: 4025,
    Description: 'Broadneck',
  },
  {
    Code: 4026,
    Description: 'Old Str Maintenance',
  },
  {
    Code: 4027,
    Description: 'Old Str Sewer Line Maintenance',
  },
  {
    Code: 4028,
    Description: 'Coll & Maint Administration',
  },
  {
    Code: 4029,
    Description: 'System Evaluation & Rehab.',
  },
  {
    Code: 4030,
    Description: 'Infilitration & Inflow',
  },
  {
    Code: 4031,
    Description: 'Water Distribution Planning',
  },
  {
    Code: 4032,
    Description: 'Cent Maint - Contract Support',
  },
  {
    Code: 4034,
    Description: 'Patuxent Wrf',
  },
  {
    Code: 4035,
    Description: 'Old Str Annapolis Wrf',
  },
  {
    Code: 4036,
    Description: 'Maryland City Wrf',
  },
  {
    Code: 4037,
    Description: 'Old Str Broadwater Wrf',
  },
  {
    Code: 4038,
    Description: 'Old Str Mayo Wrf',
  },
  {
    Code: 4039,
    Description: 'Old Str Pumping Station Ops',
  },
  {
    Code: 4040,
    Description: 'Old Str WW South Maintenance',
  },
  {
    Code: 4042,
    Description: 'Public Works - Wastewater Support Services'
  },
  {
    Code: 4043,
    Description: 'WW Operations Adminstration',
  },
  {
    Code: 4044,
    Description: 'Technical Administration',
  },
  {
    Code: 4046,
    Description: 'UTIL-CONSOLIDATED LAB SERVICES',
  },
  {
    Code: 4048,
    Description: 'Wastewater Collections & Maint',
  },
  {
    Code: 4049,
    Description: 'WW Collections',
  },
  {
    Code: 4050,
    Description: 'Technical Support',
  },
  {
    Code: 4051,
    Description: 'Safety Services',
  },
  {
    Code: 4052,
    Description: 'Pretreatment',
  },
  {
    Code: 4053,
    Description: 'Sewer Line Repairs',
  },
  {
    Code: 4054,
    Description: 'Sewer Line Maintenance',
  },
  {
    Code: 4055,
    Description: 'WW Maintenance',
  },
  {
    Code: 4056,
    Description: 'Mechanical',
  },
  {
    Code: 4057,
    Description: 'Electrical & Instrument',
  },
  {
    Code: 4058,
    Description: 'Emerg Power Sys Sup',
  },
  {
    Code: 4059,
    Description: 'Annapolis WRF',
  },
  {
    Code: 4060,
    Description: 'Operations Administration',
  },
  {
    Code: 4061,
    Description: 'Business Management Admin',
  },
  {
    Code: 4062,
    Description: 'Excel & Special Project',
  },
  {
    Code: 4063,
    Description: 'Mayo WRF',
  },
  {
    Code: 4064,
    Description: 'Broadwater WRF',
  },
  {
    Code: 4065,
    Description: 'Utility Administration',
  },
  {
    Code: 4066,
    Description: 'SCADA',
  },
  {
    Code: 4067,
    Description: 'Utility Engineering',
  },
  {
    Code: 4070,
    Description: 'Finance & Administration',
  },
  {
    Code: 4071,
    Description: 'Financial Services',
  },
  {
    Code: 4072,
    Description: 'Personnel',
  },
  {
    Code: 4073,
    Description: 'Customer Relations',
  },
  {
    Code: 4074,
    Description: 'Mgmt Information System',
  },
  {
    Code: 4075,
    Description: 'Old Str Revenue Administration',
  },
  {
    Code: 4076,
    Description: 'DPW-Utilities-Asset Management',
  },
  {
    Code: 4099,
    Description: 'Utility Op. Fund Actg Trans.',
  },
  {
    Code: 4110,
    Description: 'Water and Sewer Cap Projs-Sew',
  },
  {
    Code: 4111,
    Description: 'Water and Sewer CP-Sew-Closed',
  },
  {
    Code: 4119,
    Description: 'W & S - Sewer CP Acctg Trans.',
  },
  {
    Code: 4120,
    Description: 'Water and Sewer Cap Projs-Wat',
  },
  {
    Code: 4121,
    Description: 'Water and Sewer CP-Wat-Closed',
  },
  {
    Code: 4129,
    Description: 'W & S - Water CP Acctg Trans.',
  },
  {
    Code: 4130,
    Description: 'Water and Sewer Cap Proj-Other',
  },
  {
    Code: 4131,
    Description: 'Water and Sewer CP-Other-Close',
  },
  {
    Code: 4139,
    Description: 'W & S - Other CP Acctg Trans.',
  },
  {
    Code: 4140,
    Description: 'W & S Cap Proj-Routine Wat',
  },
  {
    Code: 4141,
    Description: 'W & S CP-Routine Wat Ext-Close',
  },
  {
    Code: 4149,
    Description: 'W & S - RWE CP Acctg Trans.',
  },
  {
    Code: 4150,
    Description: 'W & S Cap Proj-Routine Sew Ext',
  },
  {
    Code: 4151,
    Description: 'W & S CP-Routine Sew Ext-Close',
  },
  {
    Code: 4159,
    Description: 'W & S - RSE CP Acctg Trans.',
  },
  {
    Code: 4199,
    Description: 'I&P Branch Plant',
  },
  {
    Code: 4200,
    Description: 'Interest & Sinking Fund',
  },
  {
    Code: 4202,
    Description: 'Water',
  },
  {
    Code: 4203,
    Description: 'Wastewater',
  },
  {
    Code: 4219,
    Description: 'Utility I&S Fund Actg Trans.',
  },
  {
    Code: 4220,
    Description: 'Maryland City Amt Debt Service',
  },
  {
    Code: 4229,
    Description: 'Maryland City Fund Actg Trans',
  },
  {
    Code: 4230,
    Description: 'W & S Adjustments to GAAP',
  },
  {
    Code: 4300,
    Description: 'Waste Management Services Fund',
  },
  {
    Code: 4301,
    Description: 'Waste Management Services Rev',
  },
  {
    Code: 4302,
    Description: 'Waste Management Services Exp',
  },
  {
    Code: 4303,
    Description: 'Administration',
  },
  {
    Code: 4304,
    Description: 'Environmental Services',
  },
  {
    Code: 4305,
    Description: 'Alternative Disposal',
  },
  {
    Code: 4310,
    Description: 'Equipment Maintenance',
  },
  {
    Code: 4311,
    Description: 'Landfills',
  },
  {
    Code: 4312,
    Description: 'Millersville Landfill',
  },
  {
    Code: 4313,
    Description: 'Sudley Landfill',
  },
  {
    Code: 4314,
    Description: 'Glen Burnie Landfill',
  },
  {
    Code: 4320,
    Description: 'Community Services',
  },
  {
    Code: 4321,
    Description: 'Convenience Centers',
  },
  {
    Code: 4322,
    Description: 'Sudley Convenience Center',
  },
  {
    Code: 4323,
    Description: 'Glen Burnie Convenience Cntr',
  },
  {
    Code: 4324,
    Description: 'Millersville Convenience Cntr',
  },
  {
    Code: 4330,
    Description: 'Curbside Collection',
  },
  {
    Code: 4331,
    Description: 'Curbside Collection',
  },
  {
    Code: 4335,
    Description: 'Bulk Item/Community Cleanup',
  },
  {
    Code: 4336,
    Description: 'Bulk Item Collection',
  },
  {
    Code: 4337,
    Description: 'Community Cleanups',
  },
  {
    Code: 4340,
    Description: 'Recycling',
  },
  {
    Code: 4389,
    Description: 'WM Fund Actg Trans.',
  },
  {
    Code: 4390,
    Description: 'Solid Waste Fin. Assur. Fund',
  },
  {
    Code: 4399,
    Description: 'SW Fin Assur Fund Actg Trans.',
  },
  {
    Code: 4410,
    Description: 'Solid Waste Cap Projs-Landfill',
  },
  {
    Code: 4411,
    Description: 'Solid Waste -Landfill-Closed',
  },
  {
    Code: 4419,
    Description: 'SWCP-Landfill Fund Actg Trans.',
  },
  {
    Code: 4601,
    Description: 'WPRF Engineering',
  },
  {
    Code: 4602,
    Description: 'WPRF CIP Implementation',
  },
  {
    Code: 4604,
    Description: 'WPRF Inspection',
  },
  {
    Code: 4607,
    Description: 'Utility Planning',
  },
  {
    Code: 5000,
    Description: 'Central Stores Fund',
  },
  {
    Code: 5001,
    Description: 'Central Stores Operations',
  },
  {
    Code: 5002,
    Description: 'Administration',
  },
  {
    Code: 5003,
    Description: 'Warehouse',
  },
  {
    Code: 5004,
    Description: 'Print Shop',
  },
  {
    Code: 5005,
    Description: 'Mail/Stock Room',
  },
  {
    Code: 5006,
    Description: 'Roads Inventory',
  },
  {
    Code: 5007,
    Description: 'Northern Roads',
  },
  {
    Code: 5008,
    Description: 'Central Roads',
  },
  {
    Code: 5009,
    Description: 'Southern Roads',
  },
  {
    Code: 5010,
    Description: 'Western Roads',
  },
  {
    Code: 5011,
    Description: 'Eastern Roads',
  },
  {
    Code: 5049,
    Description: 'Cash & Counter Sales',
  },
  {
    Code: 5050,
    Description: 'Self Insurance Fund',
  },
  {
    Code: 5051,
    Description: 'Self Insurance Fund Revenues',
  },
  {
    Code: 5052,
    Description: 'County',
  },
  {
    Code: 5053,
    Description: 'Administration',
  },
  {
    Code: 5054,
    Description: 'Safety',
  },
  {
    Code: 5055,
    Description: 'Self Insurance',
  },
  {
    Code: 5056,
    Description: "Workmen's Compensation",
  },
  {
    Code: 5057,
    Description: 'Vehicle Collison',
  },
  {
    Code: 5058,
    Description: 'General Liability',
  },
  {
    Code: 5059,
    Description: 'Vehicle Liability',
  },
  {
    Code: 5060,
    Description: 'Board of Education',
  },
  {
    Code: 5061,
    Description: 'Administration',
  },
  {
    Code: 5062,
    Description: 'Self Insurance',
  },
  {
    Code: 5063,
    Description: "Workmen's Compensation",
  },
  {
    Code: 5064,
    Description: 'Vehicle Collison',
  },
  {
    Code: 5065,
    Description: 'General Liability',
  },
  {
    Code: 5066,
    Description: 'Vehicle Liability',
  },
  {
    Code: 5067,
    Description: 'Risk Management Administration',
  },
  {
    Code: 5068,
    Description: 'Safety',
  },
  {
    Code: 5069,
    Description: 'Insurance',
  },
  {
    Code: 5099,
    Description: 'Self Ins Fund Actg Trans.',
  },
  {
    Code: 5100,
    Description: 'Health Insurance Fund',
  },
  {
    Code: 51437,
    Description: 'Drug Diversion Program',
  },
  {
    Code: 5200,
    Description: 'Central Garage Fund',
  },
  {
    Code: 5201,
    Description: 'Fuel Inventory',
  },
  {
    Code: 5202,
    Description: 'Gas',
  },
  {
    Code: 5203,
    Description: 'Diesel',
  },
  {
    Code: 5204,
    Description: 'Vehicle Replacement',
  },
  {
    Code: 5205,
    Description: 'Services and Maintenance',
  },
  {
    Code: 52421,
    Description: 'DOJ Terrorism Response Equip.',
  },
  {
    Code: 5300,
    Description: 'Central Garage Replacement Fun',
  },
  {
    Code: 6050,
    Description: 'Pension System Fund',
  },
  {
    Code: 6100,
    Description: 'Defined Contribution Plan',
  },
  {
    Code: 6200,
    Description: 'Storm Drain',
  },
  {
    Code: 6201,
    Description: 'Storm water facil deposit',
  },
  {
    Code: 6202,
    Description: 'Patapsco-Non-tidal',
  },
  {
    Code: 6203,
    Description: 'Rhode river water shed',
  },
  {
    Code: 6204,
    Description: 'Lil Patuxent water shed',
  },
  {
    Code: 6205,
    Description: 'MN Patuxent rv water shed',
  },
  {
    Code: 6206,
    Description: 'West river water shed',
  },
  {
    Code: 6207,
    Description: 'Severn river water shed',
  },
  {
    Code: 6208,
    Description: 'South river water shed',
  },
  {
    Code: 6209,
    Description: 'Bodkin Creek water shed',
  },
  {
    Code: 6210,
    Description: 'Magothy river water shed',
  },
  {
    Code: 6211,
    Description: 'Patapsco river water shed',
  },
  {
    Code: 6212,
    Description: 'Unspec. loc-watershed',
  },
  {
    Code: 6213,
    Description: 'Herring bay water shed',
  },
  {
    Code: 6250,
    Description: 'Subdivision Deposit Agency',
  },
  {
    Code: 6251,
    Description: 'Road agreement',
  },
  {
    Code: 6252,
    Description: 'Gateway',
  },
  {
    Code: 6253,
    Description: 'Contract bid deposits',
  },
  {
    Code: 6254,
    Description: 'Non-Compliance Lien Escrow',
  },
  {
    Code: 6255,
    Description: 'Liquor license',
  },
  {
    Code: 6256,
    Description: 'Electrical permit',
  },
  {
    Code: 6257,
    Description: 'Security dep-rent agreemt',
  },
  {
    Code: 6258,
    Description: 'Screening P&Z',
  },
  {
    Code: 6259,
    Description: 'Russett Ctr. Allocation Escrow',
  },
  {
    Code: 6300,
    Description: 'Sediment Control Agency',
  },
  {
    Code: 6301,
    Description: 'Gypsy moth Spray Escrow',
  },
  {
    Code: 6302,
    Description: 'Sediment control',
  },
  {
    Code: 6303,
    Description: 'Sediment control violate',
  },
  {
    Code: 6325,
    Description: 'Recreation Agency',
  },
  {
    Code: 6326,
    Description: 'Rent',
  },
  {
    Code: 6327,
    Description: 'July 4th',
  },
  {
    Code: 6328,
    Description: 'Self Support',
  },
  {
    Code: 6329,
    Description: 'Trips',
  },
  {
    Code: 6330,
    Description: 'Ramp Escrow',
  },
  {
    Code: 6331,
    Description: 'Recreation land',
  },
  {
    Code: 6375,
    Description: 'Detention Facility Agency',
  },
  {
    Code: 6376,
    Description: 'Detention Facility Agency Rev',
  },
  {
    Code: 6377,
    Description: 'Detention Facility Agency Exp',
  },
  {
    Code: 6400,
    Description: 'Liquor Board',
  },
  {
    Code: 6420,
    Description: 'Support Agency',
  },
  {
    Code: 6421,
    Description: 'Escrow Account',
  },
  {
    Code: 6422,
    Description: 'Misc. Receivable Support',
  },
  {
    Code: 6423,
    Description: 'Reserve - Unclaimed Checks',
  },
  {
    Code: 6424,
    Description: 'Returned Checks',
  },
  {
    Code: 6425,
    Description: 'Unidentified Receipts',
  },
  {
    Code: 6450,
    Description: 'City & State Tax Coll. Agency',
  },
  {
    Code: 6475,
    Description: ' Area Agency on Aging',
  },
  {
    Code: 6476,
    Description: 'Aging',
  },
  {
    Code: 6477,
    Description: 'D-AAA Admin',
  },
  {
    Code: 6478,
    Description: 'D-AAA Admin IIIB',
  },
  {
    Code: 6479,
    Description: 'D-Aux AACo Med Soc',
  },
  {
    Code: 6480,
    Description: 'D-Elder Abse Trng T-III',
  },
  {
    Code: 6481,
    Description: 'D-Elder Abse Trng T-III G',
  },
  {
    Code: 6482,
    Description: 'D-Eldercare T-III',
  },
  {
    Code: 6483,
    Description: 'D-Hsg Svcs Annapolis',
  },
  {
    Code: 6484,
    Description: 'D-I & A St, (Gwy I)',
  },
  {
    Code: 6485,
    Description: 'D-In Hme Care T-III B',
  },
  {
    Code: 6486,
    Description: 'D-In Hme Care T-III D',
  },
  {
    Code: 6487,
    Description: 'D-In Home Care',
  },
  {
    Code: 6488,
    Description: 'D-In Home Care T-III B',
  },
  {
    Code: 6489,
    Description: 'D-In Home Care T-III D',
  },
  {
    Code: 6490,
    Description: 'D-Info and Assist (Hum Svc)',
  },
  {
    Code: 6491,
    Description: 'D-Legal Aid Bureau, Inc.',
  },
  {
    Code: 6492,
    Description: 'D-Meals on Wheels',
  },
  {
    Code: 6493,
    Description: 'D-Nutrition',
  },
  {
    Code: 6494,
    Description: 'D-Ombudsman',
  },
  {
    Code: 6495,
    Description: 'D-Prev Hlth Serv',
  },
  {
    Code: 6496,
    Description: 'D-Sr Care State (Gwy II)',
  },
  {
    Code: 6497,
    Description: 'D-Sr Care (Health Dept)',
  },
  {
    Code: 6498,
    Description: 'D-Sr I & A St (Gwy I)',
  },
  {
    Code: 6499,
    Description: 'D-Sr Visitation/POW',
  },
  {
    Code: 6500,
    Description: 'D-Transfer to Next FY-',
  },
  {
    Code: 6501,
    Description: 'D-Transfer to Next FY-B',
  },
  {
    Code: 6502,
    Description: 'D-Transfer to Next FY-C1',
  },
  {
    Code: 6503,
    Description: 'D-Transfer to Next FY-C2',
  },
  {
    Code: 6504,
    Description: 'D-Transfer to Next FY. F',
  },
  {
    Code: 6505,
    Description: 'D-Transportation',
  },
  {
    Code: 6506,
    Description: 'R-I & A St, (Gwy I)',
  },
  {
    Code: 6507,
    Description: 'R-Sr Care State (Gwy II)',
  },
  {
    Code: 6508,
    Description: 'R-Title III-D',
  },
  {
    Code: 6509,
    Description: 'R-Title III-G',
  },
  {
    Code: 6510,
    Description: 'R-Title III B',
  },
  {
    Code: 6511,
    Description: 'R-Title III C1',
  },
  {
    Code: 6512,
    Description: 'R-Title III C2',
  },
  {
    Code: 6513,
    Description: 'R-Title III D',
  },
  {
    Code: 6514,
    Description: 'R-Title III Eldercare',
  },
  {
    Code: 6515,
    Description: 'R-Title III F',
  },
  {
    Code: 6516,
    Description: 'R-Title III G',
  },
  {
    Code: 6550,
    Description: 'Reforestation',
  },
  {
    Code: 6551,
    Description: 'Reforestation-Non-Refundable',
  },
  {
    Code: 6552,
    Description: 'Forest Conservation-Non Refund',
  },
  {
    Code: 6553,
    Description: 'Reforest Tree-Bill',
  },
  {
    Code: 6554,
    Description: 'Reforestation-Refundable',
  },
  {
    Code: 6555,
    Description: 'Forest Conserv-Refund',
  },
  {
    Code: 6575,
    Description: 'Deferred Comp. Plan Agency',
  },
  {
    Code: 6576,
    Description: 'T. Rowe Price',
  },
  {
    Code: 6577,
    Description: 'American United',
  },
  {
    Code: 6578,
    Description: 'Great West',
  },
  {
    Code: 6590,
    Description: 'Tax Sale Escrow Deposits',
  },
  {
    Code: 6591,
    Description: 'Tax Sale Escrow Deposits',
  },
  {
    Code: 6592,
    Description: 'Tax Sale Auction',
  },
  {
    Code: 6593,
    Description: 'Bid Premium Deposit',
  },
  {
    Code: 6650,
    Description: 'Other Agency',
  },
  {
    Code: 6651,
    Description: 'Castranda',
  },
  {
    Code: 6652,
    Description: 'CDBG loan repayments',
  },
  {
    Code: 6653,
    Description: 'CDBG loans',
  },
  {
    Code: 6654,
    Description: 'Community devel  CDBG',
  },
  {
    Code: 6655,
    Description: 'Development tax',
  },
  {
    Code: 6656,
    Description: 'Drug and alcohol contrib',
  },
  {
    Code: 6657,
    Description: 'Drug and alcohol escrow',
  },
  {
    Code: 6658,
    Description: 'Employee Snack Bar Escrow',
  },
  {
    Code: 6659,
    Description: 'Escrow-Space Permit',
  },
  {
    Code: 6660,
    Description: 'Escrow - Crofton Village',
  },
  {
    Code: 6661,
    Description: 'Escrow - N. Arundel CATV',
  },
  {
    Code: 6662,
    Description: 'Glen Burnie Park Gar. Escrow',
  },
  {
    Code: 6663,
    Description: 'Heritage Rental Escrows',
  },
  {
    Code: 6664,
    Description: 'Home Wenshp Assist-Escrow',
  },
  {
    Code: 6665,
    Description: 'Kaiser-Aetna',
  },
  {
    Code: 6666,
    Description: 'PST Reclamation - Royalty',
  },
  {
    Code: 6667,
    Description: 'PST, Inc. Road Escrow',
  },
  {
    Code: 6668,
    Description: 'Rehab loans  Deferred Income',
  },
  {
    Code: 6669,
    Description: 'Rehab Loans Receivable',
  },
  {
    Code: 6670,
    Description: 'River Walk at Blk Wal Esc',
  },
  {
    Code: 6671,
    Description: 'Scatter Site Loan Escrow',
  },
  {
    Code: 6672,
    Description: "Sheriff's Escrow - Dist. Ct.",
  },
  {
    Code: 6673,
    Description: 'Sheriff Sale Escrow',
  },
  {
    Code: 6674,
    Description: 'Woodwise Purchase Escrow',
  },
  {
    Code: 6675,
    Description: 'Garden Plots',
  },
  {
    Code: 6676,
    Description: 'Employee Orioles Tickets',
  },
  {
    Code: 6677,
    Description: 'Cable Franchise Escrow',
  },
  {
    Code: 6678,
    Description: 'Health Dept-Septic Sys Modif.',
  },
  {
    Code: 8001,
    Description: 'Court House',
  },
  {
    Code: 8003,
    Description: 'Court House Annex',
  },
  {
    Code: 8004,
    Description: 'Court House(Allen Building)',
  },
  {
    Code: 8005,
    Description: 'Court House (New 1997)',
  },
  {
    Code: 8007,
    Description: 'Tipton Airport',
  },
  {
    Code: 8010,
    Description: 'Pumphrey Keaser Comm Ctr',
  },
  {
    Code: 8011,
    Description: 'Ralph Bunch Comm Ctr',
  },
  {
    Code: 8015,
    Description: 'Arundel Center',
  },
  {
    Code: 8020,
    Description: 'Right of Way Houses',
  },
  {
    Code: 8023,
    Description: 'Mary Mount Manor',
  },
  {
    Code: 8025,
    Description: 'Bates High School',
  },
  {
    Code: 8028,
    Description: "Sarah's House",
  },
  {
    Code: 8030,
    Description: 'Southern Mobile Maintenance',
  },
  {
    Code: 8032,
    Description: 'Alternative H.S. - Winterode',
  },
  {
    Code: 8033,
    Description: 'Winterode Bldg-C.I.D.',
  },
  {
    Code: 8035,
    Description: 'Winterode Bldg-Rec & Parks',
  },
  {
    Code: 8037,
    Description: 'Winterode Bldg-Careers Ctr',
  },
  {
    Code: 8040,
    Description: 'Brooklyn Park MS/Aging',
  },
  {
    Code: 8043,
    Description: 'Arundel Center North',
  },
  {
    Code: 8044,
    Description: 'Ice Rink',
  },
  {
    Code: 8045,
    Description: 'Glen Burnie Office Bldg',
  },
  {
    Code: 8046,
    Description: 'Animal Shelter',
  },
  {
    Code: 8047,
    Description: 'Utilities Building',
  },
  {
    Code: 8048,
    Description: 'Utilities Garage & Shop',
  },
  {
    Code: 8049,
    Description: 'Utils & Animal Cntrl-Park Lot',
  },
  {
    Code: 8050,
    Description: 'Garage - Glen Burnie',
  },
  {
    Code: 8052,
    Description: 'Glen Burnie Parking Garage',
  },
  {
    Code: 8053,
    Description: 'Glen Burnie Warehouse',
  },
  {
    Code: 8054,
    Description: 'G. B. Urban Renewal Elect Svc',
  },
  {
    Code: 8055,
    Description: 'Hein Bros. Bldg.',
  },
  {
    Code: 8056,
    Description: 'Robinson Bldg.',
  },
  {
    Code: 8057,
    Description: 'Baltimore Annapolis Bldg',
  },
  {
    Code: 8058,
    Description: 'Heritage Office Bldg -2660',
  },
  {
    Code: 8059,
    Description: 'Heirtage Office Bldg - 2662',
  },
  {
    Code: 8060,
    Description: 'Heritage Office Bldg - 2664',
  },
  {
    Code: 8061,
    Description: 'Heritage Office Bldg- 2666',
  },
  {
    Code: 8063,
    Description: 'Evidence Storage Warehouse',
  },
  {
    Code: 8064,
    Description: 'Drug Lab',
  },
  {
    Code: 8066,
    Description: 'POLICE DEPT.  - HEADQUARTERS',
  },
  {
    Code: 8067,
    Description: 'New Animal Control Building',
  },
  {
    Code: 8068,
    Description: 'Fire Dept. Headquarters',
  },
  {
    Code: 8070,
    Description: 'Fire Training School',
  },
  {
    Code: 8072,
    Description: 'Garage - Central & Car Wash',
  },
  {
    Code: 8074,
    Description: 'Commun Tower-Millersville',
  },
  {
    Code: 8075,
    Description: 'Commun Tower-Solomon Is Rd',
  },
  {
    Code: 8076,
    Description: 'Commun Tower-So Md Blve',
  },
  {
    Code: 8077,
    Description: 'Commun Tower-5500 Sudley Rd',
  },
  {
    Code: 8078,
    Description: 'Comm Tower & Bldg-5463 Sudley',
  },
  {
    Code: 8079,
    Description: 'Comm Tower & Bldg-Soley Rd',
  },
  {
    Code: 8080,
    Description: 'Commun Tower-Fire Hdqtrs',
  },
  {
    Code: 8081,
    Description: 'Comm Tower & Bldg-Public Works',
  },
  {
    Code: 8082,
    Description: 'Comm Tower & Bldg-Jessup FS',
  },
  {
    Code: 8083,
    Description: 'Commun Tower-Broadcreek',
  },
  {
    Code: 8085,
    Description: 'Jennifer Road Gas Pump',
  },
  {
    Code: 8088,
    Description: 'Detention Center - Ordnance',
  },
  {
    Code: 8090,
    Description: 'Detention Center',
  },
  {
    Code: 8092,
    Description: 'Garage-So Dist Central Ave 214',
  },
  {
    Code: 8093,
    Description: 'Joe Cannon Rental House',
  },
  {
    Code: 8094,
    Description: 'Broadneck Caretaker',
  },
  {
    Code: 8095,
    Description: 'Corridor Park Caretaker',
  },
  {
    Code: 8096,
    Description: 'South Farm Caretaker',
  },
  {
    Code: 8097,
    Description: 'Jug Bay Caretaker',
  },
  {
    Code: 8098,
    Description: 'Kinder Park Caretaker',
  },
  {
    Code: 8099,
    Description: 'Cook Farm Caretaker',
  },
  {
    Code: 8101,
    Description: 'Cecil Ave MV Ranger Station',
  },
  {
    Code: 8102,
    Description: 'Linthicum Walks',
  },
  {
    Code: 8108,
    Description: 'Heritage Office Center',
  },
  {
    Code: 8110,
    Description: 'Arundel Olympic Swim Center',
  },
  {
    Code: 8113,
    Description: 'Public Works Building',
  },
  {
    Code: 8115,
    Description: 'Health Department',
  },
  {
    Code: 8117,
    Description: 'Library Headquarters',
  },
  {
    Code: 8120,
    Description: 'POLICE - S.O.S',
  },
  {
    Code: 8121,
    Description: 'Dorsey Annex - Circuit Court',
  },
  {
    Code: 8123,
    Description: 'Senior Center - South County',
  },
  {
    Code: 8125,
    Description: "Senior Center - O'Malley",
  },
  {
    Code: 8127,
    Description: 'Senior Center - Edgewater',
  },
  {
    Code: 8128,
    Description: 'Senior Center - Pascal',
  },
  {
    Code: 8130,
    Description: 'Senior Center - Arnold',
  },
  {
    Code: 8131,
    Description: 'Pasadena Senior Center',
  },
  {
    Code: 8132,
    Description: 'Northern Health Center',
  },
  {
    Code: 8133,
    Description: 'Annapolis Senior Center',
  },
  {
    Code: 8135,
    Description: 'Sommerville Medical Center',
  },
  {
    Code: 8137,
    Description: 'Bay Head Nike Site',
  },
  {
    Code: 8138,
    Description: 'St Margarets Office Building',
  },
  {
    Code: 8139,
    Description: 'Central Mobile Maintenance',
  },
  {
    Code: 8140,
    Description: 'Hotspot',
  },
  {
    Code: 8141,
    Description: 'POLICE  ACADEMY',
  },
  {
    Code: 8142,
    Description: 'POL - PORTABLE RADAR UNITS',
  },
  {
    Code: 8143,
    Description: 'POLICE STATION - NORTHERN',
  },
  {
    Code: 8145,
    Description: 'POLICE STATION - SOUTHERN',
  },
  {
    Code: 8147,
    Description: 'POLICE STATION - EASTERN',
  },
  {
    Code: 8149,
    Description: 'Fire Station - Paramedic Ten',
  },
  {
    Code: 8150,
    Description: 'POLICE STATION - WESTERN',
  },
  {
    Code: 8152,
    Description: 'Horticulture Crew',
  },
  {
    Code: 8153,
    Description: 'Beautification Projects',
  },
  {
    Code: 8156,
    Description: 'Library - Brooklyn Park',
  },
  {
    Code: 8158,
    Description: 'Library - Crofton',
  },
  {
    Code: 8160,
    Description: 'Library - N County Harundale',
  },
  {
    Code: 8162,
    Description: 'Library - Mountain Road',
  },
  {
    Code: 8164,
    Description: 'Library - Linthicum',
  },
  {
    Code: 8166,
    Description: 'Library - Odenton',
  },
  {
    Code: 8168,
    Description: 'Library - Riveria Beach',
  },
  {
    Code: 8170,
    Description: 'Library - Severna Park',
  },
  {
    Code: 8172,
    Description: 'Library - South County',
  },
  {
    Code: 8174,
    Description: 'Library - Annapolis',
  },
  {
    Code: 8176,
    Description: 'Library - Maryland City',
  },
  {
    Code: 8178,
    Description: 'Library - Eastport /Annap Neck',
  },
  {
    Code: 8180,
    Description: 'Library - Broadneck',
  },
  {
    Code: 8182,
    Description: 'Library - Provinces',
  },
  {
    Code: 8185,
    Description: 'Library - Edgewater',
  },
  {
    Code: 8186,
    Description: 'Roads - So. Friendship',
  },
  {
    Code: 8188,
    Description: 'Roads - Eastern Office Bldg.',
  },
  {
    Code: 8192,
    Description: 'Roads - Cent District-St Marg',
  },
  {
    Code: 8194,
    Description: 'Roads - Central District',
  },
  {
    Code: 8196,
    Description: 'Roads - So. Dist-Shady Side',
  },
  {
    Code: 8198,
    Description: 'Roads-So. Dist Central Ave 214',
  },
  {
    Code: 8200,
    Description: 'Roads - Western District',
  },
  {
    Code: 8202,
    Description: 'Roads - Northern District',
  },
  {
    Code: 8208,
    Description: 'Landfill - Glen Burnie',
  },
  {
    Code: 8209,
    Description: 'Landfill - Millersville',
  },
  {
    Code: 8210,
    Description: 'Landfill - S County(Sudley)',
  },
  {
    Code: 8211,
    Description: 'Odenton Health Center',
  },
  {
    Code: 8214,
    Description: 'Rds/Gar So Dist Cent Ave 214 C',
  },
  {
    Code: 8216,
    Description: 'Londontown Publik House',
  },
  {
    Code: 8222,
    Description: 'CSSC',
  },
  {
    Code: 8224,
    Description: 'Air Quality Lab',
  },
  {
    Code: 8225,
    Description: 'Materials Lab - St Marg',
  },
  {
    Code: 8226,
    Description: 'David Taylor Building',
  },
  {
    Code: 8229,
    Description: 'Cecil Avenue',
  },
  {
    Code: 8230,
    Description: 'Owensville Medical',
  },
  {
    Code: 8231,
    Description: 'Rec. Center - South County',
  },
  {
    Code: 8233,
    Description: 'Northern Mobile Maint.',
  },
  {
    Code: 8235,
    Description: 'Rec. & Parks - Golf Course',
  },
  {
    Code: 8236,
    Description: 'R & P - Golf Course Maint Bldg',
  },
  {
    Code: 8238,
    Description: 'R & P - Triton/Beverly Beach',
  },
  {
    Code: 8240,
    Description: 'Jessup YMCA',
  },
  {
    Code: 8241,
    Description: 'Rec. & Parks - Quiet Waters',
  },
  {
    Code: 8243,
    Description: 'Fire Station - Glen Burnie',
  },
  {
    Code: 8245,
    Description: 'Fire Station - Cape St. Claire',
  },
  {
    Code: 8247,
    Description: 'Fire Station - S Glen Burnie',
  },
  {
    Code: 8249,
    Description: 'Fire Station - Harmans/Dorsey',
  },
  {
    Code: 8251,
    Description: 'Fire Station - Jones Station',
  },
  {
    Code: 8253,
    Description: 'Fire Station - Jessup',
  },
  {
    Code: 8255,
    Description: 'Fire Station - Lombardee Beach',
  },
  {
    Code: 8257,
    Description: 'Fire Station - Linthicum',
  },
  {
    Code: 8259,
    Description: 'Fire Station - Maryland City',
  },
  {
    Code: 8261,
    Description: 'Fire Station - Waugh Chapel',
  },
  {
    Code: 8263,
    Description: 'Fire Station - West Annapolis',
  },
  {
    Code: 8264,
    Description: 'Fire Station-Vol/Green Haven',
  },
  {
    Code: 8265,
    Description: 'Fire Station - Harwood/Lothian',
  },
  {
    Code: 8267,
    Description: 'Fire Station-Vol/Orchard Beach',
  },
  {
    Code: 8268,
    Description: 'Fire Station - Armiger',
  },
  {
    Code: 8279,
    Description: 'Miscellaneous',
  },
  {
    Code: 8280,
    Description: 'Jessup Commuter Rail Station',
  },
  {
    Code: 8286,
    Description: 'Fire Station-Vol/Arnold',
  },
  {
    Code: 8288,
    Description: 'Fire Station-Vol/Arundel',
  },
  {
    Code: 8290,
    Description: 'Fire Station - Avalon Shores',
  },
  {
    Code: 8292,
    Description: 'Fire Station-Vol/Brooklyn',
  },
  {
    Code: 8294,
    Description: 'Fire Station-Vol/Deale',
  },
  {
    Code: 8296,
    Description: 'Fire Station-Vol/Erlgh Hghts',
  },
  {
    Code: 8298,
    Description: 'Fire Station-Vol/Ferndale',
  },
  {
    Code: 8300,
    Description: 'Fire Station-Vol/Galesville',
  },
  {
    Code: 8302,
    Description: 'Fire Station-Vol/Herald Harbor',
  },
  {
    Code: 8304,
    Description: 'Fire Station-Vol/Lake Shore',
  },
  {
    Code: 8306,
    Description: 'Fire Station - Marley',
  },
  {
    Code: 8308,
    Description: 'Fire Station-Vol/Odenton',
  },
  {
    Code: 8310,
    Description: 'Bell Branch Park',
  },
  {
    Code: 8312,
    Description: 'Fire Station-Vol/Powhatan Bch',
  },
  {
    Code: 8314,
    Description: 'Fire Station-Vol/Riva',
  },
  {
    Code: 8316,
    Description: 'Fire Station-Vol/Riveria Beach',
  },
  {
    Code: 8318,
    Description: 'Fire Station-Vol/Woodland Bch',
  },
  {
    Code: 8320,
    Description: 'Fire Rescue Squad - 7th Dist',
  },
  {
    Code: 8322,
    Description: 'Rec & Parks - Downs Memorial',
  },
  {
    Code: 8323,
    Description: 'Rec & Parks - Kinder Park',
  },
  {
    Code: 8324,
    Description: 'Rec & Parks - Lake Waterford',
  },
  {
    Code: 8325,
    Description: 'Rec & Parks - Mayo Beach',
  },
  {
    Code: 8326,
    Description: 'Rec & Parks - Harmans Park',
  },
  {
    Code: 8327,
    Description: 'Rec & Parks - High Point Park',
  },
  {
    Code: 8328,
    Description: 'Rec & Parks - Thomas Point',
  },
  {
    Code: 8329,
    Description: 'R&P-Davidsonville Family R C',
  },
  {
    Code: 8330,
    Description: 'Rec & Parks - Equestrian Cntr',
  },
  {
    Code: 8331,
    Description: 'Rec & Parks - Andover Park',
  },
  {
    Code: 8332,
    Description: 'Rec & Parks - Sawmill Creek',
  },
  {
    Code: 8333,
    Description: 'Rec & Parks - Md City Rec A',
  },
  {
    Code: 8334,
    Description: 'Rec & Parks - Jug Bay Rec A',
  },
  {
    Code: 8335,
    Description: 'Rec & Parks - Joe Cannon Stdm',
  },
  {
    Code: 8336,
    Description: 'Annapolis High Court',
  },
  {
    Code: 8337,
    Description: 'Arden of the Seven Park',
  },
  {
    Code: 8338,
    Description: 'Arnold Park',
  },
  {
    Code: 8339,
    Description: 'Arundel Hills Park',
  },
  {
    Code: 8340,
    Description: 'Arundel Village',
  },
  {
    Code: 8341,
    Description: 'B & A Trail Park',
  },
  {
    Code: 8342,
    Description: 'Bacontown Park',
  },
  {
    Code: 8344,
    Description: 'Belvedere Park',
  },
  {
    Code: 8345,
    Description: 'Bestgate Park',
  },
  {
    Code: 8346,
    Description: 'Beverly/Triton Beach',
  },
  {
    Code: 8347,
    Description: 'Brooklyn Park 2',
  },
  {
    Code: 8348,
    Description: 'Brownswood Park',
  },
  {
    Code: 8349,
    Description: 'Crofton Park',
  },
  {
    Code: 8350,
    Description: "Deale/Tracy's Park",
  },
  {
    Code: 8351,
    Description: 'Edgewater Park',
  },
  {
    Code: 8352,
    Description: 'Elvation Park',
  },
  {
    Code: 8353,
    Description: 'Freetown Park',
  },
  {
    Code: 8354,
    Description: 'Glen Burnie Park',
  },
  {
    Code: 8355,
    Description: 'Herald Harbor Park',
  },
  {
    Code: 8356,
    Description: 'Jacobsville Park',
  },
  {
    Code: 8357,
    Description: 'Jessup/Dorsey Park',
  },
  {
    Code: 8358,
    Description: 'Jessup Provinces Park',
  },
  {
    Code: 8359,
    Description: 'Lake Shore Athletic Complex',
  },
  {
    Code: 8360,
    Description: 'Lake Shore Park',
  },
  {
    Code: 8361,
    Description: 'Linthicum Park',
  },
  {
    Code: 8362,
    Description: 'Loch Haven Park',
  },
  {
    Code: 8363,
    Description: 'Tick Neck Park',
  },
  {
    Code: 8364,
    Description: 'Odenton Park',
  },
  {
    Code: 8365,
    Description: 'Overlook Park',
  },
  {
    Code: 8366,
    Description: 'Peninsula Park(AOB)',
  },
  {
    Code: 8367,
    Description: 'Pleasantville Park',
  },
  {
    Code: 8368,
    Description: 'Point Pleasant Park',
  },
  {
    Code: 8369,
    Description: 'Poplar Ridge/Ft Smallwood',
  },
  {
    Code: 8370,
    Description: 'Pumphrey Park',
  },
  {
    Code: 8371,
    Description: 'Queenstown Park',
  },
  {
    Code: 8372,
    Description: 'Riverside Park',
  },
  {
    Code: 8373,
    Description: 'Riverwood Park',
  },
  {
    Code: 8374,
    Description: 'Rock Creek Park',
  },
  {
    Code: 8375,
    Description: 'Shady Side Park',
  },
  {
    Code: 8376,
    Description: "Shipley' Choice",
  },
  {
    Code: 8378,
    Description: 'Solley Park',
  },
  {
    Code: 8379,
    Description: 'So County Softball Field',
  },
  {
    Code: 8380,
    Description: 'Southgate/Old Mill Park',
  },
  {
    Code: 8381,
    Description: 'So. River Farm',
  },
  {
    Code: 8382,
    Description: 'South Shore Trail',
  },
  {
    Code: 8383,
    Description: 'Sunset Park',
  },
  {
    Code: 8384,
    Description: 'Towers Branch Park',
  },
  {
    Code: 8385,
    Description: 'Twin Oaks',
  },
  {
    Code: 8386,
    Description: 'Waterbury Park',
  },
  {
    Code: 8387,
    Description: "Carr's Wharf",
  },
  {
    Code: 8388,
    Description: 'Deale Wharf',
  },
  {
    Code: 8389,
    Description: 'Freetown Rec. Center',
  },
  {
    Code: 8390,
    Description: 'Galesville Wharf',
  },
  {
    Code: 8391,
    Description: 'Hancocks Resolution',
  },
  {
    Code: 8392,
    Description: 'Londontown Publik House',
  },
  {
    Code: 8393,
    Description: 'Meade Village Rec. Center',
  },
  {
    Code: 8394,
    Description: 'South County Rec. Center',
  },
  {
    Code: 8396,
    Description: 'Upton Road Softball Complex',
  },
  {
    Code: 8397,
    Description: 'Brooklyn Park 1',
  },
  {
    Code: 8398,
    Description: 'Cape St. Claire Park',
  },
  {
    Code: 8399,
    Description: 'Cedar Hill Park',
  },
  {
    Code: 8400,
    Description: 'Cypress Creek Park',
  },
  {
    Code: 8401,
    Description: 'Davidsonville Park',
  },
  {
    Code: 8402,
    Description: 'Bell Branch Park',
  },
  {
    Code: 8403,
    Description: 'Friendship Park',
  },
  {
    Code: 8404,
    Description: 'Hammonds Park',
  },
  {
    Code: 8405,
    Description: 'Havenwood Park',
  },
  {
    Code: 8406,
    Description: 'Jessup 1 Park',
  },
  {
    Code: 8407,
    Description: 'Mago Vista Park',
  },
  {
    Code: 8408,
    Description: 'North Glen Park',
  },
  {
    Code: 8409,
    Description: 'Corridor Park',
  },
  {
    Code: 8410,
    Description: 'Severn/Danza Park',
  },
  {
    Code: 8411,
    Description: 'Broadneck',
  },
  {
    Code: 8413,
    Description: 'Bodkin Park',
  },
  {
    Code: 8414,
    Description: 'Bachman Park',
  },
  {
    Code: 8415,
    Description: 'BW & A Trailer Park - MV',
  },
  {
    Code: 8419,
    Description: 'Smith Horse Farm',
  },
  {
    Code: 8420,
    Description: 'Furniture Repairs',
  },
  {
    Code: 9000,
    Description: 'Library',
  },
  {
    Code: 9001,
    Description: 'Library Revenues',
  },
  {
    Code: 9002,
    Description: 'Annapolis Branch',
  },
  {
    Code: 9003,
    Description: 'Brooklyn Branch',
  },
  {
    Code: 9004,
    Description: 'Linthicum Branch',
  },
  {
    Code: 9005,
    Description: 'North County Branch',
  },
  {
    Code: 9006,
    Description: 'Odenton Branch',
  },
  {
    Code: 9007,
    Description: 'Riviera Beach Branch',
  },
  {
    Code: 9008,
    Description: 'Severna Park Branch',
  },
  {
    Code: 9009,
    Description: 'South County Branch',
  },
  {
    Code: 9010,
    Description: 'Administration',
  },
  {
    Code: 9011,
    Description: 'Crofton Branch',
  },
  {
    Code: 9012,
    Description: 'Annapolis Neck Branch',
  },
  {
    Code: 9013,
    Description: 'Maryland City Branch',
  },
  {
    Code: 9014,
    Description: 'Broadneck Branch',
  },
  {
    Code: 9015,
    Description: 'Provinces Branch',
  },
  {
    Code: 9016,
    Description: 'Edgewater Branch',
  },
  {
    Code: 9017,
    Description: 'Mountain Rd Branch',
  },
  {
    Code: 9050,
    Description: 'CLCM Escrow',
  },
  {
    Code: 9051,
    Description: 'Elizabeth Werner Memorial',
  },
  {
    Code: 9052,
    Description: 'Elmer M Jackson Jr. Mem Fund',
  },
  {
    Code: 9053,
    Description: 'Library Updates',
  },
  {
    Code: 9054,
    Description: 'Memorial',
  },
  {
    Code: 9055,
    Description: 'Miscellaneous Donations',
  },
  {
    Code: 9061,
    Description: 'Special Projects',
  },
  {
    Code: 9062,
    Description: 'Staff AV',
  },
  {
    Code: 9063,
    Description: 'Staff Benefits',
  },
  {
    Code: 9064,
    Description: 'Staff Books',
  },
  {
    Code: 9065,
    Description: 'MLGIP Investment Earnings',
  },
  {
    Code: 9066,
    Description: 'Training',
  },
  {
    Code: 9067,
    Description: 'Maryland City Opening',
  },
  {
    Code: 9068,
    Description: 'Tech Scholarship',
  },
  {
    Code: 9069,
    Description: 'DLDS/Encly Brit Escrow',
  },
  {
    Code: 9070,
    Description: 'Staff Book Shipping',
  },
  {
    Code: 9071,
    Description: 'MCEN Registration',
  },
  {
    Code: 9072,
    Description: 'Summer Reading Promotions',
  },
  {
    Code: 9083,
    Description: 'Univ. Svc Fund Refund',
  },
  {
    Code: 9090,
    Description: 'Library  GASB34 Conversion Fd',
  },
  {
    Code: 9091,
    Description: 'Asset Expense',
  },
  {
    Code: 9100,
    Description: 'Library Grants Special Revenue',
  },
  {
    Code: 9197,
    Description: 'Library Deferred Compensation',
  },
  {
    Code: 9198,
    Description: 'Library General Long Term Debt',
  },
  {
    Code: 9199,
    Description: 'Library General Fixed Assets',
  },
  {
    Code: 9200,
    Description: 'Board of Education',
  },
  {
    Code: 9201,
    Description: 'Board of Education Revenues',
  },
  {
    Code: 9202,
    Description: 'Administration',
  },
  {
    Code: 9203,
    Description: 'Mid-Level Admin',
  },
  {
    Code: 9204,
    Description: 'Instructional Salaries',
  },
  {
    Code: 9205,
    Description: 'Other Instruct Cost',
  },
  {
    Code: 9206,
    Description: 'Textbooks/Supplies',
  },
  {
    Code: 9207,
    Description: 'Pupil Services',
  },
  {
    Code: 9208,
    Description: 'Pupil Transportation',
  },
  {
    Code: 9209,
    Description: 'Operation of Plant',
  },
  {
    Code: 9210,
    Description: 'Maintenance of Plant',
  },
  {
    Code: 9211,
    Description: 'Fixed Charges',
  },
  {
    Code: 9212,
    Description: 'Community Services',
  },
  {
    Code: 9213,
    Description: 'Capital Outlay',
  },
  {
    Code: 9214,
    Description: 'Debt Service',
  },
  {
    Code: 9215,
    Description: 'Special Education',
  },
  {
    Code: 9300,
    Description: 'Community College (Budget Only',
  },
  {
    Code: 9301,
    Description: 'Community College Fund Revenue',
  },
  {
    Code: 9302,
    Description: 'Instruction',
  },
  {
    Code: 9303,
    Description: 'Academic Support',
  },
  {
    Code: 9304,
    Description: 'Student Services',
  },
  {
    Code: 9305,
    Description: 'Plant Operations',
  },
  {
    Code: 9306,
    Description: 'Institutional Support',
  },
  {
    Code: 9307,
    Description: 'Debt Service',
  },
  {
    Code: 9400,
    Description: 'Workforce Development Corp.',
  },
  {
    Code: 9800,
    Description: 'General Long Term Debt',
  },
  {
    Code: 9900,
    Description: 'General Fixed Assets',
  },
  {
    Code: 9901,
    Description: 'Asset Expense',
  },
  {
    Code: 9990,
    Description: 'Blanket Purchase Orders',
  },
  {
    Code: 9995,
    Description: 'Cent Serv Property Inventory',
  },
  {
    Code: 9996,
    Description: 'CS Prop Inv - Asset Expense',
  },
  {
    Code: 9997,
    Description: 'FA Intransit Physical Owner',
  },
  {
    Code: 9998,
    Description: 'FA Physical Owner - Hold',
  },
];

export const originalPurchasers = [
  {
    Code: '',
    Description: '',
  },
  {
    Code: ' ',
    Description: '                             .',
  },
  {
    Code: ' C106700',
    Description: 'Advance Land Acquisition',
  },
  {
    Code: ' C106701',
    Description: 'Advance Land Acquisition',
  },
  {
    Code: ' C106799',
    Description: 'Adv Land Acq - Conv',
  },
  {
    Code: ' C206500',
    Description: 'Demo Bldg Code/Health',
  },
  {
    Code: ' C206501',
    Description: 'Demo Brown & American Homes',
  },
  {
    Code: ' C206502',
    Description: 'Demo Oscar Thomas Property',
  },
  {
    Code: ' C206503',
    Description: 'Demo Williams II Property',
  },
  {
    Code: ' C206504',
    Description: 'Demo Floyd Clark Property',
  },
  {
    Code: ' C206505',
    Description: 'Demo Miller Property',
  },
  {
    Code: ' C206506',
    Description: 'Demo Bolivor Avenue',
  },
  {
    Code: ' C206507',
    Description: 'Demo Kharod Property',
  },
  {
    Code: ' C206508',
    Description: 'Demo Brock Bridge Road',
  },
  {
    Code: ' C206509',
    Description: 'Demo Debra Cowan Property',
  },
  {
    Code: ' C206510',
    Description: 'Demo Houston Property',
  },
  {
    Code: ' C206511',
    Description: 'Demo Duvall Property',
  },
  {
    Code: ' C206512',
    Description: 'Demo Heyser Property',
  },
  {
    Code: ' C206513',
    Description: 'Demo Lot 115 & 99 6th St',
  },
  {
    Code: ' C206514',
    Description: 'Demo 361 Volley Cove Arnold',
  },
  {
    Code: ' C206515',
    Description: 'Demo Annapolis Neck Prop',
  },
  {
    Code: ' C206516',
    Description: 'Demo Walnut Av, North Beach',
  },
  {
    Code: ' C206517',
    Description: 'Demo 7343 Green Acres Dr',
  },
  {
    Code: ' C206518',
    Description: 'Demo 100 7th Av, Brooklyn',
  },
  {
    Code: ' C206519',
    Description: 'Demo 323 Zepplin Av, Baltimore',
  },
  {
    Code: ' C206520',
    Description: 'Demo 315 Linden Av, Edgewater',
  },
  {
    Code: ' C206521',
    Description: 'Demo 200 Berlin Av, Baltimore',
  },
  {
    Code: ' C206522',
    Description: 'Demo 1216 Cross Rd, Annapolis',
  },
  {
    Code: ' C206523',
    Description: 'Demo 215 Kuethe Rd, GB',
  },
  {
    Code: ' C206524',
    Description: 'Demo 5915 Belle Grove, Balt',
  },
  {
    Code: ' C206525',
    Description: 'Demo 238 N Hammonds Ferry Rd',
  },
  {
    Code: ' C206526',
    Description: 'Demo 100 First Av, Glen Burnie',
  },
  {
    Code: ' C206527',
    Description: 'Demo 200 9th Av, SE, GB',
  },
  {
    Code: ' C206528',
    Description: 'Demo 7155 Forest Av, Hanover',
  },
  {
    Code: ' C206529',
    Description: '2006 Willow Way, Crofton',
  },
  {
    Code: ' C206530',
    Description: 'Demo 2456 Pike Ridge Rd',
  },
  {
    Code: ' C206531',
    Description: 'Demo 1441 Watts Av, Severn',
  },
  {
    Code: ' C206532',
    Description: 'Demo 7880 Brockbridge Rd',
  },
  {
    Code: ' C206533',
    Description: 'Demo 777 MacSherry Dr,Arnold',
  },
  {
    Code: ' C206534',
    Description: 'Demo 4103 3rd Street, Balt.',
  },
  {
    Code: ' C206535',
    Description: 'Demo 1009 Kelso Dr, GB',
  },
  {
    Code: ' C206536',
    Description: 'Demo 436 Crain Hwy, GB',
  },
  {
    Code: ' C206537',
    Description: 'Demo 1216 Cross Rd, Annap II',
  },
  {
    Code: ' C206538',
    Description: 'Demo Well, 391 Yorkshire Ln.',
  },
  {
    Code: ' C206539',
    Description: 'Demo 506 Sunset Knoll Road',
  },
  {
    Code: ' C206540',
    Description: 'Trash Removal, 2201 Fendall',
  },
  {
    Code: ' C206541',
    Description: 'Demo 5 Carvel Crt, Pasadena',
  },
  {
    Code: ' C206599',
    Description: 'Demo Bldg Code - Conv',
  },
  {
    Code: ' C231700',
    Description: 'W/S Conn Revolv Fund',
  },
  {
    Code: ' C231701',
    Description: 'W/S Conn Revolv Fund',
  },
  {
    Code: ' C231799',
    Description: 'W/S Conn - Conv',
  },
  {
    Code: ' C315000',
    Description: 'Courthouse Expansion',
  },
  {
    Code: ' C315001',
    Description: 'Courthouse Arundel Ctr Renov',
  },
  {
    Code: ' C315002',
    Description: 'Courthouse Phase I&II Superstr',
  },
  {
    Code: ' C315003',
    Description: 'Courthouse Phase II Tenant Fit',
  },
  {
    Code: ' C315004',
    Description: 'Courthouse Foundation Bid Pkg',
  },
  {
    Code: ' C315005',
    Description: 'Courthouse 1824 Bldg Restorati',
  },
  {
    Code: ' C315099',
    Description: 'Courthouse - Conv',
  },
  {
    Code: ' C343400',
    Description: 'Scatter Site Renewal',
  },
  {
    Code: ' C343401',
    Description: 'Scatter Site Renewal',
  },
  {
    Code: ' C343402',
    Description: 'Scattr Site Renew-Ferndale Lts',
  },
  {
    Code: ' C343403',
    Description: 'Scattr Site Ren-W.Downs House',
  },
  {
    Code: ' C343404',
    Description: 'Scattr Site Ren-Benson Hammnd',
  },
  {
    Code: ' C343405',
    Description: 'Scattr Site Ren-Marley Neck',
  },
  {
    Code: ' C343499',
    Description: 'Scatter Site Renewal - Conv',
  },
  {
    Code: ' C343500',
    Description: 'Chg Agst GC Closed Projects',
  },
  {
    Code: ' C343501',
    Description: 'Chg Agst GC Closed Projects',
  },
  {
    Code: ' C343599',
    Description: 'Chg Agst GC Clsd Prj - Conv',
  },
  {
    Code: ' C346700',
    Description: 'Asbestos Remv Reb-Rev Only',
  },
  {
    Code: ' C346701',
    Description: 'Asbestos Remv Reb-Rev Only',
  },
  {
    Code: ' C346798',
    Description: 'Asbestos Rem Reb-98 Rev Only',
  },
  {
    Code: ' C346799',
    Description: 'Asbestos Rem Reb-99 Rev Only',
  },
  {
    Code: ' C383200',
    Description: 'Conservation Trust',
  },
  {
    Code: ' C383201',
    Description: 'Conservation Trust',
  },
  {
    Code: ' C383299',
    Description: 'Conservation Trust - Conv',
  },
  {
    Code: ' C386600',
    Description: 'Critical Area Reforest',
  },
  {
    Code: ' C386601',
    Description: 'Critical Area Reforest',
  },
  {
    Code: ' C386699',
    Description: 'Critical Area Reforest - Conv',
  },
  {
    Code: ' C410700',
    Description: 'ADA Workplace Modification',
  },
  {
    Code: ' C410701',
    Description: 'ADA Mods Priority 1',
  },
  {
    Code: ' C410702',
    Description: 'ADA Mods Phase 2',
  },
  {
    Code: ' C410703',
    Description: 'ADA Mods Phase 3',
  },
  {
    Code: ' C410704',
    Description: 'ADA Mods Phase 4',
  },
  {
    Code: ' C410705',
    Description: 'ADA Mods Phase 5',
  },
  {
    Code: ' C410706',
    Description: 'ADA Mods Phase 6',
  },
  {
    Code: ' C410707',
    Description: 'ADA Mods Sidewalks',
  },
  {
    Code: ' C410708',
    Description: 'ADA Mods, Phase 7',
  },
  {
    Code: ' C410709',
    Description: 'ADA Mods, Phase 8',
  },
  {
    Code: ' C410799',
    Description: 'ADA Mods - Conv',
  },
  {
    Code: ' C421400',
    Description: 'Glen Burnie Town Center',
  },
  {
    Code: ' C421401',
    Description: 'GB Twn Ctr Urban Renewal',
  },
  {
    Code: ' C421402',
    Description: 'GB Twn Ctr Platzer Lane Parkin',
  },
  {
    Code: ' C421403',
    Description: 'GB Twn Ctr Greenway House Demo',
  },
  {
    Code: ' C421404',
    Description: 'GB Twn Ctr Greenway Parking Lo',
  },
  {
    Code: ' C421499',
    Description: 'GB Twn Ctr Conv',
  },
  {
    Code: ' C422100',
    Description: 'Cable Fib Op Intercon',
  },
  {
    Code: ' C422101',
    Description: 'Cable Fib Op Intercon',
  },
  {
    Code: ' C422199',
    Description: 'Cable Fib Op Intercon - Conv',
  },
  {
    Code: ' C423800',
    Description: 'Tipton Airport',
  },
  {
    Code: ' C423801',
    Description: 'Tipton Army Airfield Study I',
  },
  {
    Code: ' C423899',
    Description: 'Tipton - Conv',
  },
  {
    Code: ' C427700',
    Description: 'Reforest-Tree Bill',
  },
  {
    Code: ' C427701',
    Description: 'Reforest-Tree Bill',
  },
  {
    Code: ' C427799',
    Description: 'Reforest-Tree Bill Conv',
  },
  {
    Code: ' C431400',
    Description: "Sarah's House",
  },
  {
    Code: ' C431499',
    Description: "Sarah's House Conv",
  },
  {
    Code: ' C436800',
    Description: 'DPW Facility Compliance',
  },
  {
    Code: ' C436801',
    Description: 'Env Compliance Brdnck/St Mrgrt',
  },
  {
    Code: ' C436802',
    Description: 'Env Compliance Road Operations',
  },
  {
    Code: ' C436803',
    Description: 'Env Compliance St Mrgrt/N Dist',
  },
  {
    Code: ' C436804',
    Description: 'Env Compliance Phase #01',
  },
  {
    Code: ' C436805',
    Description: 'Env Compliance Phase #02',
  },
  {
    Code: ' C436806',
    Description: 'DPW Facility Compliance Phs 3',
  },
  {
    Code: ' C436899',
    Description: 'Env Compliance Conv',
  },
  {
    Code: ' C437000',
    Description: 'Undrgrd Storage Tank  Repl',
  },
  {
    Code: ' C437001',
    Description: 'UST Various Sites',
  },
  {
    Code: ' C437002',
    Description: 'UST Western Police',
  },
  {
    Code: ' C437003',
    Description: 'UST Patuxent & E. Roads',
  },
  {
    Code: ' C437004',
    Description: 'UST Upgrade',
  },
  {
    Code: ' C437005',
    Description: 'UST Heating Oil Tanks',
  },
  {
    Code: ' C437006',
    Description: 'UST Heating Oil Tanks, Phase 2',
  },
  {
    Code: ' C437007',
    Description: 'UST Heating Oil Tanks, Phase 3',
  },
  {
    Code: ' C437008',
    Description: 'UST Heating Oil Tanks, Phase 4',
  },
  {
    Code: ' C437009',
    Description: 'UST Heating Oil Tanks GB Garag',
  },
  {
    Code: ' C437010',
    Description: 'UST Install Monitoring System',
  },
  {
    Code: ' C437011',
    Description: 'UST Heating Oil Tanks, Phase 5',
  },
  {
    Code: ' C437012',
    Description: 'UST Htng Oil Tnks FY 01,Ph 6',
  },
  {
    Code: ' C437013',
    Description: 'UST Waste Oil Tnks, Phase 7',
  },
  {
    Code: ' C437099',
    Description: 'UST Conv',
  },
  {
    Code: ' C440300',
    Description: 'Major Mechanical Systems',
  },
  {
    Code: ' C440301',
    Description: 'Mech Sys N Dist Police Sta',
  },
  {
    Code: ' C440302',
    Description: 'Mech Sys North County Library',
  },
  {
    Code: ' C440303',
    Description: 'Mech Sys Heritage Ofc Cmplx',
  },
  {
    Code: ' C440304',
    Description: 'Mech Sys Severna Park Library',
  },
  {
    Code: ' C440305',
    Description: 'Mech Sys Annapolis Library',
  },
  {
    Code: ' C440306',
    Description: 'Mech Sys Brooklyn Park Library',
  },
  {
    Code: ' C440307',
    Description: 'Maj Mech Sys-South County Libr',
  },
  {
    Code: ' C440308',
    Description: 'Maj Mech Sys-Brooklyn Pk Libr',
  },
  {
    Code: ' C440309',
    Description: 'Maj Mech Sys-G B Senior Ctr',
  },
  {
    Code: ' C440310',
    Description: 'Maj Mech-Health Dpt. Tower',
  },
  {
    Code: ' C440311',
    Description: 'Maj Mech-FY02 Assessment',
  },
  {
    Code: ' C440312',
    Description: 'Maj Mech-Pascal Sr Center III',
  },
  {
    Code: ' C440313',
    Description: 'Maj Mech-FY03 System Repl.',
  },
  {
    Code: ' C440314',
    Description: 'Maj Mech-DPW Renov./Truman',
  },
  {
    Code: ' C440399',
    Description: 'Mech Sys Conv',
  },
  {
    Code: ' C442500',
    Description: 'Central Serv Gar/So Distr',
  },
  {
    Code: ' C442501',
    Description: 'S Dist Rd Ops Fac',
  },
  {
    Code: ' C442502',
    Description: 'Central Serv Gar/Rd Ops Fac',
  },
  {
    Code: ' C442599',
    Description: 'Central Serv Gar/So Distr Conv',
  },
  {
    Code: ' C443400',
    Description: 'Agricultural Easement Program',
  },
  {
    Code: ' C443401',
    Description: 'Ag Easemnt',
  },
  {
    Code: ' C443499',
    Description: 'Ag Easemnt Conv',
  },
  {
    Code: ' C443500',
    Description: 'Facility Renov/Reloc',
  },
  {
    Code: ' C443501',
    Description: 'Facility Renov/Reloc',
  },
  {
    Code: ' C443502',
    Description: 'Facility Renov/Reloc FY 01',
  },
  {
    Code: ' C443503',
    Description: 'Facility Renov/Reloc FY 03',
  },
  {
    Code: ' C443599',
    Description: 'Facility Renov/Reloc Conv',
  },
  {
    Code: ' C452000',
    Description: 'Gen Co Program Mangmnt',
  },
  {
    Code: ' C452001',
    Description: 'Gen Co Program Mangmnt',
  },
  {
    Code: ' C452099',
    Description: 'Gen Co Prgm Mgmt Conv',
  },
  {
    Code: ' C452100',
    Description: 'Gen Co Project Plan',
  },
  {
    Code: ' C452101',
    Description: 'Proj Plan',
  },
  {
    Code: ' C452102',
    Description: 'Proj Plan Animal Control Fac',
  },
  {
    Code: ' C452103',
    Description: 'Career Center Schematic Design',
  },
  {
    Code: ' C452104',
    Description: 'Arundel Center North, Ph II',
  },
  {
    Code: ' C452105',
    Description: 'AA Med Ctr Feasibility Study',
  },
  {
    Code: ' C452199',
    Description: 'Proj Plan Conv',
  },
  {
    Code: ' C452200',
    Description: 'Bates High School Renov',
  },
  {
    Code: ' C452201',
    Description: 'Bates High School Renov',
  },
  {
    Code: ' C452299',
    Description: 'Bates High Schl Renov Conv',
  },
  {
    Code: ' C452400',
    Description: 'Salt Strg Envr Compl',
  },
  {
    Code: ' C452401',
    Description: 'Salt Strg Envr Compl',
  },
  {
    Code: ' C452499',
    Description: 'Salt Strg Envr Compl Conv',
  },
  {
    Code: ' C459600',
    Description: 'Animal Control Facility',
  },
  {
    Code: ' C459601',
    Description: 'Animal Control Facility',
  },
  {
    Code: ' C459699',
    Description: 'Animal Control Fclty Conv',
  },
  {
    Code: ' C459700',
    Description: 'Combined Sup Serv Complex',
  },
  {
    Code: ' C459701',
    Description: 'Combined Sup Serv Complex',
  },
  {
    Code: ' C459702',
    Description: 'Comb Sup Serv Complex Renov',
  },
  {
    Code: ' C459703',
    Description: 'Comb Sup Serv Complex-HVAC',
  },
  {
    Code: ' C459799',
    Description: 'CSSC Conv',
  },
  {
    Code: ' C459800',
    Description: 'County Complex Paving',
  },
  {
    Code: ' C459801',
    Description: 'Paving Maxwell Frye Road',
  },
  {
    Code: ' C459802',
    Description: 'Paving Police & Fire HQ Lot',
  },
  {
    Code: ' C459803',
    Description: 'Paving Millersvl Gar&Carwash',
  },
  {
    Code: ' C459804',
    Description: 'Paving Glen Burnie Serv Garage',
  },
  {
    Code: ' C459805',
    Description: 'Paving FY 01',
  },
  {
    Code: ' C459806',
    Description: 'Paving - Heritage Off Cmplx',
  },
  {
    Code: ' C459807',
    Description: 'County Complex Paving-Multi',
  },
  {
    Code: ' C459899',
    Description: 'Paving Conv',
  },
  {
    Code: ' C459900',
    Description: 'Financial Management System',
  },
  {
    Code: ' C459901',
    Description: 'Financial Management System',
  },
  {
    Code: ' C459999',
    Description: 'Financial Mgmt Sys Conv',
  },
  {
    Code: ' C460000',
    Description: 'Historic Odenton Enhan',
  },
  {
    Code: ' C460001',
    Description: 'Historic Odenton Enhan',
  },
  {
    Code: ' C460099',
    Description: 'Historic Odenton Enhan Conv',
  },
  {
    Code: ' C466600',
    Description: 'Millersv Garage Exp',
  },
  {
    Code: ' C466601',
    Description: 'Millersv Garage Exp',
  },
  {
    Code: ' C466699',
    Description: 'Millersv Garage Exp Conv',
  },
  {
    Code: ' C473300',
    Description: 'Arundel Ctr No Ph 2',
  },
  {
    Code: ' C473301',
    Description: 'Arundel Ctr No Ph 2',
  },
  {
    Code: ' C473399',
    Description: 'Arundel Ctr No Ph 2 Conv',
  },
  {
    Code: ' C473400',
    Description: 'Facil Lighting Retro',
  },
  {
    Code: ' C473401',
    Description: 'Facil Lighting Retro',
  },
  {
    Code: ' C473402',
    Description: 'Facil Lighting Retro - FY 00',
  },
  {
    Code: ' C473403',
    Description: 'Facil Lighting Retro - Phs 2',
  },
  {
    Code: ' C473404',
    Description: 'Facil Lighting Retro - Phs 3',
  },
  {
    Code: ' C473499',
    Description: 'Facil Lighting Retro Conv',
  },
  {
    Code: ' C476400',
    Description: 'Brooklyn Pk Comm Ctr',
  },
  {
    Code: ' C476401',
    Description: 'Brooklyn Pk Comm Ctr',
  },
  {
    Code: ' C476499',
    Description: 'Brooklyn Pk Comm Ctr Conv',
  },
  {
    Code: ' C476500',
    Description: 'Gateway Center',
  },
  {
    Code: ' C476501',
    Description: 'Gateway Center',
  },
  {
    Code: ' C476599',
    Description: 'Gateway Center Conv',
  },
  {
    Code: ' C476600',
    Description: 'Odenton Health Center',
  },
  {
    Code: ' C476699',
    Description: 'Odenton Health Center Conv',
  },
  {
    Code: ' C477300',
    Description: 'S. County Middle School Plan',
  },
  {
    Code: ' C477301',
    Description: 'S. County Middle School Plan',
  },
  {
    Code: ' C477399',
    Description: 'S. County MS Plan Conv',
  },
  {
    Code: ' C478200',
    Description: 'Mjr Cnty Roof Repl',
  },
  {
    Code: ' C478201',
    Description: 'Roofs Randazzo & Eisen GlfCrs',
  },
  {
    Code: ' C478202',
    Description: 'Roofs Ph1 Jug Bay,SP,Chmb,W Rd',
  },
  {
    Code: ' C478203',
    Description: 'Roofs Annapolis Libry Skylghts',
  },
  {
    Code: ' C478204',
    Description: 'Major County Roof Repl',
  },
  {
    Code: ' C478205',
    Description: 'Roofs FY 00 Arundel Center',
  },
  {
    Code: ' C478206',
    Description: 'Roofs FY 00 Arundel Ctr, Ph 2',
  },
  {
    Code: ' C478207',
    Description: 'Major County Roof Repl FY 01',
  },
  {
    Code: ' C478208',
    Description: "Maj Cnty Roof Repl '01-Study",
  },
  {
    Code: ' C478209',
    Description: "Maj Cnty Roof Repl '02-Phs I",
  },
  {
    Code: ' C478210',
    Description: "Maj Cnty Roof Repl '02-Phs 2",
  },
  {
    Code: ' C478211',
    Description: 'Maj Cnty Roof Repl-FY03',
  },
  {
    Code: ' C478297',
    Description: 'Mjr Cty Roof Repl 97 Conv',
  },
  {
    Code: ' C478298',
    Description: 'Mjr County Roofs 98 Conv',
  },
  {
    Code: ' C478299',
    Description: 'Mjr County Roofs 99 Conv',
  },
  {
    Code: ' C478300',
    Description: 'School Sidewalks',
  },
  {
    Code: ' C478301',
    Description: 'Schl SW Van Bokkelen ES',
  },
  {
    Code: ' C478302',
    Description: 'Schl SW Hampton Road',
  },
  {
    Code: ' C478303',
    Description: 'Schl SW Outing Avenue',
  },
  {
    Code: ' C478304',
    Description: 'Schl SW Misc Locations',
  },
  {
    Code: ' C478305',
    Description: 'Schl SW Misc Locations FY 00',
  },
  {
    Code: ' C478306',
    Description: 'Schl SW Hammonds La/Mark Dr',
  },
  {
    Code: ' C478307',
    Description: 'Schl SW Misc Locations FY 01',
  },
  {
    Code: ' C478308',
    Description: 'Schl SW 01-Park ES',
  },
  {
    Code: ' C478309',
    Description: 'Schl SW 01-Red Clay Road',
  },
  {
    Code: ' C478310',
    Description: 'Schl SW 01-Marshall Road',
  },
  {
    Code: ' C478311',
    Description: 'Schl SW 01-Evergreen Road',
  },
  {
    Code: ' C478312',
    Description: 'Schl SW 01-Duvall Highway',
  },
  {
    Code: ' C478313',
    Description: 'Schl SW 01-Ferndale Road',
  },
  {
    Code: ' C478314',
    Description: 'Schl SW 01-1st Avenue East',
  },
  {
    Code: ' C478315',
    Description: 'Schl SW 02-Freetown Area',
  },
  {
    Code: ' C478316',
    Description: 'Schl SW 02-Eastern Street',
  },
  {
    Code: ' C478317',
    Description: 'Schl SW 02-MD177 Lakeshore ES',
  },
  {
    Code: ' C478318',
    Description: 'Schl SW 02-East/West Blvd.',
  },
  {
    Code: ' C478319',
    Description: 'Schl SW 02-Crofton Pkwy.',
  },
  {
    Code: ' C478320',
    Description: 'Schl SW 02-Mago Vista Road',
  },
  {
    Code: ' C478321',
    Description: 'Schl SW 03-Oakwood Road',
  },
  {
    Code: ' C478322',
    Description: 'Schl SW 03-Freetown Phs I',
  },
  {
    Code: ' C478323',
    Description: 'Schl SW 03-Truckhouse Road',
  },
  {
    Code: ' C478397',
    Description: 'School Sidewalks 97 Conv',
  },
  {
    Code: ' C478398',
    Description: 'School Sidewalks 98 Conv',
  },
  {
    Code: ' C478399',
    Description: 'Schl SW Conv',
  },
  {
    Code: ' C478400',
    Description: 'Drvwy & Park Lots',
  },
  {
    Code: ' C478401',
    Description: 'D&P West Meade ES',
  },
  {
    Code: ' C478402',
    Description: 'D&P High Point ES',
  },
  {
    Code: ' C478403',
    Description: 'D&P FY 99 Misc Lots/Drwys',
  },
  {
    Code: ' C478404',
    Description: 'D&P FY 00 Misc Lots/Drwys',
  },
  {
    Code: ' C478405',
    Description: 'D&P FY 99 Pasadena ES',
  },
  {
    Code: ' C478406',
    Description: 'D&P FY 00 Riviera ES',
  },
  {
    Code: ' C478407',
    Description: 'D&P FY 00 Glen Burnie Park ES',
  },
  {
    Code: ' C478408',
    Description: 'D&P-Richard Henry Lee ES',
  },
  {
    Code: ' C478409',
    Description: 'D&P FY03-Four Seasons ES',
  },
  {
    Code: ' C478410',
    Description: 'D&P FY03-Point Pleasant ES',
  },
  {
    Code: ' C478411',
    Description: 'D&P FY03-Hillsmere ES',
  },
  {
    Code: ' C478497',
    Description: 'Drwy & Park Lots 97 Conv',
  },
  {
    Code: ' C478498',
    Description: 'D&P 98 Conv',
  },
  {
    Code: ' C478499',
    Description: 'D&P 99 Conv',
  },
  {
    Code: ' C480200',
    Description: 'Arun Cen Renovations',
  },
  {
    Code: ' C480201',
    Description: 'Arun Cen Renovations',
  },
  {
    Code: ' C480299',
    Description: 'Arun Cen Renov Conv',
  },
  {
    Code: ' C480500',
    Description: 'Maryland Hall Renov',
  },
  {
    Code: ' C480501',
    Description: 'Maryland Hall Renov',
  },
  {
    Code: ' C480599',
    Description: 'MD Hall Renov Conv',
  },
  {
    Code: ' C484500',
    Description: 'North Arundel Hosp',
  },
  {
    Code: ' C484501',
    Description: 'North Arundel Hosp',
  },
  {
    Code: ' C484599',
    Description: 'N Arundel Hosp Conv',
  },
  {
    Code: ' C484600',
    Description: 'Anne Arundel Med Ctr',
  },
  {
    Code: ' C484601',
    Description: 'Anne Arundel Med Ctr',
  },
  {
    Code: ' C484699',
    Description: 'AA Med Ctr Conv',
  },
  {
    Code: ' C485000',
    Description: 'Truck Wash Facility',
  },
  {
    Code: ' C485001',
    Description: 'Truck Wash Facility',
  },
  {
    Code: ' C485099',
    Description: 'Truck Wash Fclty Conv',
  },
  {
    Code: ' C485100',
    Description: 'Benson/Hammond House',
  },
  {
    Code: ' C485101',
    Description: 'Benson/Hammond House',
  },
  {
    Code: ' C485199',
    Description: 'Benson/Hammond House Conv',
  },
  {
    Code: ' C490700',
    Description: 'Davidsonville Elem',
  },
  {
    Code: ' C490701',
    Description: 'Davidsonville Elem',
  },
  {
    Code: ' C490799',
    Description: 'Davidsonville Elem Conv',
  },
  {
    Code: ' C490800',
    Description: 'Mayo Elem',
  },
  {
    Code: ' C490801',
    Description: 'Mayo Elem',
  },
  {
    Code: ' C490899',
    Description: 'Mayo Elem Conv',
  },
  {
    Code: ' C491300',
    Description: 'Glen Burnie Garage Improvement',
  },
  {
    Code: ' C491301',
    Description: 'Glen Burnie Garage Improvement',
  },
  {
    Code: ' C491399',
    Description: 'Glen Burnie Garage Imps Conv',
  },
  {
    Code: ' C493300',
    Description: 'David Taylor Improvements',
  },
  {
    Code: ' C493301',
    Description: 'David Taylor Improvements',
  },
  {
    Code: ' C493399',
    Description: 'David Taylor Imps Conv',
  },
  {
    Code: ' C500600',
    Description: 'Courthouse Development',
  },
  {
    Code: ' C500601',
    Description: 'Courthouse Development',
  },
  {
    Code: ' C500602',
    Description: 'Family Law Division, Ph 2',
  },
  {
    Code: ' C500700',
    Description: 'Arundel Center Renovation',
  },
  {
    Code: ' C500701',
    Description: 'Arundel Center Renovation',
  },
  {
    Code: ' C500702',
    Description: 'Arundel Center Renov. Phs II',
  },
  {
    Code: ' C500900',
    Description: 'New Glen Burnie Parking Garage',
  },
  {
    Code: ' C500901',
    Description: 'New Glen Burnie Parking Garage',
  },
  {
    Code: ' C501000',
    Description: 'Parole Health Center',
  },
  {
    Code: ' C501001',
    Description: 'Parole Health Center',
  },
  {
    Code: ' C501100',
    Description: 'Failed Sewage Disposal Sys Fnd',
  },
  {
    Code: ' C501101',
    Description: 'Failed Sewage Disposal Sys Fnd',
  },
  {
    Code: ' C501200',
    Description: 'Carrie Weedon Center',
  },
  {
    Code: ' C501201',
    Description: 'Carrie Weedon Center',
  },
  {
    Code: ' C501300',
    Description: 'BOE Maint & Infrstructure',
  },
  {
    Code: ' C501301',
    Description: 'BOE Maint & Infrstructure',
  },
  {
    Code: ' C504300',
    Description: 'Parking Garage Rehab',
  },
  {
    Code: ' C504301',
    Description: 'Parking Garage Rehab',
  },
  {
    Code: ' C504302',
    Description: 'Pkg Garage Rehab-Glen Burnie',
  },
  {
    Code: ' C504303',
    Description: 'Pkg Garage Rehab-Whitmore Rpr',
  },
  {
    Code: ' C504400',
    Description: '800 MHZ Radio System',
  },
  {
    Code: ' C504401',
    Description: '800 MHZ Radio System',
  },
  {
    Code: ' C504500',
    Description: 'Rural Legacy Land Program',
  },
  {
    Code: ' C504501',
    Description: 'Rural Legacy Land Program',
  },
  {
    Code: ' C504600',
    Description: 'Winterode HVAC Rehab',
  },
  {
    Code: ' C504601',
    Description: 'Winterode HVAC Rehab',
  },
  {
    Code: ' C504700',
    Description: 'Old Sani Com Bldg Renov',
  },
  {
    Code: ' C504701',
    Description: 'Old Sani Com Bldg Renov',
  },
  {
    Code: ' C504800',
    Description: 'Highland Beach Town Hall',
  },
  {
    Code: ' C504801',
    Description: 'Highland Beach Town Hall',
  },
  {
    Code: ' C504900',
    Description: 'Heritage Harbor Respite Care',
  },
  {
    Code: ' C504901',
    Description: 'Heritage Harbor Respite Care',
  },
  {
    Code: ' C505000',
    Description: 'Robinson Building',
  },
  {
    Code: ' C505001',
    Description: 'Robinson Building',
  },
  {
    Code: ' C509900',
    Description: 'Cable TV PEG Facilities',
  },
  {
    Code: ' C509901',
    Description: 'Cable TV PEG Facilities',
  },
  {
    Code: ' C509902',
    Description: 'Cable TV PEG Studio',
  },
  {
    Code: ' C510100',
    Description: 'Laurel Track Comm Betterment',
  },
  {
    Code: ' C510101',
    Description: 'Laurel Track Comm Betterment',
  },
  {
    Code: ' C510102',
    Description: 'Laurel Track Comm-Inter. Study',
  },
  {
    Code: ' C519600',
    Description: 'Information Technology Enhance',
  },
  {
    Code: ' C519601',
    Description: 'Information Technology Enhance',
  },
  {
    Code: ' C519700',
    Description: 'Central Dist Fac/Traffic Maint',
  },
  {
    Code: ' C519701',
    Description: 'Central Dist Fac/Traffic Maint',
  },
  {
    Code: ' C519800',
    Description: 'Elementary School Contingency',
  },
  {
    Code: ' C519801',
    Description: 'Elementary School Contingency',
  },
  {
    Code: ' C888800',
    Description: 'GC Trans. for PY Clos Projects',
  },
  {
    Code: ' C888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' C888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' C999900',
    Description: 'GC Class Account',
  },
  {
    Code: ' C999901',
    Description: 'GC Class Account',
  },
  {
    Code: ' C999999',
    Description: 'GC Class Account Conv',
  },
  {
    Code: ' D241500',
    Description: 'Storm Wtr Pond Maint-Rev Only',
  },
  {
    Code: ' D241501',
    Description: 'Storm Wtr Pond Maint-Rev Only',
  },
  {
    Code: ' D241599',
    Description: 'Storm Wtr Pond Maint-Rev Only',
  },
  {
    Code: ' D300500',
    Description: 'N/E Chelsea Beach S/D',
  },
  {
    Code: ' D300599',
    Description: 'N/E Chelsea Beach S/D',
  },
  {
    Code: ' D346400',
    Description: 'Chg Against SD Closed Projects',
  },
  {
    Code: ' D346401',
    Description: 'Chg Against SD Closed Projects',
  },
  {
    Code: ' D346499',
    Description: 'Chg Agnst SD Clsd Prjs Conv',
  },
  {
    Code: ' D381800',
    Description: 'Cape St. Claire S/D',
  },
  {
    Code: ' D381801',
    Description: 'Cape St. Claire S/D Phase 1',
  },
  {
    Code: ' D381802',
    Description: 'Cape St. Claire S/D Phase 2A',
  },
  {
    Code: ' D381803',
    Description: 'Cape St. Claire S/D Phase 2B',
  },
  {
    Code: ' D381804',
    Description: 'Cape St. Claire S/D Phase 3',
  },
  {
    Code: ' D381805',
    Description: 'Cape St. Claire Ph 3 Sys 11&12',
  },
  {
    Code: ' D381806',
    Description: 'Cape St. Claire Ph 3 Sys 11B',
  },
  {
    Code: ' D381807',
    Description: 'Cape St. Claire Ph 3 Sys 12',
  },
  {
    Code: ' D381808',
    Description: 'Cape St. Claire Ph 3 Sys 4',
  },
  {
    Code: ' D381899',
    Description: 'Cape St. Claire S/D Conv',
  },
  {
    Code: ' D406900',
    Description: 'NPDES Permit Program',
  },
  {
    Code: ' D406901',
    Description: 'NPDES Permit Program',
  },
  {
    Code: ' D406902',
    Description: 'NPDES Magothy Rvr Wtrshed',
  },
  {
    Code: ' D406903',
    Description: 'NPDES Save Our Streams Plan',
  },
  {
    Code: ' D406904',
    Description: 'NPDES Monitoring Stations',
  },
  {
    Code: ' D406905',
    Description: 'NPDES South River Wtrshed',
  },
  {
    Code: ' D406906',
    Description: 'NPDES Retrofit Assmnt Study',
  },
  {
    Code: ' D406907',
    Description: 'NPDES Storm Event Monitoring',
  },
  {
    Code: ' D406908',
    Description: 'NPDES Pollutant Load Est Study',
  },
  {
    Code: ' D406909',
    Description: 'NPDES Illicit Dischrg Detectn',
  },
  {
    Code: ' D406910',
    Description: 'NPDES Cloverleaf SWMP',
  },
  {
    Code: ' D406911',
    Description: 'NPDES Foxchase SWMP #1',
  },
  {
    Code: ' D406912',
    Description: 'NPDES Sunnyfield Outfall Resto',
  },
  {
    Code: ' D406913',
    Description: "NPDES Gray's Luck SWMP",
  },
  {
    Code: ' D406914',
    Description: "NPDES Shipley's Choice Emg Pln",
  },
  {
    Code: ' D406915',
    Description: 'NPDES Lake of Pines Emg Plan',
  },
  {
    Code: ' D406916',
    Description: "NPDES Shipley's Choice SWMP",
  },
  {
    Code: ' D406917',
    Description: 'NPDES Retro Assmnt Stdy Ph II',
  },
  {
    Code: ' D406918',
    Description: 'NPDES Illicit Connections 1999',
  },
  {
    Code: ' D406919',
    Description: 'NPDES So Rvr Wtrshd Strm Stab',
  },
  {
    Code: ' D406920',
    Description: 'NPDES Ridgemere Xing Emerg AP',
  },
  {
    Code: ' D406921',
    Description: "NPDES Shipley's Choice SWMP",
  },
  {
    Code: ' D406922',
    Description: 'NPDES Severn Rvr Wtrshed M P',
  },
  {
    Code: ' D406923',
    Description: 'NPDES Illicit Conn Detect 02',
  },
  {
    Code: ' D406924',
    Description: 'NPDES Permit Prog Annual Rpt',
  },
  {
    Code: ' D406925',
    Description: 'NPDES Illicit Conn Detect 03',
  },
  {
    Code: ' D406926',
    Description: 'NPDES Prmt Prg Annual Rpt 03',
  },
  {
    Code: ' D406927',
    Description: 'NPDES - CIMS Project',
  },
  {
    Code: ' D406928',
    Description: 'NPDES-SW Utility Enterprise',
  },
  {
    Code: ' D406999',
    Description: 'NPDES Permit Program Conv',
  },
  {
    Code: ' D416300',
    Description: 'Odenton Phase 2 S/D',
  },
  {
    Code: ' D416301',
    Description: 'Odenton Phase 2 S/D',
  },
  {
    Code: ' D416399',
    Description: 'Odenton Phase 2 S/D Conv',
  },
  {
    Code: ' D429000',
    Description: 'Rippling Estate Retro',
  },
  {
    Code: ' D429001',
    Description: 'Rippling Estate Retro Ph 1',
  },
  {
    Code: ' D429002',
    Description: 'Rippling Estate Retro Ph 2',
  },
  {
    Code: ' D429003',
    Description: 'Rippling Estate Retro Ph 2A',
  },
  {
    Code: ' D429099',
    Description: 'Rippling Estate Retro Conv',
  },
  {
    Code: ' D431800',
    Description: 'Towsers Branch Retro',
  },
  {
    Code: ' D431801',
    Description: 'Towsers Branch Retro Ph 1',
  },
  {
    Code: ' D431802',
    Description: 'Towsers Branch Retro Ph 2',
  },
  {
    Code: ' D431803',
    Description: 'Towsers Branch Retro- Rev Only',
  },
  {
    Code: ' D431899',
    Description: 'Towsers Branch Retro Conv',
  },
  {
    Code: ' D432800',
    Description: 'Longwood Ave Channel Rehab',
  },
  {
    Code: ' D432899',
    Description: 'Longwood Ave Channel Rehab',
  },
  {
    Code: ' D442600',
    Description: 'Kingswood Rd Strm Dn',
  },
  {
    Code: ' D442601',
    Description: 'Kingswood Rd Strm Dn',
  },
  {
    Code: ' D442699',
    Description: 'Kingswood Rd Strm Dn Conv',
  },
  {
    Code: ' D448300',
    Description: 'Stormwtr Pond Maint',
  },
  {
    Code: ' D448301',
    Description: 'Stormwtr Pond Maint',
  },
  {
    Code: ' D448302',
    Description: 'Stormwtr Pond Maint FY 01',
  },
  {
    Code: ' D448303',
    Description: 'Stormwtr Pond Maint FY 02',
  },
  {
    Code: ' D448304',
    Description: 'Stormwater Pond Maint FY 03',
  },
  {
    Code: ' D448399',
    Description: 'Stormwtr Pond Maint Conv',
  },
  {
    Code: ' D451100',
    Description: 'Culvert Rehab',
  },
  {
    Code: ' D451101',
    Description: 'Culvert Rehab',
  },
  {
    Code: ' D451102',
    Description: 'Culvert Rehab 00-Alview Terr',
  },
  {
    Code: ' D451103',
    Description: 'Culvert Rehab 00-Maple Av',
  },
  {
    Code: ' D451104',
    Description: 'Culvert Rehab00-Pt Pleasant Rd',
  },
  {
    Code: ' D451105',
    Description: 'Culvert Rehab 00 - Race Rd.',
  },
  {
    Code: ' D451106',
    Description: 'Culvert Rehab 00 - WB&A Rd.',
  },
  {
    Code: ' D451107',
    Description: 'Culvert Rehab 00-McKendree Rd',
  },
  {
    Code: ' D451108',
    Description: 'Culvert Rehab 01-Oak Dr CSDS',
  },
  {
    Code: ' D451109',
    Description: 'Clvrt Rhb 01-New Cut Rd Clvt',
  },
  {
    Code: ' D451110',
    Description: 'Clvrt Rhb 01-Webster Pl CSDS',
  },
  {
    Code: ' D451111',
    Description: 'Clvrt Rhb 01-Sherman Av CSDS',
  },
  {
    Code: ' D451112',
    Description: 'Clvrt Rhb 01-Jones Station Rd',
  },
  {
    Code: ' D451113',
    Description: 'C R 02-New Cut Rd Culv Insp',
  },
  {
    Code: ' D451114',
    Description: 'C R 02-Chalmers&4th Avs CSDS',
  },
  {
    Code: ' D451115',
    Description: 'C R 02-Hilltop Rd Culv Rehab',
  },
  {
    Code: ' D451116',
    Description: 'C R 02-Maureen Dr CSDS Rehab',
  },
  {
    Code: ' D451117',
    Description: 'C R 02-Windward Dr CSDS Rhb',
  },
  {
    Code: ' D451118',
    Description: 'C R 02-Riva Rd CSDS Jt Rehab',
  },
  {
    Code: ' D451119',
    Description: 'C R 02-Lakeland Rd Clvrt Rhb',
  },
  {
    Code: ' D451120',
    Description: 'C R 02-St Albans Sq CSDS Rhb',
  },
  {
    Code: ' D451121',
    Description: 'C R 02-Shiloh Ct Outfall Rhb',
  },
  {
    Code: ' D451122',
    Description: 'CR 02-Westphalia Ct CSDS Rhb',
  },
  {
    Code: ' D451123',
    Description: 'C R 02-Severnview Dr CSDS',
  },
  {
    Code: ' D451124',
    Description: 'C R 02-Southwest Rd CSDS Rhb',
  },
  {
    Code: ' D451125',
    Description: 'CR 02-Elvaton Rd Outfall Rhb',
  },
  {
    Code: ' D451126',
    Description: 'C R 02-Long Cove Rd CSDS Rhb',
  },
  {
    Code: ' D451127',
    Description: 'C R 02-Wainwright Ave CSDS',
  },
  {
    Code: ' D451128',
    Description: 'C R 02 - Riva Rd CSDS Repair',
  },
  {
    Code: ' D451129',
    Description: 'C R 02 - Hog Farm Rd Culvert',
  },
  {
    Code: ' D451130',
    Description: 'C R 03 - Downs Outfall Rehab',
  },
  {
    Code: ' D451131',
    Description: 'C R 03 - Hickory Pt Rd CSDS',
  },
  {
    Code: ' D451132',
    Description: 'CR 03 - Heritage Hrbr Outfall',
  },
  {
    Code: ' D451133',
    Description: 'C R 03 - Old Oak Rd Culvert',
  },
  {
    Code: ' D451134',
    Description: 'C R 03 - New Cut Farms CSDS',
  },
  {
    Code: ' D451135',
    Description: 'C R 03 - Stonegate Ave CSDS',
  },
  {
    Code: ' D451136',
    Description: 'C R 03 - Seaward Dr CSDS',
  },
  {
    Code: ' D451199',
    Description: 'Culvert Rehab Conv',
  },
  {
    Code: ' D451300',
    Description: 'Olen Drive Storm Drn',
  },
  {
    Code: ' D451301',
    Description: 'Olen Drive Storm Drn',
  },
  {
    Code: ' D451399',
    Description: 'Olen Drive Storm Drn Conv',
  },
  {
    Code: ' D451500',
    Description: 'Hsptl Drv Stormwtr Pd',
  },
  {
    Code: ' D451501',
    Description: 'Hsptl Drv Stormwtr Pd',
  },
  {
    Code: ' D451599',
    Description: 'Hsptl Drv Stormwtr Pd Conv',
  },
  {
    Code: ' D460200',
    Description: 'Catherine Ave Storm Drain',
  },
  {
    Code: ' D460201',
    Description: 'Catherine Ave Storm Drain',
  },
  {
    Code: ' D460202',
    Description: 'Catherine Ave SD 209th St',
  },
  {
    Code: ' D460299',
    Description: 'Catherine Ave SD Conv',
  },
  {
    Code: ' D460300',
    Description: 'Elvaton Storm Drain',
  },
  {
    Code: ' D460301',
    Description: 'Elvaton Storm Drain Ph 1',
  },
  {
    Code: ' D460302',
    Description: 'Elvaton Storm Drain Ph 2A',
  },
  {
    Code: ' D460303',
    Description: 'Elvaton Storm Drain Ph 2B',
  },
  {
    Code: ' D460399',
    Description: 'Elvaton Storm Drain Conv',
  },
  {
    Code: ' D473500',
    Description: 'Bodkin Road S/D',
  },
  {
    Code: ' D473501',
    Description: 'Bodkin Road S/D',
  },
  {
    Code: ' D473599',
    Description: 'Bodkin Road S/D',
  },
  {
    Code: ' D473600',
    Description: 'Brick Church Rd Culvert',
  },
  {
    Code: ' D473601',
    Description: 'Brick Church Rd Culvert',
  },
  {
    Code: ' D473699',
    Description: 'Brick Church Rd Culvert',
  },
  {
    Code: ' D473700',
    Description: 'Elmer Hagner Ln Culvert',
  },
  {
    Code: ' D473701',
    Description: 'Elmer Hagner Ln Culvert',
  },
  {
    Code: ' D473799',
    Description: 'Elmer Hagner Ln Culvert',
  },
  {
    Code: ' D473800',
    Description: 'Hog Neck Road S/D',
  },
  {
    Code: ' D473801',
    Description: 'Hog Neck Road S/D',
  },
  {
    Code: ' D473899',
    Description: 'Hog Neck Road S/D',
  },
  {
    Code: ' D473900',
    Description: 'Parole Town Center',
  },
  {
    Code: ' D473901',
    Description: 'Parole Town Center',
  },
  {
    Code: ' D473999',
    Description: 'Parole Town Center',
  },
  {
    Code: ' D474000',
    Description: 'Patuxent Rd Culvert',
  },
  {
    Code: ' D474001',
    Description: 'Patuxent Rd Culvert',
  },
  {
    Code: ' D474099',
    Description: 'Patuxent Rd Culvert',
  },
  {
    Code: ' D474100',
    Description: 'W. Benfield Rd Culvert',
  },
  {
    Code: ' D474101',
    Description: 'W. Benfield Rd Culvert',
  },
  {
    Code: ' D474199',
    Description: 'W. Benfield Rd Culvert',
  },
  {
    Code: ' D478500',
    Description: 'Emergency Storm Drain',
  },
  {
    Code: ' D478501',
    Description: 'Poplar Pt Emerg SD',
  },
  {
    Code: ' D478502',
    Description: 'Brock Bridge Rd Emerg SD',
  },
  {
    Code: ' D478503',
    Description: 'Maryland Av Emerg SD',
  },
  {
    Code: ' D478504',
    Description: 'Brightwood/Martin Dr Emerg SD',
  },
  {
    Code: ' D478505',
    Description: 'Main Cr/Goose Emerg SD',
  },
  {
    Code: ' D478506',
    Description: 'Westfield Rd Emerg SD',
  },
  {
    Code: ' D478507',
    Description: 'Holy Cross Rd Emerg SD',
  },
  {
    Code: ' D478508',
    Description: 'Echo Cove Dr Emerg SD',
  },
  {
    Code: ' D478509',
    Description: 'Cape St John Culvert',
  },
  {
    Code: ' D478510',
    Description: 'Severn Dr Emrg',
  },
  {
    Code: ' D478511',
    Description: 'Margate Dr South Emrg',
  },
  {
    Code: ' D478512',
    Description: 'Claiborne Rd Emrg',
  },
  {
    Code: ' D478513',
    Description: 'Hill Creek Rd Emrg',
  },
  {
    Code: ' D478514',
    Description: 'Creston Park Emrg',
  },
  {
    Code: ' D478515',
    Description: 'Arden Bog Outfall Reloc Emrg',
  },
  {
    Code: ' D478516',
    Description: 'Wharf Road Emrg',
  },
  {
    Code: ' D478517',
    Description: 'West Pasadena Rd Emrg',
  },
  {
    Code: ' D478518',
    Description: 'West Shore Dr Emrg',
  },
  {
    Code: ' D478519',
    Description: 'OAKDALE CIRCLE SD',
  },
  {
    Code: ' D478520',
    Description: 'Baton Chapel Emerg S/D',
  },
  {
    Code: ' D478521',
    Description: 'Solley Road Emerg S/D',
  },
  {
    Code: ' D478522',
    Description: 'Harmony Ave/Ct Emerg S/D',
  },
  {
    Code: ' D478523',
    Description: 'Armiger Drive Emrg S/D',
  },
  {
    Code: ' D478524',
    Description: 'Storm Drains Open End - FY 00',
  },
  {
    Code: ' D478525',
    Description: 'Arundel Bch Rd Emerg SD FY 00',
  },
  {
    Code: ' D478526',
    Description: 'Marydell Av Emerg SD FY 00',
  },
  {
    Code: ' D478527',
    Description: 'Thelma Av Emerg SD FY 00',
  },
  {
    Code: ' D478528',
    Description: 'Montrose Rd Emerg SD FY 00',
  },
  {
    Code: ' D478529',
    Description: 'Laurel Acres Emerg SD FY 00',
  },
  {
    Code: ' D478530',
    Description: 'Emergency SD Eng Services',
  },
  {
    Code: ' D478531',
    Description: 'Washington Rd Emerg SD FY 00',
  },
  {
    Code: ' D478532',
    Description: 'Main Cr/Goose Emerg SD FY 01',
  },
  {
    Code: ' D478533',
    Description: "Md Av/Ridgeway ES Emg SD '01",
  },
  {
    Code: ' D478534',
    Description: "Monard Ave. Emg SD '01",
  },
  {
    Code: ' D478535',
    Description: "Rainbow Dr. Emg SD '01",
  },
  {
    Code: ' D478536',
    Description: "Cypress/Oak Grove Emg SD '01",
  },
  {
    Code: ' D478537',
    Description: "Island View Rd. Emg SD '01",
  },
  {
    Code: ' D478538',
    Description: "Spencer Rd. Emg SD '01",
  },
  {
    Code: ' D478539',
    Description: "Music Lane Emg SD '01",
  },
  {
    Code: ' D478540',
    Description: "Magothy Beach/Center SD '01",
  },
  {
    Code: ' D478541',
    Description: "Old County Road SD '01",
  },
  {
    Code: ' D478542',
    Description: "Holloway Road SD '01",
  },
  {
    Code: ' D478543',
    Description: "Aurora Hills Outfall SD '01",
  },
  {
    Code: ' D478544',
    Description: "Shelton Drive SD '01",
  },
  {
    Code: ' D478545',
    Description: 'Shore Acres Storm Drain',
  },
  {
    Code: ' D478546',
    Description: 'Wingate/Cape St Claire SD',
  },
  {
    Code: ' D478547',
    Description: 'Old County Rd SWM Retrofit',
  },
  {
    Code: ' D478548',
    Description: 'Selby Storm Drain Study',
  },
  {
    Code: ' D478549',
    Description: 'Hillsmere Existing Syst. Cap.',
  },
  {
    Code: ' D478550',
    Description: 'Woodlawn Heights SD',
  },
  {
    Code: ' D478551',
    Description: "ESD Plan Development '02",
  },
  {
    Code: ' D478552',
    Description: "Oak Court Rehab ESD '02",
  },
  {
    Code: ' D478553',
    Description: "ESD Test Pitting '02",
  },
  {
    Code: ' D478554',
    Description: "Hartman Dr Rehab ESD '02",
  },
  {
    Code: ' D478555',
    Description: 'ESD 03 - Wainright Ave. SD',
  },
  {
    Code: ' D478556',
    Description: "Oak Lane/Post 40 Road SD '02",
  },
  {
    Code: ' D478557',
    Description: "Holly Hill/Ponder Cove SD '02",
  },
  {
    Code: ' D478558',
    Description: 'Selby Heights Drive SD',
  },
  {
    Code: ' D478559',
    Description: "ESD Plan Development '03",
  },
  {
    Code: ' D478560',
    Description: "East Park Dr ESD '03",
  },
  {
    Code: ' D478561',
    Description: 'ESD 03-South River Terr CSD',
  },
  {
    Code: ' D478562',
    Description: 'ESD 03 - Panther Court CSD',
  },
  {
    Code: ' D478563',
    Description: 'Selby Heights SD Phase 1A',
  },
  {
    Code: ' D478564',
    Description: 'ESD 03 - Fair Oaks Ct CSDS',
  },
  {
    Code: ' D478596',
    Description: 'Emergency S/D 96 Conv',
  },
  {
    Code: ' D478597',
    Description: 'Emergency S/D 97 Conv',
  },
  {
    Code: ' D478598',
    Description: 'Emergency S/D FY 98 Conv',
  },
  {
    Code: ' D478599',
    Description: 'Emergency S/D FY 99 Conv',
  },
  {
    Code: ' D480600',
    Description: 'Old Mill Rd Cul Rep',
  },
  {
    Code: ' D480601',
    Description: 'Old Mill Rd Cul Rep',
  },
  {
    Code: ' D480700',
    Description: 'Burns Cross Rd Cul',
  },
  {
    Code: ' D480701',
    Description: 'Burns Cross Rd Cul',
  },
  {
    Code: ' D480800',
    Description: 'Hog Farm Rd Cul Rep',
  },
  {
    Code: ' D480801',
    Description: 'Hog Farm Rd Cul Rep',
  },
  {
    Code: ' D480899',
    Description: 'Hog Farm Rd Cul Rep',
  },
  {
    Code: ' D480900',
    Description: 'New Cut Rd Cul Rep',
  },
  {
    Code: ' D480901',
    Description: 'New Cut Rd Cul Rep',
  },
  {
    Code: ' D481000',
    Description: 'Central Ave Cul Repl',
  },
  {
    Code: ' D481001',
    Description: 'Central Ave Cul Repl',
  },
  {
    Code: ' D481100',
    Description: 'Capetown SWMP Rehab',
  },
  {
    Code: ' D481101',
    Description: 'Capetown SWMP Rehab',
  },
  {
    Code: ' D481199',
    Description: 'Capetown SWMP Rehab',
  },
  {
    Code: ' D481200',
    Description: "McBride's Lane Imp",
  },
  {
    Code: ' D481201',
    Description: "McBride's Lane Imp",
  },
  {
    Code: ' D481299',
    Description: "McBride's Lane Imp",
  },
  {
    Code: ' D499900',
    Description: 'NPDES SD Retrofits',
  },
  {
    Code: ' D499901',
    Description: 'NPDES Foxchase SWMP Retro',
  },
  {
    Code: ' D499902',
    Description: 'NPDES Cloverleaf SWMP Retro',
  },
  {
    Code: ' D499903',
    Description: 'NPDES Sunnyfld Outfall Restor',
  },
  {
    Code: ' D499904',
    Description: 'NPDES Grays Luck SWMP',
  },
  {
    Code: ' D499905',
    Description: 'NPDES Capetowne SWMP Retro',
  },
  {
    Code: ' D499906',
    Description: 'NPDES College Stn SWMP Retro',
  },
  {
    Code: ' D499907',
    Description: 'NPDES Courts of Crofton Retro',
  },
  {
    Code: ' D499908',
    Description: 'NPDES Severn Station SWMP',
  },
  {
    Code: ' D501400',
    Description: 'Lake Drive Storm Drain',
  },
  {
    Code: ' D501401',
    Description: 'Lake Drive Storm Drain',
  },
  {
    Code: ' D501500',
    Description: 'Gov Bridge Culverts Repl',
  },
  {
    Code: ' D501501',
    Description: 'Gov Bridge Culverts Repl',
  },
  {
    Code: ' D501600',
    Description: 'St. George Rd Culverts',
  },
  {
    Code: ' D501601',
    Description: 'St. George Rd Culverts',
  },
  {
    Code: ' D501700',
    Description: 'Brock Bridge Rd Culverts',
  },
  {
    Code: ' D501701',
    Description: 'Brock Bridge Rd Culverts',
  },
  {
    Code: ' D501800',
    Description: 'Fallon Drive Storm Drain',
  },
  {
    Code: ' D501801',
    Description: 'Fallon Drive Storm Drain',
  },
  {
    Code: ' D505100',
    Description: 'New Cut Farms SD',
  },
  {
    Code: ' D505101',
    Description: 'New Cut Farms SD',
  },
  {
    Code: ' D505200',
    Description: 'Shady Side Culverts',
  },
  {
    Code: ' D505201',
    Description: 'Shady Side Culverts',
  },
  {
    Code: ' D510200',
    Description: 'Saunders Point Storm Drains',
  },
  {
    Code: ' D510201',
    Description: 'Saunders Point Storm Drains',
  },
  {
    Code: ' D510300',
    Description: 'Long Pt Rd SD Rehab',
  },
  {
    Code: ' D510301',
    Description: 'Long Pt Rd SD Rehab',
  },
  {
    Code: ' D515500',
    Description: 'Selby On The Bay SD',
  },
  {
    Code: ' D515501',
    Description: 'Selby On The Bay SD',
  },
  {
    Code: ' D515502',
    Description: 'Selby Heights SD Phase 2',
  },
  {
    Code: ' D515600',
    Description: 'Harmans Road Culvert Rehab',
  },
  {
    Code: ' D515601',
    Description: 'Harmans Road Culvert Rehab',
  },
  {
    Code: ' D515800',
    Description: 'FEMA Flood Plain Rev',
  },
  {
    Code: ' D515801',
    Description: 'FEMA Flood Plain Rev',
  },
  {
    Code: ' D515900',
    Description: 'Four Season Stream Rehab',
  },
  {
    Code: ' D515901',
    Description: 'Four Season Stream Rehab',
  },
  {
    Code: ' D888800',
    Description: 'SD Trans. for PY Clos Projects',
  },
  {
    Code: ' D888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' D888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' D999900',
    Description: 'S/D Class Account',
  },
  {
    Code: ' D999901',
    Description: 'S/D Class Account',
  },
  {
    Code: ' D999999',
    Description: 'S/D Class Account',
  },
  {
    Code: ' E356200',
    Description: 'Broadneck Sr Addn',
  },
  {
    Code: ' E356201',
    Description: 'Broadneck Sr Addn-Rev Only',
  },
  {
    Code: ' E356299',
    Description: 'Broadneck Sr Addn',
  },
  {
    Code: ' E364000',
    Description: 'Meade Area Middle',
  },
  {
    Code: ' E364099',
    Description: 'Meade Area Middle',
  },
  {
    Code: ' E364200',
    Description: 'Park Elementary School',
  },
  {
    Code: ' E364299',
    Description: 'Park Elementary School',
  },
  {
    Code: ' E377500',
    Description: 'Ridgeway Elementary',
  },
  {
    Code: ' E377599',
    Description: 'Ridgeway Elementary',
  },
  {
    Code: ' E385700',
    Description: 'C.A.T. North',
  },
  {
    Code: ' E385701',
    Description: 'C.A.T. North-Rev Only',
  },
  {
    Code: ' E385799',
    Description: 'C.A.T. North',
  },
  {
    Code: ' E407800',
    Description: 'Project Plan/Feasibility',
  },
  {
    Code: ' E407899',
    Description: 'Project Plan/Feasibility',
  },
  {
    Code: ' E409300',
    Description: 'Deale Elementary',
  },
  {
    Code: ' E409399',
    Description: 'Deale Elementary',
  },
  {
    Code: ' E409400',
    Description: 'South Shore Elem Renov',
  },
  {
    Code: ' E409401',
    Description: 'South Shore Elm Ren-Rev Onl',
  },
  {
    Code: ' E409499',
    Description: 'South Shore Elem Renov',
  },
  {
    Code: ' E409900',
    Description: 'Meade Heights Elem',
  },
  {
    Code: ' E409901',
    Description: 'Meade Heights Elem-Rev Only',
  },
  {
    Code: ' E409999',
    Description: 'Meade Heights Elem',
  },
  {
    Code: ' E434600',
    Description: 'Additions to Pre-K',
  },
  {
    Code: ' E434699',
    Description: 'Additions to Pre-K',
  },
  {
    Code: ' E434800',
    Description: 'Brooklyn Park Middle',
  },
  {
    Code: ' E434899',
    Description: 'Brooklyn Park Middle',
  },
  {
    Code: ' E434900',
    Description: 'Adams Park Elem Plan',
  },
  {
    Code: ' E434999',
    Description: 'Adams Park Elem Plan',
  },
  {
    Code: ' E435400',
    Description: 'Media Center Upgr 95',
  },
  {
    Code: ' E435499',
    Description: 'Media Center Upgr 95',
  },
  {
    Code: ' E441100',
    Description: 'Science Lab Renov',
  },
  {
    Code: ' E441199',
    Description: 'Science Lab Renov',
  },
  {
    Code: ' E446700',
    Description: 'Health & Safety FY96',
  },
  {
    Code: ' E446799',
    Description: 'Health & Safety FY96',
  },
  {
    Code: ' E446800',
    Description: 'Repl UST FY96',
  },
  {
    Code: ' E446899',
    Description: 'Repl UST FY96',
  },
  {
    Code: ' E446900',
    Description: 'BOE Maj Roof Repl 96',
  },
  {
    Code: ' E446999',
    Description: 'BOE Maj Roof Repl 96',
  },
  {
    Code: ' E447000',
    Description: 'Systemic Projects 96',
  },
  {
    Code: ' E447099',
    Description: 'Systemic Projects 96',
  },
  {
    Code: ' E447100',
    Description: 'Media Center Renov',
  },
  {
    Code: ' E447199',
    Description: 'Media Center Renov',
  },
  {
    Code: ' E447300',
    Description: 'Jacobsville Elementary',
  },
  {
    Code: ' E447399',
    Description: 'Jacobsville Elementary',
  },
  {
    Code: ' E447400',
    Description: 'Repl/Reinsul Boilers 96',
  },
  {
    Code: ' E447499',
    Description: 'Repl/Reinsul Boilers 96',
  },
  {
    Code: ' E447500',
    Description: 'School Furniture 96',
  },
  {
    Code: ' E447599',
    Description: 'School Furniture 96',
  },
  {
    Code: ' E447600',
    Description: 'Asbestos Abatement 96',
  },
  {
    Code: ' E447699',
    Description: 'Asbestos Abatement 96',
  },
  {
    Code: ' E447700',
    Description: 'Southern MS-- Addition',
  },
  {
    Code: ' E447799',
    Description: 'Southern MS-- Addition',
  },
  {
    Code: ' E447800',
    Description: 'Barrier Free AC 96',
  },
  {
    Code: ' E447899',
    Description: 'Barrier Free AC 96',
  },
  {
    Code: ' E447900',
    Description: 'Pre-K Renov & Add',
  },
  {
    Code: ' E447999',
    Description: 'Pre-K Renov & Add',
  },
  {
    Code: ' E448800',
    Description: 'Relocate Classrooms 96',
  },
  {
    Code: ' E448899',
    Description: 'Relocate Classrooms 96',
  },
  {
    Code: ' E449000',
    Description: 'Ft Smallwood Elementary',
  },
  {
    Code: ' E449099',
    Description: 'Ft Smallwood Elementary',
  },
  {
    Code: ' E455500',
    Description: 'Asbestos Abatement 97',
  },
  {
    Code: ' E455599',
    Description: 'Asbestos Abatement 97',
  },
  {
    Code: ' E455600',
    Description: 'BOE Maj Roof Repl 97',
  },
  {
    Code: ' E455699',
    Description: 'BOE Maj Roof Repl 97',
  },
  {
    Code: ' E455700',
    Description: 'BOE Undgrnd Stg Tk 97',
  },
  {
    Code: ' E455799',
    Description: 'BOE Undgrnd Stg Tk 97',
  },
  {
    Code: ' E455800',
    Description: 'Boiler Repl/Insul 97',
  },
  {
    Code: ' E455899',
    Description: 'Boiler Repl/Insul 97',
  },
  {
    Code: ' E456200',
    Description: 'Health & Safety 97',
  },
  {
    Code: ' E456299',
    Description: 'Health & Safety 97',
  },
  {
    Code: ' E456700',
    Description: 'Relocate Classrooms 97',
  },
  {
    Code: ' E456701',
    Description: 'Relocate Classrms 97-Rev Only',
  },
  {
    Code: ' E456799',
    Description: 'Relocate Classrooms 97',
  },
  {
    Code: ' E457400',
    Description: 'Systemic Projects 97',
  },
  {
    Code: ' E457499',
    Description: 'Systemic Projects 97',
  },
  {
    Code: ' E457700',
    Description: 'Media Center Renov 97',
  },
  {
    Code: ' E457799',
    Description: 'Media Center Renov 97',
  },
  {
    Code: ' E457800',
    Description: 'Jones ES Renov & Add',
  },
  {
    Code: ' E457899',
    Description: 'Jones ES Renov & Add',
  },
  {
    Code: ' E457900',
    Description: 'Belvedere ES Renov/Add',
  },
  {
    Code: ' E457999',
    Description: 'Belvedere ES Renov/Add',
  },
  {
    Code: ' E458000',
    Description: 'Davidsonville ES Repl',
  },
  {
    Code: ' E458099',
    Description: 'Davidsonville ES Repl',
  },
  {
    Code: ' E458100',
    Description: 'School Furniture 97',
  },
  {
    Code: ' E458199',
    Description: 'School Furniture 97',
  },
  {
    Code: ' E458200',
    Description: 'Barrier Free Access 97',
  },
  {
    Code: ' E458299',
    Description: 'Barrier Free Access 97',
  },
  {
    Code: ' E458300',
    Description: 'S Pk Hs Sc-lab Renov',
  },
  {
    Code: ' E458399',
    Description: 'S Pk Hs Sc-lab Renov',
  },
  {
    Code: ' E458400',
    Description: 'Jessup Es Wtrprof Rep',
  },
  {
    Code: ' E458499',
    Description: 'Jessup Es Wtrprof Rep',
  },
  {
    Code: ' E458500',
    Description: 'Riviera Bch Walls & Part',
  },
  {
    Code: ' E458599',
    Description: 'Riviera Bch Walls & Part',
  },
  {
    Code: ' E458600',
    Description: 'Upgrd Various Sch 97',
  },
  {
    Code: ' E458699',
    Description: 'Upgrd Various Sch 97',
  },
  {
    Code: ' E458900',
    Description: 'Crofton MS 6 Clsrm Wing',
  },
  {
    Code: ' E458999',
    Description: 'Crofton MS 6 Clsrm Wing',
  },
  {
    Code: ' E459000',
    Description: 'Crofton ES 6 Clsrm Wing',
  },
  {
    Code: ' E459099',
    Description: 'Crofton ES 6 Clsrm Wing',
  },
  {
    Code: ' E459100',
    Description: 'Piney Orchard ES',
  },
  {
    Code: ' E459199',
    Description: 'Piney Orchard ES',
  },
  {
    Code: ' E459200',
    Description: 'Mayo ES--Replacement',
  },
  {
    Code: ' E459299',
    Description: 'Mayo ES--Replacement',
  },
  {
    Code: ' E469100',
    Description: 'Health & Safety FY98',
  },
  {
    Code: ' E469199',
    Description: 'Health & Safety FY98',
  },
  {
    Code: ' E469200',
    Description: 'Repl UST FY98',
  },
  {
    Code: ' E469299',
    Description: 'Repl UST FY98',
  },
  {
    Code: ' E469300',
    Description: 'BOE Major Roof Repl 98',
  },
  {
    Code: ' E469399',
    Description: 'BOE Major Roof Repl 98',
  },
  {
    Code: ' E469400',
    Description: 'Renov Bldg Systems 98',
  },
  {
    Code: ' E469499',
    Description: 'Renov Bldg Systems 98',
  },
  {
    Code: ' E469500',
    Description: 'Relocate Classrooms 98',
  },
  {
    Code: ' E469599',
    Description: 'Relocate Classrooms 98',
  },
  {
    Code: ' E469600',
    Description: 'Media Center Renov 98',
  },
  {
    Code: ' E469699',
    Description: 'Media Center Renov 98',
  },
  {
    Code: ' E469700',
    Description: 'Walls & Partition Prgm 98',
  },
  {
    Code: ' E469799',
    Description: 'Walls & Partition Prgm 98',
  },
  {
    Code: ' E469800',
    Description: 'Repl & Reinsul Boilers 98',
  },
  {
    Code: ' E469899',
    Description: 'Repl & Reinsul Boilers 98',
  },
  {
    Code: ' E469900',
    Description: 'Asbestos Abatement 98',
  },
  {
    Code: ' E469999',
    Description: 'Asbestos Abatement 98',
  },
  {
    Code: ' E470000',
    Description: 'Barrier Free Access 98',
  },
  {
    Code: ' E470099',
    Description: 'Barrier Free Access 98',
  },
  {
    Code: ' E470100',
    Description: 'School Furniture 98',
  },
  {
    Code: ' E470199',
    Description: 'School Furniture 98',
  },
  {
    Code: ' E470300',
    Description: 'Upgr Various Schools 98',
  },
  {
    Code: ' E470399',
    Description: 'Upgr Various Schools 98',
  },
  {
    Code: ' E470400',
    Description: 'GB HS Science Lab Renov',
  },
  {
    Code: ' E470499',
    Description: 'GB HS Science Lab Renov',
  },
  {
    Code: ' E470500',
    Description: 'Technology in MD 98',
  },
  {
    Code: ' E470599',
    Description: 'Technology in MD 98',
  },
  {
    Code: ' E470600',
    Description: 'Odenton SWM Sys Rep',
  },
  {
    Code: ' E470699',
    Description: 'Odenton SWM Sys Rep',
  },
  {
    Code: ' E470700',
    Description: 'Carpet Repl 98',
  },
  {
    Code: ' E470799',
    Description: 'Carpet Repl 98',
  },
  {
    Code: ' E470800',
    Description: 'HVAC Renovation 98',
  },
  {
    Code: ' E470899',
    Description: 'HVAC Renovation 98',
  },
  {
    Code: ' E470900',
    Description: 'Bldg Exterior Renov 98',
  },
  {
    Code: ' E470999',
    Description: 'Bldg Exterior Renov 98',
  },
  {
    Code: ' E471700',
    Description: 'Glendale ES-- Replacement',
  },
  {
    Code: ' E471701',
    Description: 'Glendale ES-- Replacement',
  },
  {
    Code: ' E471799',
    Description: 'Glendale ES-- Replacement',
  },
  {
    Code: ' E475300',
    Description: 'Construction Prog Mgmt',
  },
  {
    Code: ' E475399',
    Description: 'Construction Prog Mgmt',
  },
  {
    Code: ' E476000',
    Description: 'Textbooks',
  },
  {
    Code: ' E476099',
    Description: 'Textbooks',
  },
  {
    Code: ' E476100',
    Description: 'Student Data System',
  },
  {
    Code: ' E476199',
    Description: 'Student Data System',
  },
  {
    Code: ' E476200',
    Description: 'Yr 2000/Admin Equip',
  },
  {
    Code: ' E476299',
    Description: 'Yr 2000/Admin Equip',
  },
  {
    Code: ' E476300',
    Description: 'Vehicle Replacement',
  },
  {
    Code: ' E476399',
    Description: 'Vehicle Replacement',
  },
  {
    Code: ' E485300',
    Description: 'Health & Safety 99',
  },
  {
    Code: ' E485399',
    Description: 'Health & Safety 99',
  },
  {
    Code: ' E485400',
    Description: 'UST 99',
  },
  {
    Code: ' E485499',
    Description: 'UST 99',
  },
  {
    Code: ' E485500',
    Description: 'BOE Major Roof Repl 99',
  },
  {
    Code: ' E485599',
    Description: 'BOE Major Roof Repl 99',
  },
  {
    Code: ' E485600',
    Description: 'Renov Bldg Systems 99',
  },
  {
    Code: ' E485699',
    Description: 'Renov Bldg Systems 99',
  },
  {
    Code: ' E485700',
    Description: 'Relocate Classrooms 99',
  },
  {
    Code: ' E485799',
    Description: 'Relocate Classrooms 99',
  },
  {
    Code: ' E485800',
    Description: 'Walls & Partition Prgm 99',
  },
  {
    Code: ' E485899',
    Description: 'Walls & Partition Prgm 99',
  },
  {
    Code: ' E485900',
    Description: 'Repl & Reinsul Boilers 99',
  },
  {
    Code: ' E485999',
    Description: 'Repl & Reinsul Boilers 99',
  },
  {
    Code: ' E486000',
    Description: 'Asbestos Abatement 99',
  },
  {
    Code: ' E486099',
    Description: 'Asbestos Abatement 99',
  },
  {
    Code: ' E486100',
    Description: 'Barrier Free Access 99',
  },
  {
    Code: ' E486199',
    Description: 'Barrier Free Access 99',
  },
  {
    Code: ' E486200',
    Description: 'School Furniture 99',
  },
  {
    Code: ' E486299',
    Description: 'School Furniture 99',
  },
  {
    Code: ' E486300',
    Description: 'Upgr Various Schools 99',
  },
  {
    Code: ' E486399',
    Description: 'Upgr Various Schools 99',
  },
  {
    Code: ' E486400',
    Description: 'Technology in MD 99',
  },
  {
    Code: ' E486499',
    Description: 'Technology in MD 99',
  },
  {
    Code: ' E486500',
    Description: 'Carpet Repl 99',
  },
  {
    Code: ' E486599',
    Description: 'Carpet Repl 99',
  },
  {
    Code: ' E486600',
    Description: 'HVAC Renovation 99',
  },
  {
    Code: ' E486699',
    Description: 'HVAC Renovation 99',
  },
  {
    Code: ' E486700',
    Description: 'Bldg Exterior Renov 99',
  },
  {
    Code: ' E486799',
    Description: 'Bldg Exterior Renov 99',
  },
  {
    Code: ' E486800',
    Description: 'Old Mill Science Lab',
  },
  {
    Code: ' E486899',
    Description: 'Old Mill Science Lab',
  },
  {
    Code: ' E486900',
    Description: 'Southern HS Run Track',
  },
  {
    Code: ' E486999',
    Description: 'Southern HS Run Track',
  },
  {
    Code: ' E487100',
    Description: 'Aging School Grant',
  },
  {
    Code: ' E487199',
    Description: 'Aging School Grant',
  },
  {
    Code: ' E487700',
    Description: 'North County Addition',
  },
  {
    Code: ' E487799',
    Description: 'North County Addition',
  },
  {
    Code: ' E488400',
    Description: 'South River Science Lab',
  },
  {
    Code: ' E488499',
    Description: 'South River Science Lab',
  },
  {
    Code: ' E490100',
    Description: 'South River HS Walls',
  },
  {
    Code: ' E490199',
    Description: 'South River HS Walls',
  },
  {
    Code: ' E490200',
    Description: 'North County HS-- Addition',
  },
  {
    Code: ' E490299',
    Description: 'North County HS-- Addition',
  },
  {
    Code: ' E493800',
    Description: 'Aging School Grant 00',
  },
  {
    Code: ' E493801',
    Description: 'Aging School Grant 00',
  },
  {
    Code: ' E493900',
    Description: 'Asbestos Abatement 00',
  },
  {
    Code: ' E493901',
    Description: 'Asbestos Abatement 00',
  },
  {
    Code: ' E494000',
    Description: 'Barrier Free Access 00',
  },
  {
    Code: ' E494001',
    Description: 'Barrier Free Access 00',
  },
  {
    Code: ' E494100',
    Description: 'Boil Repl & Reinsul 00',
  },
  {
    Code: ' E494101',
    Description: 'Boil Repl & Reinsul 00',
  },
  {
    Code: ' E494200',
    Description: 'Bldg Electr Upgrd 00',
  },
  {
    Code: ' E494201',
    Description: 'Bldg Electr Upgrd 00',
  },
  {
    Code: ' E494300',
    Description: 'Bldg Exterior Renov 00',
  },
  {
    Code: ' E494301',
    Description: 'Bldg Exterior Renov 00',
  },
  {
    Code: ' E494400',
    Description: 'Carpet Replacement 00',
  },
  {
    Code: ' E494401',
    Description: 'Carpet Replacement 00',
  },
  {
    Code: ' E494500',
    Description: 'Ches. HS Track Repl',
  },
  {
    Code: ' E494501',
    Description: 'Ches. HS Track Repl',
  },
  {
    Code: ' E494600',
    Description: 'Fire Alarm Repl 00',
  },
  {
    Code: ' E494601',
    Description: 'Fire Alarm Repl 00',
  },
  {
    Code: ' E494700',
    Description: 'Gym Floors Replace',
  },
  {
    Code: ' E494701',
    Description: 'Gym Floors Replace',
  },
  {
    Code: ' E494800',
    Description: 'Health & Safety 00',
  },
  {
    Code: ' E494801',
    Description: 'Health & Safety 00',
  },
  {
    Code: ' E494900',
    Description: 'Health Room Mod 00',
  },
  {
    Code: ' E494901',
    Description: 'Health Room Mod 00',
  },
  {
    Code: ' E495000',
    Description: 'HS Lab Modernization',
  },
  {
    Code: ' E495001',
    Description: 'HS Lab Modernization',
  },
  {
    Code: ' E495100',
    Description: 'HVAC Renovations 00',
  },
  {
    Code: ' E495101',
    Description: 'HVAC Renovations 00',
  },
  {
    Code: ' E495200',
    Description: 'Paint Water Towers 00',
  },
  {
    Code: ' E495201',
    Description: 'Paint Water Towers 00',
  },
  {
    Code: ' E495300',
    Description: 'Reloc Classrooms 00',
  },
  {
    Code: ' E495301',
    Description: 'Reloc Classrooms 00',
  },
  {
    Code: ' E495400',
    Description: 'Roof Replacement 00',
  },
  {
    Code: ' E495401',
    Description: 'Roof Replacement 00',
  },
  {
    Code: ' E495500',
    Description: 'School Furniture 00',
  },
  {
    Code: ' E495501',
    Description: 'School Furniture 00',
  },
  {
    Code: ' E495700',
    Description: 'Southern HS Well & Water',
  },
  {
    Code: ' E495701',
    Description: 'Southern HS Well & Water',
  },
  {
    Code: ' E495800',
    Description: 'Technology in MD 00',
  },
  {
    Code: ' E495801',
    Description: 'Technology in MD 00',
  },
  {
    Code: ' E495900',
    Description: 'Undrgrnd Stg Tanks 00',
  },
  {
    Code: ' E495901',
    Description: 'Undrgrnd Stg Tanks 00',
  },
  {
    Code: ' E496000',
    Description: 'Upgrd Various Schools 00',
  },
  {
    Code: ' E496001',
    Description: 'Upgrd Various Schools 00',
  },
  {
    Code: ' E496100',
    Description: 'Vehicle Replacement 00',
  },
  {
    Code: ' E496101',
    Description: 'Vehicle Replacement 00',
  },
  {
    Code: ' E498400',
    Description: 'Marley ES--Replacement',
  },
  {
    Code: ' E498401',
    Description: 'Marley ES--Replacement',
  },
  {
    Code: ' E498700',
    Description: 'Harman ES --',
  },
  {
    Code: ' E498701',
    Description: 'Harman ES --',
  },
  {
    Code: ' E498900',
    Description: 'Pasadena ES -- Feasibility Stu',
  },
  {
    Code: ' E498901',
    Description: 'Pasadena ES -- Feasibility Stu',
  },
  {
    Code: ' E499200',
    Description: "Bldg Systems Renov '00",
  },
  {
    Code: ' E499201',
    Description: "Bldg Systems Renov '00",
  },
  {
    Code: ' E499500',
    Description: "Stormwater Pond Maint '00",
  },
  {
    Code: ' E499501',
    Description: "Stormwater Pond Maint '00",
  },
  {
    Code: ' E500800',
    Description: 'Major Struc Rehab 92',
  },
  {
    Code: ' E500899',
    Description: 'Major Struc Rehab 92',
  },
  {
    Code: ' E501900',
    Description: 'Adv Systemic Construction Acct',
  },
  {
    Code: ' E501901',
    Description: 'Adv Systemic Construction Acct',
  },
  {
    Code: ' E504200',
    Description: 'BOE Maintenance Backlog',
  },
  {
    Code: ' E505300',
    Description: 'Health and Safety 01',
  },
  {
    Code: ' E505301',
    Description: 'Health and Safety 01',
  },
  {
    Code: ' E505400',
    Description: "Roof Replacement '01",
  },
  {
    Code: ' E505401',
    Description: "Roof Replacement '01",
  },
  {
    Code: ' E505500',
    Description: "Relocatable Classrooms '01",
  },
  {
    Code: ' E505501',
    Description: "Relocatable Classrooms '01",
  },
  {
    Code: ' E505600',
    Description: 'Redistricting Implementation',
  },
  {
    Code: ' E505601',
    Description: 'Redistricting Implementation',
  },
  {
    Code: ' E505700',
    Description: "Asbestos Abatement '01",
  },
  {
    Code: ' E505701',
    Description: "Asbestos Abatement '01",
  },
  {
    Code: ' E505800',
    Description: "Technology in MD Schools '01",
  },
  {
    Code: ' E505801',
    Description: "Technology in MD Schools '01",
  },
  {
    Code: ' E505900',
    Description: 'Marley MS - Replacement',
  },
  {
    Code: ' E505901',
    Description: 'Marley MS - Replacement',
  },
  {
    Code: ' E506000',
    Description: 'Cape St. Claire ES - Revital',
  },
  {
    Code: ' E506001',
    Description: 'Cape St. Claire ES - Revital',
  },
  {
    Code: ' E506100',
    Description: "Walls & Partitions '01",
  },
  {
    Code: ' E506101',
    Description: "Walls & Partitions '01",
  },
  {
    Code: ' E506200',
    Description: "Barrier Free Access '01",
  },
  {
    Code: ' E506201',
    Description: "Barrier Free Access '01",
  },
  {
    Code: ' E506300',
    Description: "Health Room Modifications '01",
  },
  {
    Code: ' E506301',
    Description: "Health Room Modifications '01",
  },
  {
    Code: ' E506400',
    Description: "School Furniture '01",
  },
  {
    Code: ' E506401',
    Description: "School Furniture '01",
  },
  {
    Code: ' E506500',
    Description: "Upgrade Various Schools '01",
  },
  {
    Code: ' E506501',
    Description: "Upgrade Various Schools '01",
  },
  {
    Code: ' E506600',
    Description: "Paint Water Towers '01",
  },
  {
    Code: ' E506601',
    Description: "Paint Water Towers '01",
  },
  {
    Code: ' E506700',
    Description: "Vehicle Replacement '01",
  },
  {
    Code: ' E506701',
    Description: "Vehicle Replacement '01",
  },
  {
    Code: ' E506800',
    Description: "Aging Schools-St Grant Prg '01",
  },
  {
    Code: ' E506801',
    Description: "Aging Schools-St Grant Prg '01",
  },
  {
    Code: ' E506900',
    Description: "Stormwater Pond Maint. '01",
  },
  {
    Code: ' E506901',
    Description: "Stormwater Pond Maint. '01",
  },
  {
    Code: ' E507100',
    Description: "Building Systems Renov '02",
  },
  {
    Code: ' E507101',
    Description: "Building Systems Renov '02",
  },
  {
    Code: ' E507200',
    Description: "Maint Backlog Reduction '01",
  },
  {
    Code: ' E507201',
    Description: "Maint Backlog Reduction '01",
  },
  {
    Code: ' E510400',
    Description: "Health & Safety '02",
  },
  {
    Code: ' E510401',
    Description: "Health & Safety '02",
  },
  {
    Code: ' E510500',
    Description: "Roof Replacement '02",
  },
  {
    Code: ' E510501',
    Description: "Roof Replacement '02",
  },
  {
    Code: ' E510600',
    Description: "Building Systems Renovation'03",
  },
  {
    Code: ' E510601',
    Description: "Building Systems Renovation'03",
  },
  {
    Code: ' E510700',
    Description: "Maint Backlog Reduction '02",
  },
  {
    Code: ' E510701',
    Description: "Maint Backlog Reduction '02",
  },
  {
    Code: ' E510900',
    Description: "Relocatable Classrooms '02",
  },
  {
    Code: ' E510901',
    Description: "Relocatable Classrooms '02",
  },
  {
    Code: ' E511000',
    Description: "Asbestos Abatement '02",
  },
  {
    Code: ' E511001',
    Description: "Asbestos Abatement '02",
  },
  {
    Code: ' E511100',
    Description: "Walls & Partitions '02",
  },
  {
    Code: ' E511101',
    Description: "Walls & Partitions '02",
  },
  {
    Code: ' E511200',
    Description: "Barrier Free Access '02",
  },
  {
    Code: ' E511201',
    Description: "Barrier Free Access '02",
  },
  {
    Code: ' E511300',
    Description: "Health Room Modifications '02",
  },
  {
    Code: ' E511301',
    Description: "Health Room Modifications '02",
  },
  {
    Code: ' E511400',
    Description: "School Furniture '02",
  },
  {
    Code: ' E511401',
    Description: "School Furniture '02",
  },
  {
    Code: ' E511500',
    Description: "Upgrade Various Schools '02",
  },
  {
    Code: ' E511501',
    Description: "Upgrade Various Schools '02",
  },
  {
    Code: ' E511600',
    Description: "Vehicle Replacement '02",
  },
  {
    Code: ' E511601',
    Description: "Vehicle Replacement '02",
  },
  {
    Code: ' E511700',
    Description: "Aging Schools '02",
  },
  {
    Code: ' E511701',
    Description: "Aging Schools '02",
  },
  {
    Code: ' E511800',
    Description: 'Seven Oaks ES -- New',
  },
  {
    Code: ' E511801',
    Description: 'Seven Oaks ES -- New',
  },
  {
    Code: ' E511900',
    Description: 'Science Lab Modernization',
  },
  {
    Code: ' E511901',
    Description: 'Science Lab Modernization',
  },
  {
    Code: ' E512000',
    Description: 'Technology in Maryland Schools',
  },
  {
    Code: ' E512001',
    Description: 'Technology in Maryland Schools',
  },
  {
    Code: ' E512100',
    Description: 'Qualified Zone Academy Bonds',
  },
  {
    Code: ' E512101',
    Description: 'Qualified Zone Academy Bonds',
  },
  {
    Code: ' E512200',
    Description: 'Crofton ES -- Gymnasium',
  },
  {
    Code: ' E512201',
    Description: 'Crofton ES -- Gymnasium',
  },
  {
    Code: ' E517700',
    Description: 'Health & Safety 03',
  },
  {
    Code: ' E517701',
    Description: 'Health & Safety 03',
  },
  {
    Code: ' E517800',
    Description: 'Roof Replacement 03',
  },
  {
    Code: ' E517801',
    Description: 'Roof Replacement 03',
  },
  {
    Code: ' E517900',
    Description: "Building Systems Renovation'04",
  },
  {
    Code: ' E517901',
    Description: "Building Systems Renovation'04",
  },
  {
    Code: ' E518000',
    Description: 'Maintenance Backlog Reduction',
  },
  {
    Code: ' E518001',
    Description: 'Maintenance Backlog Reduction',
  },
  {
    Code: ' E518100',
    Description: 'Relocatable Classrooms 03',
  },
  {
    Code: ' E518101',
    Description: 'Relocatable Classrooms 03',
  },
  {
    Code: ' E518200',
    Description: 'Asbestos Abatement 03',
  },
  {
    Code: ' E518201',
    Description: 'Asbestos Abatement 03',
  },
  {
    Code: ' E518300',
    Description: 'TIMS Electrical Upgrade',
  },
  {
    Code: ' E518301',
    Description: 'TIMS Electrical Upgrade',
  },
  {
    Code: ' E518400',
    Description: 'Walls & Partitions 03',
  },
  {
    Code: ' E518401',
    Description: 'Walls & Partitions 03',
  },
  {
    Code: ' E518500',
    Description: 'Barrier Free Access 03',
  },
  {
    Code: ' E518501',
    Description: 'Barrier Free Access 03',
  },
  {
    Code: ' E518600',
    Description: 'Health Room Modifications 03',
  },
  {
    Code: ' E518601',
    Description: 'Health Room Modifications 03',
  },
  {
    Code: ' E518700',
    Description: 'School Furniture 03',
  },
  {
    Code: ' E518701',
    Description: 'School Furniture 03',
  },
  {
    Code: ' E518800',
    Description: 'Upgrade Various Schools 03',
  },
  {
    Code: ' E518801',
    Description: 'Upgrade Various Schools 03',
  },
  {
    Code: ' E518900',
    Description: 'Vehicle Replacement 03',
  },
  {
    Code: ' E518901',
    Description: 'Vehicle Replacement 03',
  },
  {
    Code: ' E519000',
    Description: 'Window Air Conditioners Initia',
  },
  {
    Code: ' E519001',
    Description: 'Window Air Conditioners Initia',
  },
  {
    Code: ' E519100',
    Description: 'Aging Schools 03',
  },
  {
    Code: ' E519101',
    Description: 'Aging Schools 03',
  },
  {
    Code: ' E520300',
    Description: 'Severna Park HS -- Air Conditi',
  },
  {
    Code: ' E520301',
    Description: 'Severna Park HS -- Air Conditi',
  },
  {
    Code: ' E520400',
    Description: 'Ferndale ES-Roof Repl/Water In',
  },
  {
    Code: ' E520401',
    Description: 'Ferndale ES-Roof Repl/Water In',
  },
  {
    Code: ' E520500',
    Description: 'North County HS -- PE Facility',
  },
  {
    Code: ' E520501',
    Description: 'North County HS -- PE Facility',
  },
  {
    Code: ' E888800',
    Description: 'BE Trans. for PY Clos Projects',
  },
  {
    Code: ' E888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' E888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' E999900',
    Description: 'Education Class Account',
  },
  {
    Code: ' E999901',
    Description: 'Education Class Account',
  },
  {
    Code: ' E999999',
    Description: 'Education Class Account Conv',
  },
  {
    Code: ' F346500',
    Description: 'Chg Agst F & P Clsd Proj',
  },
  {
    Code: ' F346501',
    Description: 'Chg Agst F & P Clsd Proj Conv.',
  },
  {
    Code: ' F346599',
    Description: 'Chg Agst F & P Clsd Proj Conv.',
  },
  {
    Code: ' F416500',
    Description: 'Detention Center New/Upgrd',
  },
  {
    Code: ' F416501',
    Description: 'Detention  Ctr Master Plan Upd',
  },
  {
    Code: ' F416502',
    Description: 'Det Ctr Ordn Rd Demo Phase B',
  },
  {
    Code: ' F416503',
    Description: 'Det Ctr Ordn Rd Stewrk (BP1)',
  },
  {
    Code: ' F416504',
    Description: 'Det Center Misc Renovations',
  },
  {
    Code: ' F416505',
    Description: 'Jennifer Rd Det Ctr Ph 1 Stewr',
  },
  {
    Code: ' F416506',
    Description: 'Det Ctr Ord  Rd Det Eq (BP2)',
  },
  {
    Code: ' F416507',
    Description: 'Det Ctr Ord Rd Gen Con (BP3)',
  },
  {
    Code: ' F416508',
    Description: 'Det Ctr Ord Rd F&L Eq (BP4)',
  },
  {
    Code: ' F416509',
    Description: 'Det Ctr Ord Rd F,F,Eq (BP5)',
  },
  {
    Code: ' F416510',
    Description: 'Jennifer Rd Det Ctr Ph2 GenCon',
  },
  {
    Code: ' F416599',
    Description: 'Det Ctr New/Upgrd Conv',
  },
  {
    Code: ' F416700',
    Description: 'Severn Fire Station',
  },
  {
    Code: ' F416701',
    Description: 'Severn Fire Station',
  },
  {
    Code: ' F416702',
    Description: 'Severn Fire Station',
  },
  {
    Code: ' F416799',
    Description: 'Ridgeway Fire Stat Conv',
  },
  {
    Code: ' F437400',
    Description: 'Brooklyn Fire Station',
  },
  {
    Code: ' F437401',
    Description: 'Brooklyn Fire Station',
  },
  {
    Code: ' F437402',
    Description: 'Brooklyn Fire Stn.-Temporary',
  },
  {
    Code: ' F437499',
    Description: 'Brooklyn Fire Stat  Conv',
  },
  {
    Code: ' F437500',
    Description: 'N. District Pol St Addt',
  },
  {
    Code: ' F437599',
    Description: 'N. District Pol St Addt',
  },
  {
    Code: ' F438000',
    Description: 'New South Distr Pol Stat',
  },
  {
    Code: ' F438001',
    Description: 'New So Distr Pol Stat',
  },
  {
    Code: ' F438099',
    Description: 'New So Distr Pol Stat Conv',
  },
  {
    Code: ' F439200',
    Description: 'West Dist Addition',
  },
  {
    Code: ' F439201',
    Description: 'West Dist Pol Stat Addition',
  },
  {
    Code: ' F439299',
    Description: 'West Dist Addition Conv',
  },
  {
    Code: ' F441500',
    Description: 'Rep/Ren Volunteer FS',
  },
  {
    Code: ' F441501',
    Description: 'Rep/Ren Volunteer FS',
  },
  {
    Code: ' F441599',
    Description: 'Rep/ Ren Volunteer FS Conv',
  },
  {
    Code: ' F451800',
    Description: 'Maryland City FS Addition',
  },
  {
    Code: ' F451801',
    Description: 'Maryland City FS Addition',
  },
  {
    Code: ' F451899',
    Description: 'Maryland City FS Add Conv',
  },
  {
    Code: ' F451900',
    Description: 'W. Annapolis Fire Stat  Reloc',
  },
  {
    Code: ' F451901',
    Description: 'W. Annapolis FS Relocation',
  },
  {
    Code: ' F451902',
    Description: 'W. Annapolis FS Relocation',
  },
  {
    Code: ' F451999',
    Description: 'W. Annapolis FS  Reloc  Conv',
  },
  {
    Code: ' F460400',
    Description: 'Emergency Oper Center',
  },
  {
    Code: ' F460499',
    Description: 'Emergency Oper Center',
  },
  {
    Code: ' F460500',
    Description: 'Police Facility Repair',
  },
  {
    Code: ' F460501',
    Description: 'Police Facility Repair',
  },
  {
    Code: ' F460502',
    Description: 'Pol Fac Rep Ph2 HVAC/Resurf',
  },
  {
    Code: ' F460599',
    Description: 'Police Facility Rep Conv',
  },
  {
    Code: ' F460600',
    Description: 'Fire Burn Bldg New',
  },
  {
    Code: ' F460601',
    Description: 'Fire Burn Bldg New',
  },
  {
    Code: ' F460699',
    Description: 'Fire Burn Bldg New Conv',
  },
  {
    Code: ' F460700',
    Description: 'Fire/Police Project Plan',
  },
  {
    Code: ' F460701',
    Description: 'Jessup & Jones Stat  FS Study',
  },
  {
    Code: ' F460702',
    Description: 'ECU & Police HQ Study',
  },
  {
    Code: ' F460703',
    Description: 'Fire Station Location Study',
  },
  {
    Code: ' F460704',
    Description: 'Project Plan-3 Fire Stations',
  },
  {
    Code: ' F460705',
    Description: 'Proj Plan-E. Police Station',
  },
  {
    Code: ' F460799',
    Description: 'Fire/Police Project Plan Conv',
  },
  {
    Code: ' F460800',
    Description: 'Semi Enclosed Fire Range',
  },
  {
    Code: ' F460801',
    Description: 'Semi Encl Firing Range',
  },
  {
    Code: ' F460899',
    Description: 'Semi Encl  Fire Range Conv',
  },
  {
    Code: ' F484000',
    Description: 'Riva Fire Sta Add',
  },
  {
    Code: ' F484001',
    Description: 'Riva FS Addition',
  },
  {
    Code: ' F484099',
    Description: 'Riva Fire Sta Add Conv',
  },
  {
    Code: ' F489300',
    Description: 'Eastern Pol Modular',
  },
  {
    Code: ' F489301',
    Description: 'Eastern Pol Modular Bldg',
  },
  {
    Code: ' F489399',
    Description: 'Eastern Pol Modular Conv',
  },
  {
    Code: ' F502000',
    Description: 'Vehicle Emission System',
  },
  {
    Code: ' F502001',
    Description: 'Vehicle Emission System',
  },
  {
    Code: ' F502002',
    Description: 'Vehicle Emission System, Ph2',
  },
  {
    Code: ' F502003',
    Description: 'Vehicle Emission System, Ph3',
  },
  {
    Code: ' F502004',
    Description: 'Vehicle Emission System, Ph 4',
  },
  {
    Code: ' F502005',
    Description: 'Vehicle Emission System, Ph 5',
  },
  {
    Code: ' F502100',
    Description: 'Odenton Fire Station Renov',
  },
  {
    Code: ' F502101',
    Description: 'Odenton Fire Station Renov',
  },
  {
    Code: ' F507300',
    Description: 'FS Emergency Generator',
  },
  {
    Code: ' F507301',
    Description: 'FS Emergency Generator',
  },
  {
    Code: ' F507400',
    Description: 'Jones Station FS Addition',
  },
  {
    Code: ' F507401',
    Description: 'Jones Station FS Addition',
  },
  {
    Code: ' F507700',
    Description: 'West District PS Addition',
  },
  {
    Code: ' F507701',
    Description: 'West District PS Addition',
  },
  {
    Code: ' F515000',
    Description: 'Police Headquarters Renov',
  },
  {
    Code: ' F515001',
    Description: 'Police Headquarters Renov',
  },
  {
    Code: ' F520100',
    Description: 'Lake Shore Vol F S Renov',
  },
  {
    Code: ' F520101',
    Description: 'Lake Shore Vol F S Renov',
  },
  {
    Code: ' F888800',
    Description: 'PF Trans. for PY Clos Projects',
  },
  {
    Code: ' F888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' F888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' F999900',
    Description: 'Fire/Pol Class Account',
  },
  {
    Code: ' F999901',
    Description: 'Fire/Pol Class Account',
  },
  {
    Code: ' F999999',
    Description: 'Fire/Pol  Class Account Conv',
  },
  {
    Code: ' H161200',
    Description: 'Road Agreement W/T Devlpr',
  },
  {
    Code: ' H161201',
    Description: 'RA W/T Devlpr/Fishing Creek ?',
  },
  {
    Code: ' H161202',
    Description: 'Sandbridge Utl-Grd-Pw Default',
  },
  {
    Code: ' H161203',
    Description: 'Severn Hill - Grading Default',
  },
  {
    Code: ' H161299',
    Description: 'Road Agreement W/T Devlpr Conv',
  },
  {
    Code: ' H253500',
    Description: 'East-West Blvd.',
  },
  {
    Code: ' H253501',
    Description: 'East-West Blvd Phase 1',
  },
  {
    Code: ' H253502',
    Description: 'East-West Blvd Phase 2',
  },
  {
    Code: ' H253503',
    Description: 'East-West Blvd Phase 3A',
  },
  {
    Code: ' H253504',
    Description: 'East-West Blvd Phase 3',
  },
  {
    Code: ' H253505',
    Description: 'East-West Blvd  Prop Demolitio',
  },
  {
    Code: ' H253599',
    Description: 'East-West Blvd. Conv',
  },
  {
    Code: ' H305500',
    Description: 'Bridge Repl Turkey PT',
  },
  {
    Code: ' H305599',
    Description: 'Bridge Repl Turkey PT',
  },
  {
    Code: ' H316700',
    Description: 'Odenton Road',
  },
  {
    Code: ' H316701',
    Description: 'Odenton Rd Sidewalk',
  },
  {
    Code: ' H316799',
    Description: 'Odenton Rd Sidewalk',
  },
  {
    Code: ' H346600',
    Description: 'Chg Agst R & B Clsd Projects',
  },
  {
    Code: ' H346601',
    Description: 'Chg Agst R & B Clsd Proj',
  },
  {
    Code: ' H346699',
    Description: 'Chg Agst R & B Clsd Proj Conv',
  },
  {
    Code: ' H349400',
    Description: 'Morgan Road Extended',
  },
  {
    Code: ' H349401',
    Description: 'Morgan Road Extended',
  },
  {
    Code: ' H349499',
    Description: 'Morgan Road Ext Conv',
  },
  {
    Code: ' H349600',
    Description: 'Earleigh Heights Rd',
  },
  {
    Code: ' H349601',
    Description: 'Earleigh Heights Road',
  },
  {
    Code: ' H349699',
    Description: 'Earleigh Heights Rd Conv',
  },
  {
    Code: ' H357600',
    Description: 'Jumpers Hole Rd 3',
  },
  {
    Code: ' H357601',
    Description: 'Jumpers Hole Rd Phase IIIB',
  },
  {
    Code: ' H357699',
    Description: 'Jumpers Hole Rd 3 Conv',
  },
  {
    Code: ' H357700',
    Description: 'Riva S. Of S. River',
  },
  {
    Code: ' H357701',
    Description: 'Riva So of South River',
  },
  {
    Code: ' H357799',
    Description: 'Riva S. Of S. River Conv.',
  },
  {
    Code: ' H358100',
    Description: 'Patuxent/Conway Rds',
  },
  {
    Code: ' H358101',
    Description: 'Patuxent/Conway Rds',
  },
  {
    Code: ' H358199',
    Description: 'Patuxent/Conway Rds Conv',
  },
  {
    Code: ' H361000',
    Description: 'Medical Boulevard',
  },
  {
    Code: ' H361001',
    Description: 'Medical Boulevard',
  },
  {
    Code: ' H361002',
    Description: 'Medical Boulevard Ph2',
  },
  {
    Code: ' H361003',
    Description: 'Medical Blvd/Scotts Xing-SWMP',
  },
  {
    Code: ' H361004',
    Description: 'Medical Parkway Phase 2',
  },
  {
    Code: ' H361099',
    Description: 'Medical Boulevard Conv',
  },
  {
    Code: ' H361400',
    Description: 'New Disney Rd Recon',
  },
  {
    Code: ' H361401',
    Description: 'New Disney Rd Recon',
  },
  {
    Code: ' H361499',
    Description: 'New Disney Rd Recon Conv',
  },
  {
    Code: ' H371200',
    Description: 'Town Cntr To Reece Rd',
  },
  {
    Code: ' H371201',
    Description: 'Town Cntr To Reece Road',
  },
  {
    Code: ' H371299',
    Description: 'Town Cntr To Reece Rd  Conv',
  },
  {
    Code: ' H371600',
    Description: 'Forest Dr Enhancement',
  },
  {
    Code: ' H371601',
    Description: 'Forest Drive Ph2',
  },
  {
    Code: ' H371602',
    Description: 'Forest Drive Ph1 & Ph3',
  },
  {
    Code: ' H371603',
    Description: 'Bay Ridge Bikeway',
  },
  {
    Code: ' H371604',
    Description: 'Forest Drive Ph4',
  },
  {
    Code: ' H371699',
    Description: 'Forest Dr Enhancement Conv',
  },
  {
    Code: ' H376200',
    Description: 'Nutwell Road Bridge',
  },
  {
    Code: ' H376299',
    Description: 'Nutwell Road Bridge',
  },
  {
    Code: ' H382500',
    Description: 'Brockbrdg Rd Reloca',
  },
  {
    Code: ' H382501',
    Description: 'Brockbrdg Rd Relocation',
  },
  {
    Code: ' H382599',
    Description: 'Brockbrdg Rd Reloca Conv',
  },
  {
    Code: ' H383100',
    Description: 'Quarterfield Road',
  },
  {
    Code: ' H383101',
    Description: 'Quarterfield Road',
  },
  {
    Code: ' H383199',
    Description: 'Quarterfield Road Conv',
  },
  {
    Code: ' H387400',
    Description: 'Solley Road Realignmt',
  },
  {
    Code: ' H387401',
    Description: 'Solley Road Realignment',
  },
  {
    Code: ' H387499',
    Description: 'Solley Road Realignmt Conv',
  },
  {
    Code: ' H387900',
    Description: 'Hospital Drive Extension',
  },
  {
    Code: ' H387901',
    Description: 'Hospital Dr Ext Ph 1',
  },
  {
    Code: ' H387999',
    Description: 'Hospital Drive Ext Conv',
  },
  {
    Code: ' H388600',
    Description: 'Ft Smallwood/Ed Raynor',
  },
  {
    Code: ' H388601',
    Description: 'Ft Smallwood/Edwin Raynor Rd',
  },
  {
    Code: ' H388699',
    Description: 'Ft Smallwood/Ed Raynor Conv',
  },
  {
    Code: ' H391500',
    Description: 'Bradley Road',
  },
  {
    Code: ' H391599',
    Description: 'Bradley Road',
  },
  {
    Code: ' H396700',
    Description: 'Housley Rd Extended',
  },
  {
    Code: ' H396701',
    Description: 'Housley Rd Extended',
  },
  {
    Code: ' H396799',
    Description: 'Housley Rd Extended Conv',
  },
  {
    Code: ' H410600',
    Description: 'Transportation Master Plan',
  },
  {
    Code: ' H410601',
    Description: 'Transportation Master Plan',
  },
  {
    Code: ' H410602',
    Description: 'TMP Parole Transprt Needs Stdy',
  },
  {
    Code: ' H410603',
    Description: 'Pedestrian/Bike Master Plan',
  },
  {
    Code: ' H410604',
    Description: 'Mayo/Londontown Streetscape',
  },
  {
    Code: ' H410699',
    Description: 'Transportation Master Plan Con',
  },
  {
    Code: ' H412900',
    Description: 'Countywide  Sidewalks',
  },
  {
    Code: ' H412901',
    Description: 'Countywide Sidewalks',
  },
  {
    Code: ' H412999',
    Description: 'Countywide Sidewalks Conv',
  },
  {
    Code: ' H415800',
    Description: 'Marley Nck/Solly Conn',
  },
  {
    Code: ' H415801',
    Description: 'Marley Nck/Solly Conn',
  },
  {
    Code: ' H415899',
    Description: 'Marley Nck/Solly Conn Conv',
  },
  {
    Code: ' H418700',
    Description: 'Arundel On The Bay Rd',
  },
  {
    Code: ' H418701',
    Description: 'Arundel On The Bay Rd',
  },
  {
    Code: ' H418799',
    Description: 'Arundel On The Bay Rd Conv',
  },
  {
    Code: ' H418900',
    Description: 'Snug Harbor Road',
  },
  {
    Code: ' H418901',
    Description: 'Snug Harbor Road',
  },
  {
    Code: ' H418999',
    Description: 'Snug Harbor Road Conv',
  },
  {
    Code: ' H419600',
    Description: 'Coll Prkwy & Cpe St Claire Rd',
  },
  {
    Code: ' H419601',
    Description: 'Coll Prkwy & Cpe St Claire Rd',
  },
  {
    Code: ' H419699',
    Description: 'Coll Prkwy/Cpe St Cl Rd Conv',
  },
  {
    Code: ' H427800',
    Description: 'Riva Town Cntr Blvd',
  },
  {
    Code: ' H427801',
    Description: 'Riva Town Cntr Blvd',
  },
  {
    Code: ' H427899',
    Description: 'Riva Town Cntr Blvd Conv',
  },
  {
    Code: ' H428000',
    Description: 'Sands Rd Bridge Repl',
  },
  {
    Code: ' H428001',
    Description: 'Sands Rd Bridge Repl',
  },
  {
    Code: ' H428099',
    Description: 'Sands Rd Bridge Repl Conv',
  },
  {
    Code: ' H428200',
    Description: 'Sudlersville/S Recon',
  },
  {
    Code: ' H428201',
    Description: 'Sudlersville So Reconstruction',
  },
  {
    Code: ' H428299',
    Description: 'Sudlersville/S Recon Conv',
  },
  {
    Code: ' H428300',
    Description: 'Thomas Road Recon',
  },
  {
    Code: ' H428301',
    Description: 'Thomas Road Reconstruction',
  },
  {
    Code: ' H428399',
    Description: 'Thomas Road Recon Conv',
  },
  {
    Code: ' H428400',
    Description: 'Charles Road Recon',
  },
  {
    Code: ' H428499',
    Description: 'Charles Road Recon',
  },
  {
    Code: ' H428500',
    Description: 'Science Park Road Impr',
  },
  {
    Code: ' H428501',
    Description: 'Science Park Rd Improvements',
  },
  {
    Code: ' H428502',
    Description: 'Wilelinor Est Pond Retrofit',
  },
  {
    Code: ' H428599',
    Description: 'Science Park Road Impr Conv',
  },
  {
    Code: ' H429100',
    Description: "Veteran's Highway Intercnt",
  },
  {
    Code: ' H429101',
    Description: "Veteran's Highway Intercnt",
  },
  {
    Code: ' H429199',
    Description: "Veteran's Highway Intercnt Con",
  },
  {
    Code: ' H432200',
    Description: 'Chry Grv/Grnbr/Newtw',
  },
  {
    Code: ' H432299',
    Description: 'Chry Grv/Grnbr/Newtw',
  },
  {
    Code: ' H432500',
    Description: 'MD 170/Odenton Junction',
  },
  {
    Code: ' H432599',
    Description: 'MD 170/Odenton Junction',
  },
  {
    Code: ' H432600',
    Description: 'MD 175/Odenton Town Center',
  },
  {
    Code: ' H432601',
    Description: 'MD 175/OTC/Sapp. to MD170',
  },
  {
    Code: ' H432602',
    Description: 'MD 175/OTC/MD 170 to MD32',
  },
  {
    Code: ' H432603',
    Description: 'MD175/OTC/MD32 to Clark Road',
  },
  {
    Code: ' H432699',
    Description: 'MD 175/Odenton Town Ctr Conv',
  },
  {
    Code: ' H437700',
    Description: 'Jennifer Road Ramp',
  },
  {
    Code: ' H437701',
    Description: 'Jennifer Road Ramp',
  },
  {
    Code: ' H437799',
    Description: 'Jennifer Road Ramp Conv',
  },
  {
    Code: ' H437800',
    Description: 'Riva Rd Ramp Access',
  },
  {
    Code: ' H437801',
    Description: 'Riva Road Ramp Access',
  },
  {
    Code: ' H437899',
    Description: 'Riva Rd Ramp Access  Conv',
  },
  {
    Code: ' H438100',
    Description: 'Frkln Gib 2 Bridg Repl',
  },
  {
    Code: ' H438199',
    Description: 'Frkln Gib 2 Bridg Repl',
  },
  {
    Code: ' H438200',
    Description: 'Brdg Repl/Gambrill Rd',
  },
  {
    Code: ' H438201',
    Description: 'Bridge Repl/Gambrills Road',
  },
  {
    Code: ' H438299',
    Description: 'Brdg Repl/Gambrill Rd Conv',
  },
  {
    Code: ' H438600',
    Description: 'Pasture Brook New Cut Rd',
  },
  {
    Code: ' H438601',
    Description: 'Pasture Brook New Cut Rd',
  },
  {
    Code: ' H438699',
    Description: 'Pasture Brook New Cut Rd Conv',
  },
  {
    Code: ' H438800',
    Description: 'Hrwood/Richsn Rd Imp',
  },
  {
    Code: ' H438899',
    Description: 'Hrwood/Richsn Rd Imp',
  },
  {
    Code: ' H439000',
    Description: 'Old Stage West Of Mayo',
  },
  {
    Code: ' H439001',
    Description: 'Old Stage South  Of Mayo Rd',
  },
  {
    Code: ' H439099',
    Description: 'Old Stage West Of Mayo Conv',
  },
  {
    Code: ' H441300',
    Description: 'Wb & A Rd @ Brns Crss',
  },
  {
    Code: ' H441399',
    Description: 'Wb & A Rd @ Brns Crss',
  },
  {
    Code: ' H442300',
    Description: 'Ridge Road Phase III',
  },
  {
    Code: ' H442301',
    Description: 'Ridge Road Phase III',
  },
  {
    Code: ' H442399',
    Description: 'Ridge Road Phase III  Conv',
  },
  {
    Code: ' H442800',
    Description: 'Duvall Hwy Improvements',
  },
  {
    Code: ' H442801',
    Description: 'Duvall Hwy Improvements',
  },
  {
    Code: ' H442899',
    Description: 'Duvall Hwy Improvements Conv',
  },
  {
    Code: ' H443100',
    Description: 'MD 173/MD 177 Connection',
  },
  {
    Code: ' H443101',
    Description: 'Mtn Rd/Ft Smallwood Rd Conn',
  },
  {
    Code: ' H443102',
    Description: 'MD 177 ByPass',
  },
  {
    Code: ' H443103',
    Description: 'MD 177/MD 173 Connector, Ph 1',
  },
  {
    Code: ' H443104',
    Description: 'MD 177/MD 173 Connector, Ph 2',
  },
  {
    Code: ' H443199',
    Description: 'MD 173/MD 177 Connection Conv',
  },
  {
    Code: ' H443300',
    Description: 'Town Ctr Rds/MD 32 Link',
  },
  {
    Code: ' H443301',
    Description: 'Town Ctr Rds to MD 32 Link',
  },
  {
    Code: ' H443399',
    Description: 'Town Ctr Rds/MD 32 Link  Conv',
  },
  {
    Code: ' H453100',
    Description: 'Marley Neck Blvd North',
  },
  {
    Code: ' H453101',
    Description: 'Marley Neck Blvd North',
  },
  {
    Code: ' H453199',
    Description: 'Marley Neck Blvd North  Conv',
  },
  {
    Code: ' H453200',
    Description: 'FBRM  Project Plan',
  },
  {
    Code: ' H453201',
    Description: 'Sands Rd Bridge O/Ferry Branch',
  },
  {
    Code: ' H453202',
    Description: 'Sands Rd Bridge O/Galloway Cr',
  },
  {
    Code: ' H453203',
    Description: 'Dicus Mill Rd Br O/Severn Run',
  },
  {
    Code: ' H453204',
    Description: 'Brock Bridge Rd O/Patuxent Rvr',
  },
  {
    Code: ' H453205',
    Description: 'Governor Br Rd O/Green Branch',
  },
  {
    Code: ' H453206',
    Description: 'Race Rd Bridge O/Piney Run',
  },
  {
    Code: ' H453299',
    Description: 'FBRM  Project Plan Conv',
  },
  {
    Code: ' H455100',
    Description: 'H S Truman Ext/Adm Cochrane',
  },
  {
    Code: ' H455101',
    Description: 'H S Truman Ext/Adm Cochrane',
  },
  {
    Code: ' H455199',
    Description: 'HSTruman Ext/Adm Cochrane Conv',
  },
  {
    Code: ' H461000',
    Description: 'Cap St Claire Rd Wide',
  },
  {
    Code: ' H461001',
    Description: 'Cap St Claire Rd Widening',
  },
  {
    Code: ' H461099',
    Description: 'Cap St Claire Rd Wide Conv',
  },
  {
    Code: ' H461100',
    Description: 'Chstnt Tre/Grn Holly',
  },
  {
    Code: ' H461101',
    Description: 'Chestnut Tree/Green Holly Rds',
  },
  {
    Code: ' H461199',
    Description: 'Chstnt Tre/Grn Holly Conv',
  },
  {
    Code: ' H461200',
    Description: 'Pasadena Gateway',
  },
  {
    Code: ' H461299',
    Description: 'Pasadena Gateway',
  },
  {
    Code: ' H461300',
    Description: 'Mountain Road Bypass',
  },
  {
    Code: ' H461301',
    Description: 'Mountain Road Bypass',
  },
  {
    Code: ' H461302',
    Description: 'Mountain Rd Byps-Reversible Ln',
  },
  {
    Code: ' H461399',
    Description: 'Mountain Road Bypass Conv',
  },
  {
    Code: ' H461400',
    Description: 'Right Turn Ln Outing Ave',
  },
  {
    Code: ' H461401',
    Description: 'Right Turn Ln  at Outing Ave',
  },
  {
    Code: ' H461499',
    Description: 'Right Turn Ln Outing Ave Conv',
  },
  {
    Code: ' H461500',
    Description: 'Severn Rd Curve improv',
  },
  {
    Code: ' H461501',
    Description: 'Severn Rd Curve improv',
  },
  {
    Code: ' H461599',
    Description: 'Severn Rd Curve improv Conv',
  },
  {
    Code: ' H461600',
    Description: 'Undrwd at  Mt  Tabor Rd',
  },
  {
    Code: ' H461601',
    Description: 'Undrwd at Mt  Tabor Rd',
  },
  {
    Code: ' H461699',
    Description: 'Undrwd at Mt  Tabor Rd Conv',
  },
  {
    Code: ' H463900',
    Description: 'Waugh Chapel Road',
  },
  {
    Code: ' H463901',
    Description: 'Waugh Chapel Road',
  },
  {
    Code: ' H463999',
    Description: 'Waugh Chapel Road Conv',
  },
  {
    Code: ' H464000',
    Description: 'Francis Station Road',
  },
  {
    Code: ' H464001',
    Description: 'Francis Station Road',
  },
  {
    Code: ' H464099',
    Description: 'Francis Station Road Conv',
  },
  {
    Code: ' H464100',
    Description: 'Magothy Bch/Magothy Brdg Con',
  },
  {
    Code: ' H464101',
    Description: 'Magothy Bch/Magothy Brdg Conn',
  },
  {
    Code: ' H464199',
    Description: 'Magothy Bch/Brdg Conn Conv',
  },
  {
    Code: ' H464200',
    Description: 'Brockbridge Rd Brdg/Patuxent',
  },
  {
    Code: ' H464201',
    Description: 'Brockbridge Rd Brdg/Pat River',
  },
  {
    Code: ' H464299',
    Description: 'Brockbridge Rd Brdg/Pat Conv',
  },
  {
    Code: ' H464300',
    Description: 'Sands Rd Brdg/Galloway Creek',
  },
  {
    Code: ' H464301',
    Description: 'Sands Rd Brdg/Galloway Creek',
  },
  {
    Code: ' H464399',
    Description: 'SandsRd Brdg/Gallowy Crk Conv',
  },
  {
    Code: ' H464400',
    Description: 'Sands Rd Brdg/Ferry Branch',
  },
  {
    Code: ' H464401',
    Description: 'Sands Rd Brdg/Ferry Branch',
  },
  {
    Code: ' H464499',
    Description: 'Sands Rd Brdg/Ferry Br Conv',
  },
  {
    Code: ' H464500',
    Description: 'Dicus Mill/Severn Run',
  },
  {
    Code: ' H464501',
    Description: 'DicusMill Rd Brdg /SevernRun',
  },
  {
    Code: ' H464599',
    Description: 'Dicus Mill/Severn Run Conv',
  },
  {
    Code: ' H464600',
    Description: 'Governor Brdg Rd/Green Branch',
  },
  {
    Code: ' H464601',
    Description: 'Governor Brdg Rd/Green Branch',
  },
  {
    Code: ' H464699',
    Description: 'Governr Brdg Rd/Grn Brnch Conv',
  },
  {
    Code: ' H464700',
    Description: 'Race Rd Brdg/Piney Run',
  },
  {
    Code: ' H464701',
    Description: 'Race Rd Brdg/Piney Run',
  },
  {
    Code: ' H464799',
    Description: 'Race Rd Brdg/Piney Run Conv',
  },
  {
    Code: ' H464800',
    Description: 'Brockbridge Bypass Lane',
  },
  {
    Code: ' H464801',
    Description: 'Brockbridge Rd Safety Imprv',
  },
  {
    Code: ' H464899',
    Description: 'Brockbridge Bypass Lane Conv',
  },
  {
    Code: ' H467800',
    Description: 'Repl Sig Cab & Cntl 98',
  },
  {
    Code: ' H467899',
    Description: 'Repl Sig Cab & Cntl 98',
  },
  {
    Code: ' H468100',
    Description: 'Traffic Count 98',
  },
  {
    Code: ' H468101',
    Description: 'Traffic Count 98',
  },
  {
    Code: ' H468197',
    Description: 'Traffic Count 97',
  },
  {
    Code: ' H468199',
    Description: 'Traffic Count 98 Conv',
  },
  {
    Code: ' H474400',
    Description: 'Pasadena At Lake Waterford',
  },
  {
    Code: ' H474401',
    Description: 'Pasadena At Lake Waterford',
  },
  {
    Code: ' H474499',
    Description: 'Pasadena At Lake Waterford Con',
  },
  {
    Code: ' H474500',
    Description: 'Catherine Ave/MD 100',
  },
  {
    Code: ' H474501',
    Description: 'Catherine Ave/MD 100',
  },
  {
    Code: ' H474599',
    Description: 'Catherine Ave/MD 100 Conv',
  },
  {
    Code: ' H474600',
    Description: 'Chesapeake Center Drive',
  },
  {
    Code: ' H474601',
    Description: 'Chesapeake Center Drive',
  },
  {
    Code: ' H474699',
    Description: 'Chesapeake Center Dr Conv',
  },
  {
    Code: ' H474700',
    Description: 'Holly Avenue',
  },
  {
    Code: ' H474701',
    Description: 'Holly Avenue',
  },
  {
    Code: ' H474799',
    Description: 'Holly Avenue Conv',
  },
  {
    Code: ' H474800',
    Description: 'Woods Road Bike Path',
  },
  {
    Code: ' H474801',
    Description: 'Woods Road Bike Path',
  },
  {
    Code: ' H474899',
    Description: 'Woods Road Widening Conv',
  },
  {
    Code: ' H475400',
    Description: 'MD 214 @ MD 468 Improv',
  },
  {
    Code: ' H475401',
    Description: 'MD 214 @ MD 468 Improv',
  },
  {
    Code: ' H475499',
    Description: 'MD 214 @ MD 468 Improv Conv',
  },
  {
    Code: ' H475500',
    Description: 'Forest Dr Relief Rte',
  },
  {
    Code: ' H475501',
    Description: 'Forest Dr Relief Rte Study',
  },
  {
    Code: ' H475599',
    Description: 'Forest Dr Relief Rte Conv',
  },
  {
    Code: ' H476700',
    Description: 'Gateway Village Dr.',
  },
  {
    Code: ' H476701',
    Description: 'Gateway Village Dr.',
  },
  {
    Code: ' H476799',
    Description: 'Gateway Village Dr. Conv',
  },
  {
    Code: ' H476800',
    Description: 'National Business Pk',
  },
  {
    Code: ' H476801',
    Description: 'National Business Pk',
  },
  {
    Code: ' H476899',
    Description: 'National Business Pk  Conv',
  },
  {
    Code: ' H477000',
    Description: 'West St Improvement',
  },
  {
    Code: ' H477001',
    Description: 'West St Improvement',
  },
  {
    Code: ' H477099',
    Description: 'West St Improvement Conv',
  },
  {
    Code: ' H477700',
    Description: 'Wilderness Point Default',
  },
  {
    Code: ' H477799',
    Description: 'Wilderness Point Default',
  },
  {
    Code: ' H478600',
    Description: 'Road Resurfacing',
  },
  {
    Code: ' H478601',
    Description: 'Road Resurfacing 98',
  },
  {
    Code: ' H478602',
    Description: 'Road Resurfacing 99',
  },
  {
    Code: ' H478603',
    Description: 'N Dist Hot Mix Asphalt FY00',
  },
  {
    Code: ' H478604',
    Description: 'C Dist Hot Mix Asphalt FY00',
  },
  {
    Code: ' H478605',
    Description: 'S Dist Hot Mix Asphalt  FY00',
  },
  {
    Code: ' H478606',
    Description: 'Slurry Seal Countywide FY00',
  },
  {
    Code: ' H478607',
    Description: 'Surf Treatment Countywide FY00',
  },
  {
    Code: ' H478608',
    Description: 'N Dist Hot Mix Asphalt FY01',
  },
  {
    Code: ' H478609',
    Description: 'C Dist Hot Mix Asphalt FY01',
  },
  {
    Code: ' H478610',
    Description: 'S Dist Hot Mix Asphalt  FY01',
  },
  {
    Code: ' H478611',
    Description: 'Slurry Seal Countywide FY01',
  },
  {
    Code: ' H478612',
    Description: 'Surf Treatment Countywide FY01',
  },
  {
    Code: ' H478613',
    Description: 'Rd Resurf Inspection FY 01',
  },
  {
    Code: ' H478614',
    Description: 'Rd Resurf Constr Mgt FY 01',
  },
  {
    Code: ' H478615',
    Description: 'N Dist Hot Mix Asphalt FY02',
  },
  {
    Code: ' H478616',
    Description: 'C Dist Hot Mix Asphalt FY02',
  },
  {
    Code: ' H478617',
    Description: 'S Dist Hot Mix Asphalt  FY02',
  },
  {
    Code: ' H478618',
    Description: 'Slurry Seal Countywide FY02',
  },
  {
    Code: ' H478619',
    Description: 'Surf Treatment Countywide FY02',
  },
  {
    Code: ' H478620',
    Description: 'Rd Resurf Inspection FY 02',
  },
  {
    Code: ' H478621',
    Description: 'Rd Resurf Constr Mgt FY 02',
  },
  {
    Code: ' H478622',
    Description: 'N Dist Hot Mix Asphalt FY 03',
  },
  {
    Code: ' H478623',
    Description: 'C Dist Hot Mix Asphalt FY 03',
  },
  {
    Code: ' H478624',
    Description: 'S Dist Hot Mix Asphalt FY 03',
  },
  {
    Code: ' H478625',
    Description: 'Slurry Seal Countywide FY 03',
  },
  {
    Code: ' H478626',
    Description: 'Surf Treatment Cntywd FY 03',
  },
  {
    Code: ' H478627',
    Description: 'Rd Resurf Constr Mgt FY 03',
  },
  {
    Code: ' H478628',
    Description: 'Rd Resurf Inspection FY 03',
  },
  {
    Code: ' H478697',
    Description: 'Road Resurfacing 97',
  },
  {
    Code: ' H478698',
    Description: 'Road Resurfacing 98 Conv',
  },
  {
    Code: ' H478699',
    Description: 'Road Resurfacing 99 Conv',
  },
  {
    Code: ' H478700',
    Description: 'Mjr Bridge Rehab (MBR)',
  },
  {
    Code: ' H478701',
    Description: 'Mjr Bridge Rehab 97',
  },
  {
    Code: ' H478702',
    Description: 'MBR98 - Magothy Bridge',
  },
  {
    Code: ' H478703',
    Description: 'MBR98 - Conways Road Bridge',
  },
  {
    Code: ' H478704',
    Description: 'MBR99',
  },
  {
    Code: ' H478705',
    Description: 'Major Bridge Rehab-Misc.',
  },
  {
    Code: ' H478706',
    Description: 'Major Bridge Rehab-Sands Rd.',
  },
  {
    Code: ' H478707',
    Description: 'Major Bridge Rehab-Misc FY03',
  },
  {
    Code: ' H478797',
    Description: 'Mjr Bridge Rehab 97 Conv',
  },
  {
    Code: ' H478798',
    Description: 'Mjr Bridge Rehab 98 Conv',
  },
  {
    Code: ' H478799',
    Description: 'Mjr Bridge Rehab 99 Conv',
  },
  {
    Code: ' H478800',
    Description: 'Hwy Sfty Improv  (HSI)',
  },
  {
    Code: ' H478801',
    Description: 'HSI 98 - MD2 @Jones Station Rd',
  },
  {
    Code: ' H478802',
    Description: 'HSI 98 - Schematic Design',
  },
  {
    Code: ' H478803',
    Description: 'HSI 98 - Duvall Hwy/Pine Haven',
  },
  {
    Code: ' H478804',
    Description: 'HSI 98 - Riva & Homewood Rds',
  },
  {
    Code: ' H478805',
    Description: 'HSI 99 - Catherine Ave & Mtn R',
  },
  {
    Code: ' H478806',
    Description: 'HSI 99 - Outing Ave',
  },
  {
    Code: ' H478807',
    Description: 'HSI 99 - MD 2 at Jones Stat Rd',
  },
  {
    Code: ' H478808',
    Description: 'HSI99-ChestnutTree/BlueRidgeDr',
  },
  {
    Code: ' H478809',
    Description: 'HSI99-Hampton Rd SD Inlet Mods',
  },
  {
    Code: ' H478810',
    Description: 'HSI 00-Lang Dr Retaining Wall',
  },
  {
    Code: ' H478811',
    Description: 'HSI00-Hammonds Ferry/Evelyn Av',
  },
  {
    Code: ' H478812',
    Description: 'HSI 00 - East Park Dr',
  },
  {
    Code: ' H478813',
    Description: 'HSI00-Cath. Av (228-231 Sts)',
  },
  {
    Code: ' H478814',
    Description: 'HSI 00 - Traffic Eng Projs',
  },
  {
    Code: ' H478815',
    Description: 'HSI 00 - Infrastructure Projs',
  },
  {
    Code: ' H478816',
    Description: 'HSI 02 - Franklin Manor Blkhd',
  },
  {
    Code: ' H478817',
    Description: 'HSI 02-Idlewilde Rd Extension',
  },
  {
    Code: ' H478818',
    Description: 'HSI 02-Intersection Studies',
  },
  {
    Code: ' H478819',
    Description: 'HSI 02-Catherine Ave.',
  },
  {
    Code: ' H478820',
    Description: 'HSI 02-E.Raynor SW Connection',
  },
  {
    Code: ' H478821',
    Description: 'HSI 02-College Pkwy Crossover',
  },
  {
    Code: ' H478822',
    Description: 'HSI 03-Bestgate/Lincoln Study',
  },
  {
    Code: ' H478897',
    Description: 'Hwy Sfty Imprv 97',
  },
  {
    Code: ' H478898',
    Description: 'Hwy Sfty Improv 98 - Conv',
  },
  {
    Code: ' H478899',
    Description: 'Hwy Sfty Improv 99 Conv',
  },
  {
    Code: ' H478900',
    Description: 'Rd Reconstruction',
  },
  {
    Code: ' H478901',
    Description: 'Rd. Reconstruction 97',
  },
  {
    Code: ' H478902',
    Description: 'Rd Recon 98 - New Jersey Ave',
  },
  {
    Code: ' H478903',
    Description: 'Rd Recon 99 - Carroll & Glen R',
  },
  {
    Code: ' H478904',
    Description: 'Rd Recon 00 - Doyle Drwy',
  },
  {
    Code: ' H478905',
    Description: 'Rd Recon 00 - Riva Rd',
  },
  {
    Code: ' H478906',
    Description: 'Rd Recon 00 - Forest Dr',
  },
  {
    Code: ' H478907',
    Description: 'Rd Recon 00 - Adm Cochrane Rd',
  },
  {
    Code: ' H478908',
    Description: 'Rd Recon 00 - Crawford Rd',
  },
  {
    Code: ' H478909',
    Description: 'Rd Recon 00 - Hospital Rd',
  },
  {
    Code: ' H478910',
    Description: 'Rd Recon 00 - Oakwood Rd',
  },
  {
    Code: ' H478911',
    Description: 'Rd Recon 01 - Belvedere/Emerso',
  },
  {
    Code: ' H478912',
    Description: 'Rd Recon 01 - Crownsville Rd',
  },
  {
    Code: ' H478913',
    Description: 'Rd Recon 01 - Beaghan Dr',
  },
  {
    Code: ' H478914',
    Description: 'Rd Recon 01 - Ridgewick Rd',
  },
  {
    Code: ' H478915',
    Description: 'Rd Recon 01 - Sycamore Rd',
  },
  {
    Code: ' H478916',
    Description: 'RR01-Shore Ac & Sunrs Bch Rds',
  },
  {
    Code: ' H478917',
    Description: 'Rd Recon 02-West Nursery Rd',
  },
  {
    Code: ' H478918',
    Description: 'RR 02-Sheridan & Oxford Drs',
  },
  {
    Code: ' H478919',
    Description: 'Rd Recon 02-Brock Bridge Rd',
  },
  {
    Code: ' H478920',
    Description: 'Rd Recon 02-Monroe Circle',
  },
  {
    Code: ' H478921',
    Description: 'Rd Recon 02-W. Edgevale Rd',
  },
  {
    Code: ' H478922',
    Description: 'Rd Recon 02-Hammonds La',
  },
  {
    Code: ' H478923',
    Description: 'Rd Recon 02-New Cut Rd',
  },
  {
    Code: ' H478924',
    Description: 'Rd Recon 02-Delaware Ave',
  },
  {
    Code: ' H478925',
    Description: 'Rd Recon 03-Bodkin Ave/MD177',
  },
  {
    Code: ' H478926',
    Description: 'Rd Recon 03-MD177/Magothy',
  },
  {
    Code: ' H478927',
    Description: 'Rd Recon 03-Old Riverside Dr',
  },
  {
    Code: ' H478928',
    Description: 'Rd Recon 03-Riva Rd (#32749)',
  },
  {
    Code: ' H478929',
    Description: 'RR03-Hammonds Ferry Rd (317)',
  },
  {
    Code: ' H478930',
    Description: 'RR03-Truckhouse Rd (#32160)',
  },
  {
    Code: ' H478931',
    Description: 'Rd Recon 03-Eastway (#3715)',
  },
  {
    Code: ' H478932',
    Description: 'Rd Recon 03-New Cut Farms',
  },
  {
    Code: ' H478933',
    Description: 'Rd Recon 03-Odenton Rd SW',
  },
  {
    Code: ' H478934',
    Description: 'Rd Recon 03-Corporate Blvd',
  },
  {
    Code: ' H478935',
    Description: 'Rd Recon 03-Hamlen Rd',
  },
  {
    Code: ' H478997',
    Description: 'Rd Reconstruction 97 Conv',
  },
  {
    Code: ' H478998',
    Description: 'Rd Reconstruction 98 Conv',
  },
  {
    Code: ' H478999',
    Description: 'Rd Reconstruction 99 Conv',
  },
  {
    Code: ' H479000',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479001',
    Description: 'Sdwlk Crb Gttr Rpl 97/Olen Dr',
  },
  {
    Code: ' H479002',
    Description: 'SCGR 98 - Cheddington Rd',
  },
  {
    Code: ' H479003',
    Description: 'Sdwlk Crb & Gttr 99',
  },
  {
    Code: ' H479004',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479005',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479006',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479007',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479008',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479009',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479010',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479011',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479012',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479013',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479014',
    Description: 'Mas. Recon-Ardmore Rd Rehab',
  },
  {
    Code: ' H479015',
    Description: 'Mas. Recon-Southwell Rd Rehab',
  },
  {
    Code: ' H479097',
    Description: 'Sdwlk Crb & Gttr 97 Conv',
  },
  {
    Code: ' H479098',
    Description: 'Sdwlk Crb & Gttr 98 Conv',
  },
  {
    Code: ' H479099',
    Description: 'Masonry Reconstruction',
  },
  {
    Code: ' H479100',
    Description: 'Guardrail',
  },
  {
    Code: ' H479101',
    Description: 'Guardrail FY99',
  },
  {
    Code: ' H479102',
    Description: 'Guardrail FY 00',
  },
  {
    Code: ' H479103',
    Description: 'Guardrail FY 01',
  },
  {
    Code: ' H479104',
    Description: 'Guardrail FY 02',
  },
  {
    Code: ' H479105',
    Description: 'Guardrail FY 03',
  },
  {
    Code: ' H479197',
    Description: 'Guardrail 97',
  },
  {
    Code: ' H479198',
    Description: 'Guardrail 98',
  },
  {
    Code: ' H479199',
    Description: 'Guardrail FY99 Conv',
  },
  {
    Code: ' H479200',
    Description: 'Signal Equipment',
  },
  {
    Code: ' H479201',
    Description: 'Signal Equipment 98',
  },
  {
    Code: ' H479202',
    Description: 'Signal Equipment 99',
  },
  {
    Code: ' H479203',
    Description: 'Signal Equipment FY 00',
  },
  {
    Code: ' H479204',
    Description: 'Signal Equipment FY 01',
  },
  {
    Code: ' H479205',
    Description: 'Signal Equipment FY 02',
  },
  {
    Code: ' H479206',
    Description: 'Signal Equipment FY 03',
  },
  {
    Code: ' H479298',
    Description: 'Signal Equipment 98 - Conv',
  },
  {
    Code: ' H479299',
    Description: 'Signal Equipment 99 - Conv',
  },
  {
    Code: ' H479300',
    Description: 'State Highway Proj',
  },
  {
    Code: ' H479301',
    Description: 'State Highway Proj 98',
  },
  {
    Code: ' H479302',
    Description: 'State Highway Proj 99',
  },
  {
    Code: ' H479303',
    Description: 'State Highway Proj FY 00',
  },
  {
    Code: ' H479304',
    Description: 'State Highway Proj FY 01',
  },
  {
    Code: ' H479305',
    Description: 'State Highway Proj FY 02',
  },
  {
    Code: ' H479306',
    Description: 'State Highway Projects FY 03',
  },
  {
    Code: ' H479397',
    Description: 'State Highway Proj 97',
  },
  {
    Code: ' H479398',
    Description: 'State Highway Proj 98 Conv',
  },
  {
    Code: ' H479399',
    Description: 'State Highway Proj 99 Conv',
  },
  {
    Code: ' H479400',
    Description: 'Traffic Sig',
  },
  {
    Code: ' H479401',
    Description: 'New Traffic Signals 98',
  },
  {
    Code: ' H479402',
    Description: 'New Traffic Signals 99',
  },
  {
    Code: ' H479403',
    Description: 'Traf Sig FY00-Medical/Bestgate',
  },
  {
    Code: ' H479404',
    Description: 'Traf Sig FY00-Countywide',
  },
  {
    Code: ' H479405',
    Description: 'Traf Sig FY 01',
  },
  {
    Code: ' H479406',
    Description: 'Traf Sig FY 01-Phase II',
  },
  {
    Code: ' H479407',
    Description: 'Traf Sig Misc Construction',
  },
  {
    Code: ' H479408',
    Description: 'Traffic Signals FY 02',
  },
  {
    Code: ' H479409',
    Description: 'Traffic Signals FY 03',
  },
  {
    Code: ' H479497',
    Description: 'New Traffic Sig 97',
  },
  {
    Code: ' H479498',
    Description: 'Traffic Sig 98 Conv',
  },
  {
    Code: ' H479499',
    Description: 'Traffic Sig 99 Conv',
  },
  {
    Code: ' H479500',
    Description: 'Nghborhd Traf Con',
  },
  {
    Code: ' H479501',
    Description: 'Neighbrhd Trfc Con 98',
  },
  {
    Code: ' H479502',
    Description: 'Nghborhd Traf Con 99',
  },
  {
    Code: ' H479503',
    Description: 'Nghborhd Traf Con FY 00',
  },
  {
    Code: ' H479504',
    Description: 'N T C FY 00-Arundel Bch Rndabt',
  },
  {
    Code: ' H479505',
    Description: 'N T C FY 00 - Speed Humps',
  },
  {
    Code: ' H479506',
    Description: 'N T C FY 00 - Idlewilde Rd Ext',
  },
  {
    Code: ' H479507',
    Description: 'Nghborhd Traf Con FY 01',
  },
  {
    Code: ' H479508',
    Description: 'N Y C FY 01 - Speed Humps',
  },
  {
    Code: ' H479509',
    Description: 'Nghbrhd Traf Cntrl FY 02',
  },
  {
    Code: ' H479510',
    Description: 'Nghbrhd Traffic Cntrl FY 03',
  },
  {
    Code: ' H479597',
    Description: 'Neighbhd Traf Con 97',
  },
  {
    Code: ' H479598',
    Description: 'Nghborhd Traf Con 98 Conv',
  },
  {
    Code: ' H479599',
    Description: 'Nghborhd Traf Con 99 Conv',
  },
  {
    Code: ' H481800',
    Description: 'Clark Road Relocate',
  },
  {
    Code: ' H481801',
    Description: 'Clark Road Relocate',
  },
  {
    Code: ' H481899',
    Description: 'Clark Road Relocate Conv',
  },
  {
    Code: ' H481900',
    Description: 'Tick Neck Road Ext',
  },
  {
    Code: ' H481901',
    Description: 'Tick Neck Road Ext',
  },
  {
    Code: ' H481999',
    Description: 'Tick Neck Road Ext Conv',
  },
  {
    Code: ' H483900',
    Description: 'Uncomp Rest on Kill Lara UA952',
  },
  {
    Code: ' H483999',
    Description: 'Uncomp Rest on Kill Lara UA952',
  },
  {
    Code: ' H484100',
    Description: 'Rita Drive',
  },
  {
    Code: ' H484101',
    Description: 'Rita Drive',
  },
  {
    Code: ' H484199',
    Description: 'Rita Drive Conv',
  },
  {
    Code: ' H484200',
    Description: 'Dorchester Tax District',
  },
  {
    Code: ' H484201',
    Description: 'Dorchester Tax District',
  },
  {
    Code: ' H484299',
    Description: 'Dorchester Rd. Conv',
  },
  {
    Code: ' H489000',
    Description: 'Farmington Vill Tax Dis',
  },
  {
    Code: ' H489001',
    Description: 'Farmington Vill Tax Dis',
  },
  {
    Code: ' H489099',
    Description: 'Farmington Vill Tax Dis Conv',
  },
  {
    Code: ' H489400',
    Description: 'Odenton Rd Sdwk-So',
  },
  {
    Code: ' H489401',
    Description: 'Odenton Rd Sdwk-So',
  },
  {
    Code: ' H489402',
    Description: 'Odenton Rd Sdwk-So, Phase 2',
  },
  {
    Code: ' H489499',
    Description: 'Odenton Rd Sdwk-So Conv',
  },
  {
    Code: ' H489500',
    Description: 'Odenton Marc Enhncmt',
  },
  {
    Code: ' H489501',
    Description: 'Odenton Marc  Area Enhncmt',
  },
  {
    Code: ' H489599',
    Description: 'Odenton March Enhncmt Conv',
  },
  {
    Code: ' H490500',
    Description: 'Long Hill Rd Extend',
  },
  {
    Code: ' H490501',
    Description: 'Long Hill Rd Extend',
  },
  {
    Code: ' H490599',
    Description: 'Long Hill Rd Extend Conv',
  },
  {
    Code: ' H502200',
    Description: 'Crestwood Sidewalk,Curb,Gutter',
  },
  {
    Code: ' H502201',
    Description: 'Cheddington Rd Ph II',
  },
  {
    Code: ' H502202',
    Description: 'Madingley Rd Recon (Crestwd)',
  },
  {
    Code: ' H502300',
    Description: 'Glen Gardens Rd Recon',
  },
  {
    Code: ' H502301',
    Description: 'Glen Gardens Recon-Carroll Rd',
  },
  {
    Code: ' H502302',
    Description: 'Glen Grdns Recon-Glen Rd',
  },
  {
    Code: ' H502303',
    Description: 'Glen Grdns-Delaware Ave Ph I',
  },
  {
    Code: ' H502304',
    Description: 'Glen Grdns-Delaware Ave Ph 2',
  },
  {
    Code: ' H502500',
    Description: 'Forest/Wigley Rd Imprvmnt',
  },
  {
    Code: ' H502501',
    Description: 'Forest/Wigley Rd Imprvmnt',
  },
  {
    Code: ' H502900',
    Description: 'Arundel Mills Tax District',
  },
  {
    Code: ' H502901',
    Description: 'Arundel Mills Tax District',
  },
  {
    Code: ' H504000',
    Description: 'Riva Town Cntr Blvd',
  },
  {
    Code: ' H504001',
    Description: 'Riva Town Ctr Blvd',
  },
  {
    Code: ' H507800',
    Description: 'Idlewilde Road',
  },
  {
    Code: ' H507801',
    Description: 'Idlewilde Road',
  },
  {
    Code: ' H507900',
    Description: 'East Park Drive',
  },
  {
    Code: ' H507901',
    Description: 'East Park Drive',
  },
  {
    Code: ' H508000',
    Description: 'Provinces Sdwk/ Root Guard',
  },
  {
    Code: ' H508001',
    Description: 'Provinces Sdwk/ Root Guard',
  },
  {
    Code: ' H508100',
    Description: 'Dundee Rdway,Sdwk,C&G',
  },
  {
    Code: ' H508101',
    Description: 'Dundee Rdway,Sdwk,C&G',
  },
  {
    Code: ' H508102',
    Description: 'Dundee Comm. Resurfacing',
  },
  {
    Code: ' H508200',
    Description: 'Guilford Rd Bridge Replacemnt',
  },
  {
    Code: ' H508201',
    Description: 'Guilford Rd Bridge Replacemnt',
  },
  {
    Code: ' H508300',
    Description: 'Hanover Road',
  },
  {
    Code: ' H508301',
    Description: 'Hanover Road',
  },
  {
    Code: ' H508400',
    Description: 'Sidewalk/Bikeway Fund',
  },
  {
    Code: ' H508401',
    Description: 'Sidewalk/Bikeway Fund',
  },
  {
    Code: ' H508402',
    Description: 'Sidewalk/Bikeway Fund-MD 177',
  },
  {
    Code: ' H510000',
    Description: 'Catherine Avenue Widening',
  },
  {
    Code: ' H510001',
    Description: 'Catherine Avenue Widening',
  },
  {
    Code: ' H512300',
    Description: 'Route 50 Sound Barriers',
  },
  {
    Code: ' H512301',
    Description: 'Route 50 Sound Barriers',
  },
  {
    Code: ' H512400',
    Description: 'Ferndale Road Sidewalk',
  },
  {
    Code: ' H512401',
    Description: 'Ferndale Road Sidewalk',
  },
  {
    Code: ' H512500',
    Description: 'Odenton Marc Enchance Phs 2',
  },
  {
    Code: ' H512501',
    Description: 'Odenton Marc Enchance Phs 2',
  },
  {
    Code: ' H512502',
    Description: 'Odenton Marc-MD175 Sidewalk',
  },
  {
    Code: ' H512600',
    Description: 'PGMA Transportation Studies',
  },
  {
    Code: ' H512601',
    Description: 'PGMA Trans Stdy-Lincln/Cmptn',
  },
  {
    Code: ' H512602',
    Description: 'PGMA Trans Stdy-Ridgely/Wlsn',
  },
  {
    Code: ' H512603',
    Description: 'PGMA Trans Stdy-Ped. Improve.',
  },
  {
    Code: ' H512604',
    Description: 'PGMA Trans Stdy-178 & Bestgate',
  },
  {
    Code: ' H512700',
    Description: 'Rt 2 Left Turn Lane',
  },
  {
    Code: ' H512701',
    Description: 'Rt 2 Left Turn Lane',
  },
  {
    Code: ' H512800',
    Description: 'MD 214 @ MD 468 Impr',
  },
  {
    Code: ' H512801',
    Description: 'MD 214 @ MD 468 Impr',
  },
  {
    Code: ' H512900',
    Description: 'Parole Intermodal Transit Fac.',
  },
  {
    Code: ' H512901',
    Description: 'Parole Intermodal Transit Fac.',
  },
  {
    Code: ' H512902',
    Description: 'Parole Intermodal/Comm.Legacy',
  },
  {
    Code: ' H513100',
    Description: 'Signal Communications',
  },
  {
    Code: ' H513101',
    Description: 'Signal Communications',
  },
  {
    Code: ' H515200',
    Description: 'Forest Drive',
  },
  {
    Code: ' H515201',
    Description: 'Forest Drive',
  },
  {
    Code: ' H515400',
    Description: 'Hanover Road',
  },
  {
    Code: ' H515401',
    Description: 'Hanover Road',
  },
  {
    Code: ' H888800',
    Description: 'RB Trans. for PY Clos Projects',
  },
  {
    Code: ' H888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' H888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' H999900',
    Description: 'R & B Class Account',
  },
  {
    Code: ' H999901',
    Description: 'R & B Class Account',
  },
  {
    Code: ' H999999',
    Description: 'R & B Class Account Conv',
  },
  {
    Code: ' J420100',
    Description: 'AACC Amer Dis Act',
  },
  {
    Code: ' J420199',
    Description: 'AACC Amer Dis Act',
  },
  {
    Code: ' J430200',
    Description: 'Gym Renovations',
  },
  {
    Code: ' J430299',
    Description: 'Gym Renovations',
  },
  {
    Code: ' J441200',
    Description: 'Campus Improvements',
  },
  {
    Code: ' J441299',
    Description: 'Campus Improvements',
  },
  {
    Code: ' J448400',
    Description: 'Traffic Study & Rd Mods',
  },
  {
    Code: ' J448499',
    Description: 'Traffic Study & Rd Mods',
  },
  {
    Code: ' J448500',
    Description: 'Signage',
  },
  {
    Code: ' J448599',
    Description: 'Signage',
  },
  {
    Code: ' J448600',
    Description: 'Sidewalks',
  },
  {
    Code: ' J448699',
    Description: 'Sidewalks',
  },
  {
    Code: ' J459400',
    Description: 'Storage, Grounds, Veh Bldg',
  },
  {
    Code: ' J459499',
    Description: 'Storage, Grounds, Veh Bldg',
  },
  {
    Code: ' J466200',
    Description: 'AACC Furniture',
  },
  {
    Code: ' J466299',
    Description: 'AACC Furniture',
  },
  {
    Code: ' J472600',
    Description: 'Comm Infrastruc Ph II',
  },
  {
    Code: ' J472699',
    Description: 'Comm Infrastruc Ph II',
  },
  {
    Code: ' J472700',
    Description: 'Security Emerg Phone Stations',
  },
  {
    Code: ' J472799',
    Description: 'Security Emerg Phone Stations',
  },
  {
    Code: ' J472800',
    Description: 'Student Ped Mall/Admin Bldg',
  },
  {
    Code: ' J472900',
    Description: 'Student Serv Ctr Renov/Add',
  },
  {
    Code: ' J472999',
    Description: 'Student Serv Ctr Renov/Add',
  },
  {
    Code: ' J473000',
    Description: 'Central Sta Fire Alarm Sys',
  },
  {
    Code: ' J473099',
    Description: 'Central Sta Fire Alarm Sys',
  },
  {
    Code: ' J473200',
    Description: 'Existing Util Study Upgr',
  },
  {
    Code: ' J473299',
    Description: 'Existing Util Study Upgr',
  },
  {
    Code: ' J488600',
    Description: 'W. Co. Academic Study',
  },
  {
    Code: ' J488699',
    Description: 'W. Co. Academic Study',
  },
  {
    Code: ' J488700',
    Description: 'Athletic Fac Renov Ph II',
  },
  {
    Code: ' J488701',
    Description: 'Athletic Fac Renov Ph II',
  },
  {
    Code: ' J488800',
    Description: 'Repl Seating & Carpet',
  },
  {
    Code: ' J488899',
    Description: 'Repl Seating & Carpet',
  },
  {
    Code: ' J488900',
    Description: 'Replace Fencing',
  },
  {
    Code: ' J488999',
    Description: 'Replace Fencing',
  },
  {
    Code: ' J490600',
    Description: 'Tennis Court Repairs',
  },
  {
    Code: ' J490699',
    Description: 'Tennis Court Repairs',
  },
  {
    Code: ' J500300',
    Description: 'Fine Arts Building',
  },
  {
    Code: ' J500399',
    Description: 'Fine Arts Building',
  },
  {
    Code: ' J503000',
    Description: 'Western Core Elec Power',
  },
  {
    Code: ' J503001',
    Description: 'Western Core Elec Power',
  },
  {
    Code: ' J503100',
    Description: 'Repl Careers Bldg Elevator',
  },
  {
    Code: ' J503101',
    Description: 'Repl Careers Bldg Elevator',
  },
  {
    Code: ' J503200',
    Description: 'Repl Careers Bldg Roof',
  },
  {
    Code: ' J503201',
    Description: 'Repl Careers Bldg Roof',
  },
  {
    Code: ' J503300',
    Description: 'Ctr for Applied Learning & Sci',
  },
  {
    Code: ' J503301',
    Description: 'Ctr for Applied Learning & Sci',
  },
  {
    Code: ' J508500',
    Description: 'Upgrade Master Plan',
  },
  {
    Code: ' J508501',
    Description: 'Upgrade Master Plan',
  },
  {
    Code: ' J508600',
    Description: 'Deferred Maintenance',
  },
  {
    Code: ' J508601',
    Description: 'Deferred Maintenance',
  },
  {
    Code: ' J519300',
    Description: 'Replace Plant Building Roof',
  },
  {
    Code: ' J519301',
    Description: 'Replace Plant Building Roof',
  },
  {
    Code: ' J888800',
    Description: 'CC Trans. for PY Clos Projects',
  },
  {
    Code: ' J888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' J888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' J999900',
    Description: 'Comm College Class Account',
  },
  {
    Code: ' J999999',
    Description: 'Comm College Class Acct Conv',
  },
  {
    Code: ' L351000',
    Description: 'Crofton Area Library',
  },
  {
    Code: ' L351001',
    Description: 'Crofton Branch Library',
  },
  {
    Code: ' L351099',
    Description: 'Crofton Area Library Conv',
  },
  {
    Code: ' L357500',
    Description: 'Chg Agst Lib Clsd Projects',
  },
  {
    Code: ' L357501',
    Description: 'Chg Agst Lib Clsd Projects',
  },
  {
    Code: ' L357599',
    Description: 'Chg Agst Lib Clsd Projs Conv',
  },
  {
    Code: ' L377100',
    Description: 'Maryland City Library',
  },
  {
    Code: ' L377101',
    Description: 'Maryland City Library',
  },
  {
    Code: ' L377199',
    Description: 'Maryland City Library Conv',
  },
  {
    Code: ' L475600',
    Description: 'West County Region Lib',
  },
  {
    Code: ' L475601',
    Description: 'West County Region Lib',
  },
  {
    Code: ' L475699',
    Description: 'West County Region Lib Conv',
  },
  {
    Code: ' L479600',
    Description: 'Library Renovation',
  },
  {
    Code: ' L479601',
    Description: 'LB98 No Co  Handicap Prkg/Rmp',
  },
  {
    Code: ' L479602',
    Description: 'LB98 EAN Br Intr Lighting Impr',
  },
  {
    Code: ' L479603',
    Description: 'LB98 Video Surveillance',
  },
  {
    Code: ' L479604',
    Description: 'LB98 No Co Restroom Upgrades',
  },
  {
    Code: ' L479605',
    Description: 'LB99 Riviera Bch Int Lighting',
  },
  {
    Code: ' L479606',
    Description: 'LB99 Handicap Ramp at No Co',
  },
  {
    Code: ' L479607',
    Description: 'LB99 Bpk Roof/SW Drainage',
  },
  {
    Code: ' L479608',
    Description: 'LB99 Restroom Upgrades/Renov',
  },
  {
    Code: ' L479609',
    Description: 'LR00 Brooklyn Pk Int Lighting',
  },
  {
    Code: ' L479610',
    Description: 'LR 01-Pass Thru Expenditures',
  },
  {
    Code: ' L479611',
    Description: 'LR01-Brooklyn Pk Window Upgr',
  },
  {
    Code: ' L479612',
    Description: 'LR01-Information Desks',
  },
  {
    Code: ' L479613',
    Description: 'LR 02-Pass Thru Expenditures',
  },
  {
    Code: ' L479614',
    Description: 'LR 03-Pass Thru Expenditures',
  },
  {
    Code: ' L479615',
    Description: 'LR 03-S.County/Eastport Upgrs',
  },
  {
    Code: ' L479616',
    Description: 'LR 03-S.County Meeting Room',
  },
  {
    Code: ' L479617',
    Description: 'LR 03-Annapolis/Severna Park',
  },
  {
    Code: ' L479697',
    Description: 'Library Renov 97',
  },
  {
    Code: ' L479698',
    Description: 'Library Renovations 98 Conv',
  },
  {
    Code: ' L479699',
    Description: 'Library Renovation 99  Conv',
  },
  {
    Code: ' L500100',
    Description: 'South Co HVAC/WR',
  },
  {
    Code: ' L500101',
    Description: 'South Co HVAC/WR',
  },
  {
    Code: ' L513200',
    Description: 'Library Materials Account',
  },
  {
    Code: ' L513201',
    Description: 'Library Materials Account',
  },
  {
    Code: ' L513202',
    Description: 'Library Materials Account 03',
  },
  {
    Code: ' L888800',
    Description: 'LI Trans. for PY Clos Projects',
  },
  {
    Code: ' L888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' L888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' L999900',
    Description: 'Lib Class Account',
  },
  {
    Code: ' L999901',
    Description: 'Lib Class Account',
  },
  {
    Code: ' L999999',
    Description: 'Lib Class Account Conv',
  },
  {
    Code: ' M432100',
    Description: 'Arundel Comm Devel Serv',
  },
  {
    Code: ' M432199',
    Description: 'Arundel Comm Devel Serv',
  },
  {
    Code: ' M437100',
    Description: 'Home Program M-94',
  },
  {
    Code: ' M437199',
    Description: 'Home Program M-94',
  },
  {
    Code: ' M445400',
    Description: 'Home Program M-95',
  },
  {
    Code: ' M445499',
    Description: 'Home Program M-95',
  },
  {
    Code: ' M455200',
    Description: 'Home Program M-96',
  },
  {
    Code: ' M455299',
    Description: 'Home Program M-96',
  },
  {
    Code: ' M461700',
    Description: 'Home Ownership Initiative',
  },
  {
    Code: ' M461799',
    Description: 'Home Ownership Initiative',
  },
  {
    Code: ' M471300',
    Description: 'Home Program M-97',
  },
  {
    Code: ' M471399',
    Description: 'Home Program M-97',
  },
  {
    Code: ' M479700',
    Description: 'Home Program M-98',
  },
  {
    Code: ' M479799',
    Description: 'Home Program M-98',
  },
  {
    Code: ' M488200',
    Description: 'Homeless Programs',
  },
  {
    Code: ' M488299',
    Description: 'Homeless Programs',
  },
  {
    Code: ' M500200',
    Description: 'Home Program (M-99)',
  },
  {
    Code: ' M500201',
    Description: 'Home Program (M-99)',
  },
  {
    Code: ' M500300',
    Description: 'Homeless Program (99)',
  },
  {
    Code: ' M500301',
    Description: 'Homeless Program (99)',
  },
  {
    Code: ' M508700',
    Description: 'Home Program (M-00)',
  },
  {
    Code: ' M508701',
    Description: 'Home Program (M-00)',
  },
  {
    Code: ' M508800',
    Description: 'Homeless Program (00)',
  },
  {
    Code: ' M508801',
    Description: 'Homeless Program (00)',
  },
  {
    Code: ' M513300',
    Description: 'Home Program (M-01)',
  },
  {
    Code: ' M513301',
    Description: 'Home Program (M-01)',
  },
  {
    Code: ' M513400',
    Description: 'Homeless Program (01)',
  },
  {
    Code: ' M513401',
    Description: 'Homeless Program (01)',
  },
  {
    Code: ' M520200',
    Description: 'Homeless Program (02)',
  },
  {
    Code: ' M520201',
    Description: 'Homeless Program (02)',
  },
  {
    Code: ' M520300',
    Description: 'Home Program M-02',
  },
  {
    Code: ' M520301',
    Description: 'Home Program M-02',
  },
  {
    Code: ' M520400',
    Description: 'Brooklyn Park Revitalization',
  },
  {
    Code: ' M520401',
    Description: 'Brooklyn Park Revitalization',
  },
  {
    Code: ' M888800',
    Description: 'CD Trans. for PY Clos Projects',
  },
  {
    Code: ' M888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' M888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' M999900',
    Description: 'Comm Development Class Acct',
  },
  {
    Code: ' M999999',
    Description: 'Comm Devel Class Acct Conv',
  },
  {
    Code: ' N363300',
    Description: 'GBL Landfill Remediation',
  },
  {
    Code: ' N363301',
    Description: 'GB Landfill RI/FS',
  },
  {
    Code: ' N363302',
    Description: 'GB L Insurance Litigation',
  },
  {
    Code: ' N363303',
    Description: 'GBL Underground Facilities',
  },
  {
    Code: ' N363304',
    Description: 'GBL Sediment/Eros Ctrl Upg',
  },
  {
    Code: ' N363305',
    Description: 'GBL Ph. I Closure',
  },
  {
    Code: ' N363306',
    Description: 'GBL Convenience Ctr Upgr',
  },
  {
    Code: ' N363399',
    Description: 'GB  Landfill Rem. Conv',
  },
  {
    Code: ' N369700',
    Description: 'Landfill Facilities',
  },
  {
    Code: ' N369701',
    Description: 'MLF - Subcells 8.1-8.4',
  },
  {
    Code: ' N369702',
    Description: 'Sudley Landfill Closure',
  },
  {
    Code: ' N369703',
    Description: 'Leachate Pretreatment',
  },
  {
    Code: ' N369704',
    Description: 'MLF - Interm Closure 5,6,7',
  },
  {
    Code: ' N369705',
    Description: 'MLF - Cell 3 & 1 Saddle',
  },
  {
    Code: ' N369706',
    Description: 'Subcell 8.5',
  },
  {
    Code: ' N369707',
    Description: 'Millersville Landfill Upgrd',
  },
  {
    Code: ' N369708',
    Description: 'MLF Cell 9 Permitting',
  },
  {
    Code: ' N369709',
    Description: 'Millersville Ldfill GasMgmt',
  },
  {
    Code: ' N369710',
    Description: 'MLF - Final Closure 5,6,7',
  },
  {
    Code: ' N369711',
    Description: 'MLF Groundwater Invest.',
  },
  {
    Code: ' N369712',
    Description: 'Sudley Lndfill Final Upgrd',
  },
  {
    Code: ' N369713',
    Description: 'Water Main Extension',
  },
  {
    Code: ' N369714',
    Description: 'Landfill Facil. Masterplan',
  },
  {
    Code: ' N369715',
    Description: 'MLF - Residentl. Conven.',
  },
  {
    Code: ' N369716',
    Description: 'MLF Gas Utilization',
  },
  {
    Code: ' N369717',
    Description: 'MLF Cells 1,2,4 Closure',
  },
  {
    Code: ' N369718',
    Description: 'Jabez Branch Restoration',
  },
  {
    Code: ' N369719',
    Description: 'Leachate Coll. Cell 8.5',
  },
  {
    Code: ' N369720',
    Description: 'MLF Potable Wells',
  },
  {
    Code: ' N369721',
    Description: 'MLF Scalehouse',
  },
  {
    Code: ' N369722',
    Description: 'MLF Maint./Admin Bldg',
  },
  {
    Code: ' N369723',
    Description: 'MLF Veh. Wheel Wash',
  },
  {
    Code: ' N369724',
    Description: 'UST Millersville Landfill',
  },
  {
    Code: ' N369725',
    Description: 'MLF - Design Subcell 8.6',
  },
  {
    Code: ' N369726',
    Description: 'MLF-Cell 1 West Excavatn',
  },
  {
    Code: ' N369727',
    Description: 'MLF - Cnvrt Ponds 1,3,4,5',
  },
  {
    Code: ' N369728',
    Description: 'MLF-Cell 9 Sediment Control',
  },
  {
    Code: ' N369729',
    Description: 'Sudley Rd LF-Borrow Area Upgr',
  },
  {
    Code: ' N369799',
    Description: 'Landfill Facilities Conv',
  },
  {
    Code: ' N422700',
    Description: 'SW Management Plan',
  },
  {
    Code: ' N422701',
    Description: 'SW Management Plan',
  },
  {
    Code: ' N422702',
    Description: 'SWMP - Rate Study',
  },
  {
    Code: ' N422703',
    Description: 'SWMP Implementation Studies',
  },
  {
    Code: ' N422704',
    Description: 'SWMP Plan Revisions',
  },
  {
    Code: ' N422705',
    Description: 'SWMP Plan Update',
  },
  {
    Code: ' N422706',
    Description: 'SW Mgt Plan 10 yr Update',
  },
  {
    Code: ' N422707',
    Description: 'SWMP Compost Fac Feasibility',
  },
  {
    Code: ' N422708',
    Description: 'SWMP Bioreactor Pilot in Cells',
  },
  {
    Code: ' N422709',
    Description: 'SWMP Rate Study FY03',
  },
  {
    Code: ' N422710',
    Description: 'SWMP Plan Update FY03',
  },
  {
    Code: ' N422711',
    Description: 'SWMP Eval. Operating Days/Hrs',
  },
  {
    Code: ' N422799',
    Description: 'SW Management Plan Conv',
  },
  {
    Code: ' N426900',
    Description: 'Solid Waste Proj Mgmt',
  },
  {
    Code: ' N426901',
    Description: 'Solid Waste Proj Mgmt',
  },
  {
    Code: ' N426999',
    Description: 'Solid Wst Prj Mgmt Conv',
  },
  {
    Code: ' N465500',
    Description: 'Cell 8 Disposal Area',
  },
  {
    Code: ' N465501',
    Description: 'MLF Subcell 8.6 Dsgn/Const',
  },
  {
    Code: ' N465502',
    Description: 'MLF Cell 8 Interim Gas Mgmt',
  },
  {
    Code: ' N465503',
    Description: 'MLF Cell 8 Grndwtr Seep Repair',
  },
  {
    Code: ' N465504',
    Description: 'MLF Blower/Flare Station Mods',
  },
  {
    Code: ' N465599',
    Description: 'Cell 8 Disposal Area Conv',
  },
  {
    Code: ' N465600',
    Description: 'MLF Cell 9 Disposal Area',
  },
  {
    Code: ' N465601',
    Description: 'Sediment Control Facilities',
  },
  {
    Code: ' N465602',
    Description: 'Jabez Branch Rest.  MLF Cell 9',
  },
  {
    Code: ' N465603',
    Description: 'Pond 2 Conversion to Infil.',
  },
  {
    Code: ' N465699',
    Description: 'Cell 9 Disposal Area Conv',
  },
  {
    Code: ' N465700',
    Description: 'Landfill Gas Utilization',
  },
  {
    Code: ' N465701',
    Description: 'MLF Landfill Gas Utilization',
  },
  {
    Code: ' N465799',
    Description: 'Landfill Gas Utilization Conv',
  },
  {
    Code: ' N465800',
    Description: 'MLF Central Maint/Admin',
  },
  {
    Code: ' N465801',
    Description: 'MLF Maint. Bldg',
  },
  {
    Code: ' N465802',
    Description: 'MLF Central Admin Bldg',
  },
  {
    Code: ' N465803',
    Description: 'MLF-Paving',
  },
  {
    Code: ' N465899',
    Description: 'MLF Central Mnt/Adm Conv',
  },
  {
    Code: ' N465900',
    Description: 'MSW Proc/Compst Facil',
  },
  {
    Code: ' N465901',
    Description: 'MSW Proc/Compst Facil',
  },
  {
    Code: ' N465999',
    Description: 'MSW Proc/Compst Fac Conv',
  },
  {
    Code: ' N484300',
    Description: 'Closed Accts - MLF',
  },
  {
    Code: ' N484301',
    Description: 'Closed Accts - MLF',
  },
  {
    Code: ' N484399',
    Description: 'Closed Accts - MLF Conv',
  },
  {
    Code: ' N496200',
    Description: 'Closed Accounts MLF',
  },
  {
    Code: ' N496201',
    Description: 'Closed Accounts MLF',
  },
  {
    Code: ' N513500',
    Description: 'G B Convenience Ctr Upgrade',
  },
  {
    Code: ' N513501',
    Description: 'G B Convenience Ctr Upgrade',
  },
  {
    Code: ' N513502',
    Description: 'GB New Conven. Ctr Upgrd II',
  },
  {
    Code: ' N513600',
    Description: 'MLF Gas Mangt Sys Upgd',
  },
  {
    Code: ' N513601',
    Description: 'MLF Gas Mangt Sys Upgd',
  },
  {
    Code: ' N513602',
    Description: 'MLF Gas Mangt Phase II',
  },
  {
    Code: ' N519900',
    Description: 'Environmental Center',
  },
  {
    Code: ' N519901',
    Description: 'Environmental Center',
  },
  {
    Code: ' N520000',
    Description: 'Millersville Lndfil Buffer Exp',
  },
  {
    Code: ' N520001',
    Description: 'Millersville Lndfil Buffer Exp',
  },
  {
    Code: ' N888800',
    Description: 'SW Trans. for PY Clos Projects',
  },
  {
    Code: ' N888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' N888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' N999900',
    Description: 'Solid Waste Class Account',
  },
  {
    Code: ' N999901',
    Description: 'Solid Waste Class Account',
  },
  {
    Code: ' N999999',
    Description: 'Solid Waste Class Account',
  },
  {
    Code: ' P311200',
    Description: 'Londontown Historic Site',
  },
  {
    Code: ' P311201',
    Description: 'Londontown Historic Site',
  },
  {
    Code: ' P311299',
    Description: 'Londonrtown Historic Site',
  },
  {
    Code: ' P339700',
    Description: 'Arden On The Severn',
  },
  {
    Code: ' P339701',
    Description: 'Arden On The Severn,Phase I',
  },
  {
    Code: ' P339799',
    Description: 'Arden On The Severn Conv',
  },
  {
    Code: ' P346100',
    Description: 'Chg Agst R & P Clsd Projects',
  },
  {
    Code: ' P346101',
    Description: 'Chg Agst R & P Clsd Projects',
  },
  {
    Code: ' P346199',
    Description: 'Chg Agst R & P Clsd Proj. Conv',
  },
  {
    Code: ' P372000',
    Description: 'South Shore Trail',
  },
  {
    Code: ' P372001',
    Description: 'South Shore Trail,Phase 1',
  },
  {
    Code: ' P372099',
    Description: 'South Shore Trail Conv',
  },
  {
    Code: ' P378700',
    Description: 'Davidsonville Park',
  },
  {
    Code: ' P378701',
    Description: 'Davidsonville Park Master Plan',
  },
  {
    Code: ' P378702',
    Description: 'Davidsonville Park,Phase 2',
  },
  {
    Code: ' P378703',
    Description: 'Davidsonville Park,Phase 3',
  },
  {
    Code: ' P378799',
    Description: 'Davidsonville Park Conv',
  },
  {
    Code: ' P393600',
    Description: 'W B & A Trail',
  },
  {
    Code: ' P393601',
    Description: 'W B & A Trail Phase I',
  },
  {
    Code: ' P393602',
    Description: 'W B & A Trail Phase II',
  },
  {
    Code: ' P393603',
    Description: 'WB&A Trail Phs I Stream Assmnt',
  },
  {
    Code: ' P393604',
    Description: 'WB&A Trail-Little Patux. Brdg',
  },
  {
    Code: ' P393699',
    Description: 'W B & A Trail Conv',
  },
  {
    Code: ' P400200',
    Description: 'Greenways',
  },
  {
    Code: ' P400201',
    Description: 'Greenways',
  },
  {
    Code: ' P400202',
    Description: 'Greenways',
  },
  {
    Code: ' P400203',
    Description: 'Greenways FY 01',
  },
  {
    Code: ' P400299',
    Description: 'Greenways Conv',
  },
  {
    Code: ' P405700',
    Description: 'Jack Creek Park',
  },
  {
    Code: ' P405701',
    Description: 'Jack Creek Park',
  },
  {
    Code: ' P405799',
    Description: 'Jack Creek Park Conv',
  },
  {
    Code: ' P411200',
    Description: 'Jug Bay Wetlands Sanct',
  },
  {
    Code: ' P411201',
    Description: 'Jug Bay Wetlands Sanct',
  },
  {
    Code: ' P411299',
    Description: 'Jug Bay Wetlands Sanct Conv',
  },
  {
    Code: ' P416200',
    Description: 'Jug Bay Expansion',
  },
  {
    Code: ' P416299',
    Description: 'Jug Bay Expansion',
  },
  {
    Code: ' P418300',
    Description: 'West County Park',
  },
  {
    Code: ' P418301',
    Description: 'West County Park',
  },
  {
    Code: ' P418399',
    Description: 'West County Park Conv',
  },
  {
    Code: ' P418500',
    Description: 'Kinder Park Development',
  },
  {
    Code: ' P418501',
    Description: 'Kinder Park,Phase I',
  },
  {
    Code: ' P418502',
    Description: 'Kinder Park,Phase 2',
  },
  {
    Code: ' P418503',
    Description: 'Kinder Park,Phase 3',
  },
  {
    Code: ' P418504',
    Description: 'Kinder Park, Phase 2B',
  },
  {
    Code: ' P418599',
    Description: 'Kinder Park Conv',
  },
  {
    Code: ' P422600',
    Description: 'Crofton Athl Complex',
  },
  {
    Code: ' P422699',
    Description: 'Crofton Athl Complex',
  },
  {
    Code: ' P429300',
    Description: 'Piney Orchard Park',
  },
  {
    Code: ' P429301',
    Description: 'Piney Orchard Park',
  },
  {
    Code: ' P429399',
    Description: 'Piney Orchard Park Conv',
  },
  {
    Code: ' P445800',
    Description: 'Facility Lighting',
  },
  {
    Code: ' P445801',
    Description: 'Facility Lighting,Phase I',
  },
  {
    Code: ' P445802',
    Description: 'Facility Lighting,Phase2',
  },
  {
    Code: ' P445803',
    Description: 'Facility Lighting,Phase 3',
  },
  {
    Code: ' P445804',
    Description: 'Facility Lighting,Phase 4&5',
  },
  {
    Code: ' P445805',
    Description: 'Facility Ltng, Ph 5 (FY 01)',
  },
  {
    Code: ' P445899',
    Description: 'Facility Lighting Conv',
  },
  {
    Code: ' P449800',
    Description: 'Stoney Creek Park',
  },
  {
    Code: ' P449801',
    Description: 'Stoney Creek Park',
  },
  {
    Code: ' P449899',
    Description: 'Stoney Creek Park Conv',
  },
  {
    Code: ' P449900',
    Description: 'Riva Area Park',
  },
  {
    Code: ' P449901',
    Description: 'Riva Area Park Land Aquisition',
  },
  {
    Code: ' P449902',
    Description: 'Riva Area Park,Phase 1',
  },
  {
    Code: ' P449903',
    Description: 'Riva Area Park,Phase 2',
  },
  {
    Code: ' P449904',
    Description: 'Riva Area Park,Phase 3',
  },
  {
    Code: ' P449999',
    Description: 'Riva Area Park Conv',
  },
  {
    Code: ' P450100',
    Description: 'Oxbow Natural Area',
  },
  {
    Code: ' P450101',
    Description: 'Oxbow Natural Area',
  },
  {
    Code: ' P450199',
    Description: 'Oxbow Natural Area Conv',
  },
  {
    Code: ' P450300',
    Description: 'Downs Park Renov',
  },
  {
    Code: ' P450301',
    Description: 'Downs Park Renov,Phase 1',
  },
  {
    Code: ' P450302',
    Description: 'Downs Park Visitor Ctr Renov',
  },
  {
    Code: ' P450303',
    Description: 'Downs Park Phs 2A-Fish Pier',
  },
  {
    Code: ' P450399',
    Description: 'Downs Park Renov Conv',
  },
  {
    Code: ' P450600',
    Description: 'Eisenhower Golf Course',
  },
  {
    Code: ' P450601',
    Description: 'Eisenhower Golf Course Reno',
  },
  {
    Code: ' P450699',
    Description: 'Eisenhower Golf Course Conv',
  },
  {
    Code: ' P450700',
    Description: 'Quiet Waters Park Renov',
  },
  {
    Code: ' P450701',
    Description: 'Quiet Waters Reno.PhaseI',
  },
  {
    Code: ' P450702',
    Description: 'Quiet Waters Reno.Phase II',
  },
  {
    Code: ' P450703',
    Description: 'Quiet Waters Reno.Phase III',
  },
  {
    Code: ' P450704',
    Description: 'Quiet Waters Reno.Phase IIIA',
  },
  {
    Code: ' P450705',
    Description: 'Quiet Wtrs-Concert Pavilion',
  },
  {
    Code: ' P450799',
    Description: 'Quiet Waters Reno.Conv',
  },
  {
    Code: ' P450900',
    Description: 'Andover Park Renovations',
  },
  {
    Code: ' P450901',
    Description: 'Andover Park Reno. Phase 1',
  },
  {
    Code: ' P450902',
    Description: 'Andover Recreation Area',
  },
  {
    Code: ' P450999',
    Description: 'Andover Park renovations',
  },
  {
    Code: ' P451000',
    Description: 'North County Ice Rink',
  },
  {
    Code: ' P451001',
    Description: 'North County Ice Rink',
  },
  {
    Code: ' P451099',
    Description: 'North County Ice Rink Conv',
  },
  {
    Code: ' P452500',
    Description: 'R & P Project Plan',
  },
  {
    Code: ' P452501',
    Description: 'Golf Course Reno. Study',
  },
  {
    Code: ' P452502',
    Description: 'Adult Athletic Complex Study',
  },
  {
    Code: ' P452503',
    Description: 'Beverly Triton Master Plan',
  },
  {
    Code: ' P452504',
    Description: 'So. Riv.Park G.C. Master Plan',
  },
  {
    Code: ' P452505',
    Description: 'North County Ice Rink Study',
  },
  {
    Code: ' P452506',
    Description: 'Crab Creek Park',
  },
  {
    Code: ' P452507',
    Description: 'Sunset Park',
  },
  {
    Code: ' P452508',
    Description: 'College Parkway Trail',
  },
  {
    Code: ' P452509',
    Description: 'Andover Park Equestrian Ctr',
  },
  {
    Code: ' P452510',
    Description: 'Deal Elks Wetland Study',
  },
  {
    Code: ' P452511',
    Description: 'Rec.& Parks Demand Survey',
  },
  {
    Code: ' P452512',
    Description: 'Beachwood Pk Feasibility Stdy',
  },
  {
    Code: ' P452513',
    Description: 'Aquatic Center Study',
  },
  {
    Code: ' P452514',
    Description: 'Broadneck Park Expansion Study',
  },
  {
    Code: ' P452515',
    Description: 'Nike Site Master Plan',
  },
  {
    Code: ' P452516',
    Description: '1998 Land Preservation Mstr Pl',
  },
  {
    Code: ' P452517',
    Description: 'Arnold,Broadneck&Crofton Renov',
  },
  {
    Code: ' P452518',
    Description: 'Bodkin/Main Creek Analysis',
  },
  {
    Code: ' P452599',
    Description: 'R & P Project Plan Conv',
  },
  {
    Code: ' P457000',
    Description: 'School Outdoor Rec Facilities',
  },
  {
    Code: ' P457001',
    Description: 'Brockbridge ES Fields',
  },
  {
    Code: ' P457002',
    Description: 'Arnold, Broadneck, Crofton Rnv',
  },
  {
    Code: ' P457099',
    Description: 'School Outdoor Rec Fac Conv',
  },
  {
    Code: ' P461800',
    Description: 'Bachman Sports Complex',
  },
  {
    Code: ' P461801',
    Description: 'Adult Athletic Complex',
  },
  {
    Code: ' P461802',
    Description: 'Adult Athletic Complex Ph. 2',
  },
  {
    Code: ' P461803',
    Description: 'Adult Athletic Complex Ph. 3',
  },
  {
    Code: ' P461899',
    Description: 'Bachman Sports Complex Conv',
  },
  {
    Code: ' P462000',
    Description: 'Beverly Triton Beach',
  },
  {
    Code: ' P462001',
    Description: 'Beverly Triton Bch Chnl Impv',
  },
  {
    Code: ' P462099',
    Description: 'Beverly Triton Pavilion Conv',
  },
  {
    Code: ' P462100',
    Description: 'Lake Shore Complex Expan',
  },
  {
    Code: ' P462101',
    Description: 'Lake Shore Complex Expan',
  },
  {
    Code: ' P462199',
    Description: 'Lake Shore Comp.Exp.Conv',
  },
  {
    Code: ' P462200',
    Description: 'Mayo Beach Renovation',
  },
  {
    Code: ' P462201',
    Description: 'Mayo Beach Reno. Phase 1',
  },
  {
    Code: ' P462299',
    Description: 'Mayo Beach Renovation Conv',
  },
  {
    Code: ' P462400',
    Description: 'Severn Danza Expan',
  },
  {
    Code: ' P462401',
    Description: 'Severn Danza Expan',
  },
  {
    Code: ' P462402',
    Description: 'Severn Danza Expan, Ph. 2',
  },
  {
    Code: ' P462403',
    Description: 'Severn Danza Expan, Ph. 3',
  },
  {
    Code: ' P462404',
    Description: 'Severn Danza Exp. Conc/Restrm',
  },
  {
    Code: ' P462405',
    Description: 'Severn Danza Field Lighting',
  },
  {
    Code: ' P462499',
    Description: 'Severn Danza Expan Conv',
  },
  {
    Code: ' P462500',
    Description: 'Browns Woods Park',
  },
  {
    Code: ' P462599',
    Description: 'Browns Woods Park',
  },
  {
    Code: ' P462600',
    Description: 'Boat Launch Sites',
  },
  {
    Code: ' P462601',
    Description: 'Boat Launch Sites Phase 1',
  },
  {
    Code: ' P462699',
    Description: 'Boat Launch Sites Conv',
  },
  {
    Code: ' P462700',
    Description: 'Fairview Park',
  },
  {
    Code: ' P462701',
    Description: 'Fairview Park',
  },
  {
    Code: ' P462799',
    Description: 'Fairview Park Conv',
  },
  {
    Code: ' P465000',
    Description: 'Shady Cove Park',
  },
  {
    Code: ' P465001',
    Description: 'Shady Cove Park',
  },
  {
    Code: ' P465099',
    Description: 'Shady Cove Park Conv',
  },
  {
    Code: ' P468700',
    Description: 'Shoreline Erosion Contrl',
  },
  {
    Code: ' P468701',
    Description: 'Beverly Beach Phase 2',
  },
  {
    Code: ' P468702',
    Description: 'Jonas Green Pk Shore Erosion',
  },
  {
    Code: ' P468797',
    Description: 'Shrline Eros Control 97',
  },
  {
    Code: ' P468799',
    Description: 'Shoreline Eros Contrl Conv',
  },
  {
    Code: ' P471800',
    Description: 'Green Haven Wharf',
  },
  {
    Code: ' P471801',
    Description: 'Green Haven Wharf Renov.',
  },
  {
    Code: ' P471899',
    Description: 'Green Haven Wharf Conv',
  },
  {
    Code: ' P471900',
    Description: 'Crab Creek Park',
  },
  {
    Code: ' P471901',
    Description: 'Crab Creek Park',
  },
  {
    Code: ' P471999',
    Description: 'Crab Creek Park Conv',
  },
  {
    Code: ' P472000',
    Description: 'Galesville Park',
  },
  {
    Code: ' P472001',
    Description: 'Galesville Park Land',
  },
  {
    Code: ' P472099',
    Description: 'Galesville Park Conv',
  },
  {
    Code: ' P472100',
    Description: 'Jonas Green Park',
  },
  {
    Code: ' P472101',
    Description: 'Jonas Green Park Development',
  },
  {
    Code: ' P472102',
    Description: 'Jonas Green Park Phase I',
  },
  {
    Code: ' P472103',
    Description: 'VACANT BUSINESS UNIT',
  },
  {
    Code: ' P472199',
    Description: 'Jonas Green Park Conv',
  },
  {
    Code: ' P472200',
    Description: 'Jumpers Hole Park',
  },
  {
    Code: ' P472201',
    Description: 'Jumpers Hole Park',
  },
  {
    Code: ' P472299',
    Description: 'Jumpers Hole Park Conv',
  },
  {
    Code: ' P472300',
    Description: 'Lake Waterford Addition',
  },
  {
    Code: ' P472301',
    Description: 'Lake Waterford Addition',
  },
  {
    Code: ' P472399',
    Description: 'Lake Waterford Addition Conv',
  },
  {
    Code: ' P472400',
    Description: 'So County Athletic Complex',
  },
  {
    Code: ' P472401',
    Description: 'So County Athletic Complex',
  },
  {
    Code: ' P472499',
    Description: 'So County Athletic Comp.Conv',
  },
  {
    Code: ' P475700',
    Description: 'Elvaton Park Expansion',
  },
  {
    Code: ' P475701',
    Description: 'Elvaton Park Expansion',
  },
  {
    Code: ' P475799',
    Description: 'Elvaton Park Expansion Conv',
  },
  {
    Code: ' P479800',
    Description: 'Park Renovation',
  },
  {
    Code: ' P479801',
    Description: 'Park Renovation 98',
  },
  {
    Code: ' P479802',
    Description: 'Park Renovation FY 00',
  },
  {
    Code: ' P479803',
    Description: 'Park Renovation FY 01',
  },
  {
    Code: ' P479804',
    Description: 'Park Renovation FY 02',
  },
  {
    Code: ' P479805',
    Description: 'Park Renovation FY 03',
  },
  {
    Code: ' P479897',
    Description: 'Park Renovation 97',
  },
  {
    Code: ' P479898',
    Description: 'Park Renovation 98 Conv',
  },
  {
    Code: ' P479899',
    Description: 'Park Renovation 99 Conv',
  },
  {
    Code: ' P482100',
    Description: 'GB Park ES Field Improv.',
  },
  {
    Code: ' P482101',
    Description: 'GB Park ES Field Improv.',
  },
  {
    Code: ' P482102',
    Description: 'GB Park ES Field Improv. Ph 2',
  },
  {
    Code: ' P482199',
    Description: 'GB PK ES Improv. Conv',
  },
  {
    Code: ' P482200',
    Description: 'Church Creek Park',
  },
  {
    Code: ' P482201',
    Description: 'Church Creek Park',
  },
  {
    Code: ' P482299',
    Description: 'Church Creek Park Conv',
  },
  {
    Code: ' P482300',
    Description: 'Swim Center Reno.',
  },
  {
    Code: ' P482301',
    Description: 'Swim Center Reno.',
  },
  {
    Code: ' P482302',
    Description: 'Swim Center Renov, Ph. II',
  },
  {
    Code: ' P482303',
    Description: 'Swim Center Ventilation Repl.',
  },
  {
    Code: ' P482399',
    Description: 'Swim Center Reno.Conv',
  },
  {
    Code: ' P482400',
    Description: 'Hancocks Hist. Site',
  },
  {
    Code: ' P482401',
    Description: 'Hancocks Hist. Site',
  },
  {
    Code: ' P482499',
    Description: 'Hancocks Hist. Site Conv',
  },
  {
    Code: ' P482500',
    Description: 'Patuxent Greenway',
  },
  {
    Code: ' P482501',
    Description: 'Pat River Park Expansion',
  },
  {
    Code: ' P482599',
    Description: 'Patuxent Greenway Conv',
  },
  {
    Code: ' P482600',
    Description: 'Broadneck Park Expansion',
  },
  {
    Code: ' P482601',
    Description: 'Broadneck Park Expansion',
  },
  {
    Code: ' P482699',
    Description: 'Broadneck Park Expan.Conv',
  },
  {
    Code: ' P482700',
    Description: 'Beachwood Park',
  },
  {
    Code: ' P482701',
    Description: 'Beachwood Park',
  },
  {
    Code: ' P482799',
    Description: 'Beachwood Park Conv',
  },
  {
    Code: ' P482800',
    Description: 'Sunset Park Renovation',
  },
  {
    Code: ' P482801',
    Description: 'Sunset Park Renovation',
  },
  {
    Code: ' P482899',
    Description: 'Sunset Park Renovation Conv',
  },
  {
    Code: ' P488000',
    Description: 'Multi Use Athletic Facility',
  },
  {
    Code: ' P488001',
    Description: 'Multi Use Athletic Facility',
  },
  {
    Code: ' P488099',
    Description: 'Multi Use Athletic Fac.Conv',
  },
  {
    Code: ' P490000',
    Description: 'Harmans Park',
  },
  {
    Code: ' P490001',
    Description: 'Harmans Park',
  },
  {
    Code: ' P490099',
    Description: 'Harmans Park Conv',
  },
  {
    Code: ' P490900',
    Description: 'MD City Recreation Area',
  },
  {
    Code: ' P490901',
    Description: 'MD City Recreation Area',
  },
  {
    Code: ' P490999',
    Description: 'MD City Rec. Area Conv',
  },
  {
    Code: ' P491000',
    Description: 'Jabez Conservation Easment',
  },
  {
    Code: ' P491001',
    Description: 'Jabez Conservation Easment',
  },
  {
    Code: ' P491099',
    Description: 'Jabez Conservation Ease.Conv',
  },
  {
    Code: ' P503400',
    Description: 'Crownsville Area Park',
  },
  {
    Code: ' P503401',
    Description: 'Crownsville Area Park',
  },
  {
    Code: ' P503500',
    Description: 'Franklin Point Park',
  },
  {
    Code: ' P503501',
    Description: 'Franklin Point-Env. Analysis',
  },
  {
    Code: ' P503600',
    Description: 'East Park',
  },
  {
    Code: ' P503601',
    Description: 'East Park',
  },
  {
    Code: ' P503602',
    Description: 'East Park Aquatic Center',
  },
  {
    Code: ' P503700',
    Description: 'Davidsonville Area Rec Imp',
  },
  {
    Code: ' P503701',
    Description: 'Davidsonville Area Rec Imp',
  },
  {
    Code: ' P504100',
    Description: 'Broadneck Peninsula Trail',
  },
  {
    Code: ' P504101',
    Description: 'Broadneck Peninsula Trail',
  },
  {
    Code: ' P508900',
    Description: 'Central Avenue Park',
  },
  {
    Code: ' P508901',
    Description: 'Central Avenue Park',
  },
  {
    Code: ' P508902',
    Description: 'South River Colony Parcel E',
  },
  {
    Code: ' P509000',
    Description: 'Peninsula Park Expansion',
  },
  {
    Code: ' P509001',
    Description: 'Peninsula Park Expansion',
  },
  {
    Code: ' P509100',
    Description: 'Facility Irrigation',
  },
  {
    Code: ' P509101',
    Description: 'Facility Irrigation-FY 01',
  },
  {
    Code: ' P509102',
    Description: 'Facility Irrigation FY 03',
  },
  {
    Code: ' P509200',
    Description: 'Magothy Greenway',
  },
  {
    Code: ' P509201',
    Description: 'Magothy Greenway',
  },
  {
    Code: ' P509300',
    Description: 'Jug Bay Expansion',
  },
  {
    Code: ' P509301',
    Description: 'Jug Bay Expansion',
  },
  {
    Code: ' P513700',
    Description: 'Broadneck Park Expansion',
  },
  {
    Code: ' P513701',
    Description: 'Broadneck Park Expansion',
  },
  {
    Code: ' P513702',
    Description: 'Broadneck Park Expansion II',
  },
  {
    Code: ' P513800',
    Description: 'White Pond Park',
  },
  {
    Code: ' P513801',
    Description: 'White Pond Park',
  },
  {
    Code: ' P513900',
    Description: 'Bay Head Park',
  },
  {
    Code: ' P513901',
    Description: 'Bay Head Park',
  },
  {
    Code: ' P888800',
    Description: 'RP Trans. for PY Clos Projects',
  },
  {
    Code: ' P888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' P888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' P999900',
    Description: 'R & P Class Account',
  },
  {
    Code: ' P999901',
    Description: 'R & P Class Account',
  },
  {
    Code: ' P999999',
    Description: 'R & P Class Account',
  },
  {
    Code: ' Q235200',
    Description: 'Upper Magothy Dredging',
  },
  {
    Code: ' Q235201',
    Description: 'Upper Magothy Dredging',
  },
  {
    Code: ' Q235299',
    Description: 'Upper Magothy Dredging Conv',
  },
  {
    Code: ' Q238000',
    Description: 'Marley Creek Dredging',
  },
  {
    Code: ' Q238001',
    Description: 'Marley Creek Dredging',
  },
  {
    Code: ' Q238099',
    Description: 'Marley Creek Dredging Conv',
  },
  {
    Code: ' Q342400',
    Description: 'Lake Placid Dredging',
  },
  {
    Code: ' Q342401',
    Description: 'Lake Placid Dredging',
  },
  {
    Code: ' Q342499',
    Description: 'Lake Placid Dredging Conv',
  },
  {
    Code: ' Q358600',
    Description: "Tar & White's Cove Drdg",
  },
  {
    Code: ' Q358601',
    Description: "Tar & White's Cove Drdg",
  },
  {
    Code: ' Q358602',
    Description: 'Tar Cove Drdg',
  },
  {
    Code: ' Q358699',
    Description: "Tar & White's Cove Drg Conv",
  },
  {
    Code: ' Q365900',
    Description: 'Cattail Creek Dredging',
  },
  {
    Code: ' Q365999',
    Description: 'Cattail Creek Dredging',
  },
  {
    Code: ' Q366300',
    Description: 'Old Man Creek Dredging',
  },
  {
    Code: ' Q366399',
    Description: 'Old Man Creek Dredging',
  },
  {
    Code: ' Q366600',
    Description: 'Rock Crk Urban Retro',
  },
  {
    Code: ' Q366601',
    Description: 'Rock Crk Urban Retro Phase 3',
  },
  {
    Code: ' Q366699',
    Description: 'Rock Crk Urbn Retr Ph3 Conv',
  },
  {
    Code: ' Q381000',
    Description: 'Regnl Drdg Matl Placmt',
  },
  {
    Code: ' Q381099',
    Description: 'Regnl Drdg Matl Placmt',
  },
  {
    Code: ' Q416000',
    Description: 'Chg Agst Wip Clsd Projects',
  },
  {
    Code: ' Q416001',
    Description: 'Chg Agst Wip Clsd Projects',
  },
  {
    Code: ' Q416099',
    Description: 'Chg Agst Wip Clsd Proj Conv',
  },
  {
    Code: ' Q437300',
    Description: 'Stream & Ecological Restor',
  },
  {
    Code: ' Q437301',
    Description: 'Weems Crk Trib Stream Rehab',
  },
  {
    Code: ' Q437302',
    Description: 'Sawmill Creek Trib 10Restorati',
  },
  {
    Code: ' Q437303',
    Description: 'Waugh Chapel Fish Passage',
  },
  {
    Code: ' Q437304',
    Description: 'Capital Raceway Fish Passage',
  },
  {
    Code: ' Q437305',
    Description: 'Kingswood Road Stream Rehab',
  },
  {
    Code: ' Q437306',
    Description: 'Aberdeen Creek Enviro. Assmt',
  },
  {
    Code: ' Q437307',
    Description: 'Cowhide Branch Emerg. Repair',
  },
  {
    Code: ' Q437308',
    Description: 'Dobbins Is. Benefic. Use Prj',
  },
  {
    Code: ' Q437309',
    Description: 'Hines Pond Shoreline Stabilz',
  },
  {
    Code: ' Q437310',
    Description: 'Dulls Corner Stream Rehab',
  },
  {
    Code: ' Q437311',
    Description: 'Sawmill Ck @ 8th Ave Fish P',
  },
  {
    Code: ' Q437312',
    Description: 'Cowhide Branch Retrofit',
  },
  {
    Code: ' Q437313',
    Description: 'Mill Creek Spring Sav Survey',
  },
  {
    Code: ' Q437314',
    Description: 'Chartwell Stream Chan. Rpr',
  },
  {
    Code: ' Q437315',
    Description: 'Save Our Streams Monitor Prog',
  },
  {
    Code: ' Q437316',
    Description: 'Heritage Cmplx BMP Demo Proj',
  },
  {
    Code: ' Q437317',
    Description: 'Jabez Branch Ph II',
  },
  {
    Code: ' Q437318',
    Description: 'Sawmill @ 11th Av Fish Pass',
  },
  {
    Code: ' Q437319',
    Description: 'Howards Brch Wtlnds Enhnc-01',
  },
  {
    Code: ' Q437320',
    Description: 'Crofton Trib Strm Restor-01',
  },
  {
    Code: ' Q437321',
    Description: 'Parole TC Sustainable SWM Plan',
  },
  {
    Code: ' Q437322',
    Description: 'Annap. High Sch. Outfall Retro',
  },
  {
    Code: ' Q437323',
    Description: 'Warehouse Creek Improvements',
  },
  {
    Code: ' Q437324',
    Description: 'Rutland Rd Fish Pass Repair',
  },
  {
    Code: ' Q437325',
    Description: 'Hillsmere Drainage/Duvall Crk',
  },
  {
    Code: ' Q437326',
    Description: 'Brock Brdg Elem. Stream Stab.',
  },
  {
    Code: ' Q437327',
    Description: 'Weems Creek Improvements',
  },
  {
    Code: ' Q437328',
    Description: 'Hidden Road Restoration',
  },
  {
    Code: ' Q437329',
    Description: 'Conaways Creek Stabilization',
  },
  {
    Code: ' Q437330',
    Description: 'Broadneck Rd Stream Repair',
  },
  {
    Code: ' Q437331',
    Description: 'Lake Waterford Fish Pass Rpr',
  },
  {
    Code: ' Q437332',
    Description: 'Beacrane Bog Restoration',
  },
  {
    Code: ' Q437333',
    Description: 'Downs SWM Retrofit',
  },
  {
    Code: ' Q437334',
    Description: 'Cowhide Brch/Weems Crk Rehab',
  },
  {
    Code: ' Q437335',
    Description: "Howard's Branch Monitoring",
  },
  {
    Code: ' Q437336',
    Description: 'Sawmill Creek Trib. 10 Repair',
  },
  {
    Code: ' Q437337',
    Description: 'South Carolina @ Severn Rd SD',
  },
  {
    Code: ' Q437338',
    Description: 'North Carolina Avenue Outfall',
  },
  {
    Code: ' Q437339',
    Description: 'Waterway Improvement Program',
  },
  {
    Code: ' Q437340',
    Description: 'Odenton Library Stream Rest.',
  },
  {
    Code: ' Q437341',
    Description: 'Mathias Cove/Cornfield Ck SAV',
  },
  {
    Code: ' Q437342',
    Description: 'Selby Heights SD Phase I',
  },
  {
    Code: ' Q437343',
    Description: 'Hardesty Pond',
  },
  {
    Code: ' Q437344',
    Description: 'Pine Haven Stream Erosion',
  },
  {
    Code: ' Q437345',
    Description: 'Belvedere Elementary',
  },
  {
    Code: ' Q437346',
    Description: 'Blue Bird Lane Erosion',
  },
  {
    Code: ' Q437347',
    Description: 'Black Walnut Crk Outfall Rhb',
  },
  {
    Code: ' Q437399',
    Description: 'Stream & Ecological Rst Conv',
  },
  {
    Code: ' Q439300',
    Description: 'Weems Creek Dredging',
  },
  {
    Code: ' Q439399',
    Description: 'Weems Creek Dredging',
  },
  {
    Code: ' Q441800',
    Description: 'Back Creek/Bahamas Dr',
  },
  {
    Code: ' Q441801',
    Description: 'Back Creek/Bahama Bch. Drd',
  },
  {
    Code: ' Q441899',
    Description: 'Back Creek/Bahamas Dr Conv',
  },
  {
    Code: ' Q441900',
    Description: 'Mathias Cove Dredging',
  },
  {
    Code: ' Q441901',
    Description: 'Mathias Cove Dredging Prj',
  },
  {
    Code: ' Q441902',
    Description: 'Mathias Cove Retrofit Proj',
  },
  {
    Code: ' Q441999',
    Description: 'Mathias Cove Dredging Conv',
  },
  {
    Code: ' Q442000',
    Description: 'Ross Cove Dredging',
  },
  {
    Code: ' Q442099',
    Description: 'Ross Cove Dredging',
  },
  {
    Code: ' Q449300',
    Description: 'Yantz Cove Dredging',
  },
  {
    Code: ' Q449399',
    Description: 'Yantz Cove Dredging',
  },
  {
    Code: ' Q449400',
    Description: 'Magothy Headwater Dredg',
  },
  {
    Code: ' Q449401',
    Description: 'Magothy Headwater Dredg',
  },
  {
    Code: ' Q449499',
    Description: 'Magothy Headwater Dredg Conv',
  },
  {
    Code: ' Q462800',
    Description: 'Almshouse Creek Dredging',
  },
  {
    Code: ' Q462801',
    Description: 'Almshouse Creek Dredging',
  },
  {
    Code: ' Q462802',
    Description: 'Idlewilde Dmp Site Reclam.',
  },
  {
    Code: ' Q462899',
    Description: 'Almshouse Crk Drdging Conv',
  },
  {
    Code: ' Q462900',
    Description: 'Cockey Creek Dredging',
  },
  {
    Code: ' Q462901',
    Description: 'Cockey Creek Dredging',
  },
  {
    Code: ' Q462902',
    Description: 'Cockey Creek Retrofit-Outfall',
  },
  {
    Code: ' Q462903',
    Description: 'Cockey Crk Retrofit Woods Rd.',
  },
  {
    Code: ' Q462904',
    Description: 'Cockey Crk Retro Rvrside/10th',
  },
  {
    Code: ' Q462999',
    Description: 'Cockey Creek Dredging Conv',
  },
  {
    Code: ' Q463000',
    Description: 'Cornfield Creek Dredging',
  },
  {
    Code: ' Q463001',
    Description: 'Cornfield Creek Dredging',
  },
  {
    Code: ' Q463099',
    Description: 'Cornfield Crk Dredging Conv',
  },
  {
    Code: ' Q463100',
    Description: 'Elvaton Twn Swm Fac',
  },
  {
    Code: ' Q463101',
    Description: 'Elvaton Twn Swm Fac',
  },
  {
    Code: ' Q463199',
    Description: 'Elvaton Twn Swm Fac Conv',
  },
  {
    Code: ' Q463200',
    Description: 'Harundale Swm Facility',
  },
  {
    Code: ' Q463201',
    Description: 'Harundale Swm Facility',
  },
  {
    Code: ' Q463299',
    Description: 'Harundale Swm Facility Conv',
  },
  {
    Code: ' Q463300',
    Description: 'Marley Stat Wetland',
  },
  {
    Code: ' Q463301',
    Description: 'Marley Stat Wetland',
  },
  {
    Code: ' Q463399',
    Description: 'Marley Stat Wetland Conv',
  },
  {
    Code: ' Q463400',
    Description: 'Parker Creek Dredging',
  },
  {
    Code: ' Q463401',
    Description: 'Parker Creek Dredging',
  },
  {
    Code: ' Q463499',
    Description: 'Parker Creek Dredging Conv',
  },
  {
    Code: ' Q463500',
    Description: 'Prg Ruppert Ravine Reno',
  },
  {
    Code: ' Q463501',
    Description: 'Prg Ruppert Ravine Reno',
  },
  {
    Code: ' Q463599',
    Description: 'Prg Ruppert Rvine Reno Conv',
  },
  {
    Code: ' Q463600',
    Description: 'Waterway Improv Proj Pln',
  },
  {
    Code: ' Q463601',
    Description: 'Ross Cove Dredging',
  },
  {
    Code: ' Q463602',
    Description: 'Cornfield Creek Dredging',
  },
  {
    Code: ' Q463603',
    Description: 'Hill Crk Road Channel Stabl.',
  },
  {
    Code: ' Q463604',
    Description: 'Mill Creek Dredging Project',
  },
  {
    Code: ' Q463605',
    Description: 'Larkington Cove Dredging',
  },
  {
    Code: ' Q463606',
    Description: 'Magothy River/Unnamed Cove',
  },
  {
    Code: ' Q463607',
    Description: 'Whitehall Canal Dredging',
  },
  {
    Code: ' Q463608',
    Description: 'Carrs Creek Dredging',
  },
  {
    Code: ' Q463609',
    Description: 'Cypress Creek Dredging',
  },
  {
    Code: ' Q463610',
    Description: 'Forked Creek Dredging',
  },
  {
    Code: ' Q463611',
    Description: 'Grays Creek Dredging',
  },
  {
    Code: ' Q463612',
    Description: 'Locust Cove Dredging',
  },
  {
    Code: ' Q463613',
    Description: 'Wetland Creation Project',
  },
  {
    Code: ' Q463614',
    Description: "Sprigg's Pond Dredging",
  },
  {
    Code: ' Q463615',
    Description: 'Lake Ogleton Dredging',
  },
  {
    Code: ' Q463616',
    Description: 'Dredging Prog Mgt Framework',
  },
  {
    Code: ' Q463617',
    Description: 'Bathymetric Surveys',
  },
  {
    Code: ' Q463618',
    Description: 'Submerged Aquatic Veg Surveys',
  },
  {
    Code: ' Q463619',
    Description: 'Town Point DMP Site',
  },
  {
    Code: ' Q463620',
    Description: 'Parker Creek Dredging',
  },
  {
    Code: ' Q463621',
    Description: 'Dredging Prog Mgt Frmwrk Ph II',
  },
  {
    Code: ' Q463622',
    Description: 'Pocahontas Creek Dredging',
  },
  {
    Code: ' Q463623',
    Description: 'Little Magothy River Dredging',
  },
  {
    Code: ' Q463624',
    Description: 'Mill Creek Dredging/Headwaters',
  },
  {
    Code: ' Q463625',
    Description: 'Clements Creek Project Plan',
  },
  {
    Code: ' Q463626',
    Description: 'Whitehall Creek Project Plan',
  },
  {
    Code: ' Q463627',
    Description: 'Boyds Creek Dredging',
  },
  {
    Code: ' Q463699',
    Description: 'Waterway Imp Proj Pln Conv',
  },
  {
    Code: ' Q474900',
    Description: 'Brookfield Outfall Rehab',
  },
  {
    Code: ' Q474901',
    Description: 'Brookfield Outfall Rehab',
  },
  {
    Code: ' Q474999',
    Description: 'Brookfield Outfall Reh. Conv',
  },
  {
    Code: ' Q475000',
    Description: 'Waterway Dredge Placement',
  },
  {
    Code: ' Q475001',
    Description: 'Magothy River Dmp Site',
  },
  {
    Code: ' Q475002',
    Description: 'Wtrwy Drdg Place-Ben. Uses',
  },
  {
    Code: ' Q475003',
    Description: 'Sudley Landfill Stockpile',
  },
  {
    Code: ' Q475004',
    Description: 'Town Point DMP Site Mgmt.',
  },
  {
    Code: ' Q475005',
    Description: 'Bodys Cove Dredging',
  },
  {
    Code: ' Q475099',
    Description: 'Magothy River Dmp Site Conv',
  },
  {
    Code: ' Q475100',
    Description: 'Rock Creek Aeration',
  },
  {
    Code: ' Q475101',
    Description: 'Rock Creek Aeration',
  },
  {
    Code: ' Q475199',
    Description: 'Rock Creek Aeration Conv',
  },
  {
    Code: ' Q475200',
    Description: 'Whitehall Canal Dredging',
  },
  {
    Code: ' Q475201',
    Description: 'Whitehall Canal Dredging',
  },
  {
    Code: ' Q475299',
    Description: 'Whitehall Canal Drdging Conv',
  },
  {
    Code: ' Q482900',
    Description: 'Cypress Creek Dredging',
  },
  {
    Code: ' Q482901',
    Description: 'Cypress Creek Dredging',
  },
  {
    Code: ' Q482902',
    Description: 'Cypress/Mill Crk Surveys',
  },
  {
    Code: ' Q482903',
    Description: 'Cypress/Forked Crk Surveys',
  },
  {
    Code: ' Q482999',
    Description: 'Cypress Creek Drdging Conv',
  },
  {
    Code: ' Q483000',
    Description: 'Locust Cove Dredging',
  },
  {
    Code: ' Q483001',
    Description: 'Locust Cove Dredging',
  },
  {
    Code: ' Q483099',
    Description: 'Locust Cove Dredging Conv',
  },
  {
    Code: ' Q483100',
    Description: 'Larkington Cove Dredging',
  },
  {
    Code: ' Q483101',
    Description: 'Larkington Cove Dredging',
  },
  {
    Code: ' Q483199',
    Description: 'Larkington Cove Drdging Conv',
  },
  {
    Code: ' Q483200',
    Description: 'Magothy River - Unnamed Cv',
  },
  {
    Code: ' Q483201',
    Description: 'Magothy River - Unnamed Cv',
  },
  {
    Code: ' Q483299',
    Description: 'Magothy -Unnamed Cove',
  },
  {
    Code: ' Q483300',
    Description: 'Mill Creek Dredging Project',
  },
  {
    Code: ' Q483301',
    Description: 'Mill Creek Dredging Project',
  },
  {
    Code: ' Q483399',
    Description: 'Mill Crk Dredging Prj Conv',
  },
  {
    Code: ' Q483400',
    Description: 'Forked Creek Dredging',
  },
  {
    Code: ' Q483401',
    Description: 'Forked Creek Dredging',
  },
  {
    Code: ' Q483499',
    Description: 'Forked Creek Dredging Conv',
  },
  {
    Code: ' Q483500',
    Description: 'Grays Creek Dredging',
  },
  {
    Code: ' Q483501',
    Description: 'Grays Creek Dredging',
  },
  {
    Code: ' Q483502',
    Description: 'Grays Creek Monitoring',
  },
  {
    Code: ' Q483599',
    Description: 'Grays Creek Dredging Conv',
  },
  {
    Code: ' Q483700',
    Description: 'Aurora Hills SD Rehb',
  },
  {
    Code: ' Q483701',
    Description: 'Aurora Hills SD Rehb',
  },
  {
    Code: ' Q483702',
    Description: 'Aurora Hills Outfall Phase I',
  },
  {
    Code: ' Q483799',
    Description: 'Aurora Hills SD Rehb Conv',
  },
  {
    Code: ' Q488100',
    Description: 'Rockhold Creek Jetty',
  },
  {
    Code: ' Q488101',
    Description: 'Rockhold Creek Jetty',
  },
  {
    Code: ' Q488199',
    Description: 'Rockhold Creek Jetty Conv',
  },
  {
    Code: ' Q489700',
    Description: 'Howard Branch Stream Rest.',
  },
  {
    Code: ' Q489701',
    Description: 'Howard Branch Stream Rest.',
  },
  {
    Code: ' Q489799',
    Description: 'Howard Branch Strm Rst.Conv',
  },
  {
    Code: ' Q489800',
    Description: 'Olin Dr. Fish Passage',
  },
  {
    Code: ' Q489801',
    Description: 'Olin Dr. Fish Passage',
  },
  {
    Code: ' Q489899',
    Description: 'Olin Dr. Fish Passage Conv',
  },
  {
    Code: ' Q489900',
    Description: 'NSA Flood Plain Rest',
  },
  {
    Code: ' Q489901',
    Description: 'NSA/Oakhill Trib. Restoration',
  },
  {
    Code: ' Q489999',
    Description: 'NSA Flood Plain Rest Conv',
  },
  {
    Code: ' Q497300',
    Description: 'Rockhill Creek Road Cove',
  },
  {
    Code: ' Q497301',
    Description: 'Rockhill Creek Road Cove',
  },
  {
    Code: ' Q497400',
    Description: 'Sloop, Eli and Long Coves',
  },
  {
    Code: ' Q497401',
    Description: 'Sloop, Eli and Long Coves',
  },
  {
    Code: ' Q497402',
    Description: 'Sloop & Eli Coves Constr.',
  },
  {
    Code: ' Q497500',
    Description: 'Pooles Gut Dredging',
  },
  {
    Code: ' Q497501',
    Description: 'Pooles Gut Dredging',
  },
  {
    Code: ' Q497600',
    Description: 'Park Rd Outfall Rehab',
  },
  {
    Code: ' Q497601',
    Description: 'Park Rd Outfall Rehab',
  },
  {
    Code: ' Q497700',
    Description: 'Gingerville SWMP Upgrade',
  },
  {
    Code: ' Q497701',
    Description: 'Gingerville SWMP Upgrade',
  },
  {
    Code: ' Q497800',
    Description: 'Little Magothy Dredging',
  },
  {
    Code: ' Q497801',
    Description: 'Little Magothy Dredging',
  },
  {
    Code: ' Q498000',
    Description: 'Broadwater Ceek Dredging',
  },
  {
    Code: ' Q498001',
    Description: 'Broadwater Ceek Dredging',
  },
  {
    Code: ' Q498200',
    Description: 'Reidel Road SWM Pond',
  },
  {
    Code: ' Q498201',
    Description: 'Reidel Road SWM Pond',
  },
  {
    Code: ' Q499600',
    Description: 'Sawmill Trib 10 Rehab',
  },
  {
    Code: ' Q499601',
    Description: 'Sawmill Trib 10 Rehab',
  },
  {
    Code: ' Q500000',
    Description: 'DMP Site Management',
  },
  {
    Code: ' Q500001',
    Description: 'DMP Site Management',
  },
  {
    Code: ' Q500002',
    Description: 'DMP Site Mgt-FY 01',
  },
  {
    Code: ' Q503800',
    Description: 'Chartwell Stream Restoration',
  },
  {
    Code: ' Q503801',
    Description: 'Chartwell Stream Restoration',
  },
  {
    Code: ' Q503900',
    Description: 'Dulls Corner Stream Restoratn',
  },
  {
    Code: ' Q503901',
    Description: 'Dulls Corner Stream Restoratn',
  },
  {
    Code: ' Q509400',
    Description: 'Cypress Creek Retrofit',
  },
  {
    Code: ' Q509401',
    Description: 'Cypress Creek Retrofit',
  },
  {
    Code: ' Q509500',
    Description: 'Boyds Creek Dredging',
  },
  {
    Code: ' Q509501',
    Description: 'Boyds Creek Dredging',
  },
  {
    Code: ' Q509600',
    Description: 'Carrs Creek Dredging',
  },
  {
    Code: ' Q509601',
    Description: 'Carrs Creek Dredging',
  },
  {
    Code: ' Q509700',
    Description: 'Plum Creek Dredging',
  },
  {
    Code: ' Q509701',
    Description: 'Plum Creek Dredging',
  },
  {
    Code: ' Q509800',
    Description: 'Pocahontas Creek Hdw Dredging',
  },
  {
    Code: ' Q509801',
    Description: 'Pocahontas Creek Hdw Dredging',
  },
  {
    Code: ' Q514000',
    Description: 'Wilelinor SWMPS Rehab',
  },
  {
    Code: ' Q514001',
    Description: 'Wilelinor SWMPS Rehab',
  },
  {
    Code: ' Q514200',
    Description: "Shipley's Choice SWM",
  },
  {
    Code: ' Q514201',
    Description: "Shipley's Choice SWM",
  },
  {
    Code: ' Q514400',
    Description: 'Riva/Annap SD Outfall Rehab',
  },
  {
    Code: ' Q514401',
    Description: 'Riva/Annap SD Outfall Rehab',
  },
  {
    Code: ' Q514500',
    Description: 'Warehouse Creek Stream Restr',
  },
  {
    Code: ' Q514501',
    Description: 'Warehouse Creek Stream Restr',
  },
  {
    Code: ' Q514502',
    Description: 'Warehouse Crk Dr Priority Rpt',
  },
  {
    Code: ' Q514700',
    Description: 'Church Creek Stream Restoratn',
  },
  {
    Code: ' Q514701',
    Description: 'Church Creek Stream Restoratn',
  },
  {
    Code: ' Q516000',
    Description: 'Clements Creek Dredging',
  },
  {
    Code: ' Q516001',
    Description: 'Clements Creek Dredging',
  },
  {
    Code: ' Q516200',
    Description: 'Brady Cove Dredging',
  },
  {
    Code: ' Q516201',
    Description: 'Brady Cove Dredging',
  },
  {
    Code: ' Q516300',
    Description: 'Brockbridge Elem Stream Restor',
  },
  {
    Code: ' Q516301',
    Description: 'Brockbridge Elem Stream Stbl.',
  },
  {
    Code: ' Q516400',
    Description: 'Beacrane Road Bog Rehab',
  },
  {
    Code: ' Q516401',
    Description: 'Beacrane Road Bog Rehab',
  },
  {
    Code: ' Q516500',
    Description: 'Old County Road Swm Bmp',
  },
  {
    Code: ' Q516501',
    Description: 'Old County Road Swm Bmp',
  },
  {
    Code: ' Q516800',
    Description: "Gray's Creek Bog",
  },
  {
    Code: ' Q516801',
    Description: "Gray's Creek Bog",
  },
  {
    Code: ' Q517600',
    Description: 'Whitehall Creek Dredging',
  },
  {
    Code: ' Q517601',
    Description: 'Whitehall Creek Dredging',
  },
  {
    Code: ' Q888800',
    Description: 'WI Trans. for PY Clos Projects',
  },
  {
    Code: ' Q888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' Q888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' Q999900',
    Description: 'Wip Class Account',
  },
  {
    Code: ' Q999901',
    Description: 'Wip Class Account',
  },
  {
    Code: ' Q999999',
    Description: 'Wip Class Account Conv',
  },
  {
    Code: ' S647500',
    Description: 'Balto. County Sewer Agreement',
  },
  {
    Code: ' S647501',
    Description: 'Balto. County Sewer Agreement',
  },
  {
    Code: ' S647599',
    Description: 'Balt County Sewer Agrmt Conv',
  },
  {
    Code: ' S655600',
    Description: 'Nevada Ave Col Sys',
  },
  {
    Code: ' S655699',
    Description: 'Nevada Ave Col Sys',
  },
  {
    Code: ' S741300',
    Description: 'Chg Against WW Clsd Projects',
  },
  {
    Code: ' S741301',
    Description: 'Chg Against WW Clsd Projects',
  },
  {
    Code: ' S741399',
    Description: 'Chg Against WW Clsd Proj Conv',
  },
  {
    Code: ' S745200',
    Description: 'Cedar Hill Interceptor',
  },
  {
    Code: ' S745201',
    Description: 'Cedar Hill Interceptor',
  },
  {
    Code: ' S745202',
    Description: 'Cedar Hill Intrcptr-Wtlnds Mit',
  },
  {
    Code: ' S745203',
    Description: 'Cedar Hill Interceptor-SPS',
  },
  {
    Code: ' S745299',
    Description: 'Cedar Hill Interceptor Conv',
  },
  {
    Code: ' S753000',
    Description: 'Remote Monitoring Addtn',
  },
  {
    Code: ' S753001',
    Description: 'Remote Monitoring Addtn',
  },
  {
    Code: ' S753002',
    Description: 'Remote Monitoring RTU Prepurch',
  },
  {
    Code: ' S753003',
    Description: 'Remote Monitoring RTU Install',
  },
  {
    Code: ' S753099',
    Description: 'Remote Montoring Addtn Conv',
  },
  {
    Code: ' S753200',
    Description: 'Annapolis WRF/BNR',
  },
  {
    Code: ' S753201',
    Description: 'Annapolis WRF BNR Facilities',
  },
  {
    Code: ' S753202',
    Description: 'Annapolis WRF/BNR Pilot Eval',
  },
  {
    Code: ' S753203',
    Description: 'Annapolis BNR Facility',
  },
  {
    Code: ' S753204',
    Description: 'Annapolis WRF Pond Lining',
  },
  {
    Code: ' S753205',
    Description: 'Annapolis WRF Grav Thcknr #4',
  },
  {
    Code: ' S753206',
    Description: 'Annapolis WRF Control Room',
  },
  {
    Code: ' S753299',
    Description: 'Annapolis WRF/BNR Conv',
  },
  {
    Code: ' S755100',
    Description: 'Broadwater WRF Upgr II BNR',
  },
  {
    Code: ' S755101',
    Description: 'Broadwater WRF/BNR Pilot Eval',
  },
  {
    Code: ' S755102',
    Description: 'Broadwater BNR Facility',
  },
  {
    Code: ' S755103',
    Description: 'Broadwater WRF Pond Lining',
  },
  {
    Code: ' S755104',
    Description: 'Broadwater WRF Odor Control',
  },
  {
    Code: ' S755199',
    Description: 'Broadwater WRF/BNR Conv',
  },
  {
    Code: ' S757200',
    Description: 'Broadwater III, IV, V (Rev)',
  },
  {
    Code: ' S757299',
    Description: 'Broadwater III, IV, V (Rev)',
  },
  {
    Code: ' S757300',
    Description: 'Rose Haven/Holland Pt Swr',
  },
  {
    Code: ' S757301',
    Description: 'Rose Haven Force Main Install',
  },
  {
    Code: ' S757302',
    Description: 'Holland Point Collection Sys',
  },
  {
    Code: ' S757303',
    Description: 'Rose Haven Collection Sys',
  },
  {
    Code: ' S757304',
    Description: 'Chesapeake Beach WWTP Exp',
  },
  {
    Code: ' S757399',
    Description: 'Rose Haven/Holland Pt Swr Conv',
  },
  {
    Code: ' S758100',
    Description: 'Patuxent WRF Improv',
  },
  {
    Code: ' S758101',
    Description: 'Patuxent Oxid Ditch Equip Mod',
  },
  {
    Code: ' S758102',
    Description: 'Patuxent WRF Improv, Ph. I',
  },
  {
    Code: ' S758103',
    Description: 'Patuxent WRF Improv, Ph. II',
  },
  {
    Code: ' S758104',
    Description: 'Patuxent WRF Improv, Ph. III',
  },
  {
    Code: ' S758105',
    Description: 'Patux WRF N Remov & Hdwks Exp',
  },
  {
    Code: ' S758199',
    Description: 'Patuxent WRF Improv Conv',
  },
  {
    Code: ' S764400',
    Description: 'WW Project Management',
  },
  {
    Code: ' S764401',
    Description: 'WW Project Management',
  },
  {
    Code: ' S764499',
    Description: 'WW Project Management Conv',
  },
  {
    Code: ' S764800',
    Description: 'Cox Creek WRF Odor',
  },
  {
    Code: ' S764801',
    Description: 'Cox Creek WRF Odor',
  },
  {
    Code: ' S764899',
    Description: 'Cox Creek WRF Odor Conv',
  },
  {
    Code: ' S764900',
    Description: 'Cox Creek WRF BNR',
  },
  {
    Code: ' S764901',
    Description: 'Cox Creek WRF BNR',
  },
  {
    Code: ' S764902',
    Description: 'Cox Creek WRF BNR Pilot Eval',
  },
  {
    Code: ' S764999',
    Description: 'Cox Creek WRF BNR Conv',
  },
  {
    Code: ' S765100',
    Description: 'Annapolis WRF Odor',
  },
  {
    Code: ' S765101',
    Description: 'Annapolis WRF Odor',
  },
  {
    Code: ' S765199',
    Description: 'Annapolis WRF Odor Conv',
  },
  {
    Code: ' S769500',
    Description: 'Broadneck WRF Upgrd',
  },
  {
    Code: ' S769501',
    Description: 'Broadneck WRF Upgrd',
  },
  {
    Code: ' S769599',
    Description: 'Broadneck WRF Upgrd Conv',
  },
  {
    Code: ' S769700',
    Description: 'Mayo WRF Expansion',
  },
  {
    Code: ' S769701',
    Description: 'Mayo WRF Clarifier Expansion',
  },
  {
    Code: ' S769702',
    Description: 'Mayo WRF RSF#1 Upgrade',
  },
  {
    Code: ' S769703',
    Description: 'Mayo WRF RSF #1 Upgrade',
  },
  {
    Code: ' S769704',
    Description: 'Mayo WRF RSF #1 Rehab',
  },
  {
    Code: ' S769705',
    Description: 'Mayo WRF RST #2 Rehab',
  },
  {
    Code: ' S769706',
    Description: 'Mayo-Glebe Heights SPS & FM',
  },
  {
    Code: ' S769707',
    Description: 'Mayo WRF Emergent Wetland 1',
  },
  {
    Code: ' S769799',
    Description: 'Mayo WRF Expansion Conv',
  },
  {
    Code: ' S769800',
    Description: 'Glebe Heights Swr Module',
  },
  {
    Code: ' S769801',
    Description: 'Glebe Heights Swr Module, Ph I',
  },
  {
    Code: ' S769899',
    Description: 'Glebe Heights Swr Module Conv',
  },
  {
    Code: ' S773000',
    Description: 'Cross Country FM Repl',
  },
  {
    Code: ' S773001',
    Description: 'Cross Country FM Repl',
  },
  {
    Code: ' S773099',
    Description: 'Cross Country FM Repl Conv',
  },
  {
    Code: ' S773100',
    Description: 'Marley Relief FM Repl',
  },
  {
    Code: ' S773101',
    Description: 'Marley Relief FM Repl',
  },
  {
    Code: ' S773199',
    Description: 'Marley Relief FM Repl Conv',
  },
  {
    Code: ' S773200',
    Description: 'Severn Run SPS Upgrd',
  },
  {
    Code: ' S773201',
    Description: 'Severn Run SPS Upgrd',
  },
  {
    Code: ' S773299',
    Description: 'Severn Run SPS Upgrd Conv',
  },
  {
    Code: ' S776500',
    Description: 'Mayo Col Syst Upgrd',
  },
  {
    Code: ' S776501',
    Description: 'Mayo Col Syst Upgrd',
  },
  {
    Code: ' S776502',
    Description: 'Glebe Hts Col Syst Upgrd',
  },
  {
    Code: ' S776599',
    Description: 'Mayo Col Syst Upgrd Conv',
  },
  {
    Code: ' S776600',
    Description: 'Septage/Scum Rec Fac',
  },
  {
    Code: ' S776601',
    Description: 'Septage/Scum Rec Fac',
  },
  {
    Code: ' S776602',
    Description: 'Broadwtr WRF Grit System Upg.',
  },
  {
    Code: ' S776699',
    Description: 'Septage/Scum Rec Fac Conv',
  },
  {
    Code: ' S776700',
    Description: 'Wastewater Strategic Plan',
  },
  {
    Code: ' S776701',
    Description: 'Wastewater Strategic Plan',
  },
  {
    Code: ' S776799',
    Description: 'Wastewater Strategic Plan Conv',
  },
  {
    Code: ' S776800',
    Description: 'Mayo Septic Tnk Retrofit',
  },
  {
    Code: ' S776801',
    Description: 'Mayo Septic Tnk Retrofit',
  },
  {
    Code: ' S776802',
    Description: 'Mayo Septic Tnk-Add. Studies',
  },
  {
    Code: ' S776803',
    Description: 'Mayo Septic Tank Retrofit 02',
  },
  {
    Code: ' S776804',
    Description: 'Mayo Septic Tank Retrofit 03',
  },
  {
    Code: ' S776899',
    Description: 'Mayo Septic Tnk Retrofit Conv',
  },
  {
    Code: ' S776900',
    Description: 'WDS Wharf Rd Col Sys',
  },
  {
    Code: ' S776999',
    Description: 'WDS Wharf Rd Col Sys',
  },
  {
    Code: ' S777000',
    Description: 'Sludge Facil Upgrd',
  },
  {
    Code: ' S777099',
    Description: 'Sludge Facil Upgrd',
  },
  {
    Code: ' S777100',
    Description: 'Mayo Interceptor Exp',
  },
  {
    Code: ' S777101',
    Description: 'Mayo Interceptor Exp',
  },
  {
    Code: ' S777199',
    Description: 'Mayo Interceptor Exp Conv',
  },
  {
    Code: ' S777200',
    Description: 'Central Sanitation Facility',
  },
  {
    Code: ' S777201',
    Description: 'Central Sanitation Facility',
  },
  {
    Code: ' S777202',
    Description: 'Central San. - Storage Lot',
  },
  {
    Code: ' S777299',
    Description: 'Central Sanitation Facility',
  },
  {
    Code: ' S777400',
    Description: 'Maryland City WRF Improv',
  },
  {
    Code: ' S777401',
    Description: 'Maryland City WRF Imp, Ph I',
  },
  {
    Code: ' S777402',
    Description: 'Maryland City WRF Imp, Ph II',
  },
  {
    Code: ' S777499',
    Description: 'Maryland City WRF Imp Conv',
  },
  {
    Code: ' S783400',
    Description: 'Cox Creek WRF Upgrd II',
  },
  {
    Code: ' S783401',
    Description: 'Cox Creek Water & Grit Sys Upg',
  },
  {
    Code: ' S783499',
    Description: 'Cox Creek WRF Upgrd II Conv',
  },
  {
    Code: ' S783500',
    Description: 'East Howard Swr Ext',
  },
  {
    Code: ' S783599',
    Description: 'East Howard Swr Ext',
  },
  {
    Code: ' S783600',
    Description: 'GB Main Fac Security',
  },
  {
    Code: ' S783699',
    Description: 'GB Main Fac Security',
  },
  {
    Code: ' S783700',
    Description: 'Marley-Jumpers Swr Rehab',
  },
  {
    Code: ' S783701',
    Description: 'Marley-Jumpers Swr Rehab',
  },
  {
    Code: ' S783799',
    Description: 'Marley-Jumpers Swr Rehab Conv',
  },
  {
    Code: ' S783800',
    Description: 'Patuxent WRF Expansion',
  },
  {
    Code: ' S783801',
    Description: 'Patuxent WRF Expansion',
  },
  {
    Code: ' S783802',
    Description: 'Patuxent WRF Ph II Exp',
  },
  {
    Code: ' S783899',
    Description: 'Patuxent WRF Expansion Conv',
  },
  {
    Code: ' S783900',
    Description: 'WRF Outfall Rehab',
  },
  {
    Code: ' S783901',
    Description: 'WRF Outfall Rehab',
  },
  {
    Code: ' S783999',
    Description: 'WRF Outfall Rehab Conv',
  },
  {
    Code: ' S784000',
    Description: 'Laurel Heights Wastewater',
  },
  {
    Code: ' S784001',
    Description: 'Laurel Heights Wastewater',
  },
  {
    Code: ' S784099',
    Description: 'Laurel Heights Wastewater Conv',
  },
  {
    Code: ' S787200',
    Description: 'Maryland City Relief Sewer',
  },
  {
    Code: ' S787201',
    Description: 'Maryland City Relief Sewer',
  },
  {
    Code: ' S787299',
    Description: 'Maryland City Relief Sewer Con',
  },
  {
    Code: ' S787300',
    Description: 'Galesvile/Clark Pt Odor Contro',
  },
  {
    Code: ' S787301',
    Description: 'Galesvile/Clark Pt Odor Contro',
  },
  {
    Code: ' S787399',
    Description: 'Glsvil/Clrk Pt Odor Cntrl Conv',
  },
  {
    Code: ' S787400',
    Description: 'Race Road Sewer Ext',
  },
  {
    Code: ' S787401',
    Description: 'Race Road Sewer Ext',
  },
  {
    Code: ' S787499',
    Description: 'Race Road Sewer Ext Conv',
  },
  {
    Code: ' S787500',
    Description: 'Reece Rd Sewer System',
  },
  {
    Code: ' S787501',
    Description: 'Reece Rd Sewer System',
  },
  {
    Code: ' S787599',
    Description: 'Reece Rd Sewer System Conv',
  },
  {
    Code: ' S787600',
    Description: 'Ft Meade WW SysT/O',
  },
  {
    Code: ' S787601',
    Description: 'Ft Meade WW SysT/O',
  },
  {
    Code: ' S787699',
    Description: 'Ft Meade WW SysT/O Conv',
  },
  {
    Code: ' S788400',
    Description: 'Woodland Beach SPS',
  },
  {
    Code: ' S788401',
    Description: 'Woodland Beach PS Upgr',
  },
  {
    Code: ' S788402',
    Description: 'Woodland Beach FM Upgr',
  },
  {
    Code: ' S788403',
    Description: 'Woodland Bch FM-Rt2/Virg. Ave.',
  },
  {
    Code: ' S788404',
    Description: 'Woodland Bch FM-Rt2/Newtown',
  },
  {
    Code: ' S788405',
    Description: 'Woodland Bch FM-Newtown/Hills.',
  },
  {
    Code: ' S788499',
    Description: 'Woodland Beach SPS Conv',
  },
  {
    Code: ' S791800',
    Description: 'Upgr/Retrofit SPS',
  },
  {
    Code: ' S791801',
    Description: 'Parole/Woodland Beach Upgr',
  },
  {
    Code: ' S791802',
    Description: 'Odor Control, Ph 3',
  },
  {
    Code: ' S791803',
    Description: 'Odor Control, Ph 4',
  },
  {
    Code: ' S791804',
    Description: 'Ladders & Landings, Ph 1',
  },
  {
    Code: ' S791805',
    Description: 'Annapolis Rds GP Conn Repl',
  },
  {
    Code: ' S791806',
    Description: 'Storch Prop Flood Wall',
  },
  {
    Code: ' S791807',
    Description: 'Misc Chgs Closed SPS 97 Proj',
  },
  {
    Code: ' S791808',
    Description: 'Mayo Pump Stations Upgr II',
  },
  {
    Code: ' S791809',
    Description: 'Severn Run SPS Upgrd',
  },
  {
    Code: ' S791810',
    Description: 'Woodland Beach SPS',
  },
  {
    Code: ' S791811',
    Description: 'Water to Stations, Ph. I',
  },
  {
    Code: ' S791812',
    Description: 'Sylvan Shores SPS',
  },
  {
    Code: ' S791813',
    Description: 'Ladders & Landings, Ph. 2',
  },
  {
    Code: ' S791814',
    Description: 'Misc Upgrades SPS 98, Ph. I',
  },
  {
    Code: ' S791815',
    Description: 'Chalk Point Odor Control',
  },
  {
    Code: ' S791816',
    Description: 'Mill Creek SPS',
  },
  {
    Code: ' S791817',
    Description: 'SCADA Enclosures',
  },
  {
    Code: ' S791818',
    Description: 'Hillsmere Electrical Upgrade',
  },
  {
    Code: ' S791819',
    Description: 'Cape St John Electrical Upgr',
  },
  {
    Code: ' S791820',
    Description: 'Design Manual Deployment',
  },
  {
    Code: ' S791821',
    Description: 'SPS00 Misc Upgr II-Comminutors',
  },
  {
    Code: ' S791822',
    Description: 'SPS00 Misc Upg III-Ventilation',
  },
  {
    Code: ' S791823',
    Description: 'SPS 00-Mayo J-Box Repl',
  },
  {
    Code: ' S791824',
    Description: 'SPS 00-Guide Rail Replacement',
  },
  {
    Code: ' S791825',
    Description: 'SPS 00-Hoot Owl Relief FM',
  },
  {
    Code: ' S791826',
    Description: 'SPS 00-Shoreland Dr SPS',
  },
  {
    Code: ' S791827',
    Description: 'SPS 00-Belvedere Yacht Club SP',
  },
  {
    Code: ' S791828',
    Description: 'SPS 00-SPS Painting South',
  },
  {
    Code: ' S791829',
    Description: 'SPS 01-Severn Run SPS Upg II',
  },
  {
    Code: ' S791830',
    Description: 'SPS 01-SPS Painting North',
  },
  {
    Code: ' S791831',
    Description: 'SPS 01-RTU Installation',
  },
  {
    Code: ' S791832',
    Description: 'SPS 01-Generators Repl, Ph I',
  },
  {
    Code: ' S791833',
    Description: 'SPS 01-Misc. Upgrades, Ph I',
  },
  {
    Code: ' S791834',
    Description: 'SPS 01-Round Bay Replacement',
  },
  {
    Code: ' S791835',
    Description: 'SPS 01-Odor Filters Ph IV',
  },
  {
    Code: ' S791836',
    Description: 'SPS 01-Sylvan Shores',
  },
  {
    Code: ' S791837',
    Description: 'SPS 01-Air Rel. Valve Vault Up',
  },
  {
    Code: ' S791838',
    Description: 'SPS 01-Mayo Interceptor Maint.',
  },
  {
    Code: ' S791839',
    Description: 'SPS 01-Cattail Creek Repl.',
  },
  {
    Code: ' S791840',
    Description: 'SPS 01-Mill Creek VFD',
  },
  {
    Code: ' S791841',
    Description: 'Selby Collection Syst. Study',
  },
  {
    Code: ' S791842',
    Description: 'Jennifer Rd SPS Force Main',
  },
  {
    Code: ' S791843',
    Description: 'Up/Retro SPS-Shoreham Beach',
  },
  {
    Code: ' S791844',
    Description: 'Up/Retro SPS-Selby 3 & 4',
  },
  {
    Code: ' S791845',
    Description: 'Up/Retro SPS-Pump Controls',
  },
  {
    Code: ' S791846',
    Description: 'Up/Retro SPS-Mill Creek Odor',
  },
  {
    Code: ' S791847',
    Description: 'Beverly Beach-1, Pump Vault',
  },
  {
    Code: ' S791848',
    Description: 'SPS-Parole Chemical Rm Repair',
  },
  {
    Code: ' S791849',
    Description: 'SPS-Little Patuxent VFD Repl.',
  },
  {
    Code: ' S791850',
    Description: 'SPS-MD City VFD Replacement',
  },
  {
    Code: ' S791897',
    Description: 'Upgrd/Retroft SPS 97',
  },
  {
    Code: ' S791898',
    Description: 'Upgrd/Retro SPS 98 Conv',
  },
  {
    Code: ' S791899',
    Description: 'Upgr/Retrofit SPS  Conv',
  },
  {
    Code: ' S792200',
    Description: 'Dreams Landing Coll Sys',
  },
  {
    Code: ' S792201',
    Description: 'Dreams Landing Coll Sys',
  },
  {
    Code: ' S792299',
    Description: 'Dreams Landing Coll Sys Conv',
  },
  {
    Code: ' S792300',
    Description: 'Severn Run FM',
  },
  {
    Code: ' S792301',
    Description: 'Severn Run FM Upgr',
  },
  {
    Code: ' S792399',
    Description: 'Severn Run FM Conv',
  },
  {
    Code: ' S792400',
    Description: 'Annapolis WRF Exp',
  },
  {
    Code: ' S792401',
    Description: 'Annapolis WRF Exp',
  },
  {
    Code: ' S792499',
    Description: 'Annapolis WRF Exp Conv',
  },
  {
    Code: ' S792500',
    Description: 'No. Severn River PS & FM',
  },
  {
    Code: ' S792501',
    Description: 'No. Severn River PS & FM',
  },
  {
    Code: ' S792599',
    Description: 'No. Severn River PS & FM',
  },
  {
    Code: ' S792800',
    Description: 'Broadwater WRF Water',
  },
  {
    Code: ' S792801',
    Description: 'Broadwater WRF Wtr Tnk Rem',
  },
  {
    Code: ' S792802',
    Description: 'Broadwater WRF Wtr Sys Upgr',
  },
  {
    Code: ' S792899',
    Description: 'Broadwater WRF Water Conv',
  },
  {
    Code: ' S792900',
    Description: 'Cayuga Farms PS & FM',
  },
  {
    Code: ' S792901',
    Description: 'Cayuga Farms PS & FM',
  },
  {
    Code: ' S792902',
    Description: 'Cayuga Farms PS',
  },
  {
    Code: ' S792903',
    Description: 'Cayuga Farms FM',
  },
  {
    Code: ' S792904',
    Description: 'Cayuga Farms Sewer Interceptor',
  },
  {
    Code: ' S792999',
    Description: 'Cayuga Farms PS & FM Conv',
  },
  {
    Code: ' S793500',
    Description: 'Tanyard Spring PS',
  },
  {
    Code: ' S793501',
    Description: 'Tanyard Spring PS',
  },
  {
    Code: ' S793599',
    Description: 'Tanyard Spring PS Conv',
  },
  {
    Code: ' S793800',
    Description: 'North County WRF',
  },
  {
    Code: ' S793801',
    Description: 'North County WRF',
  },
  {
    Code: ' S793899',
    Description: 'North County WRF Conv',
  },
  {
    Code: ' S797400',
    Description: 'Broadwater WRF Upgrade',
  },
  {
    Code: ' S797401',
    Description: 'Broadwater WRF Upgrade',
  },
  {
    Code: ' S797402',
    Description: 'Broadwater WRF Grit System',
  },
  {
    Code: ' S797900',
    Description: 'Broadneck WRF Holding Pond',
  },
  {
    Code: ' S797901',
    Description: 'Broadneck WRF Holding Pond',
  },
  {
    Code: ' S797902',
    Description: 'Broadneck WRF Improvements',
  },
  {
    Code: ' S798000',
    Description: 'Cox Creek WRF Clarifier Mod',
  },
  {
    Code: ' S798001',
    Description: 'Cox Creek WRF Clarifier Mod',
  },
  {
    Code: ' S798002',
    Description: 'Cox Creek WRF New Sec Clar.6',
  },
  {
    Code: ' S798100',
    Description: 'Wastewater Scada Upg',
  },
  {
    Code: ' S798101',
    Description: 'Wastewater Scada Upg',
  },
  {
    Code: ' S798200',
    Description: 'Annapolis Rd Sewer',
  },
  {
    Code: ' S798201',
    Description: 'Annapolis Rd Sewer',
  },
  {
    Code: ' S798300',
    Description: 'Sabrina Pk Sewer System',
  },
  {
    Code: ' S798301',
    Description: 'Sabrina Pk Sewer System',
  },
  {
    Code: ' S798500',
    Description: 'Skidmore Sewer Sys',
  },
  {
    Code: ' S798501',
    Description: 'Skidmore Sewer Sys',
  },
  {
    Code: ' S798600',
    Description: 'Sludge Dewtr Fac/Broadwtr WRF',
  },
  {
    Code: ' S798601',
    Description: 'Sludge Dewtr Fac/Broadwtr WRF',
  },
  {
    Code: ' S798700',
    Description: 'Broadneck WRF Renov',
  },
  {
    Code: ' S798701',
    Description: 'Broadneck WRF Addition',
  },
  {
    Code: ' S799000',
    Description: 'Ridgeview SPS & FM',
  },
  {
    Code: ' S799001',
    Description: 'Ridgeview SPS & FM',
  },
  {
    Code: ' S799100',
    Description: 'Pkwy Indust Pk Sewer Takeover',
  },
  {
    Code: ' S799101',
    Description: 'Pkwy Indust Pk Sewer Takeover',
  },
  {
    Code: ' S799200',
    Description: 'Mayo Collection Sys Upgrade',
  },
  {
    Code: ' S799201',
    Description: 'Mayo Collection Sys Upgrade',
  },
  {
    Code: ' S799300',
    Description: 'Whitehall Collection System',
  },
  {
    Code: ' S799301',
    Description: 'Whitehall Manor Sewer Ext.',
  },
  {
    Code: ' S888800',
    Description: 'SE Trans. for PY Clos Projects',
  },
  {
    Code: ' S888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' S888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' S999900',
    Description: 'Sewer Class Account',
  },
  {
    Code: ' S999901',
    Description: 'Sewer Class Account',
  },
  {
    Code: ' S999999',
    Description: 'Sewer Class Account Conv',
  },
  {
    Code: ' W733300',
    Description: 'Comp Oper Wtr Sys',
  },
  {
    Code: ' W733399',
    Description: 'Comp Oper Wtr Sys',
  },
  {
    Code: ' W741400',
    Description: 'Chg Against Wtr Clsd Projects',
  },
  {
    Code: ' W741401',
    Description: 'Chg Against Wtr Clsd Projects',
  },
  {
    Code: ' W741499',
    Description: 'Chg Against Wtr Clsd Proj Conv',
  },
  {
    Code: ' W744400',
    Description: 'Exist Well Redev/Repl',
  },
  {
    Code: ' W744401',
    Description: 'Maryland City & Broadneck SA',
  },
  {
    Code: ' W744402',
    Description: 'Design & Inspection',
  },
  {
    Code: ' W744403',
    Description: 'Severndale Wells 1 & 2',
  },
  {
    Code: ' W744404',
    Description: 'Dorsey Rd Wells 4R & 15R',
  },
  {
    Code: ' W744405',
    Description: 'Sawmill, Harundale, Glendale',
  },
  {
    Code: ' W744406',
    Description: 'Crofton Mdws, King Hts, Arnold',
  },
  {
    Code: ' W744407',
    Description: 'Dorsey Rd',
  },
  {
    Code: ' W744408',
    Description: 'Dorsey Well 2R',
  },
  {
    Code: ' W744409',
    Description: 'FY 90 Package 1',
  },
  {
    Code: ' W744410',
    Description: 'FY 90 Package 2',
  },
  {
    Code: ' W744411',
    Description: 'Herald Harbor 2&2, Arnold 1',
  },
  {
    Code: ' W744412',
    Description: 'Redevelop Gibson Isl 1 (Sonic)',
  },
  {
    Code: ' W744413',
    Description: 'Redev SD3,MV1&2,HD1&2AR2',
  },
  {
    Code: ' W744414',
    Description: 'Redev BC2,PD,CH,ER,GI3',
  },
  {
    Code: ' W744415',
    Description: 'Repl Gibson Island 1',
  },
  {
    Code: ' W744416',
    Description: 'Repl Quarterfield Rd',
  },
  {
    Code: ' W744417',
    Description: 'Broad Creek Well No. 4',
  },
  {
    Code: ' W744418',
    Description: 'BC1,BC3,TR,SR,DR13,SD4&5',
  },
  {
    Code: ' W744419',
    Description: 'Repl Dorsey Wells 1 & 3',
  },
  {
    Code: ' W744420',
    Description: 'Broad Creek Well No. 5',
  },
  {
    Code: ' W744421',
    Description: 'Glendale Well Remediation',
  },
  {
    Code: ' W744422',
    Description: 'Design & Inspection',
  },
  {
    Code: ' W744423',
    Description: 'Well Abandonment',
  },
  {
    Code: ' W744424',
    Description: 'Dorsey Well 18',
  },
  {
    Code: ' W744425',
    Description: 'Dorsey Well #18 Wellhouse',
  },
  {
    Code: ' W744426',
    Description: 'Crofton Meadows Well #3',
  },
  {
    Code: ' W744427',
    Description: 'Dorsey Well #19',
  },
  {
    Code: ' W744428',
    Description: 'Broad Creek Well #2',
  },
  {
    Code: ' W744429',
    Description: 'Dorsey Well #17',
  },
  {
    Code: ' W744430',
    Description: 'Well Testing',
  },
  {
    Code: ' W744431',
    Description: 'Dorsey Well #20',
  },
  {
    Code: ' W744432',
    Description: 'Redevelopment of 3 Wells',
  },
  {
    Code: ' W744433',
    Description: 'Dorsey Well House #20',
  },
  {
    Code: ' W744434',
    Description: 'Crofton Monitoring Wells',
  },
  {
    Code: ' W744435',
    Description: 'Exist Well Redv/Rpl-Crain Hwy',
  },
  {
    Code: ' W744436',
    Description: 'Well Test/Rpr-Arnold Well #3',
  },
  {
    Code: ' W744437',
    Description: 'Redev. of Severndale Well #3',
  },
  {
    Code: ' W744499',
    Description: 'Exist Well Redev/Repl Conv',
  },
  {
    Code: ' W744800',
    Description: 'Arnold Serv Area Mods',
  },
  {
    Code: ' W744801',
    Description: 'Arnold S A Mods-Tank Raising',
  },
  {
    Code: ' W744802',
    Description: 'Arnold S A Mods-Study',
  },
  {
    Code: ' W744803',
    Description: 'Arnold Tank Raising',
  },
  {
    Code: ' W744899',
    Description: 'Arnold Serv Area Mods Conv',
  },
  {
    Code: ' W748300',
    Description: 'Wtr Fac Upgrd FMEWSA',
  },
  {
    Code: ' W748399',
    Description: 'Wtr Fac Upgrd FMEWSA',
  },
  {
    Code: ' W751000',
    Description: 'Gov Ritchie TM (Lwr)',
  },
  {
    Code: ' W751001',
    Description: 'Gov Ritchie TM',
  },
  {
    Code: ' W751099',
    Description: 'Gov Ritchie TM Conv',
  },
  {
    Code: ' W753400',
    Description: 'Demo Abandoned Facilities',
  },
  {
    Code: ' W753401',
    Description: 'Demo Abandoned Fac-Ph 2',
  },
  {
    Code: ' W753402',
    Description: 'Demo Abandoned Fac-Ph 3',
  },
  {
    Code: ' W753403',
    Description: 'Demo Abandoned Fac-Ph 4',
  },
  {
    Code: ' W753404',
    Description: 'Demo Abandoned Fac-Ph 5',
  },
  {
    Code: ' W753499',
    Description: 'Demo Abandoned Fac Conv',
  },
  {
    Code: ' W753700',
    Description: "Solomon's Island Rd T/L",
  },
  {
    Code: ' W753701',
    Description: "Solomon's Island Rd T/L-Ph 1",
  },
  {
    Code: ' W753702',
    Description: "Solomon's Island Rd T/L-Ph 2",
  },
  {
    Code: ' W753799',
    Description: "Solomon's Island Rd T/L Conv",
  },
  {
    Code: ' W757500',
    Description: 'Rose Haven Wtr Dis Syst.',
  },
  {
    Code: ' W757501',
    Description: 'Rose Haven Wtr Dis Syst.',
  },
  {
    Code: ' W757502',
    Description: 'Rose Haven Storage & Treatment',
  },
  {
    Code: ' W757599',
    Description: 'Rose Haven Wtr Dis Syst. Conv',
  },
  {
    Code: ' W757600',
    Description: 'Crain Hwy Tie Line',
  },
  {
    Code: ' W757601',
    Description: 'Crain Hwy Tie Line',
  },
  {
    Code: ' W757699',
    Description: 'Crain Hwy Tie Line Conv',
  },
  {
    Code: ' W761100',
    Description: 'Ordnance Road BPS/TM',
  },
  {
    Code: ' W761101',
    Description: 'Ordnance Road BPS/TM',
  },
  {
    Code: ' W761199',
    Description: 'Ordnance Road BPS/TM Conv',
  },
  {
    Code: ' W761200',
    Description: 'Arnold WTP Expansion',
  },
  {
    Code: ' W761201',
    Description: 'Arnold WTP Expansion',
  },
  {
    Code: ' W761202',
    Description: 'Arnold WTP Facility Repair',
  },
  {
    Code: ' W761203',
    Description: 'Arnold WTP Leak Repairs',
  },
  {
    Code: ' W761204',
    Description: 'Arnold WTP Elec/Mech/Struc Rep',
  },
  {
    Code: ' W761299',
    Description: 'Arnold WTP Expansion',
  },
  {
    Code: ' W765400',
    Description: 'B&A Blvd Trans Main',
  },
  {
    Code: ' W765499',
    Description: 'B&A Blvd Trans Main',
  },
  {
    Code: ' W765500',
    Description: 'Nursery Rd Elevated Tank',
  },
  {
    Code: ' W765501',
    Description: 'North Zone Elevated Tank',
  },
  {
    Code: ' W765502',
    Description: 'North Zone Transmission Main',
  },
  {
    Code: ' W765599',
    Description: 'Nursery Rd Elevated Tank Conv',
  },
  {
    Code: ' W765600',
    Description: 'TM Reidel Rd/Wgh Chp',
  },
  {
    Code: ' W765699',
    Description: 'TM Reidel Rd/Wgh Chp',
  },
  {
    Code: ' W765700',
    Description: 'TM Waugh Chapel/Chapelgate',
  },
  {
    Code: ' W765799',
    Description: 'TM Waugh Chapel/Chapelgate',
  },
  {
    Code: ' W777500',
    Description: 'TM Meade Vill-GB High P Zone',
  },
  {
    Code: ' W777501',
    Description: 'TM Meade Vill-GB High P Zone',
  },
  {
    Code: ' W777599',
    Description: 'TM Meade Vil-GB High P Zn Conv',
  },
  {
    Code: ' W777600',
    Description: 'Gibson Island WTP Upgr',
  },
  {
    Code: ' W777601',
    Description: 'Gibson Island WTP Upgr',
  },
  {
    Code: ' W777699',
    Description: 'Gibson Island WTP Upgr Conv',
  },
  {
    Code: ' W777800',
    Description: 'TM Ritchie To Magothy Brdg',
  },
  {
    Code: ' W777801',
    Description: 'TM Ritchie To Magothy Brdg',
  },
  {
    Code: ' W777899',
    Description: 'TM Ritchie To Magothy Br Conv',
  },
  {
    Code: ' W777900',
    Description: 'TM Severndale To Ritchie',
  },
  {
    Code: ' W777901',
    Description: 'TM Severndale To Ritchie',
  },
  {
    Code: ' W777999',
    Description: 'TM Severndale To Ritchie Conv',
  },
  {
    Code: ' W778000',
    Description: 'TM Ritchie Hwy to Mountain Rd',
  },
  {
    Code: ' W778001',
    Description: 'TM Ritchie Hwy to Mountain Rd',
  },
  {
    Code: ' W778099',
    Description: 'TM Ritchie Hwy to Mt. Rd Conv',
  },
  {
    Code: ' W778200',
    Description: 'TM Severna Pk to Elvaton Rd',
  },
  {
    Code: ' W778201',
    Description: 'TM Severna Pk to Elvaton Rd',
  },
  {
    Code: ' W778299',
    Description: 'TM Severna Pk-Elvaton Rd Conv',
  },
  {
    Code: ' W778300',
    Description: 'TM Arnold WTP to Ritchie Hwy',
  },
  {
    Code: ' W778301',
    Description: 'TM Arnold WTP to Ritchie Hwy',
  },
  {
    Code: ' W778399',
    Description: 'TM Arnold WTP Ritchie Hwy Conv',
  },
  {
    Code: ' W778400',
    Description: 'TM Odenton to GB High P Zone',
  },
  {
    Code: ' W778401',
    Description: 'TM Odenton to GB High P Zone',
  },
  {
    Code: ' W778402',
    Description: 'TM Odenton/GBH-Chapelgate',
  },
  {
    Code: ' W778403',
    Description: 'TM Meade BPS to Mapes Road',
  },
  {
    Code: ' W778499',
    Description: 'TM Odenton-GB High P Zn Conv',
  },
  {
    Code: ' W778600',
    Description: 'Crofton Meadows II WTP Upgr',
  },
  {
    Code: ' W778601',
    Description: 'Crofton Meadows II WTP Upgr',
  },
  {
    Code: ' W778602',
    Description: 'Crofton Meadows II WTP 10&11',
  },
  {
    Code: ' W778700',
    Description: 'Central Wtr Facility Ph II',
  },
  {
    Code: ' W778701',
    Description: 'Central Wtr Facility Ph II',
  },
  {
    Code: ' W778799',
    Description: 'Central Wtr Facility Ph II Con',
  },
  {
    Code: ' W778800',
    Description: 'Water Strategic Plan',
  },
  {
    Code: ' W778801',
    Description: 'Water Strategic Plan',
  },
  {
    Code: ' W778899',
    Description: 'Water Strategic Plan Conv',
  },
  {
    Code: ' W782900',
    Description: 'Brooklyn Pk Wtr Sys Rehab',
  },
  {
    Code: ' W782901',
    Description: 'Brooklyn Pk Wtr Sys Rehab',
  },
  {
    Code: ' W782902',
    Description: 'Brooklyn Pk-Clean & Line',
  },
  {
    Code: ' W782903',
    Description: 'Brooklyn Pk-Clean & Line FY02',
  },
  {
    Code: ' W782999',
    Description: 'Brooklyn Pk Wtr Sys Rehab Conv',
  },
  {
    Code: ' W783000',
    Description: 'Cape St Claire Rd TM',
  },
  {
    Code: ' W783001',
    Description: 'Cape St Claire Rd TM',
  },
  {
    Code: ' W783099',
    Description: 'Cape St Claire Rd TM Conv',
  },
  {
    Code: ' W783100',
    Description: 'East Howard Wtr Ext',
  },
  {
    Code: ' W783199',
    Description: 'East Howard Wtr Ext',
  },
  {
    Code: ' W783200',
    Description: 'Nabbs Creek Water Ext',
  },
  {
    Code: ' W783201',
    Description: 'Nabbs Creek Water Ext',
  },
  {
    Code: ' W783299',
    Description: 'Nabbs Creek Water Ext Conv',
  },
  {
    Code: ' W783300',
    Description: 'Laurel Heights Water',
  },
  {
    Code: ' W783301',
    Description: 'Laurel Heights Water',
  },
  {
    Code: ' W783399',
    Description: 'Laurel Heights Water Conv',
  },
  {
    Code: ' W787700',
    Description: 'East/West Blvd Ph II Water',
  },
  {
    Code: ' W787701',
    Description: 'East/West Blvd Ph II Water',
  },
  {
    Code: ' W787799',
    Description: 'East/West Blvd Ph II Water Con',
  },
  {
    Code: ' W787800',
    Description: 'Fire Hydrant Rehab',
  },
  {
    Code: ' W787801',
    Description: 'Fire Hydrant Rehab',
  },
  {
    Code: ' W787802',
    Description: 'Fire Hydrant Rehab Ph II',
  },
  {
    Code: ' W787803',
    Description: 'Fire Hydrant Rehab Ph III',
  },
  {
    Code: ' W787804',
    Description: 'Fire Hydrant Rehab Ph IV',
  },
  {
    Code: ' W787805',
    Description: 'Fire Hydrant Rehab Ph V',
  },
  {
    Code: ' W787806',
    Description: 'Fire Hydrant Rehab Ph VI',
  },
  {
    Code: ' W787899',
    Description: 'Fire Hydrant Rehab Conv',
  },
  {
    Code: ' W787900',
    Description: 'Ft Meade Wtr System T/O',
  },
  {
    Code: ' W787901',
    Description: 'Ft Meade Wtr System T/O',
  },
  {
    Code: ' W787999',
    Description: 'Ft Meade Wtr System T/O Conv',
  },
  {
    Code: ' W788300',
    Description: 'Millersville BPS',
  },
  {
    Code: ' W788301',
    Description: 'Millersville BPS',
  },
  {
    Code: ' W788399',
    Description: 'Millersville BPS Conv',
  },
  {
    Code: ' W793000',
    Description: 'Herald Harbor WTP Upgr',
  },
  {
    Code: ' W793001',
    Description: 'Herald Harbor WTP Upgr',
  },
  {
    Code: ' W793099',
    Description: 'Herald Harbor WTP Upgr Conv',
  },
  {
    Code: ' W793200',
    Description: 'TM Meade to Jessup',
  },
  {
    Code: ' W793201',
    Description: 'TM Meade to Jessup',
  },
  {
    Code: ' W793202',
    Description: 'TM Wtr Ext-Jessup to Ft Meade',
  },
  {
    Code: ' W793299',
    Description: 'TM Meade to Jessup Conv',
  },
  {
    Code: ' W793300',
    Description: 'TM Charter Oaks to Meade',
  },
  {
    Code: ' W793301',
    Description: 'TM Charter Oaks to Meade',
  },
  {
    Code: ' W793399',
    Description: 'TM Charter Oaks to Meade Conv',
  },
  {
    Code: ' W793400',
    Description: 'Ft Meade Booster Sta',
  },
  {
    Code: ' W793401',
    Description: 'Ft Meade Booster Sta',
  },
  {
    Code: ' W793499',
    Description: 'Ft Meade Booster Sta Conv',
  },
  {
    Code: ' W793700',
    Description: 'Science Park Rd TM',
  },
  {
    Code: ' W793701',
    Description: 'Science Park Rd TM',
  },
  {
    Code: ' W793799',
    Description: 'Science Park Rd TM Conv',
  },
  {
    Code: ' W797500',
    Description: 'Standby Wells',
  },
  {
    Code: ' W797501',
    Description: 'Standby Wells',
  },
  {
    Code: ' W797600',
    Description: 'Independent Well Upgrd',
  },
  {
    Code: ' W797601',
    Description: 'Independent Well Upgrd',
  },
  {
    Code: ' W797602',
    Description: 'IWU-Glendale R O System',
  },
  {
    Code: ' W797603',
    Description: 'IWU-Crain Hwy',
  },
  {
    Code: ' W797604',
    Description: 'IWU-Phillip Drive',
  },
  {
    Code: ' W797605',
    Description: 'IWU-Quarterfield Rd.',
  },
  {
    Code: ' W797606',
    Description: 'IWU-Crain Highway Well #2',
  },
  {
    Code: ' W797700',
    Description: 'Hillen PS and TMS',
  },
  {
    Code: ' W797701',
    Description: 'Hillen PS and TMS',
  },
  {
    Code: ' W798400',
    Description: 'Ritchie Hwy at Furnace Rd WM',
  },
  {
    Code: ' W798401',
    Description: 'Ritchie Hwy at Furnace Rd WM',
  },
  {
    Code: ' W799400',
    Description: 'Severndale WTP Upgrade PH III',
  },
  {
    Code: ' W799401',
    Description: 'Severndale WTP Upgrade PH III',
  },
  {
    Code: ' W799500',
    Description: 'Dorsey Rd WTP Upgrade Ph IV',
  },
  {
    Code: ' W799501',
    Description: 'Dorsey Rd WTP Upgrade Ph IV',
  },
  {
    Code: ' W799600',
    Description: 'Elevated Water Storage',
  },
  {
    Code: ' W799601',
    Description: 'Elevated Water Storage',
  },
  {
    Code: ' W888800',
    Description: 'WA Trans. for PY Clos Projects',
  },
  {
    Code: ' W888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' W888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' W999900',
    Description: 'Water Class Account',
  },
  {
    Code: ' W999901',
    Description: 'Water Class Account',
  },
  {
    Code: ' W999999',
    Description: 'Water Class Account Conv',
  },
  {
    Code: ' X733700',
    Description: 'Water Main Repl/Recon',
  },
  {
    Code: ' X733701',
    Description: '2" Main Replacement 98',
  },
  {
    Code: ' X733702',
    Description: 'Clean & Line 98',
  },
  {
    Code: ' X733703',
    Description: 'Water Service Repl 98',
  },
  {
    Code: ' X733704',
    Description: 'Water Model Calibration 98',
  },
  {
    Code: ' X733705',
    Description: 'Water Meter Replacement 98',
  },
  {
    Code: ' X733706',
    Description: 'Water Main Repl CM Serv 98',
  },
  {
    Code: ' X733707',
    Description: 'Pitometer C-Factor Testing 98',
  },
  {
    Code: ' X733708',
    Description: 'Water Meter Replacement 99',
  },
  {
    Code: ' X733709',
    Description: 'Water Main Repl CM Serv 99',
  },
  {
    Code: ' X733710',
    Description: 'Clean & Line 99',
  },
  {
    Code: ' X733711',
    Description: '2" Main Replacement 99',
  },
  {
    Code: ' X733712',
    Description: 'Pitometer C-Factor Testing 99',
  },
  {
    Code: ' X733713',
    Description: 'Water Service Repl 99',
  },
  {
    Code: ' X733714',
    Description: 'Water Model Calibration 99',
  },
  {
    Code: ' X733715',
    Description: 'Water Model Calibration 97',
  },
  {
    Code: ' X733716',
    Description: '2" Main Replacement 97',
  },
  {
    Code: ' X733717',
    Description: 'Wtr Meter Purchasse/Repl 97',
  },
  {
    Code: ' X733718',
    Description: 'Clean & Line 97',
  },
  {
    Code: ' X733719',
    Description: 'Water Service Repl 97',
  },
  {
    Code: ' X733720',
    Description: 'Wtr Mn Repl Proj C/M 97',
  },
  {
    Code: ' X733721',
    Description: 'Water Model Calibration OO',
  },
  {
    Code: ' X733722',
    Description: 'Water Meter Replacement OO',
  },
  {
    Code: ' X733723',
    Description: 'Water Main Repl CM Serv OO',
  },
  {
    Code: ' X733724',
    Description: 'Clean & Line OO',
  },
  {
    Code: ' X733725',
    Description: '2" Main Replacement OO',
  },
  {
    Code: ' X733726',
    Description: 'Pitometer C-Factor Testing OO',
  },
  {
    Code: ' X733727',
    Description: 'Water Service Repl OO',
  },
  {
    Code: ' X733728',
    Description: '209th St Water Connection',
  },
  {
    Code: ' X733729',
    Description: 'Operations Water Serv Repl',
  },
  {
    Code: ' X733730',
    Description: 'Press Incr-Resid NE MD32/Odntn',
  },
  {
    Code: ' X733731',
    Description: 'Clean & Line O2',
  },
  {
    Code: ' X733732',
    Description: '2" Main Replacement O2',
  },
  {
    Code: ' X733733',
    Description: 'Water Service Repl O2',
  },
  {
    Code: ' X733734',
    Description: 'Water C-Factor Testing 02',
  },
  {
    Code: ' X733735',
    Description: 'Water Model Calibration 02',
  },
  {
    Code: ' X733736',
    Description: 'Water Meter Replacement 02',
  },
  {
    Code: ' X733737',
    Description: 'Water Main Repl CM Serv 02',
  },
  {
    Code: ' X733738',
    Description: 'Clean & Line 03',
  },
  {
    Code: ' X733739',
    Description: 'Gibson Island Clean & Line 03',
  },
  {
    Code: ' X733740',
    Description: '2" Main Replacement 03',
  },
  {
    Code: ' X733741',
    Description: 'Water Service Repl. 03',
  },
  {
    Code: ' X733742',
    Description: 'Water Model Calibration 03',
  },
  {
    Code: ' X733743',
    Description: 'Water Meter Replacement 03',
  },
  {
    Code: ' X733744',
    Description: 'Water Main Repl CM Serv 03',
  },
  {
    Code: ' X733745',
    Description: 'Water C-Factor Testing 03',
  },
  {
    Code: ' X733746',
    Description: 'West Nursery Road WM',
  },
  {
    Code: ' X733799',
    Description: 'Water Main Repl/Recon Conv',
  },
  {
    Code: ' X738800',
    Description: 'Sewer Main Repl/Recon',
  },
  {
    Code: ' X738801',
    Description: "Sewer Service Lat'l Repl 97",
  },
  {
    Code: ' X738802',
    Description: 'Line Replacement 97',
  },
  {
    Code: ' X738803',
    Description: 'R-O-W Clearing 97',
  },
  {
    Code: ' X738804',
    Description: 'Towsers Branch Swr Crossing',
  },
  {
    Code: ' X738805',
    Description: 'R-O-W Clearing 98 Ph-1',
  },
  {
    Code: ' X738806',
    Description: 'R-O-W Clearing 98 Ph-2',
  },
  {
    Code: ' X738807',
    Description: 'Forest Dr F/M',
  },
  {
    Code: ' X738808',
    Description: 'Sewer Main Relining 98',
  },
  {
    Code: ' X738809',
    Description: 'Mini Sys Rehab 98',
  },
  {
    Code: ' X738810',
    Description: 'Manhole Frame & Cover Repl 98',
  },
  {
    Code: ' X738811',
    Description: 'Broadneck Trunk Relining',
  },
  {
    Code: ' X738812',
    Description: 'Permanent Flow Monitoring 98',
  },
  {
    Code: ' X738813',
    Description: 'Rd Resurf Manhole F&C Adj 98',
  },
  {
    Code: ' X738814',
    Description: 'Sewer Main Repl CM Serv 98',
  },
  {
    Code: ' X738815',
    Description: 'Sewer Model Calibration 98',
  },
  {
    Code: ' X738816',
    Description: '42" Cross Country FM Eval',
  },
  {
    Code: ' X738817',
    Description: 'Furnance Branch Sewer Repl',
  },
  {
    Code: ' X738818',
    Description: 'Sewer Main Repl CM Serv 99',
  },
  {
    Code: ' X738819',
    Description: 'Sewer Main Relining 99',
  },
  {
    Code: ' X738820',
    Description: 'Mini Sys Rehab 99',
  },
  {
    Code: ' X738821',
    Description: 'Greenwood St. Relining (Emerg)',
  },
  {
    Code: ' X738822',
    Description: 'County Force Main Investigatio',
  },
  {
    Code: ' X738823',
    Description: 'Permanent Flow Monitoring 99',
  },
  {
    Code: ' X738824',
    Description: "Sewer Service Lat'l Repl 99",
  },
  {
    Code: ' X738825',
    Description: 'Manhole Frame & Cover Repl 99',
  },
  {
    Code: ' X738826',
    Description: 'Rd Resurf Manhole F&C Adj 99',
  },
  {
    Code: ' X738827',
    Description: 'Sewer Model Calibration 99',
  },
  {
    Code: ' X738828',
    Description: 'Swr Main Relining Glen Burnie',
  },
  {
    Code: ' X738829',
    Description: 'Permanent Flow Monitoring 97',
  },
  {
    Code: ' X738830',
    Description: 'Swr Proj Inspection 97',
  },
  {
    Code: ' X738831',
    Description: 'Swr Model Calibration 97',
  },
  {
    Code: ' X738832',
    Description: 'Rd Resurf/Manhole Frame 97',
  },
  {
    Code: ' X738833',
    Description: 'Manhole Frame & Cover Repl 97',
  },
  {
    Code: ' X738834',
    Description: 'G B Townctr Swr Mn Repl',
  },
  {
    Code: ' X738835',
    Description: 'Hammond Land Emrg Swr Repair',
  },
  {
    Code: ' X738836',
    Description: 'R/W Clearing FY 99, Ph.I',
  },
  {
    Code: ' X738837',
    Description: 'R/W Clearing FY 99, Ph.II',
  },
  {
    Code: ' X738838',
    Description: 'Forest Dr F/M Slip Lining',
  },
  {
    Code: ' X738839',
    Description: 'Sewer Main Repl CM Serv OO',
  },
  {
    Code: ' X738840',
    Description: 'Sewer Main Relining OO',
  },
  {
    Code: ' X738841',
    Description: 'Mini Sys Rehab OO',
  },
  {
    Code: ' X738842',
    Description: 'Permanent Flow Monitoring OO',
  },
  {
    Code: ' X738843',
    Description: "Sewer Service Lat'l Repl OO",
  },
  {
    Code: ' X738844',
    Description: 'Manhole Frame & Cover Repl OO',
  },
  {
    Code: ' X738845',
    Description: 'Rd Resurf Manhole F&C Adj OO',
  },
  {
    Code: ' X738846',
    Description: 'Sewer Model Calibration OO',
  },
  {
    Code: ' X738847',
    Description: '209th St Sewer Connection',
  },
  {
    Code: ' X738848',
    Description: 'Loch Haven Woods Parallel FM',
  },
  {
    Code: ' X738849',
    Description: 'Lincoln Ct Sewer Main (FY 00)',
  },
  {
    Code: ' X738850',
    Description: 'Kingwood Rd Swr Relining 00',
  },
  {
    Code: ' X738851',
    Description: 'R/W Clearing FY 01',
  },
  {
    Code: ' X738852',
    Description: 'Mini System Rehab FY 01',
  },
  {
    Code: ' X738853',
    Description: 'Manhole Frame & Cover Repl 01',
  },
  {
    Code: ' X738854',
    Description: 'Odenton Collector Relining',
  },
  {
    Code: ' X738855',
    Description: "Sewer Service Lat'l Repl O1",
  },
  {
    Code: ' X738856',
    Description: 'Sewer Main Relining FY O1',
  },
  {
    Code: ' X738857',
    Description: 'Elvaton Tributary Stabil.',
  },
  {
    Code: ' X738858',
    Description: 'Sewer Model Calibration 01',
  },
  {
    Code: ' X738859',
    Description: 'Solley Rd Force Main Rehab',
  },
  {
    Code: ' X738860',
    Description: 'Sanitary Sewer System CMOM',
  },
  {
    Code: ' X738861',
    Description: 'Sewer Model Calibration 02',
  },
  {
    Code: ' X738862',
    Description: 'Sewer Main Repl CM Serv 03',
  },
  {
    Code: ' X738863',
    Description: 'Rd Resurf Manhole Frm Adj 03',
  },
  {
    Code: ' X738864',
    Description: 'Sewer Main Relining 03',
  },
  {
    Code: ' X738865',
    Description: 'Permanent Flow Monitoring 03',
  },
  {
    Code: ' X738866',
    Description: 'Sewer Service Lateral Repl 03',
  },
  {
    Code: ' X738867',
    Description: 'Manhole Frame & Cover Repl 03',
  },
  {
    Code: ' X738868',
    Description: 'Sewer Model Calibration 03',
  },
  {
    Code: ' X738869',
    Description: 'R-O-W Clearing 03',
  },
  {
    Code: ' X738870',
    Description: 'Mini System Rehab 03',
  },
  {
    Code: ' X738899',
    Description: 'Sewer Main Repl/Recon Conv',
  },
  {
    Code: ' X741200',
    Description: 'WW Service Connections',
  },
  {
    Code: ' X741201',
    Description: 'WW Service Connections',
  },
  {
    Code: ' X741202',
    Description: 'WW Serv Conn Closeout FY 98',
  },
  {
    Code: ' X741203',
    Description: 'WW Serv Conn FY 00',
  },
  {
    Code: ' X741204',
    Description: 'WW Serv Conn FY 01',
  },
  {
    Code: ' X741205',
    Description: 'WW Serv Conn FY 02',
  },
  {
    Code: ' X741206',
    Description: 'WW Serv Conn FY 03',
  },
  {
    Code: ' X741299',
    Description: 'WW Service Connections Conv',
  },
  {
    Code: ' X742400',
    Description: 'Water Service Connections',
  },
  {
    Code: ' X742401',
    Description: 'Water Service Connections',
  },
  {
    Code: ' X742402',
    Description: 'Water Srv Conn Closeout FY 98',
  },
  {
    Code: ' X742403',
    Description: 'Water Serv Conn FY 00',
  },
  {
    Code: ' X742404',
    Description: 'Water Serv Conn FY 01',
  },
  {
    Code: ' X742405',
    Description: 'Water Serv Conn FY 02',
  },
  {
    Code: ' X742406',
    Description: 'Water Serv Conn FY 03',
  },
  {
    Code: ' X742499',
    Description: 'Water Service Connections Conv',
  },
  {
    Code: ' X749000',
    Description: 'Agreements W/Developers',
  },
  {
    Code: ' X749001',
    Description: 'Remote Monitoring - Develprs',
  },
  {
    Code: ' X749002',
    Description: 'TV Inspection UA Agmts',
  },
  {
    Code: ' X749003',
    Description: 'TV Inspection UA Agreements 97',
  },
  {
    Code: ' X749004',
    Description: 'TV Inspection UA Agmts FY 00',
  },
  {
    Code: ' X749005',
    Description: 'TV Inspect UA Agmts FY 01/02',
  },
  {
    Code: ' X749006',
    Description: 'TV Inspection UA Agmts FY 03',
  },
  {
    Code: ' X749099',
    Description: 'Agreements W/Developers Conv',
  },
  {
    Code: ' X764200',
    Description: 'WW Project Planning',
  },
  {
    Code: ' X764201',
    Description: 'Mayo WRF Misc Upgr',
  },
  {
    Code: ' X764202',
    Description: 'Mayo WRF Outfall Investigation',
  },
  {
    Code: ' X764203',
    Description: 'Mayo WRF RSF #1',
  },
  {
    Code: ' X764204',
    Description: 'Central Septage Rec Fac Stdy',
  },
  {
    Code: ' X764205',
    Description: 'Future WW Scada Needs',
  },
  {
    Code: ' X764206',
    Description: 'D South River WW Col Study',
  },
  {
    Code: ' X764207',
    Description: 'Woodland Bch SPS Upgrd',
  },
  {
    Code: ' X764208',
    Description: 'Broadneck WRF Rerate Study',
  },
  {
    Code: ' X764209',
    Description: 'Broadneck WRF Op. Bldg.',
  },
  {
    Code: ' X764210',
    Description: 'Jennifer Rd. SPS-FM Repl.',
  },
  {
    Code: ' X764211',
    Description: 'WWPP-Ft. Meade Privatization',
  },
  {
    Code: ' X764299',
    Description: 'WW Project Planning Conv',
  },
  {
    Code: ' X764300',
    Description: 'Water Proj Planning',
  },
  {
    Code: ' X764301',
    Description: 'TM S. Elvaton Dr to Jumpers',
  },
  {
    Code: ' X764302',
    Description: 'East-West Blvd Ph-3 Water',
  },
  {
    Code: ' X764303',
    Description: 'Millersville LDF Regional Fire',
  },
  {
    Code: ' X764304',
    Description: 'Future Wtr Scada Needs',
  },
  {
    Code: ' X764305',
    Description: 'Cape St. Claire Water Study',
  },
  {
    Code: ' X764306',
    Description: 'MD 175 & Ridge Rd Water Study',
  },
  {
    Code: ' X764307',
    Description: 'WPP-Arnold WTP Booster Stn.',
  },
  {
    Code: ' X764308',
    Description: 'WPP-Ft. Meade Privatization',
  },
  {
    Code: ' X764309',
    Description: 'TM Meade to Jessup',
  },
  {
    Code: ' X764310',
    Description: 'WWP - Rte 170 Control Vault',
  },
  {
    Code: ' X764399',
    Description: 'Water Proj Planning Conv',
  },
  {
    Code: ' X787000',
    Description: 'Water Storage Tank Painting',
  },
  {
    Code: ' X787001',
    Description: 'Crain Hwy Tank',
  },
  {
    Code: ' X787002',
    Description: 'Amberly Tank Painting',
  },
  {
    Code: ' X787003',
    Description: 'Arnold Tank Painting',
  },
  {
    Code: ' X787004',
    Description: 'Belvedere Stand Pipe Painting',
  },
  {
    Code: ' X787005',
    Description: 'Crofton Meadows Tank Painting',
  },
  {
    Code: ' X787006',
    Description: 'Herald Harbor Tank Painting',
  },
  {
    Code: ' X787007',
    Description: 'Pasadena Tank Painting',
  },
  {
    Code: ' X787008',
    Description: 'Broad Ck Wtr Storg Tk Paint',
  },
  {
    Code: ' X787009',
    Description: 'King Hts Water Storg Tk Paint',
  },
  {
    Code: ' X787010',
    Description: 'Crain Hwy Tk Paint',
  },
  {
    Code: ' X787011',
    Description: 'Amberly Tk Paint',
  },
  {
    Code: ' X787012',
    Description: 'Linthicum Tank Painting',
  },
  {
    Code: ' X787013',
    Description: 'Belvedere StandPipe Paint 01',
  },
  {
    Code: ' X787014',
    Description: 'Jessup WS Tank Painting',
  },
  {
    Code: ' X787015',
    Description: 'Jacobsville WS Tank Painting',
  },
  {
    Code: ' X787016',
    Description: 'EWT Antenna/Misc. Work',
  },
  {
    Code: ' X787097',
    Description: 'Water Storage Tank Painting 97',
  },
  {
    Code: ' X787098',
    Description: 'Water Storage Tank Painting 98',
  },
  {
    Code: ' X787099',
    Description: 'Wtr Storage Tank Painting Conv',
  },
  {
    Code: ' X800000',
    Description: 'State Hwy Reloc-Sewer',
  },
  {
    Code: ' X800001',
    Description: 'State Hwy Reloc-Sewer',
  },
  {
    Code: ' X800002',
    Description: 'State Hwy Reloc-Sewer FY 01',
  },
  {
    Code: ' X800003',
    Description: 'State Hwy Reloc-Sewer FY 03',
  },
  {
    Code: ' X800099',
    Description: 'State Hwy Reloc-Sewer Conv',
  },
  {
    Code: ' X800100',
    Description: 'State Hwy Reloc-Water',
  },
  {
    Code: ' X800101',
    Description: 'State Hwy Reloc-Water',
  },
  {
    Code: ' X800102',
    Description: 'State Hwy Reloc-Water FY 01',
  },
  {
    Code: ' X800103',
    Description: 'State Hwy Reloc-Water FY 03',
  },
  {
    Code: ' X800199',
    Description: 'State Hwy Reloc-Water Conv',
  },
  {
    Code: ' X888800',
    Description: 'OT Trans. for PY Clos Projects',
  },
  {
    Code: ' X888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' X888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' X999900',
    Description: 'Other Class Account',
  },
  {
    Code: ' X999901',
    Description: 'Other Class Account',
  },
  {
    Code: ' X999999',
    Description: 'Other Class Account Conv',
  },
  {
    Code: ' Y514200',
    Description: 'Routine Water Extensions',
  },
  {
    Code: ' Y514201',
    Description: 'Parker Ave Wtr Ext',
  },
  {
    Code: ' Y514202',
    Description: 'Ritchie Hwy Wtr Serv Ext',
  },
  {
    Code: ' Y514203',
    Description: '210th St Water Ext',
  },
  {
    Code: ' Y514204',
    Description: 'Race Rd Water Ext',
  },
  {
    Code: ' Y514205',
    Description: 'Holly Ridge Rd Wtr Ext',
  },
  {
    Code: ' Y514206',
    Description: 'Galloway Rd Water Ext',
  },
  {
    Code: ' Y514207',
    Description: 'D Taylor Research Water Ln',
  },
  {
    Code: ' Y514208',
    Description: 'Dreams Landing Water Ext',
  },
  {
    Code: ' Y514209',
    Description: 'Kellington Drive Wtr Ext',
  },
  {
    Code: ' Y514210',
    Description: 'Midway Water Takeover',
  },
  {
    Code: ' Y514211',
    Description: 'Seabright Dr. Wtr Ext.',
  },
  {
    Code: ' Y514212',
    Description: 'Annapolis Rd-Odenton Wtr Ext',
  },
  {
    Code: ' Y514213',
    Description: 'Browns Pond Water Ext',
  },
  {
    Code: ' Y514214',
    Description: 'Tower Bank Rd Water Ext',
  },
  {
    Code: ' Y514215',
    Description: 'Woodland Circle Water Ext',
  },
  {
    Code: ' Y514216',
    Description: 'Parrish Props (B&A Blvd) W Ext',
  },
  {
    Code: ' Y514217',
    Description: 'Woodlawn Heights Water Ext',
  },
  {
    Code: ' Y514218',
    Description: 'Wilson St Water Ext',
  },
  {
    Code: ' Y514219',
    Description: 'Andorick Ave Wtr Petition SDR',
  },
  {
    Code: ' Y514220',
    Description: 'Pine Hill/Mt. Pleasant Drives',
  },
  {
    Code: ' Y514221',
    Description: 'WM Connect. Rt2/Adm.Cochran',
  },
  {
    Code: ' Y514222',
    Description: 'Spencer Road Water Extension',
  },
  {
    Code: ' Y514223',
    Description: 'Ridgefield Water Main Ext',
  },
  {
    Code: ' Y514224',
    Description: 'Gibson Is/Magothy Rd Wtr Ext',
  },
  {
    Code: ' Y514225',
    Description: 'Well Vault Demolitions',
  },
  {
    Code: ' Y514226',
    Description: 'Saltzman Road Water Extension',
  },
  {
    Code: ' Y514299',
    Description: 'Routine Water Extensions Conv',
  },
  {
    Code: ' Y888800',
    Description: 'WE Trans. for PY Clos Projects',
  },
  {
    Code: ' Y888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' Y888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' Y999900',
    Description: 'Wtr Ext Class Account',
  },
  {
    Code: ' Y999901',
    Description: 'Wtr Ext Class Account',
  },
  {
    Code: ' Y999999',
    Description: 'Wtr Ext Class Account Conv',
  },
  {
    Code: ' Z533200',
    Description: 'Routine Sewer Extensions',
  },
  {
    Code: ' Z533201',
    Description: '210th St. Swr Ext',
  },
  {
    Code: ' Z533202',
    Description: 'Race Road Swr Ext',
  },
  {
    Code: ' Z533203',
    Description: 'Earleigh Hts Swr Ext',
  },
  {
    Code: ' Z533204',
    Description: 'Sylmac Swr Ext.',
  },
  {
    Code: ' Z533205',
    Description: 'Skidmore Dr S',
  },
  {
    Code: ' Z533206',
    Description: 'Annapolis Rd',
  },
  {
    Code: ' Z533207',
    Description: 'Sabrina Park Coll Sys',
  },
  {
    Code: ' Z533208',
    Description: 'Deale Beach Rd Swr Main',
  },
  {
    Code: ' Z533209',
    Description: '210th Street Sewer Ext',
  },
  {
    Code: ' Z533210',
    Description: 'Race Road Swr Ext',
  },
  {
    Code: ' Z533211',
    Description: 'Solomons Island Rd Sewer Ext',
  },
  {
    Code: ' Z533212',
    Description: 'Dorsey Hts Sewer Ext',
  },
  {
    Code: ' Z533213',
    Description: 'Woodholme Circle Sewer Ext',
  },
  {
    Code: ' Z533214',
    Description: 'Parkway Ind Pk Sewer T/O',
  },
  {
    Code: ' Z533215',
    Description: 'Odenton Rd Sewer Ext',
  },
  {
    Code: ' Z533216',
    Description: 'Lake Av Sewer Ext',
  },
  {
    Code: ' Z533217',
    Description: 'Annapolis Rd-Odenton Swr Ext',
  },
  {
    Code: ' Z533218',
    Description: 'Skidmore Dr Swr Ext',
  },
  {
    Code: ' Z533219',
    Description: 'Lindamore Rd Swr Ext',
  },
  {
    Code: ' Z533220',
    Description: 'First St Swr Ext',
  },
  {
    Code: ' Z533221',
    Description: 'Wilson St Swr Ext',
  },
  {
    Code: ' Z533222',
    Description: 'Mathews Town Rd Swr Ext',
  },
  {
    Code: ' Z533223',
    Description: 'Whitehall Manor Swr Ext',
  },
  {
    Code: ' Z533224',
    Description: 'Mimosa Cove Rd. Swr Ext',
  },
  {
    Code: ' Z533225',
    Description: 'Pine Haven Dr. Swr Ext',
  },
  {
    Code: ' Z533226',
    Description: 'Deale Road Swr Extension',
  },
  {
    Code: ' Z533227',
    Description: 'Farragut Road Swr Extension',
  },
  {
    Code: ' Z533299',
    Description: 'Routine Sewer Extensions Conv',
  },
  {
    Code: ' Z888800',
    Description: 'WWE Trans. for PY Clos Project',
  },
  {
    Code: ' Z888802',
    Description: 'FY02 Trans for PY Clos Proj.',
  },
  {
    Code: ' Z888803',
    Description: 'FY03 Trans for PY Clos Proj.',
  },
  {
    Code: ' Z999900',
    Description: 'Sewer Ext Class Account',
  },
  {
    Code: ' Z999901',
    Description: 'Sewer Ext Class Account',
  },
  {
    Code: ' Z999999',
    Description: 'Sewer Ext Class Account Conv',
  },
  {
    Code: '1000',
    Description: 'General Fund',
  },
  {
    Code: '1001',
    Description: 'General Fund Revenues',
  },
  {
    Code: '1002',
    Description: 'Revenue Reserve Fund',
  },
  {
    Code: '1003',
    Description: 'Central Cash',
  },
  {
    Code: '1004',
    Description: 'Reserve for Perm Public Improv',
  },
  {
    Code: '1010',
    Description: 'County Executive',
  },
  {
    Code: '1011',
    Description: 'County Executive',
  },
  {
    Code: '1012',
    Description: 'Human Services',
  },
  {
    Code: '1013',
    Description: 'Economic Development',
  },
  {
    Code: '1030',
    Description: 'Chief Administrative Office',
  },
  {
    Code: '1031',
    Description: 'Management & Control',
  },
  {
    Code: '1032',
    Description: 'Contingency',
  },
  {
    Code: '1033',
    Description: 'Community Services',
  },
  {
    Code: '1040',
    Description: 'Office of Finance',
  },
  {
    Code: '1041',
    Description: 'Accounting and Control',
  },
  {
    Code: '1042',
    Description: 'Billings and Customer Service',
  },
  {
    Code: '1043',
    Description: 'Operations',
  },
  {
    Code: '1044',
    Description: 'Budget & Management Analysis',
  },
  {
    Code: '1045',
    Description: 'Pay-As-You-Go',
  },
  {
    Code: '1046',
    Description: 'Debt Service & Mandated Grants',
  },
  {
    Code: '1047',
    Description: 'General County Debt Service',
  },
  {
    Code: '1048',
    Description: 'General County Mandated Grants',
  },
  {
    Code: '1049',
    Description: 'Revenue Reserve GF Contrib.',
  },
  {
    Code: '1050',
    Description: 'Perm Public Imp-GF Contrib.',
  },
  {
    Code: '1055',
    Description: 'Office of the Budget',
  },
  {
    Code: '1056',
    Description: 'Human Services Grants',
  },
  {
    Code: '1060',
    Description: 'Central Services',
  },
  {
    Code: '1061',
    Description: 'Administration',
  },
  {
    Code: '1062',
    Description: 'Purchasing',
  },
  {
    Code: '1063',
    Description: 'Risk Management',
  },
  {
    Code: '1065',
    Description: 'Facilities Management',
  },
  {
    Code: '1066',
    Description: 'Administration',
  },
  {
    Code: '1067',
    Description: 'Northern Mobile Crew',
  },
  {
    Code: '1068',
    Description: 'Central Mobile Crew-Inactive',
  },
  {
    Code: '1069',
    Description: 'Southern Mobile Crew',
  },
  {
    Code: '1070',
    Description: 'Construction Crew',
  },
  {
    Code: '1071',
    Description: 'Horticulture Crew',
  },
  {
    Code: '1072',
    Description: 'Custodial/Security',
  },
  {
    Code: '1073',
    Description: 'Central Mobile Crew',
  },
  {
    Code: '1074',
    Description: 'Real Estate',
  },
  {
    Code: '1075',
    Description: 'Real Estate Administration',
  },
  {
    Code: '1076',
    Description: 'Property Control & Account.',
  },
  {
    Code: '1077',
    Description: 'ADA Activities',
  },
  {
    Code: '1078',
    Description: 'Information Services',
  },
  {
    Code: '1079',
    Description: 'Telecommunications',
  },
  {
    Code: '1080',
    Description: 'Print Shop',
  },
  {
    Code: '1081',
    Description: 'Mail Room',
  },
  {
    Code: '1083',
    Description: 'Central Maintance',
  },
  {
    Code: '1085',
    Description: 'Office of Info. Technology',
  },
  {
    Code: '1086',
    Description: 'Office of Info. Technology',
  },
  {
    Code: '1100',
    Description: 'Office of Law',
  },
  {
    Code: '1101',
    Description: 'Office of Law',
  },
  {
    Code: '1110',
    Description: 'Personnel',
  },
  {
    Code: '1111',
    Description: 'Administration',
  },
  {
    Code: '1112',
    Description: 'Personnel Board',
  },
  {
    Code: '1113',
    Description: 'Other Personnel Payments',
  },
  {
    Code: '1120',
    Description: 'Police',
  },
  {
    Code: '1121',
    Description: "Chief's Bureau",
  },
  {
    Code: '1123',
    Description: "Chief's Office",
  },
  {
    Code: '1124',
    Description: "Deputy Chief's Office",
  },
  {
    Code: '1125',
    Description: 'Internal Affairs',
  },
  {
    Code: '1126',
    Description: 'Intelligence',
  },
  {
    Code: '1127',
    Description: 'Public Information Office',
  },
  {
    Code: '1129',
    Description: 'Management Planning',
  },
  {
    Code: '1130',
    Description: 'Personnel',
  },
  {
    Code: '1131',
    Description: 'Accreditations',
  },
  {
    Code: '1132',
    Description: 'Training Academy',
  },
  {
    Code: '1133',
    Description: 'Field Operations Bureau',
  },
  {
    Code: '1134',
    Description: 'Patrol Division',
  },
  {
    Code: '1135',
    Description: 'Northern District',
  },
  {
    Code: '1136',
    Description: 'Eastern District',
  },
  {
    Code: '1137',
    Description: 'Southern District',
  },
  {
    Code: '1138',
    Description: 'Western District',
  },
  {
    Code: '1139',
    Description: 'Court Liaison',
  },
  {
    Code: '1140',
    Description: 'Traffic Safety',
  },
  {
    Code: '1141',
    Description: 'Special Operations',
  },
  {
    Code: '1142',
    Description: 'K-9',
  },
  {
    Code: '1143',
    Description: 'Aviation',
  },
  {
    Code: '1144',
    Description: 'Operations',
  },
  {
    Code: '1145',
    Description: 'Criminal Investigation Divisio',
  },
  {
    Code: '1146',
    Description: 'Narcotics',
  },
  {
    Code: '1147',
    Description: 'CID Property',
  },
  {
    Code: '1148',
    Description: 'CID Persons',
  },
  {
    Code: '1149',
    Description: 'Juvenile Victim Witness',
  },
  {
    Code: '1150',
    Description: 'Persons',
  },
  {
    Code: '1151',
    Description: 'Services Bureau',
  },
  {
    Code: '1152',
    Description: 'Communications',
  },
  {
    Code: '1153',
    Description: 'Evidence Collection',
  },
  {
    Code: '1154',
    Description: 'Ident. & Evidence Collection',
  },
  {
    Code: '1155',
    Description: 'Property Management',
  },
  {
    Code: '1156',
    Description: 'Crime Lab',
  },
  {
    Code: '1157',
    Description: 'Animal Control',
  },
  {
    Code: '1159',
    Description: 'Management Infor. Section',
  },
  {
    Code: '1160',
    Description: 'Records',
  },
  {
    Code: '1161',
    Description: 'Youth Activities Section',
  },
  {
    Code: '1162',
    Description: 'Youth Activities Program',
  },
  {
    Code: '1163',
    Description: 'DARE',
  },
  {
    Code: '1164',
    Description: 'Community Relations',
  },
  {
    Code: '1165',
    Description: 'Crime Prevention',
  },
  {
    Code: '1166',
    Description: 'School Crossing Guards',
  },
  {
    Code: '1167',
    Description: 'School Resource Officers',
  },
  {
    Code: '1168',
    Description: 'Technical Support',
  },
  {
    Code: '1170',
    Description: 'Career Criminal Unit',
  },
  {
    Code: '1171',
    Description: 'Red Light Program',
  },
  {
    Code: '1172',
    Description: 'Crime Analysis Unit',
  },
  {
    Code: '1200',
    Description: 'Fire Department',
  },
  {
    Code: '1201',
    Description: 'Administration Bureau',
  },
  {
    Code: '1202',
    Description: 'Administration',
  },
  {
    Code: '1203',
    Description: 'Volunteer Support',
  },
  {
    Code: '1204',
    Description: 'Operations Bureau',
  },
  {
    Code: '1205',
    Description: 'Suppression',
  },
  {
    Code: '1206',
    Description: 'Services Bureau',
  },
  {
    Code: '1207',
    Description: 'Fire Marshal',
  },
  {
    Code: '1208',
    Description: 'Maintenance',
  },
  {
    Code: '1209',
    Description: 'Training',
  },
  {
    Code: '1210',
    Description: 'Communications',
  },
  {
    Code: '1211',
    Description: 'EMS/Special Operations Bureau',
  },
  {
    Code: '1212',
    Description: 'ALS',
  },
  {
    Code: '1213',
    Description: 'Special Teams',
  },
  {
    Code: '1214',
    Description: 'Heat',
  },
  {
    Code: '1215',
    Description: 'Dive',
  },
  {
    Code: '1216',
    Description: 'Hazardous Materials',
  },
  {
    Code: '1217',
    Description: 'Emergency Management',
  },
  {
    Code: '1219',
    Description: 'CAO - Emergency Management',
  },
  {
    Code: '1220',
    Description: 'Department of Transportation',
  },
  {
    Code: '1240',
    Description: 'Office of Emergency Management',
  },
  {
    Code: '1250',
    Description: 'Inspections and Permits',
  },
  {
    Code: '1251',
    Description: 'Permits Application',
  },
  {
    Code: '1252',
    Description: 'Administration & Support',
  },
  {
    Code: '1253',
    Description: 'Permit Issuance',
  },
  {
    Code: '1254',
    Description: 'Zoning Review',
  },
  {
    Code: '1255',
    Description: 'Technical Services',
  },
  {
    Code: '1256',
    Description: 'Licensing',
  },
  {
    Code: '1257',
    Description: 'Inspection Services',
  },
  {
    Code: '1258',
    Description: 'Administration & Support',
  },
  {
    Code: '1259',
    Description: 'Environmental Programs',
  },
  {
    Code: '1260',
    Description: 'Inspections',
  },
  {
    Code: '1261',
    Description: 'Zoning Enforcement',
  },
  {
    Code: '1262',
    Description: 'Planning and Zoning',
  },
  {
    Code: '1263',
    Description: 'Planning',
  },
  {
    Code: '1264',
    Description: 'Administration & Support',
  },
  {
    Code: '1265',
    Description: 'Envir/Plan Svcs.',
  },
  {
    Code: '1266',
    Description: 'Zoning',
  },
  {
    Code: '1267',
    Description: 'Long Range Plan',
  },
  {
    Code: '1268',
    Description: 'Development',
  },
  {
    Code: '1269',
    Description: 'GIS',
  },
  {
    Code: '1270',
    Description: 'Transportation',
  },
  {
    Code: '1272',
    Description: 'P&Z - Zoning Enforcement',
  },
  {
    Code: '1281',
    Description: 'IAP - Code Compliance Division',
  },
  {
    Code: '1282',
    Description: 'I&P - Planning',
  },
  {
    Code: '1283',
    Description: 'I&P - Engineering',
  },
  {
    Code: '1295',
    Description: 'Office Of Admin. Hearings',
  },
  {
    Code: '1296',
    Description: 'Office of Admin. Hearings',
  },
  {
    Code: '1300',
    Description: 'Public Works',
  },
  {
    Code: '1301',
    Description: "Director's Office",
  },
  {
    Code: '1302',
    Description: 'Bureau of Engineering',
  },
  {
    Code: '1303',
    Description: 'Technical Engineering Div',
  },
  {
    Code: '1304',
    Description: 'General Engineering Div',
  },
  {
    Code: '1305',
    Description: 'Bureau of Highways',
  },
  {
    Code: '1306',
    Description: 'Traffic Engineering',
  },
  {
    Code: '1307',
    Description: 'Road Operations',
  },
  {
    Code: '1308',
    Description: 'Road Operations Admin',
  },
  {
    Code: '1309',
    Description: 'Districts',
  },
  {
    Code: '1310',
    Description: 'Northern',
  },
  {
    Code: '1311',
    Description: 'Central',
  },
  {
    Code: '1312',
    Description: 'Southern',
  },
  {
    Code: '1313',
    Description: 'Infrastructure Management',
  },
  {
    Code: '1314',
    Description: 'Bureau of Hwys Admin',
  },
  {
    Code: '1400',
    Description: 'Recreation and Parks',
  },
  {
    Code: '1401',
    Description: "Director's Office",
  },
  {
    Code: '1402',
    Description: 'Organized Recreation',
  },
  {
    Code: '1403',
    Description: 'Parks Management & Development',
  },
  {
    Code: '1404',
    Description: 'Recreation Programs',
  },
  {
    Code: '1405',
    Description: 'South County',
  },
  {
    Code: '1406',
    Description: 'West County',
  },
  {
    Code: '1407',
    Description: 'North County',
  },
  {
    Code: '1408',
    Description: 'East County',
  },
  {
    Code: '1409',
    Description: 'Special Programs',
  },
  {
    Code: '1410',
    Description: 'Therapeutic',
  },
  {
    Code: '1411',
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: '1412',
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: '1413',
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: '1414',
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: '1415',
    Description: 'Athletic Facility/Programs',
  },
  {
    Code: '1416',
    Description: 'Randazzo Softball Complex',
  },
  {
    Code: '1417',
    Description: 'Cannon Stadium',
  },
  {
    Code: '1418',
    Description: 'Adult Athl. Complex  Ord. Rd.',
  },
  {
    Code: '1419',
    Description: 'Special Facilities',
  },
  {
    Code: '1420',
    Description: 'Aquatics',
  },
  {
    Code: '1421',
    Description: 'B & A Trail',
  },
  {
    Code: '1422',
    Description: "Down's Park",
  },
  {
    Code: '1423',
    Description: 'Eisenhower Golf Course',
  },
  {
    Code: '1424',
    Description: 'Lake Waterford Park',
  },
  {
    Code: '1425',
    Description: 'Mayo Beach Park',
  },
  {
    Code: '1426',
    Description: 'Quiet Waters Park',
  },
  {
    Code: '1427',
    Description: 'Park Management',
  },
  {
    Code: '1428',
    Description: 'Andover Equestrian Center',
  },
  {
    Code: '1429',
    Description: 'Environmental Facilities',
  },
  {
    Code: '1430',
    Description: 'Jug Bay',
  },
  {
    Code: '1431',
    Description: 'Thomas Point',
  },
  {
    Code: '1432',
    Description: 'Horticulture Section',
  },
  {
    Code: '1433',
    Description: 'Unimproved Properties',
  },
  {
    Code: '1434',
    Description: 'Kinder Farm Park',
  },
  {
    Code: '1435',
    Description: 'Park Maintenance',
  },
  {
    Code: '1436',
    Description: 'Recreation Bureau Grants',
  },
  {
    Code: '1438',
    Description: 'Fort Smallwood Park',
  },
  {
    Code: '1443',
    Description: 'Resource Conservation',
  },
  {
    Code: '1500',
    Description: 'Aging',
  },
  {
    Code: '1501',
    Description: 'Direction/Administration',
  },
  {
    Code: '1502',
    Description: 'Nutrition',
  },
  {
    Code: '1503',
    Description: 'Transportation',
  },
  {
    Code: '1504',
    Description: 'Senior Centers',
  },
  {
    Code: '1505',
    Description: 'Pascal Senior Center',
  },
  {
    Code: '1506',
    Description: 'Arnold Senior Center',
  },
  {
    Code: '1507',
    Description: 'South County Senior Center',
  },
  {
    Code: '1508',
    Description: 'Annapolis Senior Center',
  },
  {
    Code: '1509',
    Description: "O'Malley Senior Center",
  },
  {
    Code: '1510',
    Description: 'Pasadena Senior Center',
  },
  {
    Code: '1511',
    Description: 'Outreach & Referral',
  },
  {
    Code: '1512',
    Description: 'Information and Assistance',
  },
  {
    Code: '1513',
    Description: 'Volunteers & Employment',
  },
  {
    Code: '1514',
    Description: 'Medicaid Waiver',
  },
  {
    Code: '1515',
    Description: 'Friendly Visiting',
  },
  {
    Code: '1517',
    Description: 'Sr. Hlth Ins. Counsel. Prgrm',
  },
  {
    Code: '1518',
    Description: 'Long Term Care',
  },
  {
    Code: '1519',
    Description: 'Senior Care',
  },
  {
    Code: '1520',
    Description: 'Ombudsman',
  },
  {
    Code: '1521',
    Description: 'Brooklyn Park Senior Center',
  },
  {
    Code: '1550',
    Description: 'Detention Facilities',
  },
  {
    Code: '1551',
    Description: 'Jennifer Road - Pretrail',
  },
  {
    Code: '1552',
    Description: 'Ordnance Road - Inmates',
  },
  {
    Code: '1553',
    Description: 'Admin/Support Service',
  },
  {
    Code: '1570',
    Description: 'Legislative Branch',
  },
  {
    Code: '1571',
    Description: 'County Council',
  },
  {
    Code: '1572',
    Description: 'County Auditor',
  },
  {
    Code: '1573',
    Description: 'Board of Appeals',
  },
  {
    Code: '1580',
    Description: 'Ethics Commission',
  },
  {
    Code: '1581',
    Description: 'Ethics Commission',
  },
  {
    Code: '1585',
    Description: "Office of the State's Attorney",
  },
  {
    Code: '1586',
    Description: "Office of the State's Attorney",
  },
  {
    Code: '1590',
    Description: 'Office of the Sheriff',
  },
  {
    Code: '1591',
    Description: 'Administration',
  },
  {
    Code: '1592',
    Description: 'Security',
  },
  {
    Code: '1593',
    Description: 'Ciminal Warrants',
  },
  {
    Code: '1594',
    Description: 'Domestic Relations Activities',
  },
  {
    Code: '1595',
    Description: 'Civil Process',
  },
  {
    Code: '1610',
    Description: 'Circuit Court',
  },
  {
    Code: '1611',
    Description: 'Disposition of Litigation',
  },
  {
    Code: '1612',
    Description: 'Domestic Relations',
  },
  {
    Code: '1620',
    Description: 'Orphans Court',
  },
  {
    Code: '1621',
    Description: 'Orphans Court',
  },
  {
    Code: '1625',
    Description: 'Board Of License Commissioners',
  },
  {
    Code: '1626',
    Description: 'Board of License Commissioners',
  },
  {
    Code: '1630',
    Description: 'Bd Of Supervisors Of Elections',
  },
  {
    Code: '1631',
    Description: 'Bd of Supevisors of Elections',
  },
  {
    Code: '1635',
    Description: 'Cooperative Extension Service',
  },
  {
    Code: '1636',
    Description: 'Cooperative Extension Service',
  },
  {
    Code: '1640',
    Description: 'Human Services',
  },
  {
    Code: '1641',
    Description: 'Administration',
  },
  {
    Code: '1642',
    Description: 'Grants',
  },
  {
    Code: '1660',
    Description: 'Social Services',
  },
  {
    Code: '1661',
    Description: 'Adult Services',
  },
  {
    Code: '1662',
    Description: 'Family & Youth Services',
  },
  {
    Code: '1663',
    Description: 'Staff Services',
  },
  {
    Code: '1664',
    Description: 'Family Preservation',
  },
  {
    Code: '1665',
    Description: 'Return Diversion',
  },
  {
    Code: '1680',
    Description: 'Land Use & Environ. Core Group',
  },
  {
    Code: '1681',
    Description: 'Direction',
  },
  {
    Code: '1682',
    Description: 'Tipton Airfield',
  },
  {
    Code: '1683',
    Description: 'David Taylor',
  },
  {
    Code: '1684',
    Description: 'School Construction',
  },
  {
    Code: '1686',
    Description: 'Environ & Cultural Resources',
  },
  {
    Code: '1700',
    Description: 'Soil Conservation',
  },
  {
    Code: '1701',
    Description: 'Soil Conservation',
  },
  {
    Code: '1710',
    Description: 'Health Department',
  },
  {
    Code: '1711',
    Description: 'Health Department Administrati',
  },
  {
    Code: '1712',
    Description: 'Administration - (Non State)',
  },
  {
    Code: '1713',
    Description: 'Administration (State)',
  },
  {
    Code: '1714',
    Description: 'Clinic and School Health',
  },
  {
    Code: '1715',
    Description: 'Admin, Clinic & School Health',
  },
  {
    Code: '1716',
    Description: 'Admin, Clinic & School Health',
  },
  {
    Code: '1717',
    Description: 'Reproductive Health',
  },
  {
    Code: '1718',
    Description: 'Family Planning Program',
  },
  {
    Code: '1719',
    Description: 'Materity Program',
  },
  {
    Code: '1720',
    Description: 'Dental Health',
  },
  {
    Code: '1721',
    Description: 'Dental Health Program',
  },
  {
    Code: '1722',
    Description: 'School Health & Support',
  },
  {
    Code: '1723',
    Description: 'O/T - P/T Program',
  },
  {
    Code: '1724',
    Description: 'School Support Program',
  },
  {
    Code: '1725',
    Description: 'School Health-Shared PDS Aides',
  },
  {
    Code: '1726',
    Description: 'School Hlth Prgrm I & TP -BOE',
  },
  {
    Code: '1727',
    Description: 'Community Outreach',
  },
  {
    Code: '1728',
    Description: 'Admin, Community Outreach',
  },
  {
    Code: '1729',
    Description: 'Community Outreach Admin',
  },
  {
    Code: '1730',
    Description: 'Eligibility & Enrollment',
  },
  {
    Code: '1731',
    Description: 'PWC Eligibilty Program',
  },
  {
    Code: '1732',
    Description: 'Case Management',
  },
  {
    Code: '1733',
    Description: 'Home Visiting Program',
  },
  {
    Code: '1734',
    Description: 'WIC',
  },
  {
    Code: '1735',
    Description: 'Community Health',
  },
  {
    Code: '1736',
    Description: 'Child Health Program',
  },
  {
    Code: '1737',
    Description: 'Nurse-Is-In Program',
  },
  {
    Code: '1738',
    Description: 'Service Quality',
  },
  {
    Code: '1739',
    Description: 'Surveillance Program',
  },
  {
    Code: '1740',
    Description: 'Planning & Surveillance',
  },
  {
    Code: '1741',
    Description: 'Health Info & Risk Reduction',
  },
  {
    Code: '1742',
    Description: 'Nutrition Program',
  },
  {
    Code: '1743',
    Description: 'Health Information Program',
  },
  {
    Code: '1744',
    Description: 'Aging',
  },
  {
    Code: '1745',
    Description: 'Aging Program',
  },
  {
    Code: '1746',
    Description: 'Personal Care Program',
  },
  {
    Code: '1747',
    Description: 'Community and Environ. Hlth',
  },
  {
    Code: '1748',
    Description: 'Admin, Environmental Health',
  },
  {
    Code: '1749',
    Description: 'Environmental Health Admin',
  },
  {
    Code: '1750',
    Description: 'Community Services',
  },
  {
    Code: '1751',
    Description: 'Community Services Program',
  },
  {
    Code: '1752',
    Description: 'Animal Control Program',
  },
  {
    Code: '1753',
    Description: 'Sanitary Engineering',
  },
  {
    Code: '1754',
    Description: 'Sanitary Engineering Program',
  },
  {
    Code: '1755',
    Description: 'Communicable Disease',
  },
  {
    Code: '1756',
    Description: 'Communic. Disease Program',
  },
  {
    Code: '1757',
    Description: 'TB Program',
  },
  {
    Code: '1758',
    Description: 'STD Program',
  },
  {
    Code: '1759',
    Description: 'Mental Health & Addictions',
  },
  {
    Code: '1760',
    Description: 'Mental Health',
  },
  {
    Code: '1761',
    Description: 'Addictions Treatment',
  },
  {
    Code: '1762',
    Description: 'Addictions Prevention',
  },
  {
    Code: '1763',
    Description: 'Sexual Assault Crisis Center',
  },
  {
    Code: '1764',
    Description: 'Health Info and Promotion',
  },
  {
    Code: '1765',
    Description: 'Administration, HIP',
  },
  {
    Code: '1766',
    Description: 'Administration, HIP',
  },
  {
    Code: '1767',
    Description: 'Communication',
  },
  {
    Code: '1768',
    Description: 'Communication',
  },
  {
    Code: '1769',
    Description: 'Adult Risk Reduction',
  },
  {
    Code: '1770',
    Description: 'Adult Risk Reduction',
  },
  {
    Code: '1771',
    Description: 'Youth Risk Reduction',
  },
  {
    Code: '1772',
    Description: 'Youth Risk Reduction',
  },
  {
    Code: '1773',
    Description: 'Minority Health',
  },
  {
    Code: '1774',
    Description: 'Minority Health',
  },
  {
    Code: '1985',
    Description: 'Public Libraries',
  },
  {
    Code: '1990',
    Description: 'Community College - GF Contrib',
  },
  {
    Code: '1995',
    Description: 'BOE - County Contribution',
  },
  {
    Code: '2000',
    Description: 'Whitmore Parking Garage',
  },
  {
    Code: '2010',
    Description: 'Child Care',
  },
  {
    Code: '2011',
    Description: 'Child Care Revenues',
  },
  {
    Code: '2012',
    Description: 'Area 1',
  },
  {
    Code: '2013',
    Description: 'Edgewater',
  },
  {
    Code: '2014',
    Description: 'Shady Side',
  },
  {
    Code: '2015',
    Description: 'Davidsonville',
  },
  {
    Code: '2016',
    Description: "Tracey's Landing",
  },
  {
    Code: '2017',
    Description: 'Hillsmere',
  },
  {
    Code: '2018',
    Description: 'Lothian',
  },
  {
    Code: '2019',
    Description: 'Crofton Meadows',
  },
  {
    Code: '2020',
    Description: 'Four Seasons',
  },
  {
    Code: '2021',
    Description: 'Waugh Chapel Elementary',
  },
  {
    Code: '2022',
    Description: 'Area 2',
  },
  {
    Code: '2023',
    Description: 'Brock Bridge',
  },
  {
    Code: '2024',
    Description: 'Maryland City',
  },
  {
    Code: '2025',
    Description: 'Severna Park',
  },
  {
    Code: '2026',
    Description: 'Benfield Elementary',
  },
  {
    Code: '2027',
    Description: 'Oak Hill Elementary',
  },
  {
    Code: '2028',
    Description: 'Severn Elementary',
  },
  {
    Code: '2029',
    Description: 'Quarterfield Elementary',
  },
  {
    Code: '2030',
    Description: 'Pasadena Elementary',
  },
  {
    Code: '2031',
    Description: 'Hilltop',
  },
  {
    Code: '2032',
    Description: 'Area 3',
  },
  {
    Code: '2033',
    Description: 'Windsor Farm',
  },
  {
    Code: '2034',
    Description: 'Broadneck',
  },
  {
    Code: '2035',
    Description: 'Rolling Knolls',
  },
  {
    Code: '2036',
    Description: 'Bodkin',
  },
  {
    Code: '2037',
    Description: 'Southshore',
  },
  {
    Code: '2038',
    Description: 'Solley Elementary',
  },
  {
    Code: '2039',
    Description: 'High Point Elementary',
  },
  {
    Code: '2040',
    Description: 'Lake Shore Elementary',
  },
  {
    Code: '2041',
    Description: 'Cape St. Claire',
  },
  {
    Code: '2042',
    Description: 'Area 4',
  },
  {
    Code: '2043',
    Description: 'Crofton Middle',
  },
  {
    Code: '2044',
    Description: 'Glendale',
  },
  {
    Code: '2045',
    Description: 'Administration',
  },
  {
    Code: '2046',
    Description: 'Administration',
  },
  {
    Code: '2047',
    Description: 'Southern MS',
  },
  {
    Code: '2050',
    Description: 'Mayo School Age Child Care',
  },
  {
    Code: '2100',
    Description: 'Developer Streetlight Install.',
  },
  {
    Code: '2110',
    Description: 'FAST Fund',
  },
  {
    Code: '2111',
    Description: 'FAST Fund Revenues',
  },
  {
    Code: '2112',
    Description: "State's Attorney",
  },
  {
    Code: '2113',
    Description: 'County Forfeiture',
  },
  {
    Code: '2114',
    Description: 'Police',
  },
  {
    Code: '2115',
    Description: 'County Forfeiture',
  },
  {
    Code: '2116',
    Description: 'Federal Forfeiture',
  },
  {
    Code: '2150',
    Description: 'Conference & Tourism Fund',
  },
  {
    Code: '2160',
    Description: 'Economic Development Fund',
  },
  {
    Code: '2170',
    Description: 'Incentive Loan Fund',
  },
  {
    Code: '2180',
    Description: 'Piney Orchard Wastewater Srvc',
  },
  {
    Code: '2200',
    Description: 'System Reform Initiative',
  },
  {
    Code: '2201',
    Description: 'System Reform Initia. Revenues',
  },
  {
    Code: '2202',
    Description: 'Administration',
  },
  {
    Code: '2203',
    Description: 'Family Preservation',
  },
  {
    Code: '2204',
    Description: 'Return/Diversion',
  },
  {
    Code: '2205',
    Description: 'Contractor Family Preservation',
  },
  {
    Code: '2206',
    Description: 'Contractor Return/Diversion',
  },
  {
    Code: '2207',
    Description: 'Youth Service Bureaus',
  },
  {
    Code: '2208',
    Description: 'DHR Family Services',
  },
  {
    Code: '2209',
    Description: 'Community Partnerships',
  },
  {
    Code: '2290',
    Description: 'Housing Trust',
  },
  {
    Code: '3010',
    Description: 'Gen Cnty Cap Projs',
  },
  {
    Code: '3011',
    Description: 'Gen Cnty CP-Closed',
  },
  {
    Code: '3019',
    Description: 'I&P Branch Plant',
  },
  {
    Code: '3020',
    Description: 'Gen  Cnty Cap Proj-Storm Drain',
  },
  {
    Code: '3021',
    Description: 'Gen Cnty CP-Storm Drains-Close',
  },
  {
    Code: '3030',
    Description: 'Gen Cnty Cap Proj-Educ',
  },
  {
    Code: '3031',
    Description: 'Gen Cnty CP-Educ-Closed',
  },
  {
    Code: '3040',
    Description: 'Gen Cnty Cap Proj-Fire/Police',
  },
  {
    Code: '3041',
    Description: 'Gen Cnty CP-Fire/Pol-Closed',
  },
  {
    Code: '3050',
    Description: 'Gen Cnty Cap Proj-Rds/Brdgs',
  },
  {
    Code: '3051',
    Description: 'Gen Cnty CP-Rds/Brdgs',
  },
  {
    Code: '3060',
    Description: 'Gen Cnty Cap Proj-Comm Coll',
  },
  {
    Code: '3061',
    Description: 'Gen Cnty CP-Comm Coll-Closed',
  },
  {
    Code: '3070',
    Description: 'Gen Cnty Cap Proj-Libraries',
  },
  {
    Code: '3071',
    Description: 'Gen Cnty CP-Libraries-Closed',
  },
  {
    Code: '3080',
    Description: 'Gen Cnty Cap Proj-CBG',
  },
  {
    Code: '3081',
    Description: 'Gen Cnty CP-CBG-Closed',
  },
  {
    Code: '3090',
    Description: 'Gen Cnty Cap Proj-Res & Parks',
  },
  {
    Code: '3091',
    Description: 'Gen Cnty CP-Rec & Parks-Closed',
  },
  {
    Code: '3100',
    Description: 'Gen Cnty Cap Proj-Dredging',
  },
  {
    Code: '3101',
    Description: 'Gen Cnty CP-Dredging-Closed',
  },
  {
    Code: '4000',
    Description: 'Utility Operating Fund',
  },
  {
    Code: '4004',
    Description: 'Utility Operations',
  },
  {
    Code: '4010',
    Description: 'Water Operations',
  },
  {
    Code: '4011',
    Description: 'Water Operations Revenues',
  },
  {
    Code: '4012',
    Description: 'Facility Maintenance',
  },
  {
    Code: '4013',
    Description: 'Facility Operations',
  },
  {
    Code: '4014',
    Description: 'Water Line Maintenance',
  },
  {
    Code: '4015',
    Description: 'Emergency Services',
  },
  {
    Code: '4016',
    Description: 'Collection/Dist Support Serv',
  },
  {
    Code: '4017',
    Description: 'Meter Services',
  },
  {
    Code: '4018',
    Description: 'Water Administration',
  },
  {
    Code: '4020',
    Description: 'Wastewater Operations',
  },
  {
    Code: '4021',
    Description: 'Wastewater Operations Revenues',
  },
  {
    Code: '4024',
    Description: 'Cox Creek',
  },
  {
    Code: '4025',
    Description: 'Broadneck',
  },
  {
    Code: '4026',
    Description: 'Old Str Maintenance',
  },
  {
    Code: '4027',
    Description: 'Old Str Sewer Line Maintenance',
  },
  {
    Code: '4028',
    Description: 'Coll & Maint Administration',
  },
  {
    Code: '4029',
    Description: 'System Evaluation & Rehab.',
  },
  {
    Code: '4030',
    Description: 'Infilitration & Inflow',
  },
  {
    Code: '4031',
    Description: 'Water Distribution Planning',
  },
  {
    Code: '4032',
    Description: 'Cent Maint-Contract Support',
  },
  {
    Code: '4034',
    Description: 'Patuxent Wrf',
  },
  {
    Code: '4035',
    Description: 'Old Str Annapolis Wrf',
  },
  {
    Code: '4036',
    Description: 'Maryland City Wrf',
  },
  {
    Code: '4037',
    Description: 'Old Str Broadwater Wrf',
  },
  {
    Code: '4038',
    Description: 'Old Str Mayo Wrf',
  },
  {
    Code: '4039',
    Description: 'Old Str Pumping Station Ops',
  },
  {
    Code: '4040',
    Description: 'Old Str WW South Maintenance',
  },
  {
    Code: '4043',
    Description: 'WW Operations Adminstration',
  },
  {
    Code: '4044',
    Description: 'Technical Administration',
  },
  {
    Code: '4046',
    Description: 'UTIL-CONSOLIDATED LAB SERVICES',
  },
  {
    Code: '4048',
    Description: 'Wastewater Collections & Maint',
  },
  {
    Code: '4049',
    Description: 'WW Collections',
  },
  {
    Code: '4050',
    Description: 'Technical Support',
  },
  {
    Code: '4051',
    Description: 'Safety Services',
  },
  {
    Code: '4052',
    Description: 'Pretreatment',
  },
  {
    Code: '4053',
    Description: 'Sewer Line Repairs',
  },
  {
    Code: '4054',
    Description: 'Sewer Line Maintenance',
  },
  {
    Code: '4055',
    Description: 'WW Maintenance',
  },
  {
    Code: '4056',
    Description: 'Mechanical',
  },
  {
    Code: '4057',
    Description: 'Electrical & Instrument',
  },
  {
    Code: '4058',
    Description: 'Emerg Power Sys Sup',
  },
  {
    Code: '4059',
    Description: 'Annapolis WRF',
  },
  {
    Code: '4060',
    Description: 'Operations Administration',
  },
  {
    Code: '4061',
    Description: 'Md City / Patx Service Area',
  },
  {
    Code: '4062',
    Description: 'Mayo/Broadwater Service Area',
  },
  {
    Code: '4063',
    Description: 'Mayo WRF',
  },
  {
    Code: '4064',
    Description: 'Broadwater WRF',
  },
  {
    Code: '4065',
    Description: 'Utility Administration',
  },
  {
    Code: '4067',
    Description: 'Utility Engineering',
  },
  {
    Code: '4070',
    Description: 'Finance & Administration',
  },
  {
    Code: '4071',
    Description: 'Financial Services',
  },
  {
    Code: '4072',
    Description: 'Personnel',
  },
  {
    Code: '4073',
    Description: 'Customer Relations',
  },
  {
    Code: '4074',
    Description: 'Mgmt Information System',
  },
  {
    Code: '4075',
    Description: 'Old Str Revenue Administration',
  },
  {
    Code: '4076',
    Description: 'DPW-Utilities-Asset Management',
  },
  {
    Code: '4099',
    Description: 'Utility Op. Fund Actg Trans.',
  },
  {
    Code: '4110',
    Description: 'Water and Sewer Cap Projs-Sew',
  },
  {
    Code: '4111',
    Description: 'Water and Sewer CP-Sew-Closed',
  },
  {
    Code: '4119',
    Description: 'W & S - Sewer CP Acctg Trans.',
  },
  {
    Code: '4120',
    Description: 'Water and Sewer Cap Projs-Wat',
  },
  {
    Code: '4121',
    Description: 'Water and Sewer CP-Wat-Closed',
  },
  {
    Code: '4129',
    Description: 'W & S - Water CP Acctg Trans.',
  },
  {
    Code: '4130',
    Description: 'Water and Sewer Cap Proj-Other',
  },
  {
    Code: '4131',
    Description: 'Water and Sewer CP-Other-Close',
  },
  {
    Code: '4139',
    Description: 'W & S - Other CP Acctg Trans.',
  },
  {
    Code: '4140',
    Description: 'W & S Cap Proj-Routine Wat',
  },
  {
    Code: '4141',
    Description: 'W & S CP-Routine Wat Ext-Close',
  },
  {
    Code: '4149',
    Description: 'W & S - RWE CP Acctg Trans.',
  },
  {
    Code: '4150',
    Description: 'W & S Cap Proj-Routine Sew Ext',
  },
  {
    Code: '4151',
    Description: 'W & S CP-Routine Sew Ext-Close',
  },
  {
    Code: '4159',
    Description: 'W & S - RSE CP Acctg Trans.',
  },
  {
    Code: '4199',
    Description: 'I&P Branch Plant',
  },
  {
    Code: '4200',
    Description: 'Interest & Sinking Fund',
  },
  {
    Code: '4202',
    Description: 'Water',
  },
  {
    Code: '4203',
    Description: 'Wastewater',
  },
  {
    Code: '4219',
    Description: 'Utility I&S Fund Actg Trans.',
  },
  {
    Code: '4220',
    Description: 'Maryland City Amt Debt Service',
  },
  {
    Code: '4229',
    Description: 'Maryland City Fund Actg Trans',
  },
  {
    Code: '4230',
    Description: 'W & S Adjustments to GAAP',
  },
  {
    Code: '4300',
    Description: 'Waste Management Services Fund',
  },
  {
    Code: '4301',
    Description: 'Waste Management Services Rev',
  },
  {
    Code: '4302',
    Description: 'Waste Management Services Exp',
  },
  {
    Code: '4303',
    Description: 'Administration',
  },
  {
    Code: '4304',
    Description: 'Environmental Services',
  },
  {
    Code: '4305',
    Description: 'Alternative Disposal',
  },
  {
    Code: '4310',
    Description: 'Equipment Maintenance',
  },
  {
    Code: '4311',
    Description: 'Landfills',
  },
  {
    Code: '4312',
    Description: 'Millersville Landfill',
  },
  {
    Code: '4313',
    Description: 'Sudley Landfill',
  },
  {
    Code: '4314',
    Description: 'Glen Burnie Landfill',
  },
  {
    Code: '4320',
    Description: 'Community Services',
  },
  {
    Code: '4321',
    Description: 'Convenience Centers',
  },
  {
    Code: '4322',
    Description: 'Sudley Convenience Center',
  },
  {
    Code: '4323',
    Description: 'Glen Burnie Convenience Cntr',
  },
  {
    Code: '4324',
    Description: 'Millersville Convenience Cntr',
  },
  {
    Code: '4330',
    Description: 'Curbside Collection',
  },
  {
    Code: '4331',
    Description: 'Curbside Collection',
  },
  {
    Code: '4335',
    Description: 'Bulk Item/Community Cleanup',
  },
  {
    Code: '4336',
    Description: 'Bulk Item Collection',
  },
  {
    Code: '4337',
    Description: 'Community Cleanups',
  },
  {
    Code: '4340',
    Description: 'Recycling',
  },
  {
    Code: '4389',
    Description: 'WM Fund Actg Trans.',
  },
  {
    Code: '4390',
    Description: 'Solid Waste Fin. Assur. Fund',
  },
  {
    Code: '4399',
    Description: 'SW Fin Assur Fund Actg Trans.',
  },
  {
    Code: '4410',
    Description: 'Solid Waste Cap Projs-Landfill',
  },
  {
    Code: '4411',
    Description: 'Solid Waste -Landfill-Closed',
  },
  {
    Code: '4419',
    Description: 'SWCP-Landfill Fund Actg Trans.',
  },
  {
    Code: '4604',
    Description: 'WPRF Inspection',
  },
  {
    Code: '5000',
    Description: 'Central Stores Fund',
  },
  {
    Code: '50001',
    Description: 'North County Landscape Initiat',
  },
  {
    Code: '50002',
    Description: 'Derelicit Boat Removal',
  },
  {
    Code: '5001',
    Description: 'Central Stores Operations',
  },
  {
    Code: '5002',
    Description: 'Administration',
  },
  {
    Code: '5003',
    Description: 'Warehouse',
  },
  {
    Code: '5004',
    Description: 'Print Shop',
  },
  {
    Code: '5005',
    Description: 'Mail/Stock Room',
  },
  {
    Code: '5006',
    Description: 'Roads Inventory',
  },
  {
    Code: '5007',
    Description: 'Northern Roads',
  },
  {
    Code: '5008',
    Description: 'Central Roads',
  },
  {
    Code: '5009',
    Description: 'Southern Roads',
  },
  {
    Code: '5010',
    Description: 'Western Roads',
  },
  {
    Code: '5011',
    Description: 'Eastern Roads',
  },
  {
    Code: '5049',
    Description: 'Cash & Counter Sales',
  },
  {
    Code: '5050',
    Description: 'Self Insurance Fund',
  },
  {
    Code: '50500',
    Description: 'Police 911 Board',
  },
  {
    Code: '5051',
    Description: 'Self Insurance Fund Revenues',
  },
  {
    Code: '5052',
    Description: 'County',
  },
  {
    Code: '5053',
    Description: 'Administration',
  },
  {
    Code: '5054',
    Description: 'Safety',
  },
  {
    Code: '5055',
    Description: 'Self Insurance',
  },
  {
    Code: '5056',
    Description: "Workmen's Compensation",
  },
  {
    Code: '5057',
    Description: 'Vehicle Collison',
  },
  {
    Code: '5058',
    Description: 'General Liability',
  },
  {
    Code: '5059',
    Description: 'Vehicle Liability',
  },
  {
    Code: '5060',
    Description: 'Board of Education',
  },
  {
    Code: '5061',
    Description: 'Administration',
  },
  {
    Code: '5062',
    Description: 'Self Insurance',
  },
  {
    Code: '5063',
    Description: "Workmen's Compensation",
  },
  {
    Code: '5064',
    Description: 'Vehicle Collison',
  },
  {
    Code: '5065',
    Description: 'General Liability',
  },
  {
    Code: '5066',
    Description: 'Vehicle Liability',
  },
  {
    Code: '5067',
    Description: 'Risk Management Administration',
  },
  {
    Code: '5068',
    Description: 'Safety',
  },
  {
    Code: '5069',
    Description: 'Insurance',
  },
  {
    Code: '5099',
    Description: 'Self Ins Fund Actg Trans.',
  },
  {
    Code: '5100',
    Description: 'Health Insurance Fund',
  },
  {
    Code: '51001',
    Description: 'COPS In Schools-2000',
  },
  {
    Code: '51014',
    Description: 'DNA II FLIP - 2000',
  },
  {
    Code: '51015',
    Description: 'TOP-Teen Opportunity Prog-2000',
  },
  {
    Code: '51016',
    Description: 'LLEBG Video Imaging/ID - 1999',
  },
  {
    Code: '51025',
    Description: 'MDOT-Alchol/Traffic Sfty -2000',
  },
  {
    Code: '51026',
    Description: 'SHA-Motor Carrier Safety-2000',
  },
  {
    Code: '51027',
    Description: 'Foreign Motor Veh Reg Program',
  },
  {
    Code: '51028',
    Description: 'HotSpots Pioneer/Warfield-2000',
  },
  {
    Code: '51029',
    Description: 'JAIBG -Juvenile Acct Inc -2000',
  },
  {
    Code: '51030',
    Description: 'CDS Laboratory Imp -2000',
  },
  {
    Code: '51031',
    Description: 'Crime Prevent Thru Enviro-2000',
  },
  {
    Code: '51033',
    Description: "Brooklyn Hght's Hot Spot -2000",
  },
  {
    Code: '51040',
    Description: 'Viper V - Auto Theft - 2000',
  },
  {
    Code: '51041',
    Description: 'MVOC-Victim Assist - 2000',
  },
  {
    Code: '51042',
    Description: 'MVOC DVOTEE Expansion-2000',
  },
  {
    Code: '51044',
    Description: 'VAU-NOVA - 2000',
  },
  {
    Code: '51045',
    Description: '911 Locator Lights-2000',
  },
  {
    Code: '51050',
    Description: 'Bulletproof Vest Prtnship-2000',
  },
  {
    Code: '51061',
    Description: 'WSFFA-Wm Snyder Fnd - 2000',
  },
  {
    Code: '51110',
    Description: 'RAAM Program',
  },
  {
    Code: '51114',
    Description: 'Forensic DNA Lab Imp Program',
  },
  {
    Code: '51115',
    Description: 'TOP-Teen Opportunity Program',
  },
  {
    Code: '51116',
    Description: 'LLEBG',
  },
  {
    Code: '51124',
    Description: 'Police Assoc. Mini-Grants',
  },
  {
    Code: '51125',
    Description: 'MDOT-Alcohol/Traffic Safety',
  },
  {
    Code: '51126',
    Description: 'SHA-Motor Carrier Safety',
  },
  {
    Code: '51127',
    Description: 'Foreign Motor Veh Reg Program',
  },
  {
    Code: '51128',
    Description: 'Byrne- Pioneer City CP',
  },
  {
    Code: '51129',
    Description: 'JAIB/Teen Court',
  },
  {
    Code: '51130',
    Description: 'Victim Asst. Educat.&Outreach',
  },
  {
    Code: '51132',
    Description: 'Byrne - DNA Forensic Lab Imp.',
  },
  {
    Code: '51133',
    Description: 'Hotspots-Brooklyn Heights CP',
  },
  {
    Code: '51134',
    Description: 'HotSpot-Brooklyn Heights YP',
  },
  {
    Code: '51135',
    Description: 'Brooklyn Heights-Nuisance Abat',
  },
  {
    Code: '51140',
    Description: 'Viper VI',
  },
  {
    Code: '51144',
    Description: 'Victim Asst. Education & Outre',
  },
  {
    Code: '51145',
    Description: 'School Bus Enforcement Grant',
  },
  {
    Code: '51150',
    Description: 'Bulletproof Vest Partnership',
  },
  {
    Code: '51210',
    Description: 'RAAM Program',
  },
  {
    Code: '51215',
    Description: 'PCTC-Brain Injury',
  },
  {
    Code: '51216',
    Description: 'Local Law Enforcment Block Gra',
  },
  {
    Code: '51225',
    Description: 'MDOT-Alcohol/TrafficSafety',
  },
  {
    Code: '51226',
    Description: 'SHA-Motor Carrier Safety',
  },
  {
    Code: '51227',
    Description: 'Foreign Motor Veh Reg Program',
  },
  {
    Code: '51228',
    Description: 'Byrne- Pioneer City CP',
  },
  {
    Code: '51229',
    Description: 'JAIB/Teen Court Grant',
  },
  {
    Code: '51230',
    Description: 'International Paper Co Foundat',
  },
  {
    Code: '51231',
    Description: 'Target-Bike Patrol',
  },
  {
    Code: '51233',
    Description: 'Hotspots-Brooklyn Heights CP',
  },
  {
    Code: '51234',
    Description: 'Brooklyn H./Learning & Skills',
  },
  {
    Code: '51235',
    Description: 'Hotspots-Pioneer City Comm Mob',
  },
  {
    Code: '51237',
    Description: 'Supplemental Summer Activities',
  },
  {
    Code: '51240',
    Description: 'VIPER VII',
  },
  {
    Code: '51241',
    Description: 'Victim Asst. Outreach Year 2',
  },
  {
    Code: '51244',
    Description: 'MVOC - Training for Compliance',
  },
  {
    Code: '51245',
    Description: 'School Bus Enforcement Grant',
  },
  {
    Code: '51246',
    Description: 'Tobacco Settlement',
  },
  {
    Code: '51247',
    Description: 'DVOTEE-Enhance Victim Safety',
  },
  {
    Code: '51250',
    Description: 'Bulletproof Vest Partnership',
  },
  {
    Code: '51316',
    Description: 'Local Law Enforcment Block Gra',
  },
  {
    Code: '51325',
    Description: 'MDOT-Alcohol/TrafficSafety',
  },
  {
    Code: '51326',
    Description: 'SHA-Motor Carrier Safety',
  },
  {
    Code: '51327',
    Description: 'Occupant Protection/Speed En',
  },
  {
    Code: '51328',
    Description: 'Byrne- Pioneer City CP',
  },
  {
    Code: '51329',
    Description: 'Teen Court - Juvenile Interven',
  },
  {
    Code: '51333',
    Description: 'Hotspots-Brooklyn Heights CP',
  },
  {
    Code: '51335',
    Description: 'CLIP-Crime Lab Imp Program',
  },
  {
    Code: '51340',
    Description: 'VIPER VIII',
  },
  {
    Code: '51341',
    Description: 'Victim Asst. Outreach Year 3',
  },
  {
    Code: '51344',
    Description: 'MVOC - Juv. & Adult Victim Ast',
  },
  {
    Code: '51345',
    Description: 'School Bus Enforcement Grant',
  },
  {
    Code: '51347',
    Description: 'DVOTEE-Enhance Victim Safety',
  },
  {
    Code: '51348',
    Description: 'GTEAP-Pro Prosecution Init.',
  },
  {
    Code: '51350',
    Description: 'Bulletproof Vest Partnership',
  },
  {
    Code: '51352',
    Description: 'Targeting Gun Violence',
  },
  {
    Code: '51360',
    Description: 'AA Cty Animal Shelter',
  },
  {
    Code: '51416',
    Description: 'Local Law Enforcment Block Gra',
  },
  {
    Code: '51425',
    Description: 'MDOT-Highway Safety',
  },
  {
    Code: '51428',
    Description: 'HOTSPOT-Pioneer City',
  },
  {
    Code: '51429',
    Description: 'Teen Court - LMB',
  },
  {
    Code: '51433',
    Description: 'Hotspots-Brooklyn Heights',
  },
  {
    Code: '51437',
    Description: 'Drug Diversion Program',
  },
  {
    Code: '51440',
    Description: 'VIPER IX',
  },
  {
    Code: '51441',
    Description: 'MVOC - Victim Service Training',
  },
  {
    Code: '51444',
    Description: 'MVOC - Victim Assistant',
  },
  {
    Code: '51445',
    Description: 'School Bus Enforcement Grant',
  },
  {
    Code: '51447',
    Description: 'VAWA-Victim Safety II',
  },
  {
    Code: '51448',
    Description: 'Grant tp Enforce Arrests(GTAP)',
  },
  {
    Code: '51452',
    Description: 'CEASE FIRE',
  },
  {
    Code: '51461',
    Description: 'Wal-Mart Foundation Grant',
  },
  {
    Code: '51467',
    Description: 'Paul Coverdell NFSIA Discretio',
  },
  {
    Code: '51516',
    Description: 'Local Law Enforcement Block Gr',
  },
  {
    Code: '51530',
    Description: 'Byrne - DNA Forensic Lab Imp.',
  },
  {
    Code: '51580',
    Description: 'State Aid Police Protect',
  },
  {
    Code: '51581',
    Description: 'PST Landfill',
  },
  {
    Code: '51582',
    Description: 'Light Rail',
  },
  {
    Code: '51716',
    Description: 'LLEBG Video Imaging/ID 1997',
  },
  {
    Code: '51725',
    Description: 'MDOT Alcohol/Traffic Safe 1997',
  },
  {
    Code: '51810',
    Description: 'COPS MORE95/ARAPS/FTE9.1',
  },
  {
    Code: '51811',
    Description: 'COPS MORE96/Laptop/FTE1.8',
  },
  {
    Code: '51812',
    Description: 'ICOP/Robbery/Crime Prev 1998',
  },
  {
    Code: '51813',
    Description: 'DNA I Lab Enhance-1998',
  },
  {
    Code: '51815',
    Description: 'DVOTEE/Northern District -1998',
  },
  {
    Code: '51816',
    Description: 'LLEBG Video Imaging/ID - 1997',
  },
  {
    Code: '51817',
    Description: 'LLEBG Teen Court - YAS - 1998',
  },
  {
    Code: '51825',
    Description: 'MDOT Alcohol/Traffic Safe 1998',
  },
  {
    Code: '51826',
    Description: 'BYRNE/Map Plotter-AdmSvcs',
  },
  {
    Code: '51827',
    Description: 'BYRNE/Narc Equip-CID Narc',
  },
  {
    Code: '51828',
    Description: 'HotSpots Pioneer/Warfield-1998',
  },
  {
    Code: '51840',
    Description: 'VIPER III - Auto Theft - 1998',
  },
  {
    Code: '51841',
    Description: 'MVOC-VAU-1st Yr - 1997',
  },
  {
    Code: '51842',
    Description: 'HOFNOD - YAP Unit - 1998',
  },
  {
    Code: '51843',
    Description: 'CJAF-Child Abuse Unit - 1998',
  },
  {
    Code: '51900',
    Description: 'COPS HIRING GRANTS',
  },
  {
    Code: '51901',
    Description: 'COPS AHEAD/12 Officers 1996',
  },
  {
    Code: '51902',
    Description: 'UHP I /12 Officers - 1997',
  },
  {
    Code: '51903',
    Description: 'UHP II/12 Officers - 1998',
  },
  {
    Code: '51904',
    Description: 'UHP III /25 Officers - 1999',
  },
  {
    Code: '51915',
    Description: 'TOP- Teen Opport. Prog -1999',
  },
  {
    Code: '51916',
    Description: 'LLEBG Video Imaging/ID - 1998',
  },
  {
    Code: '51925',
    Description: 'MDOT Alcohol/Traffic Safe 1999',
  },
  {
    Code: '51926',
    Description: 'SHA-Motor Carrier Safety-1999',
  },
  {
    Code: '51927',
    Description: 'MSP-Foreign Veh Enforce 1999',
  },
  {
    Code: '51928',
    Description: 'HotSpots Pioneer/Warfield-1999',
  },
  {
    Code: '51940',
    Description: 'VIPER IV-Auto Theft - 1999',
  },
  {
    Code: '51941',
    Description: 'MVOC-Victim Assist - 1999',
  },
  {
    Code: '51942',
    Description: 'MVOC DVOTEE Expansion 1999',
  },
  {
    Code: '51960',
    Description: 'Laptop-Sex Offense Unit - 1999',
  },
  {
    Code: '5200',
    Description: 'Central Garage Fund',
  },
  {
    Code: '52005',
    Description: 'Waterway Improvement Fund',
  },
  {
    Code: '5201',
    Description: 'Fuel Inventory',
  },
  {
    Code: '52010',
    Description: 'FEMA - State & Lcl Assist-2000',
  },
  {
    Code: '5202',
    Description: 'Gas',
  },
  {
    Code: '52020',
    Description: '1999 HMEP - Emerg Plan-2000',
  },
  {
    Code: '5203',
    Description: 'Diesel',
  },
  {
    Code: '5204',
    Description: 'Vehicle Replacement',
  },
  {
    Code: '52040',
    Description: 'HMEP Training Grant',
  },
  {
    Code: '5205',
    Description: 'Services and Maintenance',
  },
  {
    Code: '52110',
    Description: 'FEMA-State & Local Assist FY01',
  },
  {
    Code: '52120',
    Description: '2001 HMEP Emergency Plan',
  },
  {
    Code: '52210',
    Description: 'FEMA-State & Local Assist FY02',
  },
  {
    Code: '52220',
    Description: 'HMEP 2002 Grant Program',
  },
  {
    Code: '52221',
    Description: 'DOJ Terrorism Response Equip.',
  },
  {
    Code: '52222',
    Description: 'CHART Terminal Installation',
  },
  {
    Code: '52223',
    Description: 'LEPC Operating Grant',
  },
  {
    Code: '52310',
    Description: 'FEMA-State & Local Assist FY03',
  },
  {
    Code: '52320',
    Description: 'HMEP 2003 Grant Program',
  },
  {
    Code: '52321',
    Description: 'DOJ Terrorism Response Equip.',
  },
  {
    Code: '52421',
    Description: 'DOJ Terrorism Response Equip.',
  },
  {
    Code: '52501',
    Description: 'State Aid for Fire Protect',
  },
  {
    Code: '52506',
    Description: 'MD Port Adm Grant-Fire Boat',
  },
  {
    Code: '52507',
    Description: 'Waterway Imp. Fund-Central',
  },
  {
    Code: '52508',
    Description: 'Waterway Imp. Fund-South',
  },
  {
    Code: '52509',
    Description: 'Waterway Imp. Fund-North',
  },
  {
    Code: '52520',
    Description: 'Advanced Life Support Funding',
  },
  {
    Code: '52522',
    Description: 'Law Enforce Terrorism Prev Gra',
  },
  {
    Code: '52525',
    Description: 'MIEMSS Matching & Hardship',
  },
  {
    Code: '52710',
    Description: 'FEMA-State & Lcl Assist -1997',
  },
  {
    Code: '52720',
    Description: '1996 HMEP - Emerg Plan-1997',
  },
  {
    Code: '52810',
    Description: 'FEMA - State & Lcl Assist-1998',
  },
  {
    Code: '52820',
    Description: '1997 HMEP - Emerg Plan-1998',
  },
  {
    Code: '52830',
    Description: '1998 SARA Training Grt - 1998',
  },
  {
    Code: '52910',
    Description: 'FEMA - State & Lcl Assist-1999',
  },
  {
    Code: '52920',
    Description: '1998 HMEP - Emerg Plan-1999',
  },
  {
    Code: '52940',
    Description: 'HMEP-Emer Training-1999',
  },
  {
    Code: '52980',
    Description: 'EMS-Mini Grant- 1999',
  },
  {
    Code: '5300',
    Description: 'Central Garage Replacement Fun',
  },
  {
    Code: '53020',
    Description: 'Critical Area Grant - 2000',
  },
  {
    Code: '53030',
    Description: 'Brooklyn Heights-Nuisance Abat',
  },
  {
    Code: '53110',
    Description: 'Ridesharing Grant',
  },
  {
    Code: '53120',
    Description: 'Critical Area Grant',
  },
  {
    Code: '53125',
    Description: 'Scenic & Historic Roads Invent',
  },
  {
    Code: '53130',
    Description: 'Brooklyn Heights-Nuisance Abat',
  },
  {
    Code: '53150',
    Description: 'Pioneer City-Nuisance Abatemen',
  },
  {
    Code: '53220',
    Description: 'Critical Area Grant',
  },
  {
    Code: '53221',
    Description: 'Watershed Restoration Action',
  },
  {
    Code: '53230',
    Description: 'Brooklyn Heights-Nuisance Abat',
  },
  {
    Code: '53231',
    Description: 'Pioneer City-Nuisance Abatemen',
  },
  {
    Code: '53510',
    Description: 'Farmland Protection Progra',
  },
  {
    Code: '53515',
    Description: 'Ridesharing Grant',
  },
  {
    Code: '53520',
    Description: 'Critical Area Grant',
  },
  {
    Code: '53535',
    Description: 'MTA-Nixon Bus Company Grant',
  },
  {
    Code: '53550',
    Description: 'UPWP Grant',
  },
  {
    Code: '53551',
    Description: 'UPWP Sys Long Range Grant',
  },
  {
    Code: '53552',
    Description: 'UPWP Clean Air Grant',
  },
  {
    Code: '53553',
    Description: 'UPWP Long Range Grant',
  },
  {
    Code: '53554',
    Description: 'UPWP COOP Forecasting Gran',
  },
  {
    Code: '53555',
    Description: 'UPWP Management Grant',
  },
  {
    Code: '53556',
    Description: 'Brooklyn Heights-Comm Maint',
  },
  {
    Code: '53720',
    Description: 'Critical Area Grant - 1997',
  },
  {
    Code: '53810',
    Description: 'Ridesharing Grant - 1998',
  },
  {
    Code: '53820',
    Description: 'Critical Area Grant - 1998',
  },
  {
    Code: '53830',
    Description: 'Sensitive Areas Grant - 1998',
  },
  {
    Code: '53850',
    Description: 'HotSpots-Nuisance Abate - 1998',
  },
  {
    Code: '53910',
    Description: 'Ridesharing Grant - 1999',
  },
  {
    Code: '53920',
    Description: 'Critical Area Grant - 1999',
  },
  {
    Code: '53950',
    Description: 'HotSpots-Nuisance Abate - 1999',
  },
  {
    Code: '54050',
    Description: 'Solid Waste Stream Grant',
  },
  {
    Code: '54201',
    Description: 'Security Drinking Water Utilit',
  },
  {
    Code: '56010',
    Description: 'Jug Bay - MDNR',
  },
  {
    Code: '56020',
    Description: 'MD HotSpot Comm. Init. Phase I',
  },
  {
    Code: '56110',
    Description: 'Jug Bay - MDNR',
  },
  {
    Code: '56120',
    Description: 'MD HotSpot Comm. Init. Phas II',
  },
  {
    Code: '56130',
    Description: 'MD After School Opportunity',
  },
  {
    Code: '56131',
    Description: 'MD Sch Opport Middle-West',
  },
  {
    Code: '56132',
    Description: 'MD Sch Opport Middle-North',
  },
  {
    Code: '56211',
    Description: 'Eastern Box Turtle Patterns',
  },
  {
    Code: '56212',
    Description: 'Red-Bellied Turtles',
  },
  {
    Code: '56213',
    Description: 'Water Quality Comparison',
  },
  {
    Code: '56214',
    Description: 'Song Bird Studies',
  },
  {
    Code: '56220',
    Description: 'MD HotSpot Com. Init. Phas III',
  },
  {
    Code: '56230',
    Description: 'MD After School Opportunity',
  },
  {
    Code: '56231',
    Description: 'MD Sch Opport Middle-West',
  },
  {
    Code: '56232',
    Description: 'MD Sch Opport Middle-North',
  },
  {
    Code: '56316',
    Description: 'Equestrian Trail',
  },
  {
    Code: '56320',
    Description: 'MD HotSpot Com. Init.',
  },
  {
    Code: '56331',
    Description: 'MD School Opportunity Grant',
  },
  {
    Code: '56420',
    Description: 'MD HotSpot Com. Init.',
  },
  {
    Code: '56500',
    Description: 'School Comm Cntr Parks Recs',
  },
  {
    Code: '56515',
    Description: 'Weed Control Grant',
  },
  {
    Code: '56820',
    Description: "LLEBG-Rec's & Parks-1998",
  },
  {
    Code: '56910',
    Description: 'Jug Bay - 1999',
  },
  {
    Code: '56930',
    Description: 'Wildlife Habitat Incent - 1999',
  },
  {
    Code: '57010',
    Description: 'Nutrition',
  },
  {
    Code: '57011',
    Description: 'Nutrition T-IIIC',
  },
  {
    Code: '57012',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57013',
    Description: 'Nutrition Management',
  },
  {
    Code: '57020',
    Description: 'Preventive Health Service',
  },
  {
    Code: '57030',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57031',
    Description: 'Home Delivered Meals-USDA',
  },
  {
    Code: '57050',
    Description: 'Information Assistance',
  },
  {
    Code: '57051',
    Description: 'Information Assistance III',
  },
  {
    Code: '57052',
    Description: 'Administration -IA-IIIB',
  },
  {
    Code: '57053',
    Description: 'Public Relations - IA',
  },
  {
    Code: '57054',
    Description: 'Telephone Reassurance -IIIB',
  },
  {
    Code: '57060',
    Description: 'RSVP',
  },
  {
    Code: '57061',
    Description: 'Management - RSVP',
  },
  {
    Code: '57062',
    Description: 'Vol Direct Service-RSVP',
  },
  {
    Code: '57070',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57071',
    Description: 'Management-FGP',
  },
  {
    Code: '57072',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57080',
    Description: 'Friendly Visiting',
  },
  {
    Code: '57081',
    Description: 'Life Enrichment',
  },
  {
    Code: '57082',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57090',
    Description: 'Senior Health',
  },
  {
    Code: '57091',
    Description: 'Sr Hlth Ins. Counsel Prg',
  },
  {
    Code: '57092',
    Description: 'Curb Abuse Agnst Medicare/',
  },
  {
    Code: '57110',
    Description: 'Nutrition',
  },
  {
    Code: '57111',
    Description: 'Nutrition T-IIIC',
  },
  {
    Code: '57112',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57113',
    Description: 'Nutrition Management',
  },
  {
    Code: '57120',
    Description: 'Preventative Health Services',
  },
  {
    Code: '57130',
    Description: 'Home Delivered Meals IIC-2',
  },
  {
    Code: '57131',
    Description: 'Home Del. Meals IIC-2 USDA',
  },
  {
    Code: '57150',
    Description: 'Information and Assistance',
  },
  {
    Code: '57152',
    Description: 'Adminstration-IA-IIIB',
  },
  {
    Code: '57153',
    Description: 'Public Relations IA',
  },
  {
    Code: '57154',
    Description: 'Telephone Reassurance-I',
  },
  {
    Code: '57155',
    Description: 'Technology Grant',
  },
  {
    Code: '57160',
    Description: 'RSVP',
  },
  {
    Code: '57161',
    Description: 'Management-RSVP',
  },
  {
    Code: '57162',
    Description: 'Vol/Dir Service-RSVP',
  },
  {
    Code: '57170',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57171',
    Description: 'Management-FGP',
  },
  {
    Code: '57172',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57175',
    Description: 'Medicaid Waiver',
  },
  {
    Code: '57180',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57181',
    Description: 'Life Enrichment',
  },
  {
    Code: '57182',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57191',
    Description: 'Sr. Health Ins. Counsel. Prg',
  },
  {
    Code: '57192',
    Description: 'Curb Abuse Agnst Medicare/caid',
  },
  {
    Code: '57210',
    Description: 'Nutrition',
  },
  {
    Code: '57211',
    Description: 'Nutrition T-IIIC',
  },
  {
    Code: '57212',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57213',
    Description: 'Nutrition Management',
  },
  {
    Code: '57220',
    Description: 'Preventative Health Services',
  },
  {
    Code: '57230',
    Description: 'Home Delivered Meals IIC-2',
  },
  {
    Code: '57231',
    Description: 'Home Del. Meals IIC-2 USDA',
  },
  {
    Code: '57250',
    Description: 'Information and Assistance',
  },
  {
    Code: '57252',
    Description: 'Adminstration-IA-IIIB',
  },
  {
    Code: '57253',
    Description: 'Public Relations IA',
  },
  {
    Code: '57254',
    Description: 'Telephone Reassurance-I',
  },
  {
    Code: '57260',
    Description: 'RSVP',
  },
  {
    Code: '57261',
    Description: 'Management-RSVP',
  },
  {
    Code: '57262',
    Description: 'Vol/Dir Service-RSVP',
  },
  {
    Code: '57270',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57271',
    Description: 'Management-FGP',
  },
  {
    Code: '57272',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57280',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57281',
    Description: 'Life Enrichment',
  },
  {
    Code: '57282',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57291',
    Description: 'Sr. Health Ins. Counsel. Prg',
  },
  {
    Code: '57292',
    Description: 'Curb Abuse Agnst Medicare/caid',
  },
  {
    Code: '57310',
    Description: 'Nutrition',
  },
  {
    Code: '57311',
    Description: 'Nutrition T-IIIC',
  },
  {
    Code: '57312',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57313',
    Description: 'Nutrition Management',
  },
  {
    Code: '57320',
    Description: 'Preventative Health Services',
  },
  {
    Code: '57330',
    Description: 'Home Delivered Meals IIC-2',
  },
  {
    Code: '57331',
    Description: 'Home Del. Meals IIC-2 USDA',
  },
  {
    Code: '57350',
    Description: 'Information and Assistance',
  },
  {
    Code: '57352',
    Description: 'Adminstration-IA-IIIB',
  },
  {
    Code: '57353',
    Description: 'Public Relations IA',
  },
  {
    Code: '57354',
    Description: 'Telephone Reassurance-I',
  },
  {
    Code: '57360',
    Description: 'RSVP',
  },
  {
    Code: '57361',
    Description: 'Management-RSVP',
  },
  {
    Code: '57362',
    Description: 'Vol/Dir Service-RSVP',
  },
  {
    Code: '57370',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57371',
    Description: 'Management-FGP',
  },
  {
    Code: '57372',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57380',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57381',
    Description: 'Life Enrichment',
  },
  {
    Code: '57382',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57391',
    Description: 'Sr. Health Ins. Counsel. Prg',
  },
  {
    Code: '57392',
    Description: 'Curb Abuse Agnst Medicare/caid',
  },
  {
    Code: '57510',
    Description: 'SSTAP Program',
  },
  {
    Code: '57511',
    Description: 'SSTAP',
  },
  {
    Code: '57512',
    Description: 'Vehicle Operation',
  },
  {
    Code: '57513',
    Description: 'Maintenance',
  },
  {
    Code: '57514',
    Description: 'Administration',
  },
  {
    Code: '57515',
    Description: 'Other',
  },
  {
    Code: '57516',
    Description: 'Taxi',
  },
  {
    Code: '57517',
    Description: 'Taxi - Health',
  },
  {
    Code: '57520',
    Description: 'Senior Center Plus',
  },
  {
    Code: '57521',
    Description: 'Administration',
  },
  {
    Code: '57522',
    Description: 'Direct Services',
  },
  {
    Code: '57530',
    Description: 'Senior Inform & Assist',
  },
  {
    Code: '57540',
    Description: 'Senior Care',
  },
  {
    Code: '57541',
    Description: 'Management - SC',
  },
  {
    Code: '57542',
    Description: 'Direct Services - SC',
  },
  {
    Code: '57550',
    Description: 'Guardianship',
  },
  {
    Code: '57555',
    Description: 'Technology Grant',
  },
  {
    Code: '57560',
    Description: 'Group Sr Assisted Housing',
  },
  {
    Code: '57570',
    Description: 'Respite Care',
  },
  {
    Code: '57575',
    Description: 'Medicaid Waiver',
  },
  {
    Code: '57580',
    Description: 'LTC Assesment/Case Manageme',
  },
  {
    Code: '57590',
    Description: 'Transporation',
  },
  {
    Code: '57591',
    Description: 'Senior Transportation',
  },
  {
    Code: '57592',
    Description: 'Transportation IIIB',
  },
  {
    Code: '57593',
    Description: 'Foster Grandparents - Trans',
  },
  {
    Code: '57594',
    Description: 'RSVP - Trans',
  },
  {
    Code: '57595',
    Description: 'SSTAP - Trans',
  },
  {
    Code: '57596',
    Description: 'Trans IIIB - Match',
  },
  {
    Code: '57597',
    Description: 'Trans - County / Non-Grant',
  },
  {
    Code: '57710',
    Description: 'Nutrition',
  },
  {
    Code: '57711',
    Description: 'Nutrition T-IIIC-USDA-1997',
  },
  {
    Code: '57712',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57713',
    Description: 'Nutrition Management',
  },
  {
    Code: '57720',
    Description: 'Preventative Health Services',
  },
  {
    Code: '57730',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57731',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57750',
    Description: 'Information Assistance',
  },
  {
    Code: '57751',
    Description: 'Information Assistance IIIB',
  },
  {
    Code: '57752',
    Description: 'Administration - IA-IIIB',
  },
  {
    Code: '57753',
    Description: 'Public relations - IA',
  },
  {
    Code: '57754',
    Description: 'Telephone reassurance - IA',
  },
  {
    Code: '57760',
    Description: 'RSVP',
  },
  {
    Code: '57761',
    Description: 'Management-RSVP',
  },
  {
    Code: '57762',
    Description: 'Vol/Direct Service -RSVP',
  },
  {
    Code: '57770',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57771',
    Description: 'Management -FGP',
  },
  {
    Code: '57772',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57780',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57781',
    Description: 'Life Enrichment',
  },
  {
    Code: '57782',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57790',
    Description: 'Senior Health',
  },
  {
    Code: '57791',
    Description: 'Sr. Hlth Ins. Counsel. Prgrm',
  },
  {
    Code: '57792',
    Description: 'Curb Abuse Agnst Medicare/caid',
  },
  {
    Code: '57810',
    Description: 'Nutrition',
  },
  {
    Code: '57811',
    Description: 'Nutrition T-IIIC-USDA-1998',
  },
  {
    Code: '57812',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57813',
    Description: 'Nutrition Management',
  },
  {
    Code: '57820',
    Description: 'Preventative Health Service',
  },
  {
    Code: '57830',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57831',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57850',
    Description: 'Information Assistance',
  },
  {
    Code: '57851',
    Description: 'Information Assistance III',
  },
  {
    Code: '57852',
    Description: 'Administration - IA-IIIB',
  },
  {
    Code: '57853',
    Description: 'Public relations - IA',
  },
  {
    Code: '57854',
    Description: 'Telephone reassurance - I',
  },
  {
    Code: '57860',
    Description: 'RSVP',
  },
  {
    Code: '57861',
    Description: 'Management-RSVP',
  },
  {
    Code: '57862',
    Description: 'Vol/Direct Service -RSVP',
  },
  {
    Code: '57870',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57871',
    Description: 'Management -FGP',
  },
  {
    Code: '57872',
    Description: 'Vol/Direct Service-FGP',
  },
  {
    Code: '57880',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57881',
    Description: 'Life Enrichment',
  },
  {
    Code: '57882',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57890',
    Description: 'Senior Health',
  },
  {
    Code: '57891',
    Description: 'Sr. Hlth Ins. Counsel. Prg',
  },
  {
    Code: '57892',
    Description: 'Curb Abuse Agnst Medicare/',
  },
  {
    Code: '57910',
    Description: 'Nutrition',
  },
  {
    Code: '57911',
    Description: 'Nutrition T-IIIC',
  },
  {
    Code: '57912',
    Description: 'Nutrition Meals',
  },
  {
    Code: '57913',
    Description: 'Nutrition Management',
  },
  {
    Code: '57920',
    Description: 'Preventative Health Service',
  },
  {
    Code: '57930',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57931',
    Description: 'Home Delivered Meals IIIC-2',
  },
  {
    Code: '57950',
    Description: 'Information Assistance',
  },
  {
    Code: '57951',
    Description: 'Information Assistance III',
  },
  {
    Code: '57952',
    Description: 'Administration - IA-IIIB',
  },
  {
    Code: '57953',
    Description: 'Public relations - IA',
  },
  {
    Code: '57954',
    Description: 'Telephone reassurance - I',
  },
  {
    Code: '57960',
    Description: 'RSVP',
  },
  {
    Code: '57961',
    Description: 'Management - RSVP',
  },
  {
    Code: '57962',
    Description: 'Vol/Direct Service -RSVP',
  },
  {
    Code: '57970',
    Description: 'Foster Grandparents',
  },
  {
    Code: '57971',
    Description: 'Management  - FGP',
  },
  {
    Code: '57972',
    Description: 'Vol/Direct Service - FGP',
  },
  {
    Code: '57980',
    Description: 'Friendly Visiting (LS)',
  },
  {
    Code: '57981',
    Description: 'Life Enrichment',
  },
  {
    Code: '57982',
    Description: 'Pets on Wheels',
  },
  {
    Code: '57990',
    Description: 'Senior Health',
  },
  {
    Code: '57991',
    Description: 'Sr. Hlth Ins. Counsel. Prg',
  },
  {
    Code: '57992',
    Description: 'Curb Abuse Agnst Medicare/',
  },
  {
    Code: '58010',
    Description: 'Personal Care - Senior Care',
  },
  {
    Code: '58011',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58012',
    Description: 'Sr. Care IIID',
  },
  {
    Code: '58020',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58021',
    Description: 'Ombudsman',
  },
  {
    Code: '58022',
    Description: 'Elder Abuse',
  },
  {
    Code: '58111',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58112',
    Description: 'Sr. Care TIIID',
  },
  {
    Code: '58120',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58121',
    Description: 'Ombudsman',
  },
  {
    Code: '58122',
    Description: 'Elderly Abuse',
  },
  {
    Code: '58140',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58141',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58211',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58212',
    Description: 'Sr. Care TIIID',
  },
  {
    Code: '58220',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58221',
    Description: 'Ombudsman',
  },
  {
    Code: '58222',
    Description: 'Elderly Abuse',
  },
  {
    Code: '58240',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58241',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58311',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58320',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58321',
    Description: 'Ombudsman',
  },
  {
    Code: '58322',
    Description: 'Elderly Abuse',
  },
  {
    Code: '58340',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58341',
    Description: 'Care Givers (IIIE)',
  },
  {
    Code: '58530',
    Description: 'Vulnerable Elderly',
  },
  {
    Code: '58531',
    Description: 'Vulnerable Elderly-SHIP',
  },
  {
    Code: '58532',
    Description: 'Vulnerable Elderly-OMBUDSMAN',
  },
  {
    Code: '58533',
    Description: 'Vulnerable Elderly-Guardianshi',
  },
  {
    Code: '58710',
    Description: 'Personal Care / Senior Care',
  },
  {
    Code: '58711',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58712',
    Description: 'Sr. Care IIID',
  },
  {
    Code: '58720',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58721',
    Description: 'Ombudsman',
  },
  {
    Code: '58722',
    Description: 'Elderly Abuse',
  },
  {
    Code: '58810',
    Description: 'Personal Care / Senior Car',
  },
  {
    Code: '58811',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58812',
    Description: 'Sr. Care IIID',
  },
  {
    Code: '58820',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58821',
    Description: 'Ombudsman',
  },
  {
    Code: '58822',
    Description: 'Elderly Abuse',
  },
  {
    Code: '58910',
    Description: 'Personal Care - Senior Car',
  },
  {
    Code: '58911',
    Description: 'Sr. Care TIIIB',
  },
  {
    Code: '58912',
    Description: 'Sr. Care IIID',
  },
  {
    Code: '58920',
    Description: 'Ombudsman Program',
  },
  {
    Code: '58921',
    Description: 'Ombudsman',
  },
  {
    Code: '58922',
    Description: 'Elderly Abuse',
  },
  {
    Code: '59010',
    Description: 'VOCA - Vic of Crime Asst-2000',
  },
  {
    Code: '59021',
    Description: 'Coordinator of Volunteers',
  },
  {
    Code: '59030',
    Description: 'Drug Enhancement',
  },
  {
    Code: '59040',
    Description: 'Hotspot-Byrne-Comm.Prosecution',
  },
  {
    Code: '59050',
    Description: 'Juvenile Accountability',
  },
  {
    Code: '59060',
    Description: 'LLEBG',
  },
  {
    Code: '59070',
    Description: 'White Collar Crimes Pros-2000',
  },
  {
    Code: '59080',
    Description: 'MVOC/ADVOCATE-2000',
  },
  {
    Code: '59110',
    Description: 'VOCA-Victims of Crime 2001',
  },
  {
    Code: '59111',
    Description: 'VOCA-Victims of Crime Assist.',
  },
  {
    Code: '59140',
    Description: 'Hotspot-Byrne-Comm.Prosecution',
  },
  {
    Code: '59141',
    Description: 'DOC Prosecutor',
  },
  {
    Code: '59150',
    Description: 'Juvenile Intervent. Procecutor',
  },
  {
    Code: '59160',
    Description: 'LLEBG',
  },
  {
    Code: '59170',
    Description: 'White Collar Crimes Prosecutor',
  },
  {
    Code: '59180',
    Description: 'Victim Advocate Violent Crimes',
  },
  {
    Code: '59201',
    Description: 'Comm. Gun Violence Prosecution',
  },
  {
    Code: '59240',
    Description: 'Hotspot-Pioneer City-Comm.Pros',
  },
  {
    Code: '59260',
    Description: 'LLEBG',
  },
  {
    Code: '59270',
    Description: 'White Collar Crimes Prosecutor',
  },
  {
    Code: '59280',
    Description: 'Victim Advocate Violent Crimes',
  },
  {
    Code: '59340',
    Description: 'Hotspot-Pioneer City-Comm.Pros',
  },
  {
    Code: '59350',
    Description: 'Hotspot-Brooklyn Heights-Comm',
  },
  {
    Code: '59360',
    Description: 'LLEBG',
  },
  {
    Code: '59515',
    Description: 'MACRO Grant - Paralegal',
  },
  {
    Code: '59581',
    Description: 'Victim Notification Specialist',
  },
  {
    Code: '59710',
    Description: 'VOCA - Vio. Spouse Abuse-1997',
  },
  {
    Code: '59730',
    Description: 'LLEBG - Enhancing Adjudic-1997',
  },
  {
    Code: '59810',
    Description: 'VOCA - Vio. Spouse Abuse-1998',
  },
  {
    Code: '59820',
    Description: 'MVOC - Victims of Crime - 1998',
  },
  {
    Code: '59840',
    Description: 'HotSpots -Com Prosecutio-1998',
  },
  {
    Code: '59910',
    Description: 'VOCA - Vio. Spouse Abuse -1999',
  },
  {
    Code: '59920',
    Description: 'MVOC - Victims of Crime -1999',
  },
  {
    Code: '59930',
    Description: 'Drug Ct. Enhancement-1999',
  },
  {
    Code: '59940',
    Description: 'HotSpots Comm Grant - 1999',
  },
  {
    Code: '59950',
    Description: 'Juvenile Acctblty Block-1999',
  },
  {
    Code: '59960',
    Description: 'LLEBG - Enhancing Adjudic-1999',
  },
  {
    Code: '60010',
    Description: 'LLEBG Enhance Security-2000',
  },
  {
    Code: '60110',
    Description: 'LLEBG',
  },
  {
    Code: '60115',
    Description: 'Domestic Violence Protective',
  },
  {
    Code: '60310',
    Description: 'LLEBG',
  },
  {
    Code: '6050',
    Description: 'Pension System Fund',
  },
  {
    Code: '60510',
    Description: "Sheriff's COOP Grant",
  },
  {
    Code: '60515',
    Description: 'Domestic Violence Protective',
  },
  {
    Code: '60520',
    Description: 'Protective Order Data Entry',
  },
  {
    Code: '60550',
    Description: 'Incentive Payment',
  },
  {
    Code: '60710',
    Description: 'LLEBG -Enhance Security -1997',
  },
  {
    Code: '60910',
    Description: 'LLEBG -Enhance Security -1999',
  },
  {
    Code: '6100',
    Description: 'Defined Contribution Plan',
  },
  {
    Code: '61130',
    Description: 'Local Law Enforcement Block Gr',
  },
  {
    Code: '61230',
    Description: 'Local Law Enforcement Block Gr',
  },
  {
    Code: '61330',
    Description: 'Local Law Enforcement Block Gr',
  },
  {
    Code: '61505',
    Description: 'MACRO Grant - Mediation Serv',
  },
  {
    Code: '61510',
    Description: 'Family Related Cases Grant',
  },
  {
    Code: '61520',
    Description: 'Welfare Grants',
  },
  {
    Code: '61521',
    Description: 'Welfare Enforcement Grant',
  },
  {
    Code: '61522',
    Description: 'Welfare Incentive Grant',
  },
  {
    Code: '61525',
    Description: 'Juvenile Drug Court',
  },
  {
    Code: '61526',
    Description: 'STOP Grant',
  },
  {
    Code: '61550',
    Description: 'Incentive Payment',
  },
  {
    Code: '61810',
    Description: 'Welfare Grant - 1998',
  },
  {
    Code: '61811',
    Description: 'Welfare Enforcement - 1998',
  },
  {
    Code: '61812',
    Description: 'Welfare Incentive - 1998',
  },
  {
    Code: '61910',
    Description: 'Welfare  Grant - 1999',
  },
  {
    Code: '61911',
    Description: 'Welfare Enforcement - 1999',
  },
  {
    Code: '61912',
    Description: 'Welfare Incentive - 1999',
  },
  {
    Code: '61913',
    Description: 'Genetic Testing - 1999',
  },
  {
    Code: '6200',
    Description: 'Storm Drain',
  },
  {
    Code: '6201',
    Description: 'Storm water facil deposit',
  },
  {
    Code: '62015',
    Description: 'Volunteer Center-MOU',
  },
  {
    Code: '6202',
    Description: 'Patapsco-Non-tidal',
  },
  {
    Code: '6203',
    Description: 'Rhode river water shed',
  },
  {
    Code: '6204',
    Description: 'Lil Patuxent water shed',
  },
  {
    Code: '6205',
    Description: 'MN Patuxent rv water shed',
  },
  {
    Code: '6206',
    Description: 'West river water shed',
  },
  {
    Code: '6207',
    Description: 'Severn river water shed',
  },
  {
    Code: '6208',
    Description: 'South river water shed',
  },
  {
    Code: '6209',
    Description: 'Bodkin Creek water shed',
  },
  {
    Code: '6210',
    Description: 'Magothy river water shed',
  },
  {
    Code: '6211',
    Description: 'Patapsco river water shed',
  },
  {
    Code: '6212',
    Description: 'Unspec. loc-watershed',
  },
  {
    Code: '6213',
    Description: 'Herring bay water shed',
  },
  {
    Code: '6250',
    Description: 'Subdivision Deposit Agency',
  },
  {
    Code: '6251',
    Description: 'Road agreement',
  },
  {
    Code: '6252',
    Description: 'Gateway',
  },
  {
    Code: '6253',
    Description: 'Contract bid deposits',
  },
  {
    Code: '6254',
    Description: 'Non-Compliance Lien Escrow',
  },
  {
    Code: '6255',
    Description: 'Liquor license',
  },
  {
    Code: '6256',
    Description: 'Electrical permit',
  },
  {
    Code: '6257',
    Description: 'Security dep-rent agreemt',
  },
  {
    Code: '6258',
    Description: 'Screening P&Z',
  },
  {
    Code: '6259',
    Description: 'Russett Ctr. Allocation Escrow',
  },
  {
    Code: '62705',
    Description: 'Weatherization Assist. - 1997',
  },
  {
    Code: '62710',
    Description: 'LLEBG - Crime Prevention -1997',
  },
  {
    Code: '62830',
    Description: 'HotSpots - Mobilization - 1998',
  },
  {
    Code: '62930',
    Description: 'HotSpots - Mobilization - 1999',
  },
  {
    Code: '6300',
    Description: 'Sediment Control Agency',
  },
  {
    Code: '6301',
    Description: 'Gypsy moth Spray Escrow',
  },
  {
    Code: '6302',
    Description: 'Sediment control',
  },
  {
    Code: '6303',
    Description: 'Sediment control violate',
  },
  {
    Code: '63030',
    Description: "SH - Sarah's House - 2000",
  },
  {
    Code: '63031',
    Description: 'SH - Transportation - 2000',
  },
  {
    Code: '63032',
    Description: 'SH - Utilities - 2000',
  },
  {
    Code: '63033',
    Description: 'SH - Renovation - 2000',
  },
  {
    Code: '63034',
    Description: 'SH - Insurance - 2000',
  },
  {
    Code: '63040',
    Description: 'Outreach & Support-2000',
  },
  {
    Code: '63050',
    Description: 'Non -Member Training -20000',
  },
  {
    Code: '63060',
    Description: 'Federal Assistance Grant',
  },
  {
    Code: '63065',
    Description: 'Federal Administration Grant',
  },
  {
    Code: '63070',
    Description: 'Family Support Cntr-2000',
  },
  {
    Code: '63071',
    Description: 'Family Support Cntr Oper-2000',
  },
  {
    Code: '63072',
    Description: 'In - Home Intervention-2000',
  },
  {
    Code: '63073',
    Description: 'Comm Based Family Supp-2000',
  },
  {
    Code: '63075',
    Description: 'Volunteer Feasibility-2000',
  },
  {
    Code: '63080',
    Description: 'Child Care Rescr/Ref -2000',
  },
  {
    Code: '63130',
    Description: "Sarah's House",
  },
  {
    Code: '63230',
    Description: "Sarah's House",
  },
  {
    Code: '6325',
    Description: 'Recreation Agency',
  },
  {
    Code: '6326',
    Description: 'Rent',
  },
  {
    Code: '6327',
    Description: 'July 4th',
  },
  {
    Code: '6328',
    Description: 'Self Support',
  },
  {
    Code: '6329',
    Description: 'Trips',
  },
  {
    Code: '6330',
    Description: 'Ramp Escrow',
  },
  {
    Code: '6331',
    Description: 'Recreation land',
  },
  {
    Code: '63330',
    Description: "Sarah's House",
  },
  {
    Code: '63335',
    Description: 'Service-Linked Housing Program',
  },
  {
    Code: '63336',
    Description: 'Homeless Women-Crisis Shelter',
  },
  {
    Code: '63337',
    Description: "ETHS-Sarah's House",
  },
  {
    Code: '63338',
    Description: "POC-Sarah's House",
  },
  {
    Code: '63430',
    Description: "Sarah's House",
  },
  {
    Code: '63501',
    Description: 'Success By 6-United Way',
  },
  {
    Code: '63510',
    Description: 'Foodlink Grant',
  },
  {
    Code: '63515',
    Description: 'Community Partnership Agreemen',
  },
  {
    Code: '63520',
    Description: 'Welfare Information Network',
  },
  {
    Code: '63525',
    Description: 'Dept Social Service Reimburse',
  },
  {
    Code: '63530',
    Description: 'Literacy Works Grant',
  },
  {
    Code: '63537',
    Description: "ETHS-Sarah's House",
  },
  {
    Code: '63538',
    Description: "POC-Sarah's House",
  },
  {
    Code: '63545',
    Description: 'After School Evening Program',
  },
  {
    Code: '63550',
    Description: 'Federal Administration Grant',
  },
  {
    Code: '63560',
    Description: 'Federal Assistance Grant',
  },
  {
    Code: '63565',
    Description: 'Federal Administration Grant',
  },
  {
    Code: '63570',
    Description: 'Family Support Center Grant',
  },
  {
    Code: '63571',
    Description: 'Operating - Fam Supp Ctr',
  },
  {
    Code: '63572',
    Description: 'In - Home Intervention',
  },
  {
    Code: '63573',
    Description: 'Comm Based Family Support & Re',
  },
  {
    Code: '63574',
    Description: 'Mini Grant - LMB',
  },
  {
    Code: '63575',
    Description: 'Supplement In-Home Interventio',
  },
  {
    Code: '63576',
    Description: 'Youth Support Center',
  },
  {
    Code: '63580',
    Description: 'Serviced Linked Housing',
  },
  {
    Code: '63590',
    Description: 'Food Bank, Inc. - TEFAP',
  },
  {
    Code: '63595',
    Description: 'Child Advocacy Center',
  },
  {
    Code: '6375',
    Description: 'Detention Facility Agency',
  },
  {
    Code: '6376',
    Description: 'Detention Facility Agency Rev',
  },
  {
    Code: '6377',
    Description: 'Detention Facility Agency Exp',
  },
  {
    Code: '63820',
    Description: 'SHP-Support Housing Prog-1998',
  },
  {
    Code: '63821',
    Description: 'SHP-Supportive Housing I -1998',
  },
  {
    Code: '63822',
    Description: 'SHP-Supporti Housing II -1998',
  },
  {
    Code: '63823',
    Description: 'SHP-Supporti Housing III -1998',
  },
  {
    Code: '63830',
    Description: "SH - Sarah's House - 1998",
  },
  {
    Code: '63831',
    Description: 'SH -Transportation - 1998',
  },
  {
    Code: '63832',
    Description: 'SH - Utilities - 1998',
  },
  {
    Code: '63833',
    Description: 'SH - Renovations - 1998',
  },
  {
    Code: '63894',
    Description: 'Adult Foster Care - 1998',
  },
  {
    Code: '63910',
    Description: 'CTAA/Job Links-1999',
  },
  {
    Code: '63920',
    Description: 'SHP-Support Housing Prog-1998',
  },
  {
    Code: '63921',
    Description: 'SHP-Supportive Housing I -1998',
  },
  {
    Code: '63922',
    Description: 'SHP-Supporti Housing II -1998',
  },
  {
    Code: '63930',
    Description: "SH - Sarah's House - 1999",
  },
  {
    Code: '63931',
    Description: 'SH - Transportation - 1999',
  },
  {
    Code: '63932',
    Description: 'SH - Utilities - 1999',
  },
  {
    Code: '63933',
    Description: 'SH - Renovation - 1999',
  },
  {
    Code: '63940',
    Description: 'Drug Court Enhancement Initiat',
  },
  {
    Code: '63960',
    Description: 'Federal Assistance Grant',
  },
  {
    Code: '63965',
    Description: 'Federal Administration Grant',
  },
  {
    Code: '63971',
    Description: 'Operating - Fam Supp Ctr',
  },
  {
    Code: '63972',
    Description: 'In - Home Intervention',
  },
  {
    Code: '63973',
    Description: 'Comm Based Family Support & Re',
  },
  {
    Code: '63980',
    Description: 'Child Care Resrc & Refer-1999',
  },
  {
    Code: '63981',
    Description: 'Child Care Res & Ref  Fee-1999',
  },
  {
    Code: '63985',
    Description: 'Lessons Learned  - 1999',
  },
  {
    Code: '63990',
    Description: 'Food Bank-Temp Emerg - 1999',
  },
  {
    Code: '63994',
    Description: 'Adult Foster Care - 1999',
  },
  {
    Code: '63995',
    Description: 'VOCA-Vict of Child Abuse-1999',
  },
  {
    Code: '6400',
    Description: 'Liquor Board',
  },
  {
    Code: '64010',
    Description: 'Ryan White Title I',
  },
  {
    Code: '64030',
    Description: 'LLEBG',
  },
  {
    Code: '64040',
    Description: 'Hot Spots',
  },
  {
    Code: '64110',
    Description: 'Ryan White Title I Grant',
  },
  {
    Code: '64130',
    Description: 'LLEBG',
  },
  {
    Code: '64140',
    Description: 'Hot Spots',
  },
  {
    Code: '64141',
    Description: 'Combating Underage Drinking',
  },
  {
    Code: '6420',
    Description: 'Support Agency',
  },
  {
    Code: '6421',
    Description: 'Escrow Account',
  },
  {
    Code: '6422',
    Description: 'Misc. Receivable Support',
  },
  {
    Code: '6423',
    Description: 'Reserve - Unclaimed Checks',
  },
  {
    Code: '64230',
    Description: 'LLEBG',
  },
  {
    Code: '6424',
    Description: 'Returned Checks',
  },
  {
    Code: '6425',
    Description: 'Unidentified Receipts',
  },
  {
    Code: '64330',
    Description: 'LLEBG',
  },
  {
    Code: '6450',
    Description: 'City & State Tax Coll. Agency',
  },
  {
    Code: '64501',
    Description: 'Ft. Meade Disaster Relief Fund',
  },
  {
    Code: '64502',
    Description: 'PHP Bio: Planning & Readiness',
  },
  {
    Code: '64503',
    Description: 'PHP Bio: Surveil.& Epidem.',
  },
  {
    Code: '64504',
    Description: 'PHP Bio: Laboratory & Biologic',
  },
  {
    Code: '64505',
    Description: 'PHP Bio: Information Tech.',
  },
  {
    Code: '64506',
    Description: 'PHP Bio: Health Risk Commun.',
  },
  {
    Code: '64507',
    Description: 'PHP Bio: Education & Training',
  },
  {
    Code: '64510',
    Description: 'Local Health Planning',
  },
  {
    Code: '64511',
    Description: 'CRF Cancer: Non-Clinical',
  },
  {
    Code: '64512',
    Description: 'CRF Cancer: Clinical',
  },
  {
    Code: '64513',
    Description: 'CRF Cancer: Administrative',
  },
  {
    Code: '64514',
    Description: 'CRF Tobacco:  Planning',
  },
  {
    Code: '64515',
    Description: 'CRF Tobacco:  Community Based',
  },
  {
    Code: '64516',
    Description: 'CRF Tobacco:  School Based',
  },
  {
    Code: '64517',
    Description: 'CRF Tobacco:  Enforcement',
  },
  {
    Code: '64518',
    Description: 'CRF Tobacco:  Cessation',
  },
  {
    Code: '64519',
    Description: 'CRF Tobacco:  Administrative',
  },
  {
    Code: '64520',
    Description: 'Target-Childrens Mental He',
  },
  {
    Code: '64521',
    Description: 'Target-School Health',
  },
  {
    Code: '64522',
    Description: 'Target-Prenatal Services',
  },
  {
    Code: '64523',
    Description: 'Target-Dental Health',
  },
  {
    Code: '64524',
    Description: 'Target-Adult Immunization',
  },
  {
    Code: '64525',
    Description: 'Target-Tuberculosis',
  },
  {
    Code: '64526',
    Description: 'Target-STD',
  },
  {
    Code: '64527',
    Description: 'Target-Employee Health',
  },
  {
    Code: '64528',
    Description: 'Target Cancer',
  },
  {
    Code: '64529',
    Description: 'Target-Home Visiting/DDA',
  },
  {
    Code: '64530',
    Description: 'Target-MAP Services/Eligib',
  },
  {
    Code: '64531',
    Description: 'Target-Food Control',
  },
  {
    Code: '64532',
    Description: 'Target-AIDS',
  },
  {
    Code: '64533',
    Description: 'Target-Special Populations',
  },
  {
    Code: '64534',
    Description: 'Target-Health Information',
  },
  {
    Code: '64535',
    Description: 'Target-Planning & Surveil',
  },
  {
    Code: '64536',
    Description: 'Target Emerging Pathogens',
  },
  {
    Code: '64537',
    Description: 'Local Health Planning',
  },
  {
    Code: '64538',
    Description: 'Arbovirus Surveillance Plan',
  },
  {
    Code: '64539',
    Description: 'S.T.O.P. Substance Abuse',
  },
  {
    Code: '64540',
    Description: 'Sexual Assault Crisis Cris',
  },
  {
    Code: '64545',
    Description: 'Cty Exec - Drug Initiative',
  },
  {
    Code: '64546',
    Description: 'STAR Program Enhancement',
  },
  {
    Code: '64550',
    Description: 'Ordinance Rd Detention Cen',
  },
  {
    Code: '64551',
    Description: 'TCA Addictions Prog. Spec. Exp',
  },
  {
    Code: '64555',
    Description: 'County Halfway Houses',
  },
  {
    Code: '64560',
    Description: 'Prevention - County',
  },
  {
    Code: '64565',
    Description: 'Providence Center',
  },
  {
    Code: '64570',
    Description: 'I & A Grant',
  },
  {
    Code: '64575',
    Description: 'Drug Intervention Grant',
  },
  {
    Code: '64580',
    Description: 'Nutrition Risk Reduction G',
  },
  {
    Code: '64585',
    Description: 'Bicycle Sfty - Inj. Prev G',
  },
  {
    Code: '64590',
    Description: 'Family Planning Grant',
  },
  {
    Code: '64595',
    Description: 'Healthy Teens Grant',
  },
  {
    Code: '64676',
    Description: 'Diagnosis - B & C Cancer G',
  },
  {
    Code: '6475',
    Description: ' Area Agency on Aging',
  },
  {
    Code: '6476',
    Description: 'Aging',
  },
  {
    Code: '6477',
    Description: 'D-AAA Admin',
  },
  {
    Code: '6478',
    Description: 'D-AAA Admin IIIB',
  },
  {
    Code: '6479',
    Description: 'D-Aux AACo Med Soc',
  },
  {
    Code: '6480',
    Description: 'D-Elder Abse Trng T-III',
  },
  {
    Code: '6481',
    Description: 'D-Elder Abse Trng T-III G',
  },
  {
    Code: '64810',
    Description: 'Ryan White Title I Grant (',
  },
  {
    Code: '6482',
    Description: 'D-Eldercare T-III',
  },
  {
    Code: '6483',
    Description: 'D-Hsg Svcs Annapolis',
  },
  {
    Code: '64830',
    Description: 'LLEBG - Health Dept - Dru',
  },
  {
    Code: '6484',
    Description: 'D-I & A St, (Gwy I)',
  },
  {
    Code: '64840',
    Description: 'Hot Spots -Drug Free Sch',
  },
  {
    Code: '6485',
    Description: 'D-In Hme Care T-III B',
  },
  {
    Code: '6486',
    Description: 'D-In Hme Care T-III D',
  },
  {
    Code: '6487',
    Description: 'D-In Home Care',
  },
  {
    Code: '6488',
    Description: 'D-In Home Care T-III B',
  },
  {
    Code: '6489',
    Description: 'D-In Home Care T-III D',
  },
  {
    Code: '6490',
    Description: 'D-Info and Assist (Hum Svc)',
  },
  {
    Code: '6491',
    Description: 'D-Legal Aid Bureau, Inc.',
  },
  {
    Code: '64910',
    Description: 'Ryan White Title I Grant (',
  },
  {
    Code: '6492',
    Description: 'D-Meals on Wheels',
  },
  {
    Code: '64920',
    Description: 'Ryan White II-Consortia Gr',
  },
  {
    Code: '6493',
    Description: 'D-Nutrition',
  },
  {
    Code: '64930',
    Description: 'LLEBG - Addictions Coun-1999',
  },
  {
    Code: '64933',
    Description: 'Drug Ct. - Urinanalysis',
  },
  {
    Code: '6494',
    Description: 'D-Ombudsman',
  },
  {
    Code: '64940',
    Description: 'Hot Spots -Drug Free Sch',
  },
  {
    Code: '6495',
    Description: 'D-Prev Hlth Serv',
  },
  {
    Code: '6496',
    Description: 'D-Sr Care State (Gwy II)',
  },
  {
    Code: '6497',
    Description: 'D-Sr Care (Health Dept)',
  },
  {
    Code: '6498',
    Description: 'D-Sr I & A St (Gwy I)',
  },
  {
    Code: '6499',
    Description: 'D-Sr Visitation/POW',
  },
  {
    Code: '6500',
    Description: 'D-Transfer to Next FY-',
  },
  {
    Code: '6501',
    Description: 'D-Transfer to Next FY-B',
  },
  {
    Code: '6502',
    Description: 'D-Transfer to Next FY-C1',
  },
  {
    Code: '6503',
    Description: 'D-Transfer to Next FY-C2',
  },
  {
    Code: '6504',
    Description: 'D-Transfer to Next FY. F',
  },
  {
    Code: '6505',
    Description: 'D-Transportation',
  },
  {
    Code: '6506',
    Description: 'R-I & A St, (Gwy I)',
  },
  {
    Code: '6507',
    Description: 'R-Sr Care State (Gwy II)',
  },
  {
    Code: '6508',
    Description: 'R-Title III-D',
  },
  {
    Code: '6509',
    Description: 'R-Title III-G',
  },
  {
    Code: '6510',
    Description: 'R-Title III B',
  },
  {
    Code: '6511',
    Description: 'R-Title III C1',
  },
  {
    Code: '6512',
    Description: 'R-Title III C2',
  },
  {
    Code: '6513',
    Description: 'R-Title III D',
  },
  {
    Code: '6514',
    Description: 'R-Title III Eldercare',
  },
  {
    Code: '6515',
    Description: 'R-Title III F',
  },
  {
    Code: '6516',
    Description: 'R-Title III G',
  },
  {
    Code: '6550',
    Description: 'Reforestation',
  },
  {
    Code: '6551',
    Description: 'Reforestation-Non-Refundable',
  },
  {
    Code: '65510',
    Description: 'Improved Pregnancy Outcome',
  },
  {
    Code: '65515',
    Description: 'WIC - Farmers Market',
  },
  {
    Code: '6552',
    Description: 'Forest Conservation-Non Refund',
  },
  {
    Code: '65520',
    Description: 'Cancer Outreach Grant',
  },
  {
    Code: '65525',
    Description: 'Geriatric Eval. Services G',
  },
  {
    Code: '6553',
    Description: 'Reforest Tree-Bill',
  },
  {
    Code: '65530',
    Description: 'Ombudsman',
  },
  {
    Code: '65535',
    Description: 'Admin. Care Coordination',
  },
  {
    Code: '6554',
    Description: 'Reforestation-Refundable',
  },
  {
    Code: '65540',
    Description: 'PWC Eligibility/Kids Count',
  },
  {
    Code: '65545',
    Description: 'MA Transportation Grant',
  },
  {
    Code: '6555',
    Description: 'Forest Conserv-Refund',
  },
  {
    Code: '65550',
    Description: 'TB Control Grant',
  },
  {
    Code: '65554',
    Description: 'Prevention Case Mgt-2000',
  },
  {
    Code: '65555',
    Description: 'STD Grant',
  },
  {
    Code: '65560',
    Description: 'Immunization Grant',
  },
  {
    Code: '65565',
    Description: 'Refugee Resettlement',
  },
  {
    Code: '65570',
    Description: 'Laboratory Services Grant',
  },
  {
    Code: '65575',
    Description: 'HIV Counsel & Test Grant',
  },
  {
    Code: '65580',
    Description: 'Home Outreach Grant',
  },
  {
    Code: '65584',
    Description: 'Model Program Initiatives',
  },
  {
    Code: '65585',
    Description: 'Substance Abuse/Sexual Off',
  },
  {
    Code: '65586',
    Description: 'School Based Mental Health',
  },
  {
    Code: '65587',
    Description: 'Enhanced Student Services',
  },
  {
    Code: '65588',
    Description: 'DJJ Mental Health Assessors',
  },
  {
    Code: '65589',
    Description: 'Cigarette Restitution Fund',
  },
  {
    Code: '65590',
    Description: 'Home & Comm. Based HIV Gra',
  },
  {
    Code: '65591',
    Description: 'Employment in Recovery',
  },
  {
    Code: '65592',
    Description: 'Adolescent Services Grant',
  },
  {
    Code: '65593',
    Description: 'MHA Administration',
  },
  {
    Code: '65594',
    Description: 'Hispanic Initiative Grant',
  },
  {
    Code: '65595',
    Description: 'Mental Health Grant',
  },
  {
    Code: '65596',
    Description: 'Alcohol & Drug Abuse Preve',
  },
  {
    Code: '65597',
    Description: 'Addictions-Treatment Grant',
  },
  {
    Code: '65598',
    Description: 'Halfway Houses-Grant',
  },
  {
    Code: '65599',
    Description: 'Family Preservation Services',
  },
  {
    Code: '6575',
    Description: 'Deferred Comp. Plan Agency',
  },
  {
    Code: '6576',
    Description: 'T. Rowe Price',
  },
  {
    Code: '6577',
    Description: 'American United',
  },
  {
    Code: '6578',
    Description: 'Great West',
  },
  {
    Code: '6590',
    Description: 'Tax Sale Escrow Deposits',
  },
  {
    Code: '6591',
    Description: 'Tax Sale Escrow Deposits',
  },
  {
    Code: '6592',
    Description: 'Tax Sale Auction',
  },
  {
    Code: '6593',
    Description: 'Bid Premium Deposit',
  },
  {
    Code: '66005',
    Description: 'Marketing Plan',
  },
  {
    Code: '66010',
    Description: 'Coop Lib.of Central MD-2000',
  },
  {
    Code: '66030',
    Description: 'Staff Development - MCEN',
  },
  {
    Code: '66040',
    Description: 'Staff Development',
  },
  {
    Code: '66055',
    Description: 'Marketing Plan',
  },
  {
    Code: '66065',
    Description: 'Greenhouse Grant',
  },
  {
    Code: '66090',
    Description: 'Portatech Classroom-1999',
  },
  {
    Code: '66095',
    Description: 'Community Pntrshp/Parenting Cn',
  },
  {
    Code: '66121',
    Description: 'LATP Web Services & Equipment',
  },
  {
    Code: '66125',
    Description: 'LATP Retirement',
  },
  {
    Code: '66126',
    Description: 'Library Serv & Tech-Marketing',
  },
  {
    Code: '66127',
    Description: 'Library Serv & Tech-Learning',
  },
  {
    Code: '66128',
    Description: 'Library Serv & Tech-Birth-5',
  },
  {
    Code: '66129',
    Description: 'Library Serv & Tech-Assignmen',
  },
  {
    Code: '66140',
    Description: 'Staff Development',
  },
  {
    Code: '66231',
    Description: 'Library Serv & Tech-Learn Liab',
  },
  {
    Code: '66232',
    Description: 'Library Serv & Tech-Assoc Trai',
  },
  {
    Code: '66233',
    Description: 'Library Serv & Tech-B to 5 Mar',
  },
  {
    Code: '66301',
    Description: 'Cutural Arts Foundation',
  },
  {
    Code: '66332',
    Description: 'Library Serv & Tech-Assoc Trai',
  },
  {
    Code: '66340',
    Description: 'Staff Development',
  },
  {
    Code: '6650',
    Description: 'Other Agency',
  },
  {
    Code: '6651',
    Description: 'Castranda',
  },
  {
    Code: '66510',
    Description: 'Coop Libraries of Central MD',
  },
  {
    Code: '66511',
    Description: 'Cooperative Resource Sharing',
  },
  {
    Code: '66512',
    Description: 'Coop Libraries of Central MD',
  },
  {
    Code: '6652',
    Description: 'CDBG loan repayments',
  },
  {
    Code: '6653',
    Description: 'CDBG loans',
  },
  {
    Code: '6654',
    Description: 'Community devel  CDBG',
  },
  {
    Code: '66540',
    Description: 'Staff Development',
  },
  {
    Code: '6655',
    Description: 'Development tax',
  },
  {
    Code: '6656',
    Description: 'Drug and alcohol contrib',
  },
  {
    Code: '6657',
    Description: 'Drug and alcohol escrow',
  },
  {
    Code: '6658',
    Description: 'Employee Snack Bar Escrow',
  },
  {
    Code: '6659',
    Description: 'Escrow-Space Permit',
  },
  {
    Code: '6660',
    Description: 'Escrow - Crofton Village',
  },
  {
    Code: '6661',
    Description: 'Escrow - N. Arundel CATV',
  },
  {
    Code: '6662',
    Description: 'Glen Burnie Park Gar. Escrow',
  },
  {
    Code: '6663',
    Description: 'Heritage Rental Escrows',
  },
  {
    Code: '6664',
    Description: 'Home Wenshp Assist-Escrow',
  },
  {
    Code: '6665',
    Description: 'Kaiser-Aetna',
  },
  {
    Code: '6666',
    Description: 'PST Reclamation - Royalty',
  },
  {
    Code: '6667',
    Description: 'PST, Inc. Road Escrow',
  },
  {
    Code: '6668',
    Description: 'Rehab loans  Deferred Income',
  },
  {
    Code: '6669',
    Description: 'Rehab Loans Receivable',
  },
  {
    Code: '6670',
    Description: 'River Walk at Blk Wal Esc',
  },
  {
    Code: '6671',
    Description: 'Scatter Site Loan Escrow',
  },
  {
    Code: '66710',
    Description: 'Topical Areas Review - 1997',
  },
  {
    Code: '6672',
    Description: "Sheriff's Escrow - Dist. Ct.",
  },
  {
    Code: '6673',
    Description: 'Sheriff Sale Escrow',
  },
  {
    Code: '66730',
    Description: 'Staff Develop for MCEN - 1997',
  },
  {
    Code: '6674',
    Description: 'Woodwise Purchase Escrow',
  },
  {
    Code: '66740',
    Description: 'Staff Development - 1997',
  },
  {
    Code: '6675',
    Description: 'Garden Plots',
  },
  {
    Code: '6676',
    Description: 'Employee Orioles Tickets',
  },
  {
    Code: '66760',
    Description: 'Small Business Connection-1997',
  },
  {
    Code: '6677',
    Description: 'Cable Franchise Escrow',
  },
  {
    Code: '66770',
    Description: 'LSCA Title II -Technology-1997',
  },
  {
    Code: '6678',
    Description: 'Health Dept-Septic Sys Modif.',
  },
  {
    Code: '66820',
    Description: 'Self-Service Reference - 1998',
  },
  {
    Code: '66830',
    Description: 'Staff Develop for MCEN - 1998',
  },
  {
    Code: '66840',
    Description: 'Staff Development - 1998',
  },
  {
    Code: '66850',
    Description: 'Title II-Assistive Techn -1998',
  },
  {
    Code: '66920',
    Description: 'Self Service Ref Shadow-1999',
  },
  {
    Code: '66930',
    Description: 'MCEN-1999',
  },
  {
    Code: '66940',
    Description: 'Staff Development - 1999',
  },
  {
    Code: '66960',
    Description: 'Technology Scholarship-1999',
  },
  {
    Code: '66970',
    Description: 'RUSA Conference-1999',
  },
  {
    Code: '66980',
    Description: 'Snowbird-1999',
  },
  {
    Code: '66981',
    Description: 'Gates Foundation Grant',
  },
  {
    Code: '67110',
    Description: 'LLEBG',
  },
  {
    Code: '67210',
    Description: 'LLEBG',
  },
  {
    Code: '67280',
    Description: 'YS-Project Champion Award',
  },
  {
    Code: '67281',
    Description: 'YS-Admin.',
  },
  {
    Code: '67310',
    Description: 'LLEBG',
  },
  {
    Code: '67380',
    Description: 'YS-Project Champion Award',
  },
  {
    Code: '67381',
    Description: 'YS-Admin.',
  },
  {
    Code: '67382',
    Description: 'YS-Youth Support Center',
  },
  {
    Code: '67383',
    Description: 'YS-Underage Drinking',
  },
  {
    Code: '67384',
    Description: 'YS-Keep A Clear Mind',
  },
  {
    Code: '67510',
    Description: 'Pass Through Programs PTP',
  },
  {
    Code: '67511',
    Description: 'YSB- Annapolis    PTP',
  },
  {
    Code: '67512',
    Description: 'YSB- Harundale     PTP',
  },
  {
    Code: '67513',
    Description: 'Elem. Violence Prevention',
  },
  {
    Code: '67514',
    Description: 'School Comm Ctr Grant - PTP',
  },
  {
    Code: '67515',
    Description: 'ICAPP',
  },
  {
    Code: '67516',
    Description: 'Delinquency Prevention -1999',
  },
  {
    Code: '67517',
    Description: 'Suicide Prevention',
  },
  {
    Code: '67518',
    Description: 'Adolescent Pregnancy',
  },
  {
    Code: '67519',
    Description: 'Elementary School Violence Pre',
  },
  {
    Code: '67520',
    Description: 'Family Pres-CLAY ST',
  },
  {
    Code: '67521',
    Description: 'Domestic Violence Coordinating',
  },
  {
    Code: '67530',
    Description: 'Community Partnership',
  },
  {
    Code: '67531',
    Description: 'CP-Library Parenting',
  },
  {
    Code: '67532',
    Description: 'CP-Parent Help Line',
  },
  {
    Code: '67533',
    Description: 'CP-Behavorial Interventions',
  },
  {
    Code: '67534',
    Description: 'CP-Home Visiting',
  },
  {
    Code: '67535',
    Description: 'CP-Behavorial InterventionEval',
  },
  {
    Code: '67540',
    Description: 'Delinquency Prevention',
  },
  {
    Code: '67541',
    Description: 'Mental Health Resource DP',
  },
  {
    Code: '67542',
    Description: 'Runaway Shelter DP',
  },
  {
    Code: '67543',
    Description: 'First Time Offenders Prog DP',
  },
  {
    Code: '67544',
    Description: 'Alternative Education Prog  DP',
  },
  {
    Code: '67545',
    Description: 'Family Enrichment Prog   DP',
  },
  {
    Code: '67546',
    Description: 'Project Attend  DP',
  },
  {
    Code: '67547',
    Description: 'JIFI Program  DP',
  },
  {
    Code: '67550',
    Description: 'Consolidated Grant',
  },
  {
    Code: '67560',
    Description: 'Local Education Agency',
  },
  {
    Code: '67570',
    Description: 'After School Program',
  },
  {
    Code: '67571',
    Description: 'After School Program-Hotspots',
  },
  {
    Code: '67572',
    Description: 'MD After School Opportunity',
  },
  {
    Code: '67573',
    Description: 'Lights on After School',
  },
  {
    Code: '67592',
    Description: 'LMB Admin',
  },
  {
    Code: '67593',
    Description: 'LMB Family Preservation',
  },
  {
    Code: '67594',
    Description: 'LMB Family Preservation Admin',
  },
  {
    Code: '67595',
    Description: 'Return Diversion Program',
  },
  {
    Code: '67596',
    Description: 'Return Diversion Admin',
  },
  {
    Code: '67598',
    Description: 'OCYF Base Grant',
  },
  {
    Code: '67599',
    Description: 'Medicaid',
  },
  {
    Code: '67810',
    Description: 'LLEBG - Runaway Shelter - 1998',
  },
  {
    Code: '67820',
    Description: 'Runaway Shelter - 1998',
  },
  {
    Code: '67900',
    Description: 'Rollover Savings - 1999',
  },
  {
    Code: '67902',
    Description: 'Programs - Rollover - 1999',
  },
  {
    Code: '67904',
    Description: 'Programs - Rollover - 1998',
  },
  {
    Code: '67910',
    Description: 'LLEBG - Runaway Shelter - 1999',
  },
  {
    Code: '69510',
    Description: 'Extension Service Grant',
  },
  {
    Code: '70500',
    Description: 'David Taylor NCR Grant',
  },
  {
    Code: '70510',
    Description: 'David Taylor Grant',
  },
  {
    Code: '74010',
    Description: 'LLEBG-Detention Center 2000',
  },
  {
    Code: '74030',
    Description: 'Byrne Grant- Drug Control-2000',
  },
  {
    Code: '74110',
    Description: 'LLEBG-Detention Center',
  },
  {
    Code: '74810',
    Description: 'LLEBG - Detention Ctr - 1998',
  },
  {
    Code: '74910',
    Description: 'LLEBG - Detention Ctr - 1999',
  },
  {
    Code: '74940',
    Description: 'Workforce Dev. Ed. Cntr-1999',
  },
  {
    Code: '75002',
    Description: 'Summer Youth Employ Prog 2000',
  },
  {
    Code: '75203',
    Description: 'Child Care Resource & Referral',
  },
  {
    Code: '75500',
    Description: 'Electricity Deregulation Grant',
  },
  {
    Code: '75501',
    Description: 'Base Crtkr Grant-David Taylor',
  },
  {
    Code: '75504',
    Description: 'Food Bank Inc. TEFAP',
  },
  {
    Code: '75505',
    Description: 'Food Link Program',
  },
  {
    Code: '76001',
    Description: 'WIA PY01 Title I Grant',
  },
  {
    Code: '76101',
    Description: 'WIA PY00 Title I Grant',
  },
  {
    Code: '76201',
    Description: 'WIA PY02 Title I Grant',
  },
  {
    Code: '76202',
    Description: 'PY98 Welfare-to-Work Grant',
  },
  {
    Code: '76204',
    Description: 'PY01 Rapid Response Grant',
  },
  {
    Code: '76303',
    Description: 'PY02 Metro-Tech Grant',
  },
  {
    Code: '8001',
    Description: 'Court House',
  },
  {
    Code: '8003',
    Description: 'Court House Annex',
  },
  {
    Code: '8004',
    Description: 'Court House(Allen Building)',
  },
  {
    Code: '8005',
    Description: 'Court House (New 1997)',
  },
  {
    Code: '8007',
    Description: 'Tipton Airport',
  },
  {
    Code: '8010',
    Description: 'Pumphrey Keaser Comm Ctr',
  },
  {
    Code: '8011',
    Description: 'Ralph Bunch Comm Ctr',
  },
  {
    Code: '8015',
    Description: 'Arundel Center',
  },
  {
    Code: '8020',
    Description: 'Right of Way Houses',
  },
  {
    Code: '8023',
    Description: 'Mary Mount Manor',
  },
  {
    Code: '8025',
    Description: 'Bates High School',
  },
  {
    Code: '8028',
    Description: "Sarah's House",
  },
  {
    Code: '8030',
    Description: 'Southern Mobile Maintenance',
  },
  {
    Code: '8032',
    Description: 'Alternative H.S. - Winterode',
  },
  {
    Code: '8033',
    Description: 'Winterode Bldg-C.I.D.',
  },
  {
    Code: '8035',
    Description: 'Winterode Bldg-Rec & Parks',
  },
  {
    Code: '8037',
    Description: 'Winterode Bldg-Careers Ctr',
  },
  {
    Code: '8040',
    Description: 'Brooklyn Park MS/Aging',
  },
  {
    Code: '8043',
    Description: 'Arundel Center North',
  },
  {
    Code: '8044',
    Description: 'Ice Rink',
  },
  {
    Code: '8045',
    Description: 'Glen Burnie Office Bldg',
  },
  {
    Code: '8046',
    Description: 'Animal Shelter',
  },
  {
    Code: '8047',
    Description: 'Utilities Building',
  },
  {
    Code: '8048',
    Description: 'Utilities Garage & Shop',
  },
  {
    Code: '8049',
    Description: 'Utils & Animal Cntrl-Park Lot',
  },
  {
    Code: '8050',
    Description: 'Garage - Glen Burnie',
  },
  {
    Code: '8052',
    Description: 'Glen Burnie Parking Garage',
  },
  {
    Code: '8053',
    Description: 'Glen Burnie Warehouse',
  },
  {
    Code: '8054',
    Description: 'G. B. Urban Renewal Elect Svc',
  },
  {
    Code: '8055',
    Description: 'Hein Bros. Bldg.',
  },
  {
    Code: '8056',
    Description: 'Robinson Bldg.',
  },
  {
    Code: '8058',
    Description: 'Heritage Office Bldg -2660',
  },
  {
    Code: '8059',
    Description: 'Heirtage Office Bldg - 2662',
  },
  {
    Code: '8060',
    Description: 'Heritage Office Bldg - 2664',
  },
  {
    Code: '8061',
    Description: 'Heritage Office Bldg- 2666',
  },
  {
    Code: '8063',
    Description: 'Evidence Storage Warehouse',
  },
  {
    Code: '8064',
    Description: 'Drug Lab',
  },
  {
    Code: '8066',
    Description: 'Police Dept. Headquarters',
  },
  {
    Code: '8067',
    Description: 'New Animal Control Building',
  },
  {
    Code: '8068',
    Description: 'Fire Dept. Headquarters',
  },
  {
    Code: '8070',
    Description: 'Fire Training School',
  },
  {
    Code: '8072',
    Description: 'Garage - Central & Car Wash',
  },
  {
    Code: '8074',
    Description: 'Commun Tower-Millersville',
  },
  {
    Code: '8075',
    Description: 'Commun Tower-Solomon Is Rd',
  },
  {
    Code: '8076',
    Description: 'Commun Tower-So Md Blve',
  },
  {
    Code: '8077',
    Description: 'Commun Tower-5500 Sudley Rd',
  },
  {
    Code: '8078',
    Description: 'Comm Tower & Bldg-5463 Sudley',
  },
  {
    Code: '8079',
    Description: 'Comm Tower & Bldg-Soley Rd',
  },
  {
    Code: '8080',
    Description: 'Commun Tower-Fire Hdqtrs',
  },
  {
    Code: '8081',
    Description: 'Comm Tower & Bldg-Public Works',
  },
  {
    Code: '8082',
    Description: 'Comm Tower & Bldg-Jessup FS',
  },
  {
    Code: '8083',
    Description: 'Commun Tower-Broadcreek',
  },
  {
    Code: '8085',
    Description: 'Jennifer Road Gas Pump',
  },
  {
    Code: '8088',
    Description: 'Detention Center - Ordnance',
  },
  {
    Code: '8090',
    Description: 'Detention Center',
  },
  {
    Code: '8092',
    Description: 'Garage-So Dist Central Ave 214',
  },
  {
    Code: '8093',
    Description: 'Joe Cannon Rental House',
  },
  {
    Code: '8094',
    Description: 'Broadneck Caretaker',
  },
  {
    Code: '8095',
    Description: 'Corridor Park Caretaker',
  },
  {
    Code: '8096',
    Description: 'South Farm Caretaker',
  },
  {
    Code: '8097',
    Description: 'Jug Bay Caretaker',
  },
  {
    Code: '8098',
    Description: 'Kinder Park Caretaker',
  },
  {
    Code: '8099',
    Description: 'Cook Farm Caretaker',
  },
  {
    Code: '8101',
    Description: 'Cecil Ave MV Ranger Station',
  },
  {
    Code: '8102',
    Description: 'Linthicum Walks',
  },
  {
    Code: '8108',
    Description: 'Heritage Office Center',
  },
  {
    Code: '8110',
    Description: 'Arundel Olympic Swim Center',
  },
  {
    Code: '8113',
    Description: 'Public Works Building',
  },
  {
    Code: '8115',
    Description: 'Health Department',
  },
  {
    Code: '8117',
    Description: 'Library Headquarters',
  },
  {
    Code: '8120',
    Description: 'Police - S.O.S',
  },
  {
    Code: '8121',
    Description: 'Dorsey Annex - Circuit Court',
  },
  {
    Code: '8123',
    Description: 'Senior Center - South County',
  },
  {
    Code: '8125',
    Description: "Senior Center - O'Malley",
  },
  {
    Code: '8127',
    Description: 'Senior Center - Edgewater',
  },
  {
    Code: '8128',
    Description: 'Senior Center - Pascal',
  },
  {
    Code: '8130',
    Description: 'Senior Center - Arnold',
  },
  {
    Code: '8131',
    Description: 'Pasadena Senior Center',
  },
  {
    Code: '8132',
    Description: 'Northern Health Center',
  },
  {
    Code: '8133',
    Description: 'Annapolis Senior Center',
  },
  {
    Code: '8135',
    Description: 'Sommerville Medical Center',
  },
  {
    Code: '8137',
    Description: 'Bay Head Nike Site',
  },
  {
    Code: '8138',
    Description: 'St Margarets Office Building',
  },
  {
    Code: '8139',
    Description: 'Central Mobile Maintenance',
  },
  {
    Code: '8140',
    Description: 'Hotspot',
  },
  {
    Code: '8141',
    Description: 'Police Academy',
  },
  {
    Code: '8143',
    Description: 'Police Station - Northern',
  },
  {
    Code: '8145',
    Description: 'Police Station - Southern',
  },
  {
    Code: '8147',
    Description: 'Police Station - Eastern',
  },
  {
    Code: '8149',
    Description: 'Fire Station - Paramedic Ten',
  },
  {
    Code: '8150',
    Description: 'Police Station - Western',
  },
  {
    Code: '8152',
    Description: 'Horticulture Crew',
  },
  {
    Code: '8153',
    Description: 'Beautification Projects',
  },
  {
    Code: '8156',
    Description: 'Library - Brooklyn Park',
  },
  {
    Code: '8158',
    Description: 'Library - Crofton',
  },
  {
    Code: '8160',
    Description: 'Library - N County Harundale',
  },
  {
    Code: '8162',
    Description: 'Library - Mountain Road',
  },
  {
    Code: '8164',
    Description: 'Library - Linthicum',
  },
  {
    Code: '8166',
    Description: 'Library - Odenton',
  },
  {
    Code: '8168',
    Description: 'Library - Riveria Beach',
  },
  {
    Code: '8170',
    Description: 'Library - Severna Park',
  },
  {
    Code: '8172',
    Description: 'Library - South County',
  },
  {
    Code: '8174',
    Description: 'Library - Annapolis',
  },
  {
    Code: '8176',
    Description: 'Library - Maryland City',
  },
  {
    Code: '8178',
    Description: 'Library - Eastport /Annap Neck',
  },
  {
    Code: '8180',
    Description: 'Library - Broadneck',
  },
  {
    Code: '8182',
    Description: 'Library - Provinces',
  },
  {
    Code: '8185',
    Description: 'Library - Edgewater',
  },
  {
    Code: '8186',
    Description: 'Roads - So. Friendship',
  },
  {
    Code: '8188',
    Description: 'Roads - Eastern Office Bldg.',
  },
  {
    Code: '8192',
    Description: 'Roads - Cent District-St Marg',
  },
  {
    Code: '8194',
    Description: 'Roads - Central District',
  },
  {
    Code: '8196',
    Description: 'Roads - So. Dist-Shady Side',
  },
  {
    Code: '8198',
    Description: 'Roads-So. Dist Central Ave 214',
  },
  {
    Code: '8200',
    Description: 'Roads - Western District',
  },
  {
    Code: '8202',
    Description: 'Roads - Northern District',
  },
  {
    Code: '8208',
    Description: 'Landfill - Glen Burnie',
  },
  {
    Code: '8209',
    Description: 'Landfill - Millersville',
  },
  {
    Code: '8210',
    Description: 'Landfill - S County(Sudley)',
  },
  {
    Code: '8211',
    Description: 'Odenton Health Center',
  },
  {
    Code: '8214',
    Description: 'Rds/Gar So Dist Cent Ave 214 C',
  },
  {
    Code: '8216',
    Description: 'Londontown Publik House',
  },
  {
    Code: '8222',
    Description: 'CSSC',
  },
  {
    Code: '8224',
    Description: 'Air Quality Lab',
  },
  {
    Code: '8225',
    Description: 'Materials Lab - St Marg',
  },
  {
    Code: '8226',
    Description: 'David Taylor Building',
  },
  {
    Code: '8229',
    Description: 'Cecil Avenue',
  },
  {
    Code: '8230',
    Description: 'Owensville Medical',
  },
  {
    Code: '8231',
    Description: 'Rec. Center - South County',
  },
  {
    Code: '8233',
    Description: 'Northern Mobile Maint.',
  },
  {
    Code: '8235',
    Description: 'Rec. & Parks - Golf Course',
  },
  {
    Code: '8236',
    Description: 'R & P - Golf Course Maint Bldg',
  },
  {
    Code: '8238',
    Description: 'R & P - Triton/Beverly Beach',
  },
  {
    Code: '8240',
    Description: 'Jessup YMCA',
  },
  {
    Code: '8241',
    Description: 'Rec. & Parks - Quiet Waters',
  },
  {
    Code: '8243',
    Description: 'Fire Station - Glen Burnie',
  },
  {
    Code: '8245',
    Description: 'Fire Station - Cape St. Claire',
  },
  {
    Code: '8247',
    Description: 'Fire Station - S Glen Burnie',
  },
  {
    Code: '8249',
    Description: 'Fire Station - Harmans/Dorsey',
  },
  {
    Code: '8251',
    Description: 'Fire Station - Jones Station',
  },
  {
    Code: '8253',
    Description: 'Fire Station - Jessup',
  },
  {
    Code: '8255',
    Description: 'Fire Station - Lombardee Beach',
  },
  {
    Code: '8257',
    Description: 'Fire Station - Linthicum',
  },
  {
    Code: '8259',
    Description: 'Fire Station - Maryland City',
  },
  {
    Code: '8261',
    Description: 'Fire Station - Waugh Chapel',
  },
  {
    Code: '8263',
    Description: 'Fire Station - West Annapolis',
  },
  {
    Code: '8264',
    Description: 'Fire Station-Vol/Green Haven',
  },
  {
    Code: '8265',
    Description: 'Fire Station - Harwood/Lothian',
  },
  {
    Code: '8267',
    Description: 'Fire Station-Vol/Orchard Beach',
  },
  {
    Code: '8268',
    Description: 'Fire Station - Armiger',
  },
  {
    Code: '8279',
    Description: 'Miscellaneous',
  },
  {
    Code: '8280',
    Description: 'Jessup Commuter Rail Station',
  },
  {
    Code: '8286',
    Description: 'Fire Station-Vol/Arnold',
  },
  {
    Code: '8288',
    Description: 'Fire Station-Vol/Arundel',
  },
  {
    Code: '8290',
    Description: 'Fire Station - Avalon Shores',
  },
  {
    Code: '8292',
    Description: 'Fire Station-Vol/Brooklyn',
  },
  {
    Code: '8294',
    Description: 'Fire Station-Vol/Deale',
  },
  {
    Code: '8296',
    Description: 'Fire Station-Vol/Erlgh Hghts',
  },
  {
    Code: '8298',
    Description: 'Fire Station-Vol/Ferndale',
  },
  {
    Code: '8300',
    Description: 'Fire Station-Vol/Galesville',
  },
  {
    Code: '8302',
    Description: 'Fire Station-Vol/Herald Harbor',
  },
  {
    Code: '8304',
    Description: 'Fire Station-Vol/Lake Shore',
  },
  {
    Code: '8306',
    Description: 'Fire Station - Marley',
  },
  {
    Code: '8308',
    Description: 'Fire Station-Vol/Odenton',
  },
  {
    Code: '8310',
    Description: 'Bell Branch Park',
  },
  {
    Code: '8312',
    Description: 'Fire Station-Vol/Powhatan Bch',
  },
  {
    Code: '8314',
    Description: 'Fire Station-Vol/Riva',
  },
  {
    Code: '8316',
    Description: 'Fire Station-Vol/Riveria Beach',
  },
  {
    Code: '8318',
    Description: 'Fire Station-Vol/Woodland Bch',
  },
  {
    Code: '8320',
    Description: 'Fire Rescue Squad - 7th Dist',
  },
  {
    Code: '8322',
    Description: 'Rec & Parks - Downs Memorial',
  },
  {
    Code: '8323',
    Description: 'Rec & Parks - Kinder Park',
  },
  {
    Code: '8324',
    Description: 'Rec & Parks - Lake Waterford',
  },
  {
    Code: '8325',
    Description: 'Rec & Parks - Mayo Beach',
  },
  {
    Code: '8326',
    Description: 'Rec & Parks - Harmans Park',
  },
  {
    Code: '8327',
    Description: 'Rec & Parks - High Point Park',
  },
  {
    Code: '8328',
    Description: 'Rec & Parks - Thomas Point',
  },
  {
    Code: '8329',
    Description: 'R&P-Davidsonville Family R C',
  },
  {
    Code: '8330',
    Description: 'Rec & Parks - Equestrian Cntr',
  },
  {
    Code: '8331',
    Description: 'Rec & Parks - Andover Park',
  },
  {
    Code: '8332',
    Description: 'Rec & Parks - Sawmill Creek',
  },
  {
    Code: '8333',
    Description: 'Rec & Parks - Md City Rec A',
  },
  {
    Code: '8334',
    Description: 'Rec & Parks - Jug Bay Rec A',
  },
  {
    Code: '8335',
    Description: 'Rec & Parks - Joe Cannon Stdm',
  },
  {
    Code: '8336',
    Description: 'Annapolis High Court',
  },
  {
    Code: '8337',
    Description: 'Arden of the Seven Park',
  },
  {
    Code: '8338',
    Description: 'Arnold Park',
  },
  {
    Code: '8339',
    Description: 'Arundel Hills Park',
  },
  {
    Code: '8340',
    Description: 'Arundel Village',
  },
  {
    Code: '8341',
    Description: 'B & A Trail Park',
  },
  {
    Code: '8342',
    Description: 'Bacontown Park',
  },
  {
    Code: '8344',
    Description: 'Belvedere Park',
  },
  {
    Code: '8345',
    Description: 'Bestgate Park',
  },
  {
    Code: '8346',
    Description: 'Beverly/Triton Beach',
  },
  {
    Code: '8347',
    Description: 'Brooklyn Park 2',
  },
  {
    Code: '8348',
    Description: 'Brownswood Park',
  },
  {
    Code: '8349',
    Description: 'Crofton Park',
  },
  {
    Code: '8350',
    Description: "Deale/Tracy's Park",
  },
  {
    Code: '8351',
    Description: 'Edgewater Park',
  },
  {
    Code: '8352',
    Description: 'Elvation Park',
  },
  {
    Code: '8353',
    Description: 'Freetown Park',
  },
  {
    Code: '8354',
    Description: 'Glen Burnie Park',
  },
  {
    Code: '8355',
    Description: 'Herald Harbor Park',
  },
  {
    Code: '8356',
    Description: 'Jacobsville Park',
  },
  {
    Code: '8357',
    Description: 'Jessup/Dorsey Park',
  },
  {
    Code: '8358',
    Description: 'Jessup Provinces Park',
  },
  {
    Code: '8359',
    Description: 'Lake Shore Athletic Complex',
  },
  {
    Code: '8360',
    Description: 'Lake Shore Park',
  },
  {
    Code: '8361',
    Description: 'Linthicum Park',
  },
  {
    Code: '8362',
    Description: 'Loch Haven Park',
  },
  {
    Code: '8363',
    Description: 'Tick Neck Park',
  },
  {
    Code: '8364',
    Description: 'Odenton Park',
  },
  {
    Code: '8365',
    Description: 'Overlook Park',
  },
  {
    Code: '8366',
    Description: 'Peninsula Park(AOB)',
  },
  {
    Code: '8367',
    Description: 'Pleasantville Park',
  },
  {
    Code: '8368',
    Description: 'Point Pleasant Park',
  },
  {
    Code: '8369',
    Description: 'Poplar Ridge/Ft Smallwood',
  },
  {
    Code: '8370',
    Description: 'Pumphrey Park',
  },
  {
    Code: '8371',
    Description: 'Queenstown Park',
  },
  {
    Code: '8372',
    Description: 'Riverside Park',
  },
  {
    Code: '8373',
    Description: 'Riverwood Park',
  },
  {
    Code: '8374',
    Description: 'Rock Creek Park',
  },
  {
    Code: '8375',
    Description: 'Shady Side Park',
  },
  {
    Code: '8376',
    Description: "Shipley' Choice",
  },
  {
    Code: '8378',
    Description: 'Solley Park',
  },
  {
    Code: '8379',
    Description: 'So County Softball Field',
  },
  {
    Code: '8380',
    Description: 'Southgate/Old Mill Park',
  },
  {
    Code: '8381',
    Description: 'So. River Farm',
  },
  {
    Code: '8382',
    Description: 'South Shore Trail',
  },
  {
    Code: '8383',
    Description: 'Sunset Park',
  },
  {
    Code: '8384',
    Description: 'Towers Branch Park',
  },
  {
    Code: '8385',
    Description: 'Twin Oaks',
  },
  {
    Code: '8386',
    Description: 'Waterbury Park',
  },
  {
    Code: '8387',
    Description: "Carr's Wharf",
  },
  {
    Code: '8388',
    Description: 'Deale Wharf',
  },
  {
    Code: '8389',
    Description: 'Freetown Rec. Center',
  },
  {
    Code: '8390',
    Description: 'Galesville Wharf',
  },
  {
    Code: '8391',
    Description: 'Hancocks Resolution',
  },
  {
    Code: '8392',
    Description: 'Londontown Publik House',
  },
  {
    Code: '8393',
    Description: 'Meade Village Rec. Center',
  },
  {
    Code: '8394',
    Description: 'South County Rec. Center',
  },
  {
    Code: '8396',
    Description: 'Upton Road Softball Complex',
  },
  {
    Code: '8397',
    Description: 'Brooklyn Park 1',
  },
  {
    Code: '8398',
    Description: 'Cape St. Claire Park',
  },
  {
    Code: '8399',
    Description: 'Cedar Hill Park',
  },
  {
    Code: '8400',
    Description: 'Cypress Creek Park',
  },
  {
    Code: '8401',
    Description: 'Davidsonville Park',
  },
  {
    Code: '8402',
    Description: 'Bell Branch Park',
  },
  {
    Code: '8403',
    Description: 'Friendship Park',
  },
  {
    Code: '8404',
    Description: 'Hammonds Park',
  },
  {
    Code: '8405',
    Description: 'Havenwood Park',
  },
  {
    Code: '8406',
    Description: 'Jessup 1 Park',
  },
  {
    Code: '8407',
    Description: 'Mago Vista Park',
  },
  {
    Code: '8408',
    Description: 'North Glen Park',
  },
  {
    Code: '8409',
    Description: 'Corridor Park',
  },
  {
    Code: '8410',
    Description: 'Severn/Danza Park',
  },
  {
    Code: '8411',
    Description: 'Broadneck',
  },
  {
    Code: '8413',
    Description: 'Bodkin Park',
  },
  {
    Code: '8414',
    Description: 'Bachman Park',
  },
  {
    Code: '8415',
    Description: 'BW & A Trailer Park - MV',
  },
  {
    Code: '8419',
    Description: 'Smith Horse Farm',
  },
  {
    Code: '8420',
    Description: 'Furniture Repairs',
  },
  {
    Code: '9000',
    Description: 'Library',
  },
  {
    Code: '9001',
    Description: 'Library Revenues',
  },
  {
    Code: '9002',
    Description: 'Annapolis Branch',
  },
  {
    Code: '9003',
    Description: 'Brooklyn Branch',
  },
  {
    Code: '9004',
    Description: 'Linthicum Branch',
  },
  {
    Code: '9005',
    Description: 'North County Branch',
  },
  {
    Code: '9006',
    Description: 'Odenton Branch',
  },
  {
    Code: '9007',
    Description: 'Riviera Beach Branch',
  },
  {
    Code: '9008',
    Description: 'Severna Park Branch',
  },
  {
    Code: '9009',
    Description: 'South County Branch',
  },
  {
    Code: '9010',
    Description: 'Administration',
  },
  {
    Code: '9011',
    Description: 'Crofton Branch',
  },
  {
    Code: '9012',
    Description: 'Annapolis Neck Branch',
  },
  {
    Code: '9013',
    Description: 'Maryland City Branch',
  },
  {
    Code: '9014',
    Description: 'Broadneck Branch',
  },
  {
    Code: '9015',
    Description: 'Provinces Branch',
  },
  {
    Code: '9016',
    Description: 'Edgewater Branch',
  },
  {
    Code: '9017',
    Description: 'Mountain Rd Branch',
  },
  {
    Code: '9050',
    Description: 'CLCM Escrow',
  },
  {
    Code: '9051',
    Description: 'Elizabeth Werner Memorial',
  },
  {
    Code: '9052',
    Description: 'Elmer M Jackson Jr. Mem Fund',
  },
  {
    Code: '9053',
    Description: 'Library Updates',
  },
  {
    Code: '9054',
    Description: 'Memorial',
  },
  {
    Code: '9055',
    Description: 'Miscellaneous Donations',
  },
  {
    Code: '9061',
    Description: 'Special Projects',
  },
  {
    Code: '9062',
    Description: 'Staff AV',
  },
  {
    Code: '9063',
    Description: 'Staff Benefits',
  },
  {
    Code: '9064',
    Description: 'Staff Books',
  },
  {
    Code: '9065',
    Description: 'MLGIP Investment Earnings',
  },
  {
    Code: '9066',
    Description: 'Training',
  },
  {
    Code: '9067',
    Description: 'Maryland City Opening',
  },
  {
    Code: '9068',
    Description: 'Tech Scholarship',
  },
  {
    Code: '9069',
    Description: 'DLDS/Encly Brit Escrow',
  },
  {
    Code: '9070',
    Description: 'Staff Book Shipping',
  },
  {
    Code: '9071',
    Description: 'MCEN Registration',
  },
  {
    Code: '9072',
    Description: 'Summer Reading Promotions',
  },
  {
    Code: '9083',
    Description: 'Univ. Svc Fund Refund',
  },
  {
    Code: '9090',
    Description: 'Library  GASB34 Conversion Fd',
  },
  {
    Code: '9091',
    Description: 'Asset Expense',
  },
  {
    Code: '9100',
    Description: 'Library Grants Special Revenue',
  },
  {
    Code: '9197',
    Description: 'Library Deferred Compensation',
  },
  {
    Code: '9198',
    Description: 'Library General Long Term Debt',
  },
  {
    Code: '9199',
    Description: 'Library General Fixed Assets',
  },
  {
    Code: '9200',
    Description: 'Board of Education',
  },
  {
    Code: '9201',
    Description: 'Board of Education Revenues',
  },
  {
    Code: '9202',
    Description: 'Administration',
  },
  {
    Code: '9203',
    Description: 'Mid-Level Admin',
  },
  {
    Code: '9204',
    Description: 'Instructional Salaries',
  },
  {
    Code: '9205',
    Description: 'Other Instruct Cost',
  },
  {
    Code: '9206',
    Description: 'Textbooks/Supplies',
  },
  {
    Code: '9207',
    Description: 'Pupil Services',
  },
  {
    Code: '9208',
    Description: 'Pupil Transportation',
  },
  {
    Code: '9209',
    Description: 'Operation of Plant',
  },
  {
    Code: '9210',
    Description: 'Maintenance of Plant',
  },
  {
    Code: '9211',
    Description: 'Fixed Charges',
  },
  {
    Code: '9212',
    Description: 'Community Services',
  },
  {
    Code: '9213',
    Description: 'Capital Outlay',
  },
  {
    Code: '9214',
    Description: 'Debt Service',
  },
  {
    Code: '9215',
    Description: 'Special Education',
  },
  {
    Code: '9300',
    Description: 'Community College (Budget Only',
  },
  {
    Code: '9301',
    Description: 'Community College Fund Revenue',
  },
  {
    Code: '9302',
    Description: 'Instruction',
  },
  {
    Code: '9303',
    Description: 'Academic Support',
  },
  {
    Code: '9304',
    Description: 'Student Services',
  },
  {
    Code: '9305',
    Description: 'Plant Operations',
  },
  {
    Code: '9306',
    Description: 'Institutional Support',
  },
  {
    Code: '9307',
    Description: 'Debt Service',
  },
  {
    Code: '9400',
    Description: 'Workforce Development Corp.',
  },
  {
    Code: '9800',
    Description: 'General Long Term Debt',
  },
  {
    Code: '9900',
    Description: 'General Fixed Assets',
  },
  {
    Code: '9901',
    Description: 'Asset Expense',
  },
  {
    Code: '9990',
    Description: 'Blanket Purchase Orders',
  },
  {
    Code: '9995',
    Description: 'Cent Serv Property Inventory',
  },
  {
    Code: '9996',
    Description: 'CS Prop Inv - Asset Expense',
  },
  {
    Code: '9998',
    Description: 'Master Model 2',
  },
  {
    Code: '9999',
    Description: 'Master Business Unit',
  },
];

export const companyNumbers = [
  {
    Co: '01000',
    Name: 'General Fund',
  },
  {
    Co: '01002',
    Name: 'Revenue Reserve Fund',
  },
  {
    Co: '01003',
    Name: 'Central Cash',
  },
  {
    Co: '01004',
    Name: 'Reserve for Perm Public Improv',
  },
  {
    Co: '01015',
    Name: 'Eisenhower Cap Reserve Fund',
  },
  {
    Co: '01020',
    Name: 'Compass Pointe Cap Resrve Fund',
  },
  {
    Co: '01021',
    Name: 'Compass Pointe Dbt Svc Res Fun',
  },
  {
    Co: '02000',
    Name: 'Parking Garage Spec Rev Fund',
  },
  {
    Co: '02010',
    Name: 'Rec & Parks Child Care Fund',
  },
  {
    Co: '02100',
    Name: 'Developer Street Light Fund',
  },
  {
    Co: '02101',
    Name: 'Developer Street Light CP',
  },
  {
    Co: '02102',
    Name: 'Bike,Ped,Trans&Infrastr F-I-L',
  },
  {
    Co: '02105',
    Name: 'Bond Premium Revenue Fund',
  },
  {
    Co: '02109',
    Name: 'Criminal Reimbursement Fund',
  },
  {
    Co: '02110',
    Name: 'Forfeit & Asset Seizure Fnd',
  },
  {
    Co: '02120',
    Name: 'Community Development Fund',
  },
  {
    Co: '02130',
    Name: 'Energy Loan Revolving Fund',
  },
  {
    Co: '02150',
    Name: 'Conference & Visitors Fund',
  },
  {
    Co: '02160',
    Name: 'Economic Development Fund',
  },
  {
    Co: '02170',
    Name: 'Incentive Loan Program Fund',
  },
  {
    Co: '02180',
    Name: 'Piney Orchard WWS Fund',
  },
  {
    Co: '02200',
    Name: 'Partnership Children Yth & Fam',
  },
  {
    Co: '02201',
    Name: 'Finance-Non Department',
  },
  {
    Co: '02210',
    Name: 'Grant Fund-Chief Adm Office',
  },
  {
    Co: '02215',
    Name: 'Grant Fund-Circuit Court',
  },
  {
    Co: '02220',
    Name: 'Grant Fund-Fire Dept',
  },
  {
    Co: '02222',
    Name: 'Grant Fund - OEM',
  },
  {
    Co: '02225',
    Name: 'Grant Fund-Health Dept',
  },
  {
    Co: '02230',
    Name: 'Grant Fund-Police Dept',
  },
  {
    Co: '02235',
    Name: 'Grant Fund-Planning & Zoning',
  },
  {
    Co: '02237',
    Name: 'Grant Fund - Transportation',
  },
  {
    Co: '02240',
    Name: "Grant Fund-Sheriff's Office",
  },
  {
    Co: '02245',
    Name: 'Grant Fund-Social Services',
  },
  {
    Co: '02250',
    Name: "Grant Fund-State's Attorney",
  },
  {
    Co: '02255',
    Name: 'Grant Fund-Dept of Aging',
  },
  {
    Co: '02260',
    Name: 'Grant Fund-Detention Center',
  },
  {
    Co: '02262',
    Name: 'Grant Fund - Central Services',
  },
  {
    Co: '02265',
    Name: 'Grant Fund-Public Works',
  },
  {
    Co: '02270',
    Name: 'Grant Fund - Rec & Parks',
  },
  {
    Co: '02275',
    Name: 'Grant Fund-Insp & Permits',
  },
  {
    Co: '02280',
    Name: 'Grant Fund OIT',
  },
  {
    Co: '02290',
    Name: 'Housing Trust',
  },
  {
    Co: '02301',
    Name: 'Impact Fees-Schools, Dist 1',
  },
  {
    Co: '02302',
    Name: 'Impact Fees-Schools, Dist 2',
  },
  {
    Co: '02303',
    Name: 'Impact Fees-Schools, Dist 3',
  },
  {
    Co: '02304',
    Name: 'Impact Fees-Schools, Dist 4',
  },
  {
    Co: '02305',
    Name: 'Impact Fees-Schools, Dist 5',
  },
  {
    Co: '02306',
    Name: 'Impact Fees-Schools, Dist 6',
  },
  {
    Co: '02307',
    Name: 'Impact Fees-Schools, Dist 7',
  },
  {
    Co: '02308',
    Name: 'Impact Fees-HIghways, Dist 1',
  },
  {
    Co: '02309',
    Name: 'Impact Fees-Highways, Dist 2',
  },
  {
    Co: '02310',
    Name: 'Impact Fees-Highways, Dist 3',
  },
  {
    Co: '02311',
    Name: 'Impact Fees-Highways, Dist 4',
  },
  {
    Co: '02312',
    Name: 'Impact Fees-Highways, Dist 5',
  },
  {
    Co: '02313',
    Name: 'Imp Fees-Hwy. Greenburch La',
  },
  {
    Co: '02314',
    Name: 'Developer Agree-Russett',
  },
  {
    Co: '02315',
    Name: 'Developer Agree-Americbanc',
  },
  {
    Co: '02316',
    Name: 'Developer Agree-Seven Oaks',
  },
  {
    Co: '02317',
    Name: 'Developer Agree-Piney Orchard',
  },
  {
    Co: '02318',
    Name: 'West Annapolis Elementary',
  },
  {
    Co: '02319',
    Name: 'Arundel Senior High School',
  },
  {
    Co: '02320',
    Name: 'Odenton Elementary',
  },
  {
    Co: '02321',
    Name: 'Waugh Chapel Elementary',
  },
  {
    Co: '02322',
    Name: 'Crofton Elementary',
  },
  {
    Co: '02323',
    Name: 'Crofton Woods Elementary',
  },
  {
    Co: '02324',
    Name: 'Belvedere Elementary',
  },
  {
    Co: '02325',
    Name: 'Broadneck Elementary',
  },
  {
    Co: '02326',
    Name: 'Cape St. Claire Elementary',
  },
  {
    Co: '02327',
    Name: 'Windsor Farm Elementary',
  },
  {
    Co: '02328',
    Name: 'Magothy River Middle',
  },
  {
    Co: '02329',
    Name: 'Ft Smallwood Elementary',
  },
  {
    Co: '02330',
    Name: 'Jacobsville Elementary',
  },
  {
    Co: '02331',
    Name: 'Lake Shore Elementary',
  },
  {
    Co: '02332',
    Name: 'Pasadena Elementary',
  },
  {
    Co: '02333',
    Name: 'Oakwood Elementary',
  },
  {
    Co: '02334',
    Name: 'Richard Henry Lee Elementary',
  },
  {
    Co: '02335',
    Name: 'Marley Middle School',
  },
  {
    Co: '02336',
    Name: 'Freetown Elementary',
  },
  {
    Co: '02337',
    Name: 'Marley Elementary',
  },
  {
    Co: '02338',
    Name: 'Harmans Elementary',
  },
  {
    Co: '02339',
    Name: 'North County Sr High School',
  },
  {
    Co: '02340',
    Name: 'George Fox MIddle School',
  },
  {
    Co: '02341',
    Name: 'High Point Elementary',
  },
  {
    Co: '02342',
    Name: 'Sunset Elementary',
  },
  {
    Co: '02343',
    Name: 'Olde Mill Sr High School',
  },
  {
    Co: '02344',
    Name: 'Severn Elementary',
  },
  {
    Co: '02345',
    Name: 'Southgate Elementary',
  },
  {
    Co: '02346',
    Name: 'Glen Burnie Park Elementary',
  },
  {
    Co: '02347',
    Name: 'Millersville Elementary',
  },
  {
    Co: '02348',
    Name: 'Ridgeway Elementary',
  },
  {
    Co: '02349',
    Name: 'South Shore Elementary',
  },
  {
    Co: '02350',
    Name: 'Southgate-Elvation Towne',
  },
  {
    Co: '02351',
    Name: 'Severna Pk. Sr. High School',
  },
  {
    Co: '02352',
    Name: 'Folger McKinsey Elem',
  },
  {
    Co: '02353',
    Name: 'Jones Elementary',
  },
  {
    Co: '02354',
    Name: 'Davidsonville Elementary',
  },
  {
    Co: '02355',
    Name: 'Southern Middle School',
  },
  {
    Co: '02356',
    Name: 'Lothian Elementary',
  },
  {
    Co: '02357',
    Name: 'Shady Side Elementary',
  },
  {
    Co: '02358',
    Name: 'Traceys Elementary',
  },
  {
    Co: '02359',
    Name: 'Four Seasons Elementary',
  },
  {
    Co: '02360',
    Name: 'Magothy River Middle School',
  },
  {
    Co: '02361',
    Name: 'Belvedere El Students Only',
  },
  {
    Co: '02362',
    Name: 'Developer Agree Opus East',
  },
  {
    Co: '02363',
    Name: 'Four Seasons E/S-Crofton Farms',
  },
  {
    Co: '02364',
    Name: 'DEVELOPER AGREE-CITY OF ANNAPO',
  },
  {
    Co: '02365',
    Name: 'Impact Fees-Highway,  Dist 6',
  },
  {
    Co: '02400',
    Name: 'Impact Fees Public Safety',
  },
  {
    Co: '02450',
    Name: 'Laurel Race Track Comm Ben Fnd',
  },
  {
    Co: '02460',
    Name: 'Video Lottery Local Impact Aid',
  },
  {
    Co: '02500',
    Name: 'Annapolis Roads SCBD',
  },
  {
    Co: '02505',
    Name: 'Arundel on the Bay SCBD',
  },
  {
    Co: '02510',
    Name: 'Avalon Shores SCBD',
  },
  {
    Co: '02515',
    Name: 'Bay Highlands SCBD',
  },
  {
    Co: '02520',
    Name: 'Farmington Village-Small Lot',
  },
  {
    Co: '02525',
    Name: 'Beverly Beach SCBD',
  },
  {
    Co: '02530',
    Name: 'Birchwood SCBD',
  },
  {
    Co: '02535',
    Name: 'Cape Anne SCBD',
  },
  {
    Co: '02540',
    Name: 'Cape St. Claire SCBD',
  },
  {
    Co: '02545',
    Name: 'Cedarhurst SCBD',
  },
  {
    Co: '02550',
    Name: 'Chartwell SCBD',
  },
  {
    Co: '02555',
    Name: 'Columbia Beach SCBD',
  },
  {
    Co: '02560',
    Name: 'Crofton SCBD',
  },
  {
    Co: '02563',
    Name: 'Deale Beach SCBD',
  },
  {
    Co: '02565',
    Name: 'Epping Forest SCBD',
  },
  {
    Co: '02570',
    Name: 'Fairhaven Cliffs SCBD',
  },
  {
    Co: '02571',
    Name: 'Felicity Cove SCBD',
  },
  {
    Co: '02575',
    Name: 'Franklin Manor SCBD',
  },
  {
    Co: '02580',
    Name: 'Gibson Island SCBD',
  },
  {
    Co: '02582',
    Name: 'Greenbriar Gardens SCBD',
  },
  {
    Co: '02583',
    Name: 'Herald Harbor SCBD',
  },
  {
    Co: '02584',
    Name: 'Upper Magothy Beach SCBD',
  },
  {
    Co: '02585',
    Name: 'Hillsmere Shores SCBD',
  },
  {
    Co: '02586',
    Name: 'Highview on the Bay SCBD',
  },
  {
    Co: '02590',
    Name: 'Farmington Village-Large Lot',
  },
  {
    Co: '02595',
    Name: 'Hunters Harbor SCBD',
  },
  {
    Co: '02600',
    Name: 'Indian Hills (Winchester) SCBD',
  },
  {
    Co: '02605',
    Name: 'Landhaven SCBD',
  },
  {
    Co: '02607',
    Name: 'Little Magothy River SCBD',
  },
  {
    Co: '02610',
    Name: 'Long Point on the Severn SCBD',
  },
  {
    Co: '02615',
    Name: 'Manhattan Beach SCBD',
  },
  {
    Co: '02618',
    Name: 'North Beach Park SCBD',
  },
  {
    Co: '02620',
    Name: 'Owings Beach SCBD',
  },
  {
    Co: '02625',
    Name: 'Oyster Harbor SCBD',
  },
  {
    Co: '02630',
    Name: 'Parke West SCBD',
  },
  {
    Co: '02631',
    Name: 'Provinces SCBD',
  },
  {
    Co: '02632',
    Name: 'Pine Grove SCBD',
  },
  {
    Co: '02633',
    Name: 'Pines on the Severn SCBD',
  },
  {
    Co: '02635',
    Name: "Queen's Park SCBD",
  },
  {
    Co: '02636',
    Name: 'Rock View Bch/Riviera Isle SCB',
  },
  {
    Co: '02637',
    Name: 'Scheides Cove Community SCBD',
  },
  {
    Co: '02640',
    Name: 'Selby on the Bay SCBD',
  },
  {
    Co: '02645',
    Name: 'Severndale SCBD',
  },
  {
    Co: '02650',
    Name: 'Sherwood Forest SCBD',
  },
  {
    Co: '02655',
    Name: 'Shoreham Beach SCBD',
  },
  {
    Co: '02660',
    Name: 'Southgate SCBD',
  },
  {
    Co: '02665',
    Name: 'South River Heights SCBD',
  },
  {
    Co: '02670',
    Name: 'South River Manor SCBD',
  },
  {
    Co: '02675',
    Name: 'South River Park SCBD',
  },
  {
    Co: '02680',
    Name: 'Steedman Point SCBD',
  },
  {
    Co: '02685',
    Name: 'Tanglewood Lane SCBD',
  },
  {
    Co: '02690',
    Name: 'Venice Beach SCBD',
  },
  {
    Co: '02691',
    Name: 'Warthen Knolls SCBD',
  },
  {
    Co: '02692',
    Name: 'Heritage SCBD',
  },
  {
    Co: '02695',
    Name: 'Woodland Beach SCBD',
  },
  {
    Co: '02700',
    Name: 'Highland Beach SCBD',
  },
  {
    Co: '02705',
    Name: 'Carrollton Manor SCBD',
  },
  {
    Co: '02710',
    Name: 'Woodland Beach/Pasadena SCBD',
  },
  {
    Co: '02715',
    Name: 'Eden Wood SCBD',
  },
  {
    Co: '02720',
    Name: 'Amberley SCBD',
  },
  {
    Co: '02725',
    Name: 'Severna Forest SCBD',
  },
  {
    Co: '02730',
    Name: 'Sylvan View SCBD',
  },
  {
    Co: '02735',
    Name: 'Hillsmere Estates/Shore SCBD',
  },
  {
    Co: '02740',
    Name: 'Bay Ridge-Spec Off SCBD',
  },
  {
    Co: '02745',
    Name: 'Farmington Village-Townhouses',
  },
  {
    Co: '02750',
    Name: 'Stone Haven SCBD',
  },
  {
    Co: '02755',
    Name: 'Venice on the Bay SCBD',
  },
  {
    Co: '02760',
    Name: 'Farm Vill-Townhome Undeveloped',
  },
  {
    Co: '02765',
    Name: 'Farm Vill-Lrg Lot-Undev Sin F',
  },
  {
    Co: '02770',
    Name: 'Greenbriar II SCBD',
  },
  {
    Co: '02775',
    Name: 'Magothy Beach SCBD',
  },
  {
    Co: '02776',
    Name: 'Magothy Forge SCBD',
  },
  {
    Co: '02777',
    Name: 'Capetowne SCBD',
  },
  {
    Co: '02778',
    Name: 'Idlewilde SCBD',
  },
  {
    Co: '02779',
    Name: 'Severn Grove SCBD',
  },
  {
    Co: '02780',
    Name: 'Wilenor SCBD',
  },
  {
    Co: '02785',
    Name: 'Bittersweet SCBD',
  },
  {
    Co: '02786',
    Name: 'Bayside Beach SCBD',
  },
  {
    Co: '02787',
    Name: 'SCB Owings Cliffs',
  },
  {
    Co: '02788',
    Name: 'SCB Homewood',
  },
  {
    Co: '02789',
    Name: 'Sylvan Shores SCBD',
  },
  {
    Co: '02790',
    Name: 'Broadwater Creek SCBD',
  },
  {
    Co: '02791',
    Name: 'Masons Beach SCBD',
  },
  {
    Co: '02792',
    Name: 'Kensington SCBD',
  },
  {
    Co: '02793',
    Name: 'Mil-Bur SCBD',
  },
  {
    Co: '02794',
    Name: 'Loch Haven SCBD',
  },
  {
    Co: '02800',
    Name: 'Nursery Rd Tax Increment Fund',
  },
  {
    Co: '02801',
    Name: 'West Cnty Dev Dist Tax Inc Fnd',
  },
  {
    Co: '02802',
    Name: 'Farmingtn Vlg Spc Tax Dist Fnd',
  },
  {
    Co: '02803',
    Name: 'Park Place Tax Increment Fund',
  },
  {
    Co: '02804',
    Name: 'Arundel Mills Tax Inc Dist',
  },
  {
    Co: '02805',
    Name: 'Parole TC Dev Dist Tax Inc Fnd',
  },
  {
    Co: '02806',
    Name: 'Natl Bus Pk Spcl Tax Dist Fnd',
  },
  {
    Co: '02807',
    Name: 'Dorchester Specl Tax Dist Fund',
  },
  {
    Co: '02808',
    Name: 'National Business Park - North',
  },
  {
    Co: '02809',
    Name: 'Village South at Waugh Chapel',
  },
  {
    Co: '02810',
    Name: 'Odenton Town Center',
  },
  {
    Co: '02811',
    Name: 'MD Live Conference Ctr Dev Dis',
  },
  {
    Co: '02850',
    Name: 'Ag & Wdlnd Prsrvtn Sinking Fnd',
  },
  {
    Co: '02900',
    Name: 'Annapolis Cove ECD',
  },
  {
    Co: '02905',
    Name: 'Annaplis Landing ECD',
  },
  {
    Co: '02910',
    Name: 'Bay Ridge-N. Farragut ECD',
  },
  {
    Co: '02912',
    Name: 'Bay Ridge-W. Herndon ECD',
  },
  {
    Co: '02915',
    Name: 'Browns Pond WID',
  },
  {
    Co: '02920',
    Name: 'Cape Anne ECD',
  },
  {
    Co: '02922',
    Name: 'Cattail Creek WID',
  },
  {
    Co: '02925',
    Name: "Elizabeth's Landing ECD",
  },
  {
    Co: '02930',
    Name: "John's Creek WID",
  },
  {
    Co: '02935',
    Name: 'Lake Hillsmere WID',
  },
  {
    Co: '02940',
    Name: 'Lake Placid WID',
  },
  {
    Co: '02945',
    Name: 'Pine Grove Village ECD',
  },
  {
    Co: '02950',
    Name: 'Snug Harbor ECD',
  },
  {
    Co: '02955',
    Name: 'Snug Harbor SCBD',
  },
  {
    Co: '02960',
    Name: 'Arundel on the Bay ECD',
  },
  {
    Co: '02961',
    Name: 'Camp Wabanna ECD',
  },
  {
    Co: '02965',
    Name: 'Snug Harbor WID',
  },
  {
    Co: '02970',
    Name: 'Spriggs Pond WID',
  },
  {
    Co: '02975',
    Name: 'Ulmstead Estates ECD',
  },
  {
    Co: '02980',
    Name: 'Romar Estates WID',
  },
  {
    Co: '02985',
    Name: 'Buchingham Cove WID',
  },
  {
    Co: '02990',
    Name: 'Lake Hillsmere II WID',
  },
  {
    Co: '02991',
    Name: 'Whitehall WID',
  },
  {
    Co: '02992',
    Name: 'Amberley WID',
  },
  {
    Co: '02995',
    Name: 'Bay Ridge ECD',
  },
  {
    Co: '02998',
    Name: 'Branch Plant SCBD',
  },
  {
    Co: '02999',
    Name: 'Inactive SCBD',
  },
  {
    Co: '03010',
    Name: 'Gen Co Cap Proj-Gen Proj',
  },
  {
    Co: '03011',
    Name: 'Gen Cnty CP-Closed',
  },
  {
    Co: '03020',
    Name: 'Gen Co Cap Proj-Storm Drains',
  },
  {
    Co: '03021',
    Name: 'Gen Cnty CP-Storm Drains-Close',
  },
  {
    Co: '03030',
    Name: 'Gen Co Cap Proj-Education',
  },
  {
    Co: '03031',
    Name: 'Gen Cnty CP-Educ-Closed',
  },
  {
    Co: '03040',
    Name: 'Gen Co Cap Proj-Fire & Police',
  },
  {
    Co: '03041',
    Name: 'Gen Cnty CP-Fire/Pol-Closed',
  },
  {
    Co: '03050',
    Name: 'Gen Co Cap Proj-Hwy-Rd/Bdge',
  },
  {
    Co: '03051',
    Name: 'Gen Cnty CP-Red/Brdgs-Closed',
  },
  {
    Co: '03060',
    Name: 'Gen Co Cap Proj-Comm College',
  },
  {
    Co: '03061',
    Name: 'Gen Cnty CP-Comm Coll-Closed',
  },
  {
    Co: '03070',
    Name: 'Gen Co Cap Proj-Libraries',
  },
  {
    Co: '03071',
    Name: 'Gen Cnty CP-Libraries-Closed',
  },
  {
    Co: '03080',
    Name: 'Gen Co Cap Proj-CBG',
  },
  {
    Co: '03081',
    Name: 'Gen Cnty CP-CBG-Closed',
  },
  {
    Co: '03090',
    Name: 'Gen Co Cap Proj-Recs & Parks',
  },
  {
    Co: '03091',
    Name: 'Gen Cnty CP-Rec & Parks-Closed',
  },
  {
    Co: '03100',
    Name: 'Gen Co Cap Proj-Dredging Proj',
  },
  {
    Co: '03101',
    Name: 'Gen Cnty CP-Dredging-Closed',
  },
  {
    Co: '03200',
    Name: 'Cedarhurst ECD',
  },
  {
    Co: '03205',
    Name: 'Columbia Beach ECD',
  },
  {
    Co: '03210',
    Name: 'Franklin Manor ECD',
  },
  {
    Co: '03215',
    Name: 'Gibson Island ECD',
  },
  {
    Co: '03220',
    Name: 'Holland Point ECD',
  },
  {
    Co: '03225',
    Name: 'Idlewilde ECD',
  },
  {
    Co: '03230',
    Name: "Mason's Beach ECD",
  },
  {
    Co: '03235',
    Name: 'Riviera Beach ECD',
  },
  {
    Co: '03240',
    Name: 'Venice Beach ECD',
  },
  {
    Co: '03299',
    Name: 'Inactive ECD',
  },
  {
    Co: '04000',
    Name: 'Water & Wstwtr Operating Fund',
  },
  {
    Co: '04110',
    Name: 'W & S Cap Proj Swr Project',
  },
  {
    Co: '04111',
    Name: 'Water and Sewer CP-Sew-Closed',
  },
  {
    Co: '04120',
    Name: 'W &  S Cap Proj Wtr Project',
  },
  {
    Co: '04121',
    Name: 'Water and Sewer CP-Wat-Closed',
  },
  {
    Co: '04130',
    Name: 'W & S Cap Proj Oth W & S Proj',
  },
  {
    Co: '04131',
    Name: 'Water and Sewer CP-Other-Close',
  },
  {
    Co: '04140',
    Name: 'W & S Cap Proj Routine Wtr Ext',
  },
  {
    Co: '04141',
    Name: 'W & S CP-Routine Wat Ext-Close',
  },
  {
    Co: '04150',
    Name: 'W & S Cap Proj Routine Swr Ext',
  },
  {
    Co: '04151',
    Name: 'W & S CP-Routine Sew Ext-Close',
  },
  {
    Co: '04200',
    Name: 'Water & Wstwtr Sinking Fund',
  },
  {
    Co: '04220',
    Name: 'Maryland City AMT Fund',
  },
  {
    Co: '04230',
    Name: 'W & S Adjustment to GAAP',
  },
  {
    Co: '04300',
    Name: 'Waste Collection Fund',
  },
  {
    Co: '04390',
    Name: 'Solid Waste Assurance Fund',
  },
  {
    Co: '04410',
    Name: 'Solid Waste C/P-Landfill Proj',
  },
  {
    Co: '04411',
    Name: 'Gen Cnty CP-Landfill-Closed',
  },
  {
    Co: '04510',
    Name: 'WPRF Cap Projects',
  },
  {
    Co: '04511',
    Name: 'WPRF Cap Projects Closed',
  },
  {
    Co: '04600',
    Name: 'Watershed Protection & Restor',
  },
  {
    Co: '05000',
    Name: 'Central Stores Fund',
  },
  {
    Co: '05050',
    Name: 'Self Insurance Fund',
  },
  {
    Co: '05100',
    Name: 'Health Insurance Fund',
  },
  {
    Co: '05120',
    Name: 'OPEB Fund',
  },
  {
    Co: '05200',
    Name: 'Garage Working Capital Fund',
  },
  {
    Co: '05300',
    Name: 'Garage Vehicle Replacement Fnd',
  },
  {
    Co: '06050',
    Name: 'Pension Fund',
  },
  {
    Co: '06075',
    Name: 'County OPEB Trust',
  },
  {
    Co: '06076',
    Name: 'AACC OPEB Trust',
  },
  {
    Co: '06077',
    Name: 'Library OPEB Trust',
  },
  {
    Co: '06100',
    Name: 'Defined Contribution Plan',
  },
  {
    Co: '06200',
    Name: 'Storm Drain Agency',
  },
  {
    Co: '06230',
    Name: "PACE-Propty Asses'd Clean Engr",
  },
  {
    Co: '06240',
    Name: 'Sr. Center External Activity',
  },
  {
    Co: '06250',
    Name: 'Subdivision Deposit Agency',
  },
  {
    Co: '06260',
    Name: 'Circuit Court Special Fund',
  },
  {
    Co: '06270',
    Name: 'Bid & Contract Deposits',
  },
  {
    Co: '06272',
    Name: 'Arts Council of AA County',
  },
  {
    Co: '06274',
    Name: 'Brookfield HOA Escrow',
  },
  {
    Co: '06280',
    Name: 'Watershed Stewards Academy',
  },
  {
    Co: '06285',
    Name: 'Nat Bus Pk North STD',
  },
  {
    Co: '06286',
    Name: 'Two Rivers Special Taxing Dist',
  },
  {
    Co: '06287',
    Name: 'Arundel Gateway',
  },
  {
    Co: '06290',
    Name: 'Home Builder Guarantee Fees',
  },
  {
    Co: '06300',
    Name: 'Sediment Control Agency',
  },
  {
    Co: '06310',
    Name: 'Medco AA Golf Project Escrow',
  },
  {
    Co: '06320',
    Name: 'Conference & Visitor Bureau',
  },
  {
    Co: '06325',
    Name: 'Recreation Agency',
  },
  {
    Co: '06331',
    Name: 'Recreation Land Fund',
  },
  {
    Co: '06375',
    Name: 'Inmate Benefit Fund',
  },
  {
    Co: '06400',
    Name: 'Liquor Board',
  },
  {
    Co: '06420',
    Name: 'Support Agency',
  },
  {
    Co: '06430',
    Name: 'Victim Restitution Fund-SAO',
  },
  {
    Co: '06450',
    Name: 'City & State Tax Coll Agency',
  },
  {
    Co: '06475',
    Name: 'Area Agency on Aging Agency',
  },
  {
    Co: '06550',
    Name: 'Reforestation Fund',
  },
  {
    Co: '06575',
    Name: 'Deferred Comp Plan Agency',
  },
  {
    Co: '06580',
    Name: 'Defined Contrib Plan 401A',
  },
  {
    Co: '06590',
    Name: 'Tax Sale Escrow Deposits',
  },
  {
    Co: '06650',
    Name: 'SHR - Other Agency',
  },
  {
    Co: '06680',
    Name: 'Clean Energy Fund',
  },
  {
    Co: '06750',
    Name: 'SHR Escrow Dist Ct',
  },
  {
    Co: '06760',
    Name: 'SHR Escrow Cir Ct',
  },
  {
    Co: '09000',
    Name: 'Library Fund',
  },
  {
    Co: '09050',
    Name: 'CLCM Escrow',
  },
  {
    Co: '09051',
    Name: 'Elizabeth Werner Memorial',
  },
  {
    Co: '09052',
    Name: 'Elmer M Jackson Jr. Mem Fund',
  },
  {
    Co: '09053',
    Name: 'Library Updates',
  },
  {
    Co: '09054',
    Name: 'Memorial',
  },
  {
    Co: '09055',
    Name: 'Miscellaneous Deposits',
  },
  {
    Co: '09061',
    Name: 'Special Projects',
  },
  {
    Co: '09062',
    Name: 'Staff AV',
  },
  {
    Co: '09063',
    Name: 'Staff Benefits',
  },
  {
    Co: '09064',
    Name: 'Staff Books',
  },
  {
    Co: '09065',
    Name: 'MLGIP Investment Earnings',
  },
  {
    Co: '09066',
    Name: 'Training',
  },
  {
    Co: '09067',
    Name: 'Maryland City Opening',
  },
  {
    Co: '09068',
    Name: 'Tech Scholarship',
  },
  {
    Co: '09069',
    Name: 'DLDS/Encyl Brit Escrow',
  },
  {
    Co: '09070',
    Name: 'Staff Book Shipping',
  },
  {
    Co: '09071',
    Name: 'MCEN Registration',
  },
  {
    Co: '09072',
    Name: 'Summer Reading Promotions',
  },
  {
    Co: '09073',
    Name: 'W C O Grand Opening',
  },
  {
    Co: '09074',
    Name: 'David C. Marshall Mem Fund',
  },
  {
    Co: '09075',
    Name: 'Photocopying',
  },
  {
    Co: '09076',
    Name: 'Collection Service',
  },
  {
    Co: '09083',
    Name: 'Univ. Svc Fund Refund',
  },
  {
    Co: '09100',
    Name: 'Library Grants Spec Rev Fund',
  },
  {
    Co: '09195',
    Name: 'Library Pension Liability',
  },
  {
    Co: '09197',
    Name: 'Library Deferred Compensation',
  },
  {
    Co: '09198',
    Name: 'Library General Long Term Debt',
  },
  {
    Co: '09199',
    Name: 'Library General Fixed Assets',
  },
  {
    Co: '09200',
    Name: 'Local Education Fund',
  },
  {
    Co: '09295',
    Name: 'Library OPEB',
  },
  {
    Co: '09300',
    Name: 'Higher Education Fund',
  },
  {
    Co: '09400',
    Name: 'AA Workforce Dev Corp Fund',
  },
  {
    Co: '09500',
    Name: 'General Govt Pension Liability',
  },
  {
    Co: '09516',
    Name: 'Econ Dev OPEB',
  },
  {
    Co: '09545',
    Name: 'Cost Sharing AA Co Commission',
  },
  {
    Co: '09546',
    Name: 'Cost Sharing AA Co Master Judg',
  },
  {
    Co: '09547',
    Name: 'Cost Sharing AA Co Officials',
  },
  {
    Co: '09610',
    Name: 'County OPEB',
  },
  {
    Co: '09800',
    Name: 'General Long Term Debt',
  },
  {
    Co: '09900',
    Name: 'General Fixed Assets',
  },
  {
    Co: '09995',
    Name: 'Cent Serv Property Inventory',
  },
  {
    Co: '09999',
    Name: "Purchasing Blanket PO's",
  },
];
